'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('core-js/stable');
require('regenerator-runtime/runtime');
require('antd/es/avatar/style');
var _Avatar = require('antd/es/avatar');
var React = require('react');
var Dialog = require('rc-dialog');
var tsBelt = require('@mobily/ts-belt');
var mobxReactLite = require('mobx-react-lite');
var Tree = require('rc-tree');
var mobx = require('mobx');
var axios = require('axios');
var useResizeObserver = require('@react-hook/resize-observer');
require('antd/es/spin/style');
var _Spin = require('antd/es/spin');
require('antd/es/input/style');
var _Input = require('antd/es/input');
require('antd/es/popover/style');
var _Popover = require('antd/es/popover');
require('antd/es/empty/style');
var _Empty = require('antd/es/empty');
var ReactDOM = require('react-dom');
var Icon = require('@ant-design/icons');
var isHotkey = require('is-hotkey');
require('antd/es/config-provider/style');
var _ConfigProvider = require('antd/es/config-provider');
var zhCN = require('antd/es/locale/zh_CN');
var zhHK = require('antd/es/locale/zh_HK');
var zhTW = require('antd/es/locale/zh_TW');
var enUS = require('antd/es/locale/en_US');
var jaJP = require('antd/es/locale/ja_JP');
require('antd/es/modal/style');
var _Modal = require('antd/es/modal');
require('antd/es/date-picker/style');
var _DatePicker = require('antd/es/date-picker');
require('antd/es/tooltip/style');
var _Tooltip = require('antd/es/tooltip');
require('antd/es/select/style');
var _Select = require('antd/es/select');
require('antd/es/switch/style');
var _Switch = require('antd/es/switch');
require('antd/es/button/style');
var _Button = require('antd/es/button');
require('antd/es/space/style');
var _Space = require('antd/es/space');
require('antd/es/message/style');
var _message = require('antd/es/message');
var classNames = require('classnames');
require('antd/es/breadcrumb/style');
var _Breadcrumb = require('antd/es/breadcrumb');
require('antd/es/checkbox/style');
var _Checkbox = require('antd/es/checkbox');
var isEmpty = require('lodash/isEmpty');
var zhCN$1 = require('antd/es/date-picker/locale/zh_CN');
var zhHK$1 = require('antd/es/date-picker/locale/zh_TW');
var enUS$1 = require('antd/es/date-picker/locale/en_US');
var jaJP$1 = require('antd/es/date-picker/locale/ja_JP');
require('antd/es/row/style');
var _Row = require('antd/es/row');
require('antd/es/tabs/style');
var _Tabs = require('antd/es/tabs');
require('antd/es/typography/style');
var _Typography = require('antd/es/typography');
var vanillaSharing = require('vanilla-sharing');
var QRCode = require('qrcode/lib/browser');
var isMobileJs = require('ismobilejs');
require('antd/es/dropdown/style');
var _Dropdown = require('antd/es/dropdown');
require('antd/es/menu/style');
var _Menu = require('antd/es/menu');
require('antd/es/list/style');
var _List = require('antd/es/list');
var isEqual = require('lodash/isEqual');
require('antd/es/divider/style');
var _Divider = require('antd/es/divider');
require('antd/es/skeleton/style');
var _Skeleton = require('antd/es/skeleton');
require('antd/es/col/style');
var _Col = require('antd/es/col');
require('antd/es/form/style');
var _Form = require('antd/es/form');
require('antd/es/carousel/style');
var _Carousel = require('antd/es/carousel');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Avatar__default = /*#__PURE__*/_interopDefaultLegacy(_Avatar);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var Tree__default = /*#__PURE__*/_interopDefaultLegacy(Tree);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var useResizeObserver__default = /*#__PURE__*/_interopDefaultLegacy(useResizeObserver);
var _Spin__default = /*#__PURE__*/_interopDefaultLegacy(_Spin);
var _Input__default = /*#__PURE__*/_interopDefaultLegacy(_Input);
var _Popover__default = /*#__PURE__*/_interopDefaultLegacy(_Popover);
var _Empty__default = /*#__PURE__*/_interopDefaultLegacy(_Empty);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var Icon__default = /*#__PURE__*/_interopDefaultLegacy(Icon);
var _ConfigProvider__default = /*#__PURE__*/_interopDefaultLegacy(_ConfigProvider);
var zhCN__default = /*#__PURE__*/_interopDefaultLegacy(zhCN);
var zhHK__default = /*#__PURE__*/_interopDefaultLegacy(zhHK);
var zhTW__default = /*#__PURE__*/_interopDefaultLegacy(zhTW);
var enUS__default = /*#__PURE__*/_interopDefaultLegacy(enUS);
var jaJP__default = /*#__PURE__*/_interopDefaultLegacy(jaJP);
var _Modal__default = /*#__PURE__*/_interopDefaultLegacy(_Modal);
var _DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(_DatePicker);
var _Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(_Tooltip);
var _Select__default = /*#__PURE__*/_interopDefaultLegacy(_Select);
var _Switch__default = /*#__PURE__*/_interopDefaultLegacy(_Switch);
var _Button__default = /*#__PURE__*/_interopDefaultLegacy(_Button);
var _Space__default = /*#__PURE__*/_interopDefaultLegacy(_Space);
var _message__default = /*#__PURE__*/_interopDefaultLegacy(_message);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _Breadcrumb__default = /*#__PURE__*/_interopDefaultLegacy(_Breadcrumb);
var _Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(_Checkbox);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var zhCN__default$1 = /*#__PURE__*/_interopDefaultLegacy(zhCN$1);
var zhHK__default$1 = /*#__PURE__*/_interopDefaultLegacy(zhHK$1);
var enUS__default$1 = /*#__PURE__*/_interopDefaultLegacy(enUS$1);
var jaJP__default$1 = /*#__PURE__*/_interopDefaultLegacy(jaJP$1);
var _Row__default = /*#__PURE__*/_interopDefaultLegacy(_Row);
var _Tabs__default = /*#__PURE__*/_interopDefaultLegacy(_Tabs);
var _Typography__default = /*#__PURE__*/_interopDefaultLegacy(_Typography);
var isMobileJs__default = /*#__PURE__*/_interopDefaultLegacy(isMobileJs);
var _Dropdown__default = /*#__PURE__*/_interopDefaultLegacy(_Dropdown);
var _Menu__default = /*#__PURE__*/_interopDefaultLegacy(_Menu);
var _List__default = /*#__PURE__*/_interopDefaultLegacy(_List);
var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);
var _Divider__default = /*#__PURE__*/_interopDefaultLegacy(_Divider);
var _Skeleton__default = /*#__PURE__*/_interopDefaultLegacy(_Skeleton);
var _Col__default = /*#__PURE__*/_interopDefaultLegacy(_Col);
var _Form__default = /*#__PURE__*/_interopDefaultLegacy(_Form);
var _Carousel__default = /*#__PURE__*/_interopDefaultLegacy(_Carousel);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? "felo-".concat(suffixCls) : 'felo';
};

var ConfigContext = /*#__PURE__*/React__default['default'].createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls
});
var ConfigConsumer = ConfigContext.Consumer;

var orgIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABWpJREFUeF7lm11sFFUUgL8zu91O0SpE60+CSn3ARJSghUSCGjVB0iUxBoUHnhATE18UQeOLEUl8MUpBX0xMBF7sAxhiTLoNkqhRiSZQNSgk8mBRSVSKAa3Q3e3uXHOn23XaTrt3ZmdgNjOPO2fOPefbe8+959x7hZgfVaCrrHgQYYkDdwCLBa5X0CmKTt28EkYFRhWcA05Z8BOKEznhC8kzEqeJEofy8iF6HIeNKFYDdylFqHZEUMCPCIcti/7cGoaitjeUYX5GqK/oLP3DM8BmpbgzakO1PhFOAnvar+E9uZ/RKNpoGoD6jPnFS2wReE7BgiiMaqRD4LyCd+x57JaHudBIfq73oQHobl0ssAnhDRRdzRgR+lthBMXLdp59teESWFUoAOowtxbH6UexKnCLcXwgHLHb2Cir+TWo+sAAxgusqsBBFDcEbSxWeeFsFta15TkSpJ1AAMYKbBbFuwpyQRq5XLICZSU825Fnj2mbRgCUIlMq8KaCF0wVX0k5gV3teV4SodrIjoYAXOcHOagUjzVSlqT3Inzc3su6RhAaAigO0Ncq//z0P0D3BHstW0NPg3rMo3g/Sf9sYFuEp+eKCbP2AB3tq4pPkxrwTEHowJgRHpltdvAFUJvnjyZuqjP1euZYOGu3scJvnTADgLvCG+TLxCxywjo9E8IRu5cHpq8YZwAYG+ApnXBE1W7C9GzuWMter01TALiJzRinrtjaPm5awojdwWJvAjUFwNgArwHbo7ZDOpfR1nMQa163kWrn0jDjQ+tQo98byQcU2tGx1vXTfeoA3Hz+b36JI6XNLt1LduGmQHZWzuyjclyPxmgfnUq3X8ttk/WEOoBigW1K8Va0zU1oa7tnP5mb1wdSXf39AOPfbQj0jamwCC/aeXZO6QHFAifiquR4ATjnv6Ey3Odra7Z7K9aC+9x3MQM4aedZUgega3jVCsdMCQaV8wKYyzFTuaDt+8lnsizXNUZ3CBQH2amcudfMzTRq6pipXDO21IOfRZ/dy7YJAAWOK8XdUSj205G0IeB2feEHO89S0XX7EvwZtnRtAi1pQbAGQLXDjVIa4AkHPjRxJKxMkqZBrw8WPCmlAq86ih1hnTP5LmELobrJlrBdxgp8gGKjiSNRylzOgDer3UK/BqDT3uVROmeiKyEAjunNjWGlWGRidJQySQAgwmndA86huC5K59wo27mMTPfzSOYqX9XW/JVIx0L3nRo7g3Pha185Vb1IdfjteBIj4S8pDlCKo+yVe+hn4+yvEXydHZY/v72RWOD3ulwWGwA7r3e2o3uKhYYF7MCNuQDiGgJeADoBUsXfAhko9i31xEh/GAcA3CEQUxD0Aih/uwHnjwOBAFg3rSd37/76N3EAmAyCsUyDrQAA4VhsC6EWAdAfyVI4s2gL2cWvI1n/Kc/b95VycEYOMT70OKjyxCvJ0dbzEVbXGkSshkNFVS5SOfUK1dO7G8rOJeAuhaNIhtof/dfIea8x5aN5nJFB9yerq5fcikIgZzSE0idXB/pmurCbDEWRDoeZ8ryBcXrAM/WqmcCoN0jcdHhiimmuIOIFUBnehXPef1XnjepzAdDv/B5rwUqy3f8fUWgSwERBxAXQZEnMNODNJmc65ZnKmfQg8ZbEmi2KtiKAKUXR2jAIXRZvtSGgD1xOKYvXAITeGGm1IOi7MdLM1lgrTYOzbo3pXhB2c7TFFkL+m6MaQOq3x2u9IL0HJNxekPYjMi6EicPQ6TwkNbmKSvUxuUkIqT4oOQkh1Udla0Ex3Yel6xDSelzem1qm9sKEF0Kqr8xMgkj1pak6hDRfm/MOidRenJxed0vt1Vm/AmQqL0/PVolN+vX5/wDL7gmKXHpGvgAAAABJRU5ErkJggg==";

var groupIcon = "data:image/png;base64,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";

var _excluded = ["name", "src", "type"];
var avatarIconMap = {
  1: '',
  2: groupIcon,
  3: orgIcon
};

var AvatarComponent = function AvatarComponent(_ref) {
  var name = _ref.name,
      src = _ref.src,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('avatar');
  return /*#__PURE__*/React__default['default'].createElement(_Avatar__default['default'], _objectSpread2(_objectSpread2({
    className: prefixCls
  }, props), {}, {
    src: src || avatarIconMap[type || 1]
  }), name ? name.substr(0, 1).toUpperCase() : '');
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".index-module_center__1DLZi {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.index-module_dialogContent__1Khnb {\n  position: relative;\n  width: 100%;\n  padding-bottom: 64px;\n}\n";
var styles = {"center":"index-module_center__1DLZi","dialogContent":"index-module_dialogContent__1Khnb"};
styleInject(css_248z);

var css_248z$1 = ".rc-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.rc-dialog-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: auto;\n  outline: 0;\n  -webkit-overflow-scrolling: touch;\n}\n.rc-dialog-title {\n  margin: 0;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 21px;\n}\n.rc-dialog-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: none;\n  border-radius: 6px 6px;\n}\n.rc-dialog-close {\n  position: absolute;\n  top: 12px;\n  right: 20px;\n  color: #000;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 1;\n  text-decoration: none;\n  text-shadow: 0 1px 0 #fff;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  opacity: 0.2;\n  filter: alpha(opacity=20);\n}\n.rc-dialog-close-x::after {\n  content: '×';\n}\n.rc-dialog-close:hover {\n  text-decoration: none;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.rc-dialog-header {\n  padding: 13px 20px 14px 20px;\n  color: #666;\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n  border-radius: 5px 5px 0 0;\n}\n.rc-dialog-body {\n  padding: 20px;\n}\n.rc-dialog-footer {\n  padding: 10px 20px;\n  text-align: right;\n  border-top: 1px solid #e9e9e9;\n  border-radius: 0 0 5px 5px;\n}\n.rc-dialog-zoom-enter,\n.rc-dialog-zoom-appear {\n  opacity: 0;\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.rc-dialog-zoom-leave {\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n          animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.rc-dialog-zoom-enter.rc-dialog-zoom-enter-active,\n.rc-dialog-zoom-appear.rc-dialog-zoom-appear-active {\n  -webkit-animation-name: rcDialogZoomIn;\n          animation-name: rcDialogZoomIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.rc-dialog-zoom-leave.rc-dialog-zoom-leave-active {\n  -webkit-animation-name: rcDialogZoomOut;\n          animation-name: rcDialogZoomOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n@-webkit-keyframes rcDialogZoomIn {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 1;\n  }\n}\n@keyframes rcDialogZoomIn {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes rcDialogZoomOut {\n  0% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(0, 0);\n    opacity: 0;\n  }\n}\n@keyframes rcDialogZoomOut {\n  0% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(0, 0);\n    opacity: 0;\n  }\n}\n@media (min-width: 768px) {\n  .rc-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n}\n.rc-dialog-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  height: 100%;\n  background-color: #373737;\n  background-color: rgba(55, 55, 55, 0.6);\n  filter: alpha(opacity=50);\n}\n.rc-dialog-mask-hidden {\n  display: none;\n}\n.rc-dialog-fade-enter,\n.rc-dialog-fade-appear {\n  opacity: 0;\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n  -webkit-animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);\n          animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.rc-dialog-fade-leave {\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n  -webkit-animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);\n          animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.rc-dialog-fade-enter.rc-dialog-fade-enter-active,\n.rc-dialog-fade-appear.rc-dialog-fade-appear-active {\n  -webkit-animation-name: rcDialogFadeIn;\n          animation-name: rcDialogFadeIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.rc-dialog-fade-leave.rc-dialog-fade-leave-active {\n  -webkit-animation-name: rcDialogFadeOut;\n          animation-name: rcDialogFadeOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n@-webkit-keyframes rcDialogFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes rcDialogFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes rcDialogFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes rcDialogFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n";
styleInject(css_248z$1);

var css_248z$2 = ".rc-dialog-header {\n  padding-top: 24px;\n  border-bottom: none;\n}\n.rc-dialog-body {\n  padding: 24px;\n  padding-top: 0;\n}\n.rc-dialog-title {\n  margin-left: 4px;\n  color: #333;\n  font-weight: 500;\n  font-size: 16px;\n}\n.step-2 .rc-tree .rc-tree-treenode span.rc-tree-switcher,\n.invite .rc-tree .rc-tree-treenode span.rc-tree-switcher {\n  margin-left: 5px;\n}\n.step-2 .rc-dialog-close,\n.invite .rc-dialog-close {\n  top: 24px;\n  opacity: 1;\n}\n.step-2 .rc-dialog-close:hover,\n.invite .rc-dialog-close:hover {\n  opacity: 1;\n}\n.step-2 .rc-dialog-close .rc-dialog-close-x,\n.invite .rc-dialog-close .rc-dialog-close-x {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAWFJREFUaEPtmM0NgkAQhXehCiow0aMV2IIFeIRQEYGjBdiCFXjUxAqsAtZgJDGEn9n5QTeORzI7vO89dha0JvCfDVy/UYBvJ6gJaAJEB/QRIhpIXq4JkC0kNvi/BNI0PVprt1EU7YuiuBMNfC3P83zVNM3JOXepqurg09M7gSzLrs65tTHmEcfxjgrRiq/r+myMSay1t7IsN6IAnzekQnD08k6gi7xzDQvBIb7VggKgQnCJJwFgITjFkwF8IbjFswBAISTEswHMQUiJZwUYg2ivUyfW1LmAnkJjTftuv+sS7LidO9TYAQaSaC+xnNpDMArQdyXoR2ho2gSziadG5c+PUYhASM3cxBHZxD7CfGqhMKQphBGEWSNykFGEUNb2YVAJcAjg6IF6F+K68dwLoNgeCP6jPvi/VaDRLlWH2sRLiYPcRwEgLknWaAKS7kJ6awIQlyRrNAFJdyG9NQGIS5I1T16jgEC5yhXpAAAAAElFTkSuQmCC');\n  background-size: contain;\n  cursor: pointer;\n}\n.step-2 .rc-dialog-close .rc-dialog-close-x::after,\n.invite .rc-dialog-close .rc-dialog-close-x::after {\n  display: none;\n}\n";
styleInject(css_248z$2);

var LocaleContext = /*#__PURE__*/React.createContext(undefined);

/**
 * 把json文件中的数据转换成Locale对象
 * 例如：a.b.c:"123" -> { a: { b: { c: "123" } } }
 * @param data
 * @returns
 */
var jsonToObject = function jsonToObject(data) {
  var map = {};
  Object.keys(data).forEach(function (key) {
    var keys = key.split('.');
    var currentMap = {};
    keys.forEach(function (k, i) {
      if (i === 0) {
        if (i === keys.length - 1) map[k] = data[key];else if (!map[k]) {
          map[k] = {};
        }
        currentMap = map[k];
      } else {
        if (!currentMap[k]) {
          currentMap[k] = i === keys.length - 1 ? data[key] : {};
        }

        currentMap = currentMap[k];
      }
    });
  });
  return map;
};

var randomPassword = function randomPassword() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

  // Limit length
  if (length < 4) {
    length = 4;
  } else if (length > 16) {
    length = 16;
  }

  var passwordArray = ['ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz', '1234567890', '!@#$%&*()'];
  var password = [];
  var n = 0;

  for (var i = 0; i < length; i++) {
    // If password length less than 9, all value random
    if (password.length < length - 2) {
      // Get random passwordArray index
      var arrayRandom = Math.floor(Math.random() * 4); // Get password array value

      var passwordItem = passwordArray[arrayRandom]; // Get password array value random index
      // Get random real value

      var item = passwordItem[Math.floor(Math.random() * passwordItem.length)];
      password.push(item);
    } else {
      // If password large then 9, lastest 4 password will push in according to the random password index
      // Get the array values sequentially
      var newItem = passwordArray[n];
      var lastItem = newItem[Math.floor(Math.random() * newItem.length)]; // Get array splice index

      var spliceIndex = Math.floor(Math.random() * password.length);
      password.splice(spliceIndex, 0, lastItem);
      n++;
    }
  }

  return password.join('');
};

var to = "Share to";
var description = "Click to share this document to felo friends, groups or organizations";
var localeData = {
	to: to,
	description: description,
	"permissions.onlyView": "Read",
	"permissions.canEdit": "Editable",
	"permissions.edit": "Edit",
	"permissions.ownerSet": "Set as owner",
	"permissions.owner": "Owner",
	"add.title": "Add",
	"add.note": "Add note",
	"add.hint": "The file/document will be sent with the comments below",
	"add.notification": "Allow notifications to be sent",
	"link.copy": "Copy link",
	"link.on": "Open",
	"link.off": "Close",
	"link.title": "Link Sharing",
	"link.description": "Set the permissions of the people who visit through the link",
	"link.org": "Anyone who gets the link in the organization can",
	"link.any": "Anyone can get the link",
	"link.password.title": "Set link sharing password",
	"link.password.time": "Specific time",
	"link.password.placeholder": "Set Password",
	"link.password.set": "Set",
	"link.password.reset": "Reset",
	"link.date.title": "Set the expiration date of link sharing",
	"link.date.placeholder": "Set deadline",
	"link.date.format": "will be disabled on {date}",
	"link.apply.edit": "Apply for editing permissions",
	"link.apply.success": "Succeeded in applying for editing permissions",
	"manage.title": "Manage Collaborators",
	"manage.description": "Manage collaborators' access rights",
	"select.placeholder": "Search for users, groups or departments",
	"select.title": "Select contact",
	"select.contact": "Contact",
	"select.selectedNumber": "Selected number {num}"
};

var localValue = _objectSpread2({
  locale: 'en-US'
}, jsonToObject(localeData));

var title = "Share with";
var description$1 = "Member or group with access authority";
var localeData$1 = {
	title: title,
	description: description$1,
	"use.description": "Request the document owner {name}  to share the document with the following users",
	"permissions.edit": "Edit",
	"permissions.editDescription": "Edit and read document",
	"permissions.view": "Read",
	"permissions.viewDescription": "Read document only",
	"permissions.transfer": "Transfer ownership",
	"permissions.transferDescription": "Become the owner of the document",
	"permissions.owner": "Owner",
	"permissions.noDescription": "Fail to read or edit document",
	"permissions.no": "Not allow",
	"permissions.setTransferTitle": "Confirm to set this user as the owner?",
	"permissions.setTransferDescription": "This user will become the owner of this document. You will lose the administrative authority of this document",
	"add.title": "Add",
	"add.notification": "Send request notice",
	"remove.title": "Confirm to remove the authority of {name}?",
	"remove.description": "The users may not be able to view the document once removed",
	"link.copy": "Copy and share link",
	"link.get": "Get link",
	"link.encryption": "Encrypt link",
	"link.password.enable": "Enable password",
	"link.password.update": "Change",
	"link.password.copy": "Copy link and password",
	"link.password.placeholder": "Set Password",
	"link.password.description": "Note: When password is enabled, all users must enter password to access; when enabled, document authority changed to: anyone who knows the link can view/edit the document",
	"link.password.set": "Password protected link",
	"link.general.org.title": "All users in organization",
	"link.general.any.title": "Anyone who has the link",
	"select.placeholder": "Search member, group or department in organization",
	"select.all": "All Contacts",
	"select.conversation": "My conversation",
	"select.selectedNumber": "Selected:{num}",
	"link.password.ok": "Completed",
	"link.general.title": "Normal access authority",
	"apply.description": "{name}request for document access authority for below users",
	"notification.title": "Notification",
	"notification.self": "{name} request for reading/editing authority for this document",
	"notification.other": "{name}request for reading/editing authority for others",
	"notification.view": "click to check",
	"notification.unread": "unread notification",
	"notification.read": "read notification",
	"add.apply": "agree",
	"add.ignore": "ignore",
	"link.manage": "Password setting",
	"add.notificationReq": "Send request notice",
	"add.disabled": "Unable to request permission, you are not in the same organization as the document owner.",
	"link.general.org.viewDescription": "Anyone in organization who has the link can view",
	"link.general.org.editDescription": "Anyone in organization who has the link can edit",
	"link.general.any.viewDescription": "Anyone on the Internet who has the link can view",
	"link.general.any.editDescription": "Anyone on the Internet who has the link can edit"
};

var localValue$1 = _objectSpread2({
  locale: 'en-US'
}, jsonToObject(localeData$1));

var cancel = "Cancel";
var confirm = "Confirm";
var openChat = "Open Chat";
var title$1 = "Select Members";
var localeData$2 = {
	cancel: cancel,
	confirm: confirm,
	openChat: openChat,
	title: title$1
};

var localValue$2 = _objectSpread2({
  locale: 'en-US'
}, jsonToObject(localeData$2));

var cancel$1 = "Cancel";
var confirm$1 = "Confirm";
var login = "Login";
var titleSelectOrg = "Select your account/org";
var addOrg = "Add an Organization";
var logout = "Sign out";
var explainCreateOtherAccount = "Want to create another account to use Felo?";
var createOtherAccount = "Add another Account";
var loginAnonymous = "Anonymous login";
var inviteFellows = "Invite Fellows";
var switchAccount = "Switch account";
var titleJoinNewOrg = "Join new organization";
var descJoinNewOrg = "If your organization has already been using Felo, you can join via Invitation code to collaborate with fellows.";
var titleCreateNewOrg = "Create new organization";
var descCreateNewOrg = "When a new organization is created, you will become the administrator. You can add members, manage organization.";
var createTeamNameNow = "Set a name for your organization";
var labelName = "Name";
var labelJoinOrgCode = "Join using invitation code";
var labelOrgCode = "Invitation code";
var create = "Create";
var join = "Join";
var errMsgWrongOrgCode = "Invitation code is wrong or has expired";
var errMsgTeamNotExist = "organization not exist";
var personalInfo = "Account";
var orgManagement = "Organizational";
var invitationOrganization = "Invite to join the organization";
var recommendFriend = "Recommend to your friends";
var freeVersion = "Free Plan";
var generalVersion = "Standard Plan";
var advancedVersion = "Premium Plan";
var enterpriseVersion = "Enterprise Plan";
var upgrade = "Upgrade";
var localeData$3 = {
	cancel: cancel$1,
	confirm: confirm$1,
	login: login,
	titleSelectOrg: titleSelectOrg,
	addOrg: addOrg,
	logout: logout,
	explainCreateOtherAccount: explainCreateOtherAccount,
	createOtherAccount: createOtherAccount,
	loginAnonymous: loginAnonymous,
	inviteFellows: inviteFellows,
	switchAccount: switchAccount,
	titleJoinNewOrg: titleJoinNewOrg,
	descJoinNewOrg: descJoinNewOrg,
	titleCreateNewOrg: titleCreateNewOrg,
	descCreateNewOrg: descCreateNewOrg,
	createTeamNameNow: createTeamNameNow,
	labelName: labelName,
	labelJoinOrgCode: labelJoinOrgCode,
	labelOrgCode: labelOrgCode,
	create: create,
	join: join,
	errMsgWrongOrgCode: errMsgWrongOrgCode,
	errMsgTeamNotExist: errMsgTeamNotExist,
	personalInfo: personalInfo,
	orgManagement: orgManagement,
	invitationOrganization: invitationOrganization,
	recommendFriend: recommendFriend,
	freeVersion: freeVersion,
	generalVersion: generalVersion,
	advancedVersion: advancedVersion,
	enterpriseVersion: enterpriseVersion,
	upgrade: upgrade
};

var localValue$3 = _objectSpread2({
  locale: 'en-US'
}, jsonToObject(localeData$3));

var ok = "OK";
var localeData$4 = {
	"join-organization": {
	title: "Invite friends to join",
	share: "Invite by sharing",
	code: {
		title: "This is your organization invitation code, valid until {expiredAt}",
		desc: "New members can use the invitation code to create a new account, and after creating the account, they will automatically join the organization.",
		desc2: "You can also <i>copy the above text</i> or <i>copy the QR code</i> to send to your friend.",
		"copy-label": "{userName} invites you to use Felo and join \"{orgName}\". You can click on the link {link} or use the invitation code {invite_code} to join. "
	},
	sns: {
		desc: "Share invitation message to"
	},
	email: {
		title: "Invite by email",
		desc: "Invitation link will be sent to the specified email address",
		button: "Send invitation email",
		confirm: "Confirm sending email",
		fail: "The email address is malformed.",
		"success-send": "Invitation email sent.",
		"error-send": "Failed to send invitation email.",
		placeholder: "Enter the email address you want to invite here, one per line. Example:"
	}
},
	"recommend-friend": {
	title: "Recommend to your friends",
	share: "Share the recommendation",
	code: {
		title: "This is your organization invitation code, valid until {expiredAt}",
		desc: "If you consider Felo a good software, please recommend it to your friends, thank you for your support",
		desc2: "Copy the link to share with your friends",
		"copy-label": "{userName} recommends Felo to you. Register through the link below to start your collaborative fun that you've never experienced before{link}"
	},
	sns: {
		desc: "Share invitation message to"
	},
	email: {
		title: "Invite by email",
		desc: "Invitation link will be sent to the specified email address",
		button: "Send invitation email",
		confirm: "Confirm sending email",
		fail: "The email address is malformed.",
		"success-send": "Invitation email sent.",
		"error-send": "Failed to send invitation email.",
		placeholder: "Enter the email address you want to invite here, one per line. Example:"
	}
},
	"copy-text": "Copy",
	"copy-success": "Copied to clipboard.",
	ok: ok,
	"user-already-in-org": "User has already in organization",
	"send-success": "Invitation email sent.",
	"send-failed": "Failed to send",
	"send-failed-detail": "{length} invitations failed"
};

var localValue$4 = _objectSpread2({
  locale: 'en-US'
}, jsonToObject(localeData$4));

var cancel$2 = "Cancel";
var send = "Send";
var ok$1 = "OK";
var confirm$2 = "Confirm";
var on = "Open";
var off = "Close";
var remove = "Delete";
var success = "Success";
var failed = "Failed";
var localeData$5 = {
	cancel: cancel$2,
	send: send,
	ok: ok$1,
	confirm: confirm$2,
	on: on,
	off: off,
	remove: remove,
	success: success,
	failed: failed
};

var localeValue = {
  locale: 'en-US',
  global: _objectSpread2({
    locale: 'en-US'
  }, localeData$5),
  Share: localValue,
  CommonShare: localValue$1,
  Selector: localValue$2,
  PageHeader: localValue$3,
  InvitationShare: localValue$4
};

function useLocaleReceiver(componentName, defaultLocale) {
  var feloLocale = React.useContext(LocaleContext) || {};
  var componentLocale = React.useMemo(function () {
    var locale = feloLocale[componentName] || defaultLocale || localeValue[componentName || 'global'];
    return _objectSpread2({}, typeof locale === 'function' ? locale() : locale);
  }, [componentName, defaultLocale, feloLocale]);
  return [componentLocale];
}

var LocaleProvider = (function (_ref) {
  var locale = _ref.locale,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(LocaleContext.Provider, {
    value: locale
  }, children);
});

var SelectorDialog = function SelectorDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children,
      wrapClassName = _ref.wrapClassName,
      width = _ref.width,
      style = _ref.style,
      title = _ref.title;

  var _useLocaleReceiver = useLocaleReceiver('Selector'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _title = title || locale.title;

  return /*#__PURE__*/React__default['default'].createElement(Dialog__default['default'], {
    title: _title,
    visible: open,
    animation: "zoom",
    maskAnimation: "fade",
    onClose: onClose,
    destroyOnClose: true,
    wrapClassName: "".concat(wrapClassName || '', " ").concat(styles.center),
    width: width ? width : 'auto',
    style: _objectSpread2({
      minWidth: '600px'
    }, style)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.dialogContent
  }, children));
};

var StateContext = /*#__PURE__*/React__default['default'].createContext({
  baseURL: '',
  token: '',
  initInfo: {
    userIds: [],
    removable: false
  },
  onConfirm: function onConfirm() {},
  onClose: function onClose() {},
  mode: 'group'
});

var css_248z$3 = ".index-module_selectorContainer__2zjCx {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 550px;\n}\n.index-module_selectorContainer__2zjCx > div {\n  height: 100%;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  border: 1px solid #e4e4e4;\n  border-radius: 4px;\n}\n.index-module_selectorContainer__2zjCx .index-module_left__1jgKN {\n  min-width: 376px;\n  padding-right: 8px;\n  overflow-y: scroll;\n  transition: all 0.1s;\n}\n.index-module_selectorContainer__2zjCx .index-module_left__1jgKN::-webkit-scrollbar-thumb {\n  background-color: #d8d6d6;\n  border-radius: 3px;\n}\n.index-module_selectorContainer__2zjCx .index-module_left__1jgKN.index-module_full__1OuQ4 {\n  width: 100%;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW {\n  min-width: 376px;\n  padding: 8px;\n  overflow-y: scroll;\n  border-left-width: 0;\n  transition: all 0.1s;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_count__1dOnU {\n  height: 44px;\n  margin-left: 8px;\n  color: #333;\n  line-height: 44px;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_checkedNode__3Iffz {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_checkedNode__3Iffz:hover {\n  background-color: #f1f1f1;\n  border-radius: 4px;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_checkedNode__3Iffz img {\n  width: 32px;\n  height: 32px;\n  margin: 10px 8px;\n  border-radius: 9999px;\n  cursor: pointer;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_checkedNode__3Iffz div {\n  cursor: pointer;\n}\n.index-module_selectorContainer__2zjCx .index-module_right__YuJRW .index-module_checkedNode__3Iffz .index-module_remove__WHnv9 {\n  float: right;\n  width: 24px;\n  height: 24px;\n}\n.index-module_footer__1q96q {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  margin-top: 32px;\n}\n.index-module_footer__1q96q button {\n  min-width: 80px;\n  height: 32px;\n  padding-right: 7px;\n  padding-left: 7px;\n  color: #797879;\n  line-height: 20px;\n  background: transparent;\n  border: 1px solid #797879;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.index-module_footer__1q96q .index-module_confirm__n-9jZ {\n  margin-left: 12px;\n  color: white;\n  background-color: #2994ff;\n  border-style: none;\n}\n.index-module_footer__1q96q .index-module_confirm__n-9jZ[disabled] {\n  color: #797879;\n  background-color: #e4e4e4;\n  cursor: not-allowed;\n}\n.index-module_flex__3PyG5 {\n  display: flex;\n  align-items: center;\n}\n";
var styles$1 = {"selectorContainer":"index-module_selectorContainer__2zjCx","left":"index-module_left__1jgKN","full":"index-module_full__1OuQ4","right":"index-module_right__YuJRW","count":"index-module_count__1dOnU","checkedNode":"index-module_checkedNode__3Iffz","remove":"index-module_remove__WHnv9","footer":"index-module_footer__1q96q","confirm":"index-module_confirm__n-9jZ","flex":"index-module_flex__3PyG5"};
styleInject(css_248z$3);

var defaultUserAvatar = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAFO0lEQVR4nO2dS2xVVRSG/9ZKaSlQsFSKtY8UqDzaiAWpaJBqIcEaHyMVZ0CiIzXRhOhQHRjjQDEOFDswGoxxYkiMJIqGGqmBIiQFtIIpkEIrWLGKFEofZmWHpFG8Xu5de+//eNeXNO3k7rXP+br3Ofu1bl7rWxPrAbQDqIARk34Am/JNBg3ioD3fZFBRkZ/rd4ANE0KGCSHDhJBhQsgwIWSYEDJMCBkmhAwTQoYJIcOEkGFCyDAhZBQk/QJKCoFpU4DRceDCCDB8maBSWZA4IXNKgJYFwIoqYH6ZEzKZwT+BY78Ae08Au48BQxcjV/gakSXciSRUdFYxsHEl0FoPFKTZ0Y6MAZ8dAd7flxwxiRByexWwpRWYMTWzzw8NA6/uAvae1K6ZPvQP9fWLgJfaMpchzCwCXm4D2hZr1swP1EKaa4Bn1gD5edmXlZcHPL3GPX+YoRVSXgJsuVdHxhWkqGdbgJrZemVqQyvkqbv/+QalQWEB8Nw9rsUwQink1puAldX+yq8vB1rm+ys/GyiFbGgKEGO568LYoBNSWQosq/Qfp3oW0DDPf5xrhU5I68JwsdbdEi5WutAJWVUbLpY8p9ge7lRCZHqk9oZw8UqLXNfFBJUQefsJzaIbI1/036ASIrO3oQnZItOBSoi8YeVCzFRQCZk7PXzMsmnhY6aCSkhpcYSYReFjpoJKSDZT7JlSSLZmSiVEc2Y3XYqnhI+ZipzfdTI2TlCJSVAJGRkNH/NihJipoBJy7kL4mL9GiJkKKiF9Q+FjDvwePmYqqIQc6g8fs3cwfMxUUAk5eCp8zJ4z4WOmgkrI8cGwG9rGJ4ADfeHipQOVENmx19kbLt7hAeCPS+HipQPdOOTznnCxvjoaLla60AnpPg2cOOc/juySNyFpIN3Wh/v9x9n5PXCerLsC69SJ/Oee9NhKLo0CHx3wV342UAqRt5+39/gr/+OD7hwJI7STi3Lg5uuf9MuVlheiS8wU6tneNzp055oujwGvfOEO8rBCLUQO2ry4050fzBZ5WdjaARw9G/mi/gP69RAZvMnpp/Esz3m1d7o3K3YScejzynjhhbWZff7NDmDHIdUqeSMxK4bZDOKSIgO2hMuHCSEjMUKy2ZBCenrtqtALkX1T9y8B3n0s8zLaNwAPLAWmXq9ZMz/QJg6QFBoPNgD3LQamKx3+lMnET48AO7qBM+d1ytSGTkhdGfDIMmB1HXCdp/Yre7G+6XUTjD+SLeHSCFky1x32XFEdts+XJdzt++Os51+N6APDppudiMZIBzDlgKn8yIzA9q74+VCitZCGCmBjM7CU7MsyfvgZeG8f0BVJTHAhC8tdmiVpGcwc7ge2fet+hySYkHkzgc3NwF11yRoXdB53E5Mh1vkR4hki+UoebwIeakw/8RgTd9S4fF2fdAMfdPlfh/faQiQV0pN3ArMjnIzywW/Dbml5V49bX/GBFyFybk/SIC2vin0L/fBdH/Dal8BZD4NL9U5EBnTbHv3/yhBuq3TX6CMZmtozREbVT6wCHm7UKpEbSU0rC2aSeOCdPTrLzNBsIVK5XJExGbnm59fqvTmqCJHciNJV5Spy7auVEqKpCFlXr1FKstFK9aQiZMEcjVKSTa1SYk0VITPIsiHEQCtFh4qQ4gSsxPlGKxGabXIgQ0XI6QjHmdnQGrWrCNmqvCk6aUjCg9d361Q6MV9XkSvYM4QME0KGCSHDhJBhQsgwIWSYEDJMCBkmhAwTQoYJIcOEkGFCyDAhZJgQMkRIhGy5xr8wIEI2yx92h6JzCsCmvwAxsR3GI3ZM6gAAAABJRU5ErkJggg==";

var defaultDepartmentAvatar = "data:image/png;base64,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";

var defaultOrgAvatar = "data:image/png;base64,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";

var ArrowIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAPBJREFUWEftlLEJwzAQRe/QAqkCHiRZxCMEzpV38BZGVwUyjOtkCe+QRsHGRQhprC+FI5xqfenx9HVMxhcb5yMHRF/IDbpB1ACa9w66QdQAmv//DorIlYiORHRR1Rk19pmHDYpI2g6dmbmNMU4lIUsCLlxPIupVVUtBlgZcuZhZm6bph2FYgKFVBXCDnFJKLdrLaoClelkbcO1lCOE0juMj561/AsjM5xjj3SIgPHqqGWRmu5/E8pgxPajhvn37RHAHu667EdEhpSToUK4CmDM69mRgg3suy9nrgDnW3jNu0A2iBtC8d9ANogbQvPkOvgDOy1spAClFpgAAAABJRU5ErkJggg==";

var css_248z$4 = ".index-module_username__2DMdE {\n  margin-right: 5px;\n  color: #333;\n  font-size: 16px;\n}\n.index-module_position__2IOCt {\n  color: #666;\n}\n.index-module_badge__tIQRD {\n  display: inline-block;\n  height: 20px;\n  padding: 0 8px;\n  color: #687076;\n  line-height: 20px;\n  background-color: #f1f3f5;\n  border-radius: 9999px;\n}\n.index-module_switcherIcon__35Gi9 {\n  width: 20px;\n  height: 20px;\n}\n.index-module_loading__G3O8W {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n";
var styles$2 = {"username":"index-module_username__2DMdE","position":"index-module_position__2IOCt","badge":"index-module_badge__tIQRD","switcherIcon":"index-module_switcherIcon__35Gi9","loading":"index-module_loading__G3O8W"};
styleInject(css_248z$4);

var ContactTreeStore = /*#__PURE__*/function () {
  function ContactTreeStore(params) {
    _classCallCheck(this, ContactTreeStore);

    this.id = void 0;
    this.key = void 0;
    this.isUser = void 0;
    this.isRootOrg = void 0;
    this.position = void 0;
    this.children = void 0;
    this.parent = void 0;
    this.belongTo = void 0;
    this.title = void 0;
    this.titleString = void 0;
    this.checkable = void 0;
    this.disabled = void 0;
    this.disableCheckbox = void 0;
    this.icon = void 0;
    this.isLeaf = void 0;
    this.selectable = void 0;
    this.switcherIcon = void 0;
    this.dept_ids = void 0;
    this.removable = void 0;
    this.id = params.id;
    this.key = params.key;
    this.isUser = params.isUser;
    this.isRootOrg = typeof params.isRootOrg === 'boolean' ? params.isRootOrg : false;
    this.position = params.position || '';
    this.parent = params.parent;
    this.belongTo = params.belongTo;
    this.title = params.title;
    this.titleString = params.titleString;
    this.children = params.children || [];
    this.checkable = params.checkable;
    this.disabled = params.disabled;
    this.disableCheckbox = params.disableCheckbox;
    this.icon = params.icon;
    this.isLeaf = params.isLeaf; // true: user node, false: folder node

    this.selectable = params.selectable;
    this.switcherIcon = params.switcherIcon;
    this.dept_ids = params.dept_ids;
    this.removable = typeof params.removable === 'boolean' ? params.removable : false;
    mobx.makeObservable(this, {
      title: mobx.observable,
      children: mobx.observable,
      position: mobx.observable,
      setPosition: mobx.action
    });
  }

  _createClass(ContactTreeStore, [{
    key: "setPosition",
    value: function setPosition(value) {
      this.position = value;
    }
  }, {
    key: "setTitle",
    value: function setTitle(value) {
      this.title = value;
    }
  }]);

  return ContactTreeStore;
}();

var motion = {
  motionName: 'node-motion',
  motionAppear: false,
  onAppearStart: function onAppearStart() {
    return {
      height: 0
    };
  },
  onAppearActive: function onAppearActive(node) {
    return {
      height: node.scrollHeight
    };
  },
  onLeaveStart: function onLeaveStart(node) {
    return {
      height: node.offsetHeight
    };
  },
  onLeaveActive: function onLeaveActive() {
    return {
      height: 0
    };
  }
};
var Avatar = function Avatar(_ref) {
  var url = _ref.url,
      isUser = _ref.isUser,
      isRootOrg = _ref.isRootOrg;

  if (!url) {
    if (isUser) {
      return /*#__PURE__*/React__default['default'].createElement("img", {
        className: "avatar",
        src: defaultUserAvatar,
        alt: "avatar"
      });
    }

    if (isRootOrg) {
      return /*#__PURE__*/React__default['default'].createElement("img", {
        className: "avatar",
        src: defaultOrgAvatar,
        alt: "avatar"
      });
    }

    return /*#__PURE__*/React__default['default'].createElement("img", {
      className: "avatar",
      src: defaultDepartmentAvatar,
      alt: "avatar"
    });
  }

  return /*#__PURE__*/React__default['default'].createElement("img", {
    className: "avatar",
    src: url,
    alt: "avatar"
  });
};

var getSvgIcon = function getSvgIcon() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/React__default['default'].createElement("img", {
    src: ArrowIcon,
    style: style,
    className: styles$2.switcherIcon,
    alt: "arrow"
  });
};

var getTitle = function getTitle(title, position, showPosition) {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", {
    className: styles$2.username
  }, title), showPosition && position && /*#__PURE__*/React__default['default'].createElement("span", {
    className: styles$2.badge
  }, position));
};

var getIcon = function getIcon(isUser, avatar) {
  return /*#__PURE__*/React__default['default'].createElement(Avatar, {
    url: avatar,
    isUser: isUser
  });
};

var switcherIcon = function switcherIcon(obj) {
  if (obj.data.isUser) {
    return false;
  }

  if (obj.isLeaf) {
    return getSvgIcon({
      transform: 'rotate(270deg)'
    });
  }

  return getSvgIcon({
    transform: "rotate(".concat(obj.expanded ? 90 : 0, "deg)")
  });
};
var convertToRCTree = function convertToRCTree(_ref2, _ref3) {
  var users = _ref2.users,
      depts = _ref2.depts;
  var department = _ref3.department,
      showPosition = _ref3.showPosition,
      departmentMapRef = _ref3.departmentMapRef,
      isDisable = _ref3.isDisable,
      removable = _ref3.removable;
  var treeData = [];

  if (users) {
    users.forEach(function (user) {
      var id = user.id;
      var avatar = user.avatar;
      var displayName = user.display_name;
      var deptIds = user.dept_ids;
      return treeData.push(new ContactTreeStore({
        key: "".concat(id, "-").concat((department === null || department === void 0 ? void 0 : department.id) || -1),
        id: id,
        title: getTitle(displayName, '', showPosition),
        titleString: displayName,
        avatar: avatar,
        isLeaf: true,
        icon: getIcon(true, avatar),
        isUser: true,
        disabled: isDisable(id, true),
        parent: department,
        dept_ids: deptIds,
        removable: removable
      }));
    });
  }

  if (depts) {
    depts.forEach(function (user) {
      var id = user.id;
      var name = user.name;
      var deptIds = user.parent_id;
      var node = new ContactTreeStore({
        key: "".concat(id, "-").concat((department === null || department === void 0 ? void 0 : department.id) || -1),
        id: id,
        title: name,
        titleString: name,
        isUser: false,
        isLeaf: false,
        icon: getIcon(false),
        disabled: isDisable('', false),
        parent: department,
        dept_ids: [deptIds]
      });
      treeData.push(node);
      departmentMapRef === null || departmentMapRef === void 0 ? void 0 : departmentMapRef.current.set(id, node);
    });
  }

  return treeData;
};
var MY_CONVERSATIONS_KEY = 'My Conversations'; // my conversation tree node.

var convertToRCTreeFromConversation = function convertToRCTreeFromConversation(dataList, _ref4) {
  var session = _ref4.session,
      showPosition = _ref4.showPosition,
      departmentMapRef = _ref4.departmentMapRef,
      removable = _ref4.removable,
      isDisable = _ref4.isDisable,
      mode = _ref4.mode;
  var treeData = [];
  dataList.forEach(function (item) {
    var isLeaf = mode === 'forward' || ['single', 'user'].includes(item.type);
    var node = new ContactTreeStore({
      key: "".concat(item.id, "-").concat(session.id),
      id: item.id,
      title: getTitle(item.title || item.display_name, '', showPosition),
      titleString: item.title || item.display_name,
      avatar: item.avatar,
      isLeaf: isLeaf,
      icon: getIcon(false, item.avatar),
      isUser: isLeaf,
      disabled: isDisable(item.id),
      parent: session,
      belongTo: MY_CONVERSATIONS_KEY,
      removable: !!removable
    });
    treeData.push(node);
    departmentMapRef === null || departmentMapRef === void 0 ? void 0 : departmentMapRef.current.set(item.id, node);
  });
  return treeData;
};
var FROM_JSON_DATA = 'FROM_JSON_DATA';
var covertFromNormalJSON = function covertFromNormalJSON(data, _ref5) {
  var removable = _ref5.removable,
      isDisable = _ref5.isDisable;

  var translate = function translate(input, department) {
    var result = new Array(input.length);
    input.forEach(function (item, index) {
      var id = item.id,
          avatar = item.avatar,
          position = item.position,
          children = item.children;
      var displayName = item.display_name;
      var deptIds = item.dept_ids;
      var temp = new ContactTreeStore({
        key: "".concat(id, "-").concat((department === null || department === void 0 ? void 0 : department.id) || -1),
        id: id,
        title: getTitle(displayName, '', position),
        titleString: displayName,
        avatar: avatar,
        isLeaf: !children,
        icon: getIcon(true, avatar),
        isUser: !children,
        disabled: isDisable(id, true),
        parent: department,
        dept_ids: deptIds,
        removable: removable,
        belongTo: FROM_JSON_DATA,
        position: position
      });
      result[index] = temp;

      if (item.children) {
        result[index].children = translate(item.children, item);
      }
    });
    return result;
  };

  var output = translate(data, null);
  return output;
};

var css_248z$5 = ".rc-tree {\n  margin: 0;\n  border: 1px solid transparent;\n}\n.rc-tree-focused:not(.rc-tree-active-focused) {\n  border-color: cyan;\n}\n.rc-tree .rc-tree-treenode {\n  margin: 0;\n  padding: 0;\n  line-height: 24px;\n  white-space: nowrap;\n  list-style: none;\n  outline: 0;\n}\n.rc-tree .rc-tree-treenode .draggable {\n  color: #333;\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n      user-select: none;\n}\n.rc-tree .rc-tree-treenode.dragging {\n  background: rgba(100, 100, 255, 0.1);\n}\n.rc-tree .rc-tree-treenode.drop-container > .draggable::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  box-shadow: inset 0 0 0 2px red;\n  content: '';\n}\n.rc-tree .rc-tree-treenode.drop-container ~ .rc-tree-treenode {\n  border-left: 2px solid chocolate;\n}\n.rc-tree .rc-tree-treenode.drop-target {\n  background-color: yellowgreen;\n}\n.rc-tree .rc-tree-treenode.drop-target ~ .rc-tree-treenode {\n  border-left: none;\n}\n.rc-tree .rc-tree-treenode.filter-node > .rc-tree-node-content-wrapper {\n  color: #a60000 !important;\n  font-weight: bold !important;\n}\n.rc-tree .rc-tree-treenode ul {\n  margin: 0;\n  padding: 0 0 0 18px;\n}\n.rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper {\n  position: relative;\n  display: inline-block;\n  height: 24px;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  vertical-align: top;\n  cursor: pointer;\n}\n.rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper .rc-tree-iconEle {\n  margin-left: 12px;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-switcher,\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox,\n.rc-tree .rc-tree-treenode span.rc-tree-iconEle {\n  display: inline-block;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  margin-left: 9px;\n  line-height: 16px;\n  vertical-align: -0.125em;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-attachment: scroll;\n  border: 0 none;\n  outline: none;\n  cursor: pointer;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-icon__customize,\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-icon__customize,\n.rc-tree .rc-tree-treenode span.rc-tree-iconEle.rc-tree-icon__customize {\n  background-image: none;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-icon_loading {\n  margin-right: 2px;\n  vertical-align: top;\n  background: url('data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7') no-repeat scroll 0 0 transparent;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher-noop {\n  cursor: auto;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_close {\n  background-position: -75px -56px;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox {\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  margin-right: -4px;\n  margin-left: 8px;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAg1JREFUSEvtlruLE1EUxr9jYZwZwaQRRFi7GBRW8hib1WYLwTokTR6VmSBaiH+IWigyE6s8moTUgoVNtNnJg11QYjoFEdIkwZ0ZY7FXzqwjcVA0MmOVW82FM+d3+e7hfh/BtwzDuCyEuAXgBoAtAKf9NX/YHwL4AOAFET3TNO3Naj15m3a7fXI2mz0AcBvAiTUhvys/AvA0Fovdz+fzX7nIBTJsPp8/F0LsEpFIp9OvEonEKUmSLhDR2TXhC8uy3k0mk6Vpmjt8eCJ6GY1GbzLUBeq6/hjAHVmWp7lc7lMkErmyJuSX5Y7jjLrd7nnbtvnQT6rV6l36fmcH/EepVNqXJCkZBMzrsVwu9+v1+rYQQhDRNum6/hDAPVVVe8lk8nqQMK/XcDjs9ft97v2IgTxFlwqFwp6iKFfDANq2bTabTRXAWwZ+5tHXNG0B4EwYQCHEtFar8T0eMlAwRNO0MFg/ehqG4X5vgIHJvJE0MCm9RhtJN5KurcDq0LiPd6VSmf6Du/8teGEYBhuD+3i79lQsFk1ZltlCAl+WZe21Wi22PteeXAPOZDK9VCoVigGPRqOeaZrHBuxFDCKicrl8EFSe8WTiXNNoNNyM5EYMf4jKZrMfg8o1nGc6nc65n0KUPyYCOFJV9XU8Ho8oinJx3RTA7u44zvvxePxlMBhcO85OvpjoQf9bEF4dy7Cj/jfZwC4Gm+76XAAAAABJRU5ErkJggg==');\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox-checked {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAh1JREFUSEvFljtoU1EYx3/fNb6KOihUdBDqllsVpKKDg1JR1E46KKIOolDzGMRJnTrpZh1uEwsWEUXRxUHEF9QHFQQtiHjTVdzs0CW1DRrvX27aQAw0TUJyPduB73y/c873+htVy/XULThncABjk8SqaptaezOmEd8FLw1u5dLmV9pbeeM+0jJNch1IAE4jkBq2AZC1Ti7mjtmv0K4EDGFM8kzQ2yLQP24MRunkUAgtAeOePCDVDliFz6GJtKVtPmZfWviNC907MNhmcU+DwIU2v67s/kb4Ql/gRgE0yJk7pHyjqd/s5cKSCb9UzTpo5lzLgAZTMYe+QKz5I14sdJnWAI28A/v8lH10Pe0SfGgf0Cg4cNhP2eutGW0uijHEhqaAjsMliZ+IQUGs2olB0YyjfsqebB/RxsIsY0BXzV5bK2mWL6Hrc8K+uUM6KbiL5lrh/Aoch9N+0u7vvKN103ne1VNei8Xw09qV9L4/a/m4p7CpZyqAyYm0ZXePaPXULKPAjnqydjFg2N7fru/g4JszVnAzuqyAq+ZwJZe0a3tva8WPGZ4j9tQDK02LuurQeNoR48h4v/3eclP7v563Vz3DWjpT5DGir15Y/cC5QfbgeJJTA2bBgOQ8zHAPcaIRWGPAkGkM+0kS3RmyEv2NwhoGlgDGOKKnGVjpeOTNO/Lx9D8GcCgLo5MYYSAjFVEhMHKZWIZGJoQra6rdUv8vEXH6zX/kNV0AAAAASUVORK5CYII=');\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox-indeterminate {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAASZJREFUSEvtlrFKw1AYhb+j4uTc0b1RfAjBgnT3CRwUM4gPog6pdugTOItCBR9CbLo7dtVJbH65xUBaMCaxuV2S7cK5/3fvuffPPWLhCyLbMTgWdBDbZmwtavLGEh8YbwZDwSAONcrqlQ6CO9u0CZfAKbBWBpKjTYBbtbiIj/TpdDOggzHh0WB/SaC5MoJnWhw66AzYjiwCzuqAZWr2xqFC/ZzZyxJt/G3diWBP7ciugPOad5eWv3Y7HBkEPoCCWEHP3ste/aqLcy3jLLWqBarMa4BVXMud01jq7OmOQz0U8Xa3bwfTL4a5r8lfbbG+Qef1RE+FgDfWnSbc/wtYBFRG01yaMm4V0vr/eXt/nlbxALtY6C9ieA9RK4mJKdRbEM42UN1R/xtgdZnN/qUA5AAAAABJRU5ErkJggg==');\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox-disabled,\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-checked.rc-tree-checkbox-disabled {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAhdJREFUSEvFlruLU1EQxufbJGKhEpAUWgjX3EmhYKNgKawoPirtRO0EWbUQK/UP0M61UMOCnaKlhYgvWFEsBLUR1uJOICakC0ggK0lMyCcnJEsIu9mbS3I93YGZ+Z15noGMHDPbLyKXROQ4yT0ism1UZpP7KoCyiLwTkcequjIsj8GF5JZCoXBPRBZIzk0IWVccQFdE8r7v3wDw1wn1gH3Ya5Lz0wCN2gCw7Pv+SQftAc3sAcmrs4ANbAJ4qKrX0M/Zj2mFcaNH98N7wAEXSV6fpXdDXt53wBWS+2IC/kQQBPUIpR/1fasOyKjaUfSmCfwN4LSI7CD5dsPimZKH9UQicTSbzX4tFouH2+32l5kBATQBnPJ9/0OpVNrbarU+i8iuSEAANwH86Xa7iyKSXMdIB8BZVX1ZLpd3N5tNB/PG5XZsDlOplOd53i8zOy8iT0iuzV7XyCQv5nK5Z5VKZWej0fgUpr3GAgF8S6fT85lMpm5mbqg/GmriK6qar1ar22u12jLJQ2GqdtMqBfAxmUye8DyvaWa3SN4BcFtV7xaLxa2dTucNySNhYL3fImSVvlLVMwDaQRAcy+Vy70mmzOyFiLhWCH3CAp3B56p6oZ+7OTN7KiLnQpP6gpMAncqSqi6YWV5ELk8KmySka7YBfCd5MApsAIx3eMf+Pf2PD9ithfGtGLEvUQ4Y+5o4BI1nER7uqVmv+v8AAIc7Tq2PIUcAAAAASUVORK5CYII=');\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled {\n  position: relative;\n  background: #ccc;\n  border-radius: 3px;\n}\n.rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled::after {\n  position: absolute;\n  top: 5px;\n  left: 3px;\n  width: 5px;\n  height: 0;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  content: ' ';\n}\n.rc-tree:not(.rc-tree-show-line) .rc-tree-treenode .rc-tree-switcher-noop {\n  background: none;\n}\n.rc-tree.rc-tree-show-line .rc-tree-treenode:not(:last-child) > ul {\n  background: url('data:image/gif;base64,R0lGODlhCQACAIAAAMzMzP///yH5BAEAAAEALAAAAAAJAAIAAAIEjI9pUAA7') 0 0 repeat-y;\n}\n.rc-tree.rc-tree-show-line .rc-tree-treenode:not(:last-child) > .rc-tree-switcher-noop {\n  background-position: -56px -18px;\n}\n.rc-tree.rc-tree-show-line .rc-tree-treenode:last-child > .rc-tree-switcher-noop {\n  background-position: -56px -36px;\n}\n.rc-tree-child-tree {\n  display: none;\n}\n.rc-tree-child-tree-open {\n  display: block;\n}\n.rc-tree-treenode-disabled > span:not(.rc-tree-switcher),\n.rc-tree-treenode-disabled > a,\n.rc-tree-treenode-disabled > a span {\n  color: #767676;\n  cursor: not-allowed;\n}\n.rc-tree-treenode-active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.rc-tree-treenode-selected {\n  background: #f1f1f1;\n}\n.rc-tree-node-selected {\n  background-color: #ffe6b0;\n  box-shadow: 0 0 0 1px #ffb951;\n  opacity: 0.8;\n}\n.rc-tree-icon__open {\n  margin-right: 2px;\n  vertical-align: top;\n  background-position: -110px -16px;\n}\n.rc-tree-icon__close {\n  margin-right: 2px;\n  vertical-align: top;\n  background-position: -110px 0;\n}\n.rc-tree-icon__docu {\n  margin-right: 2px;\n  vertical-align: top;\n  background-position: -110px -32px;\n}\n.rc-tree-icon__customize {\n  margin-right: 2px;\n  vertical-align: top;\n}\n.rc-tree-title {\n  display: inline-block;\n}\n.rc-tree-indent {\n  display: inline-block;\n  height: 0;\n  vertical-align: bottom;\n}\n.rc-tree-indent-unit {\n  display: inline-block;\n  width: 57px;\n}\n.rc-tree-indent-unit:nth-child(n + 2) {\n  width: calc(57px - 24px);\n}\n.rc-tree-draggable-icon {\n  display: inline-flex;\n  justify-content: center;\n  width: 16px;\n}\n.rc-tree .rc-tree-treenode-switcher-open .rc-tree-indent-unit,\n.rc-tree .rc-tree-treenode-switcher-close .rc-tree-indent-unit {\n  width: calc(57px - 24.5px);\n}\n.rc-tree .rc-tree-treenode-switcher-open .rc-tree-node-content-wrapper,\n.rc-tree .rc-tree-treenode-switcher-close .rc-tree-node-content-wrapper {\n  margin-left: 6.5px !important;\n}\n.contact-page .rc-tree-treenode-switcher-open .rc-tree-node-content-wrapper,\n.contact-page .rc-tree-treenode-switcher-close .rc-tree-node-content-wrapper {\n  margin-left: 1.5px !important;\n}\n";
styleInject(css_248z$5);

var css_248z$6 = ".contact-tree {\n  padding-left: 7px;\n}\n.contact-tree .rc-tree-child-tree {\n  display: block;\n}\n.contact-tree .node-motion {\n  overflow-y: hidden;\n  transition: all 0.3s;\n}\n.contact-tree .rc-tree-treenode {\n  display: flex;\n  align-items: center;\n}\n.contact-tree .rc-tree-treenode:hover {\n  background-color: #f1f1f1;\n  border-radius: 4px;\n}\n.contact-tree .rc-tree-treenode .rc-tree-node-selected {\n  background-color: unset;\n  border-style: none;\n  box-shadow: unset;\n  opacity: 1;\n}\n.contact-tree .rc-tree-treenode .rc-tree-node-content-wrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 52px;\n  margin-left: 4px;\n}\n.contact-tree .rc-tree-treenode .rc-tree-icon__customize {\n  display: inline-block;\n  width: 32px !important;\n  height: 32px !important;\n  margin-right: 10px !important;\n}\n.contact-tree .rc-tree-treenode .rc-tree-node-content-wrapper-normal .rc-tree-icon__customize {\n  margin-left: 14px !important;\n}\n.contact-tree .rc-tree-treenode .rc-tree-indent {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  align-self: stretch;\n}\n.contact-tree .rc-tree-treenode .rc-tree-indent .rc-tree-indent-unit {\n  position: relative;\n  height: 100%;\n}\n.contact-tree .rc-tree-treenode .rc-tree-indent .rc-tree-indent-unit::before {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  border-right: 1px solid blue;\n  content: '';\n}\n.contact-tree .rc-tree-treenode .rc-tree-indent .rc-tree-indent-unit-end::before {\n  display: none;\n}\n.contact-tree .avatar {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  background-color: #cbd5e1;\n  border-radius: 9999px;\n}\n.contact-tree .rc-tree-icon__customize {\n  width: 50px !important;\n  height: 50px !important;\n}\n";
styleInject(css_248z$6);

axios__default['default'].defaults.timeout = 10000;
axios__default['default'].defaults.baseURL = location.origin;
axios__default['default'].interceptors.request.use(function (config) {
  config.data = JSON.stringify(config.data);
  config.headers = _objectSpread2(_objectSpread2({}, config.headers), {}, {
    'content-type': 'application/json'
  });
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios__default['default'].interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});
var get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var token = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    axios__default['default'].get(url, {
      params: params,
      headers: {
        authorization: token
      }
    }).then(function (response) {
      resolve(response.data);
    }).catch(function (err) {
      reject(err);
    });
  });
};
var post = function post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var token = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    axios__default['default'].post(url, data, {
      headers: {
        authorization: token
      }
    }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    });
  });
};

var getSessionList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = _ref.token, baseURL = _ref.baseURL;
            _context.prev = 1;
            _context.next = 4;
            return get(baseURL + '/api/v5/msg/session.list', {
              active_time: 0,
              count: 200,
              un_read: false,
              session_type: ''
            }, token);

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res.data.session_list);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", []);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getSessionList(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getUsersInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userIds, _ref3) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = _ref3.token, baseURL = _ref3.baseURL;
            _context2.prev = 1;
            _context2.next = 4;
            return post(baseURL + '/api/v5/web/org.user.list', {
              user_ids: userIds
            }, token);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res.data.users);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", []);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function getUsersInfo(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}(); // org_id: activeOrganization.id,
// user_ids,

var getOrganizationUserList = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params, _ref5) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            token = _ref5.token, baseURL = _ref5.baseURL;
            _context3.prev = 1;
            _context3.next = 4;
            return post(baseURL + '/api/v5/web/org.user.list', params, token);

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", []);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));

  return function getOrganizationUserList(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}(); // session_id: sessionId,
// member_type: 'user',

var getSessionMembers = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params, _ref7) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            token = _ref7.token, baseURL = _ref7.baseURL;
            _context4.prev = 1;
            _context4.next = 4;
            return post(baseURL + '/api/v5/msg/session.members.get', params, token);

          case 4:
            res = _context4.sent;
            return _context4.abrupt("return", res.data);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", []);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 8]]);
  }));

  return function getSessionMembers(_x6, _x7) {
    return _ref8.apply(this, arguments);
  };
}(); // user_ids,

var getOrganizationUserPositions = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params, _ref9) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            token = _ref9.token, baseURL = _ref9.baseURL;
            _context5.prev = 1;
            _context5.next = 4;
            return post(baseURL + '/api/v5/web/org.user.positions', params, token);

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", res.data);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", {});

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 8]]);
  }));

  return function getOrganizationUserPositions(_x8, _x9) {
    return _ref10.apply(this, arguments);
  };
}();
var getOrganizationChildList = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(params, _ref11) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            token = _ref11.token, baseURL = _ref11.baseURL;
            _context6.prev = 1;
            _context6.next = 4;
            return post(baseURL + '/api/v5/web/org.child.list', params, token);

          case 4:
            res = _context6.sent;
            return _context6.abrupt("return", res.data);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", []);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 8]]);
  }));

  return function getOrganizationChildList(_x10, _x11) {
    return _ref12.apply(this, arguments);
  };
}();
var getOrganizationChildListAll = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params, _ref13) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            token = _ref13.token, baseURL = _ref13.baseURL;
            _context7.prev = 1;
            _context7.next = 4;
            return post(baseURL + '/api/v5/web/org.child.list.all', params, token);

          case 4:
            res = _context7.sent;
            return _context7.abrupt("return", res.data);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", []);

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 8]]);
  }));

  return function getOrganizationChildListAll(_x12, _x13) {
    return _ref14.apply(this, arguments);
  };
}();
var getOrganizationUserTeamName = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref15) {
    var token, baseURL, res;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            token = _ref15.token, baseURL = _ref15.baseURL;
            _context8.prev = 1;
            _context8.next = 4;
            return get(baseURL + '/api/v5/web/org.team.name', {}, token);

          case 4:
            res = _context8.sent;
            return _context8.abrupt("return", res.data);

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](1);
            return _context8.abrupt("return", {
              name: ''
            });

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 8]]);
  }));

  return function getOrganizationUserTeamName(_x14) {
    return _ref16.apply(this, arguments);
  };
}();

var Loading = function Loading() {
  return /*#__PURE__*/React__default['default'].createElement("p", {
    className: styles$2.loading
  }, "loading");
};

var fetchRCTreeData = function fetchRCTreeData(_ref) {
  var response = _ref.response,
      department = _ref.department,
      showPosition = _ref.showPosition,
      departmentMapRef = _ref.departmentMapRef,
      _ref$disabledUserIds = _ref.disabledUserIds,
      disabledUserIds = _ref$disabledUserIds === void 0 ? [] : _ref$disabledUserIds,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'group' : _ref$mode,
      _ref$removable = _ref.removable,
      removable = _ref$removable === void 0 ? true : _ref$removable;
  return convertToRCTree(response, {
    department: department,
    showPosition: showPosition,
    isDisable: function isDisable(userId, isUser) {
      // can't click department when the mode is single.
      if (mode === 'single' && !isUser) return true;
      return disabledUserIds.includes(userId);
    },
    removable: removable,
    departmentMapRef: departmentMapRef
  });
};
var ContactTree = mobxReactLite.observer(function (_ref2) {
  var onClicked = _ref2.onClicked,
      onCheck = _ref2.onCheck,
      _ref2$showPosition = _ref2.showPosition,
      showPosition = _ref2$showPosition === void 0 ? true : _ref2$showPosition,
      _ref2$checkable = _ref2.checkable,
      checkable = _ref2$checkable === void 0 ? false : _ref2$checkable,
      defaultCheckedKeys = _ref2.defaultCheckedKeys,
      _ref2$disabledUserIds = _ref2.disabledUserIds,
      disabledUserIds = _ref2$disabledUserIds === void 0 ? [] : _ref2$disabledUserIds,
      _ref2$filteredUserIds = _ref2.filteredUserIds,
      filteredUserIds = _ref2$filteredUserIds === void 0 ? [] : _ref2$filteredUserIds,
      sessionData = _ref2.sessionData,
      moreTreeData = _ref2.moreTreeData,
      showMainTree = _ref2.showMainTree,
      showMyConversationTree = _ref2.showMyConversationTree,
      style = _ref2.style;
  var state = React.useContext(StateContext);

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _useState3 = React.useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      expandedKeys = _useState4[0],
      setExpandedKeys = _useState4[1];

  var loadedKeysRef = React.useRef([]); // department: has load the children data.

  var hasLoadedAllKeysRef = React.useRef([]); // department: has load all the children data.

  var departmentMapRef = React.useRef(new Map()); // key: dept_id, value: ContactTreeStore

  var allChildrenDataRef = React.useRef({
    users: [],
    depts: []
  });

  var _useState5 = React.useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      reRenderCount = _useState6[0],
      setReRenderCount = _useState6[1];

  var fetchSessionMembers = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(session) {
      var sessionId, _yield$getSessionMemb, members, user_ids, _yield$getOrganizatio, usersInfo, tree;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sessionId = session.id;
              _context.next = 3;
              return getSessionMembers({
                session_id: sessionId,
                member_type: 'user'
              }, {
                token: state.token,
                baseURL: state.baseURL
              });

            case 3:
              _yield$getSessionMemb = _context.sent;
              members = _yield$getSessionMemb.members;
              user_ids = members.filter(function (id) {
                return !filteredUserIds.includes(id);
              });

              if (!(user_ids.length === 0)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", {
                tree: []
              });

            case 8:
              _context.next = 10;
              return getOrganizationUserList({
                user_ids: user_ids
              }, {
                token: state.token,
                baseURL: state.baseURL
              });

            case 10:
              _yield$getOrganizatio = _context.sent;
              usersInfo = _yield$getOrganizatio.users;
              tree = convertToRCTreeFromConversation(usersInfo, {
                session: session,
                showPosition: showPosition,
                isDisable: function isDisable(userId) {
                  return disabledUserIds.includes(userId);
                },
                removable: true
              });
              getOrganizationUserPositions({
                user_ids: user_ids
              }, {
                token: state.token,
                baseURL: state.baseURL
              }).then(function (_ref4) {
                var positions = _ref4.positions;
                tree.forEach(function (item) {
                  var _positions$item$id$;

                  // TODO will be a bug if the first-level user has more than one department data.
                  var position = (_positions$item$id$ = positions[item.id][0]) === null || _positions$item$id$ === void 0 ? void 0 : _positions$item$id$.position;

                  if (position) {
                    item.setPosition(position);
                    item.setTitle(getTitle(item.titleString || '', position, true));
                  }
                });
                setReRenderCount(reRenderCount + 1);
              });
              return _context.abrupt("return", tree);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [filteredUserIds, showPosition, reRenderCount, disabledUserIds]);

  var fetchChildListData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(department) {
      var _response$child_users, _response$child_users2;

      var dept_id, response, tree, userIds;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dept_id = department.id;
              _context2.next = 3;
              return getOrganizationChildList({
                dept_id: dept_id
              }, {
                token: state.token,
                baseURL: state.baseURL
              });

            case 3:
              response = _context2.sent;
              response.child_users = ((_response$child_users = response.child_users) === null || _response$child_users === void 0 ? void 0 : _response$child_users.filter(function (user) {
                return !(filteredUserIds === null || filteredUserIds === void 0 ? void 0 : filteredUserIds.includes(user.id));
              })) || [];
              tree = fetchRCTreeData({
                response: {
                  users: response.child_users,
                  depts: response.child_depts
                },
                department: department,
                showPosition: showPosition,
                disabledUserIds: disabledUserIds,
                mode: !checkable ? 'single' : 'group',
                departmentMapRef: departmentMapRef
              }); // Counter-intuitive logic. First render the tree, then get the user location data, then replace the old tree.
              // This is because the API does not return both the tree data and the user location data.
              // It's two separate API.

              userIds = (_response$child_users2 = response.child_users) === null || _response$child_users2 === void 0 ? void 0 : _response$child_users2.map(function (user) {
                return user.id;
              });

              if (userIds && userIds.length) {
                getOrganizationUserPositions({
                  user_ids: userIds
                }, {
                  token: state.token,
                  baseURL: state.baseURL
                }).then(function (_ref6) {
                  var positions = _ref6.positions;
                  tree.forEach(function (item) {
                    if (!item.isUser) return;
                    var position = ''; // TODO will be a bug if the first-level user has more than one department data.

                    if (dept_id === 0) {
                      if (positions[item.id]) {
                        var _positions$item$id$2;

                        position = (_positions$item$id$2 = positions[item.id][0]) === null || _positions$item$id$2 === void 0 ? void 0 : _positions$item$id$2.position;
                      }
                    } else {
                      var _positions$item$id, _positions$item$id$fi;

                      position = (_positions$item$id = positions[item.id]) === null || _positions$item$id === void 0 ? void 0 : (_positions$item$id$fi = _positions$item$id.filter(function (dep) {
                        return dep.dept_id === dept_id;
                      })[0]) === null || _positions$item$id$fi === void 0 ? void 0 : _positions$item$id$fi.position;
                    }

                    if (position) {
                      item.setPosition(position);
                      item.setTitle(getTitle(item.titleString || '', position, true));
                    }
                  });
                  setReRenderCount(reRenderCount + 1);
                });
              }

              return _context2.abrupt("return", tree);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchChildListData(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var fetchAllChildrenDataOfTheDepartment = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(department) {
      var _response$users, _response$users2, _response$users3;

      var dept_id, response, map, flatData, findUsersAndDepts, tempUsers, result, stack, _loop, _ret, userIds;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dept_id = department.id;
              _context3.next = 3;
              return getOrganizationChildListAll({
                dept_id: dept_id
              }, {
                token: state.token,
                baseURL: state.baseURL
              });

            case 3:
              response = _context3.sent;
              loadedKeysRef.current = [].concat(_toConsumableArray(loadedKeysRef.current), [dept_id]); // unique the users.

              response.users = _toConsumableArray(tsBelt.A.uniqBy(((_response$users = response.users) === null || _response$users === void 0 ? void 0 : _response$users.filter(function (user) {
                return !(filteredUserIds === null || filteredUserIds === void 0 ? void 0 : filteredUserIds.includes(user.id));
              })) || [], function (user) {
                return user.id;
              }));
              allChildrenDataRef.current = {
                users: [].concat(_toConsumableArray(allChildrenDataRef.current.users), [response.users]),
                depts: [].concat(_toConsumableArray(allChildrenDataRef.current.depts), [response.depts])
              };
              map = new Map();
              flatData = [];

              findUsersAndDepts = function findUsersAndDepts(_department, _ref8) {
                var users = _ref8.users,
                    _ref8$depts = _ref8.depts,
                    depts = _ref8$depts === void 0 ? [] : _ref8$depts;
                var tree = fetchRCTreeData({
                  response: {
                    users: users,
                    depts: depts
                  },
                  department: _department,
                  showPosition: showPosition,
                  disabledUserIds: disabledUserIds,
                  mode: !checkable ? 'single' : 'group',
                  departmentMapRef: departmentMapRef
                });
                flatData = [].concat(_toConsumableArray(flatData), _toConsumableArray(tree));
                return tree;
              }; // Transform the flat structure to tree structure.


              tempUsers = (_response$users2 = response.users) === null || _response$users2 === void 0 ? void 0 : _response$users2.filter(function (user) {
                var _user$dept_ids;

                return (_user$dept_ids = user.dept_ids) === null || _user$dept_ids === void 0 ? void 0 : _user$dept_ids.includes(dept_id);
              });
              result = _toConsumableArray(findUsersAndDepts(department, {
                users: tempUsers
              }));
              stack = _toConsumableArray(response.depts || []);

              _loop = function _loop() {
                var _response$users4;

                var currentDepartment = stack[0]; // eslint-disable-next-line no-continue

                if (!currentDepartment) return "continue";
                var deptNode = findUsersAndDepts(department, {
                  depts: [currentDepartment]
                })[0];
                map.set(deptNode.id, deptNode);
                loadedKeysRef.current = [].concat(_toConsumableArray(loadedKeysRef.current), [deptNode.id]);
                var filterUsers = findUsersAndDepts(deptNode, {
                  users: (_response$users4 = response.users) === null || _response$users4 === void 0 ? void 0 : _response$users4.filter(function (user) {
                    var _user$dept_ids2;

                    return (_user$dept_ids2 = user.dept_ids) === null || _user$dept_ids2 === void 0 ? void 0 : _user$dept_ids2.includes(currentDepartment.id);
                  })
                });

                if ((currentDepartment === null || currentDepartment === void 0 ? void 0 : currentDepartment.parent_id) === dept_id) {
                  result.push(deptNode);

                  if (deptNode.children) {
                    deptNode.children = [].concat(_toConsumableArray(deptNode.children), _toConsumableArray(filterUsers));
                  } else {
                    deptNode.children = filterUsers;
                  }

                  stack.shift();
                } else if (_toConsumableArray(map.keys()).includes(currentDepartment.parent_id)) {
                  var parent = map.get(currentDepartment.parent_id);

                  if (parent.children) {
                    parent.children = [].concat(_toConsumableArray(parent.children), [deptNode]);
                  } else {
                    parent.children = [deptNode];
                  }

                  if (deptNode.children) {
                    deptNode.children = [].concat(_toConsumableArray(deptNode.children), _toConsumableArray(filterUsers));
                  } else {
                    deptNode.children = filterUsers;
                  }

                  stack.shift();
                }
              };

            case 14:
              if (!stack.length) {
                _context3.next = 20;
                break;
              }

              _ret = _loop();

              if (!(_ret === "continue")) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt("continue", 14);

            case 18:
              _context3.next = 14;
              break;

            case 20:
              userIds = (_response$users3 = response.users) === null || _response$users3 === void 0 ? void 0 : _response$users3.map(function (user) {
                return user.id;
              });

              if (userIds && userIds.length) {
                getOrganizationUserPositions({
                  user_ids: userIds
                }, {
                  token: state.token,
                  baseURL: state.baseURL
                }).then(function (_ref9) {
                  var positions = _ref9.positions;
                  flatData.forEach(function (item) {
                    if (!item.isUser) return;
                    var position = '';

                    if (positions[item.id]) {
                      var _positions$item$id$fi2;

                      position = (_positions$item$id$fi2 = positions[item.id].filter(function (dep) {
                        var _item$parent;

                        return dep.dept_id === ((_item$parent = item.parent) === null || _item$parent === void 0 ? void 0 : _item$parent.id);
                      })[0]) === null || _positions$item$id$fi2 === void 0 ? void 0 : _positions$item$id$fi2.position;
                    }

                    if (position) {
                      item.setPosition(position);
                      item.setTitle(getTitle(item.titleString || '', position, true));
                    }
                  });
                  setReRenderCount(reRenderCount + 1);
                });
              }

              return _context3.abrupt("return", {
                tree: result,
                flatData: flatData
              });

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchAllChildrenDataOfTheDepartment(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();

  var hasLoaded = function hasLoaded(departmentId, node) {
    if (node.isUser) return true;

    var judge = function judge(id) {
      return hasLoadedAllKeysRef.current.includes(id);
    };

    var loadMyself = judge(departmentId);
    if (loadMyself) return true;
    var loadParent = judge(node.dept_ids[0]);
    if (loadParent) return true;
    var done = false;
    var parentId = node.dept_ids[0];
    var status = false;

    while (!done) {
      var tempNode = departmentMapRef.current.get(parentId);

      if (tempNode === undefined) {
        done = true;
        break;
      }

      var load = judge(tempNode.dept_ids[0]);

      if (load) {
        done = true;
        status = true;
        break;
      } // eslint-disable-next-line prefer-destructuring


      parentId = tempNode.dept_ids[0];
    }

    return status;
  };

  var onLoadData = function onLoadData(treeNode) {
    var _treeNode$children;

    // Fix wired bug. Prevent load duplicate data in CreateSession Dialog mode.
    if (loadedKeysRef.current.includes(treeNode.id)) {
      return Promise.resolve();
    }

    if (((_treeNode$children = treeNode.children) === null || _treeNode$children === void 0 ? void 0 : _treeNode$children.length) !== 0) {
      loadedKeysRef.current = [].concat(_toConsumableArray(loadedKeysRef.current), [treeNode.id]);
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var folder, newData, targetNode;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                folder = treeNode; // It has children already. no need to fetch children data anymore.

                if (!(folder.id === MY_CONVERSATIONS_KEY)) {
                  _context4.next = 4;
                  break;
                }

                resolve();
                return _context4.abrupt("return");

              case 4:
                if (!(folder.belongTo === MY_CONVERSATIONS_KEY)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return fetchSessionMembers(folder);

              case 7:
                newData = _context4.sent;
                _context4.next = 13;
                break;

              case 10:
                _context4.next = 12;
                return fetchChildListData(folder);

              case 12:
                newData = _context4.sent;

              case 13:
                targetNode = departmentMapRef.current.get(folder.id);
                targetNode.children = newData; // // If the fetched children is all loaded by the initial data,
                // // set the folder as loaded.
                // const IsTheChildrenAllLoaded = (children: ContactTreeStore[]) => {
                //   return children.every((value) => disabledUserIds?.includes(value.id as string));
                // };
                // if(IsTheChildrenAllLoaded(newData) && onCheck) {
                //   onCheck([folder]);
                // }
                // P.S. This is not a bug.

                setTreeData(_toConsumableArray(treeData));
                loadedKeysRef.current = [].concat(_toConsumableArray(loadedKeysRef.current), [treeNode.id]);
                resolve();

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    });
  };

  var onExpand = function onExpand(keys) {
    setExpandedKeys(keys);
  };

  var onCheckHandler = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(checkedKeys, e) {
      var node, checked, departmentId, targetNode, tree, _yield$fetchAllChildr, allChildrenDataTree, flatData;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              node = e.node, checked = e.checked;
              departmentId = node.id;

              if (onCheck) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return");

            case 4:
              targetNode = departmentMapRef.current.get(node.id);

              if (!(node.belongTo === MY_CONVERSATIONS_KEY)) {
                _context5.next = 16;
                break;
              }

              if (!(state.mode !== 'forward' && !node.isUser && node.children.length === 0)) {
                _context5.next = 14;
                break;
              }

              _context5.next = 9;
              return fetchSessionMembers(node);

            case 9:
              tree = _context5.sent;
              targetNode.children = tree;
              setReRenderCount(reRenderCount + 1);
              onCheck([].concat(_toConsumableArray(e.checkedNodes), _toConsumableArray(tree)), e);
              return _context5.abrupt("return");

            case 14:
              onCheck(e.checkedNodes, e);
              return _context5.abrupt("return");

            case 16:
              if (!(node.belongTo === FROM_JSON_DATA || hasLoaded(departmentId, node))) {
                _context5.next = 19;
                break;
              }

              onCheck(e.checkedNodes, e);
              return _context5.abrupt("return");

            case 19:
              _context5.next = 21;
              return fetchAllChildrenDataOfTheDepartment(node);

            case 21:
              _yield$fetchAllChildr = _context5.sent;
              allChildrenDataTree = _yield$fetchAllChildr.tree;
              flatData = _yield$fetchAllChildr.flatData;
              targetNode.children = allChildrenDataTree;
              setReRenderCount(reRenderCount + 1);
              hasLoadedAllKeysRef.current = [].concat(_toConsumableArray(hasLoadedAllKeysRef.current), [departmentId]);
              onCheck([].concat(_toConsumableArray(e.checkedNodes), _toConsumableArray(flatData.filter(function (item) {
                return item.isUser;
              }))), e);

            case 28:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function onCheckHandler(_x4, _x5) {
      return _ref11.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    setTreeData(treeData.concat([])); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reRenderCount]);
  React.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var _yield$getOrganizatio2, rootName, initTreeData, rootNode, tree, root, myConversationsRoot, myConversations, moreTree;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return getOrganizationUserTeamName({
                token: state.token,
                baseURL: state.baseURL
              });

            case 2:
              _yield$getOrganizatio2 = _context6.sent;
              rootName = _yield$getOrganizatio2.name;
              initTreeData = [];

              if (!showMainTree) {
                _context6.next = 13;
                break;
              }

              rootNode = new ContactTreeStore({
                id: 0,
                key: 0,
                title: rootName,
                titleString: rootName,
                children: [],
                isUser: false,
                isRootOrg: true,
                icon: /*#__PURE__*/React__default['default'].createElement(Avatar, {
                  isUser: false,
                  isRootOrg: true
                }),
                disabled: !checkable,
                checkable: false,
                setPosition: function setPosition() {},
                setTitle: function setTitle() {}
              });
              _context6.next = 9;
              return fetchChildListData(rootNode);

            case 9:
              tree = _context6.sent;
              rootNode.children = tree;
              root = new ContactTreeStore(rootNode);
              initTreeData.push(root);

            case 13:
              if (showMyConversationTree && checkable) {
                myConversationsRoot = new ContactTreeStore({
                  children: [],
                  id: MY_CONVERSATIONS_KEY,
                  key: MY_CONVERSATIONS_KEY,
                  title: MY_CONVERSATIONS_KEY,
                  titleString: MY_CONVERSATIONS_KEY,
                  isUser: false,
                  isRootOrg: true,
                  icon: /*#__PURE__*/React__default['default'].createElement(Avatar, {
                    isUser: false,
                    isRootOrg: true
                  }),
                  disabled: false,
                  checkable: false
                });
                myConversations = convertToRCTreeFromConversation(sessionData.filter(function (item) {
                  return item.type === 'group';
                }), {
                  session: myConversationsRoot,
                  showPosition: showPosition,
                  isDisable: function isDisable(userId) {
                    return disabledUserIds.includes(userId);
                  },
                  departmentMapRef: departmentMapRef,
                  removable: state.mode === 'forward',
                  mode: state.mode
                });
                myConversationsRoot.children = myConversations;
                initTreeData.push(myConversationsRoot);
              }

              if (moreTreeData && moreTreeData.length) {
                moreTree = covertFromNormalJSON(moreTreeData, {
                  removable: true,
                  isDisable: function isDisable(userId) {
                    return disabledUserIds.includes(userId);
                  }
                });
                moreTree.forEach(function (item) {
                  item.checkable = false;
                });
                initTreeData.push.apply(initTreeData, _toConsumableArray(moreTree));
              }

              if (showMainTree) {
                setExpandedKeys([0]);
                loadedKeysRef.current = [0];
              }

              setTreeData(initTreeData);

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [sessionData]);
  return treeData.length ? /*#__PURE__*/React__default['default'].createElement(Tree__default['default'], {
    checkable: checkable,
    selectable: !checkable,
    defaultExpandAll: false,
    motion: motion,
    treeData: treeData,
    loadData: onLoadData,
    switcherIcon: switcherIcon,
    onSelect: onClicked,
    onCheck: onCheckHandler,
    checkedKeys: defaultCheckedKeys,
    expandedKeys: expandedKeys,
    onExpand: onExpand,
    className: "contact-tree",
    style: style
  }) : /*#__PURE__*/React__default['default'].createElement(Loading, null);
});
ContactTree.displayName = 'ContactTree';

var CloseIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAWFJREFUaEPtmM0NgkAQhXehCiow0aMV2IIFeIRQEYGjBdiCFXjUxAqsAtZgJDGEn9n5QTeORzI7vO89dha0JvCfDVy/UYBvJ6gJaAJEB/QRIhpIXq4JkC0kNvi/BNI0PVprt1EU7YuiuBMNfC3P83zVNM3JOXepqurg09M7gSzLrs65tTHmEcfxjgrRiq/r+myMSay1t7IsN6IAnzekQnD08k6gi7xzDQvBIb7VggKgQnCJJwFgITjFkwF8IbjFswBAISTEswHMQUiJZwUYg2ivUyfW1LmAnkJjTftuv+sS7LidO9TYAQaSaC+xnNpDMArQdyXoR2ho2gSziadG5c+PUYhASM3cxBHZxD7CfGqhMKQphBGEWSNykFGEUNb2YVAJcAjg6IF6F+K68dwLoNgeCP6jPvi/VaDRLlWH2sRLiYPcRwEgLknWaAKS7kJ6awIQlyRrNAFJdyG9NQGIS5I1T16jgEC5yhXpAAAAAElFTkSuQmCC";

var useActiveSessionsData = function useActiveSessionsData(showMyConversationTree) {
  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var state = React.useContext(StateContext);
  React.useEffect(function () {
    getSessionList({
      token: state.token,
      baseURL: state.baseURL
    }).then(function (list) {
      setData(list);
    });
  }, []);
  if (!showMyConversationTree) return data;
  return data;
};
var useUsersData = function useUsersData(userIds) {
  var _useState3 = React.useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var state = React.useContext(StateContext);
  React.useEffect(function () {
    if (!userIds) return;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _state$initInfo, list, checkedNodes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getUsersInfo(userIds, {
                token: state.token,
                baseURL: state.baseURL
              });

            case 3:
              list = _context.sent;
              checkedNodes = fetchRCTreeData({
                response: {
                  users: list
                },
                showPosition: false,
                removable: !!((_state$initInfo = state.initInfo) === null || _state$initInfo === void 0 ? void 0 : _state$initInfo.removable) // default is false

              });
              setData(checkedNodes);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }))();
  }, []);
  return [data, setData];
};
var useSize = function useSize(target) {
  var _useState5 = React.useState({
    width: 376
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      size = _useState6[0],
      setSize = _useState6[1];

  useResizeObserver__default['default'](target, function (entry) {
    // P.S. 很怪异，Observer 的 entry.contentRect 返回的 width 是子元素内容的宽度，而不是容器的宽度。
    // 所里这里手动获取容易宽度。
    var newSize = entry.target.getBoundingClientRect();
    if (!size || !newSize) return;

    if (newSize.width > size.width) {
      setSize(function (_size) {
        setSize(newSize);
      });
    }
  });
  return size;
};

var ContactsForm = mobxReactLite.observer(function (_ref) {
  var onConfirm = _ref.onConfirm,
      onClose = _ref.onClose,
      mode = _ref.mode,
      initInfo = _ref.initInfo,
      currentUserInfo = _ref.currentUserInfo,
      moreTreeData = _ref.moreTreeData,
      token = _ref.token,
      _ref$showMainTree = _ref.showMainTree,
      showMainTree = _ref$showMainTree === void 0 ? true : _ref$showMainTree,
      _ref$showMyConversati = _ref.showMyConversationTree,
      showMyConversationTree = _ref$showMyConversati === void 0 ? true : _ref$showMyConversati,
      _ref$disabledUserIds = _ref.disabledUserIds,
      disabledUserIds = _ref$disabledUserIds === void 0 ? [] : _ref$disabledUserIds,
      _ref$filteredUserIds = _ref.filteredUserIds,
      filteredUserIds = _ref$filteredUserIds === void 0 ? [] : _ref$filteredUserIds;
  var boxRef = React.useRef(null);
  var size = useSize(boxRef);

  var _useLocaleReceiver = useLocaleReceiver('Selector'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var sessionData = useActiveSessionsData(showMyConversationTree);

  var _useUsersData = useUsersData(initInfo === null || initInfo === void 0 ? void 0 : initInfo.userIds),
      _useUsersData2 = _slicedToArray(_useUsersData, 2),
      checkedNodes = _useUsersData2[0],
      setCheckedNodes = _useUsersData2[1];

  var currentUserCheckedNodes = [];

  if (currentUserInfo) {
    currentUserCheckedNodes = fetchRCTreeData({
      response: {
        users: [currentUserInfo]
      },
      showPosition: false,
      removable: false
    });
  } // merge has checked nodes, if exists, with current user node.


  var initCheckedNodes = checkedNodes.length ? currentUserCheckedNodes.concat(checkedNodes) : currentUserCheckedNodes;

  var onCheck = function onCheck(checkedNodesData, node) {
    var baseNodes = initCheckedNodes.filter(function (user) {
      return initInfo === null || initInfo === void 0 ? void 0 : initInfo.userIds.includes(user.id);
    });
    var newCheckedNodes = [].concat(_toConsumableArray(baseNodes), _toConsumableArray(checkedNodesData));

    if (!node.checked) {
      newCheckedNodes = newCheckedNodes.filter(function (user) {
        return user.id !== node.node.id;
      });
    }

    setCheckedNodes(newCheckedNodes);
  }; // select/unselect node when clicks on node item itself.


  var onClicked = function onClicked(selectedKeys, info) {
    var node = info.node;

    if (mode === 'single') {
      setCheckedNodes(node.isUser ? [node] : []);
    }
  }; // collects the id of the target's grandparent or grandparent or grand-grandparent ...


  var fetchGrandParentIds = function fetchGrandParentIds(target) {
    var ids = [target.id];
    var parent = target.parent;

    while (parent) {
      ids.push(parent.id);
      parent = parent.parent;
    }

    return ids;
  };

  var onRemove = function onRemove(target) {
    // remove node itself and it's parent or grandparent or grand-grandparent... department node.
    var newCheckedKeys = checkedNodes.filter(function (node) {
      return node.id !== target.id && !fetchGrandParentIds(target).includes(node.id);
    }); // Is the rest of the nodes are all department nodes?
    // remove them also.

    var restNodes = newCheckedKeys.filter(function (_ref2) {
      var isUser = _ref2.isUser;
      return !isUser;
    }); // +1: there is a myself node.

    if (restNodes.length + 1 === newCheckedKeys.length) {
      newCheckedKeys = newCheckedKeys.filter(function (_ref3) {
        var isUser = _ref3.isUser;
        return isUser;
      });
    }

    setCheckedNodes(newCheckedKeys);
  };

  var getRightColumns = function getRightColumns() {
    if (!checkedNodes || !checkedNodes.length) return null;
    var filterCheckedNodes = tsBelt.A.uniqBy(checkedNodes.filter(function (_ref4) {
      var isUser = _ref4.isUser;
      return isUser;
    }), function (user) {
      return user.id;
    });
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles$1.count
    }, "Selected: ", filterCheckedNodes === null || filterCheckedNodes === void 0 ? void 0 : filterCheckedNodes.length, ' ', mode === 'forward' ? 'chat' : 'member', "(s)"), filterCheckedNodes.map(function (node) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        key: node.id,
        className: styles$1.checkedNode
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: styles$1.flex
      }, /*#__PURE__*/React__default['default'].createElement("div", null, node.icon), /*#__PURE__*/React__default['default'].createElement("div", null, node.title)), node.removable && /*#__PURE__*/React__default['default'].createElement("img", {
        src: CloseIcon,
        className: styles$1.remove,
        onClick: function onClick() {
          return onRemove(node);
        }
      }));
    }));
  };

  var onCreate = function onCreate() {
    var uniqCheckedNodes = tsBelt.A.uniqBy(checkedNodes, function (user) {
      return user.id;
    });

    if (!uniqCheckedNodes || !uniqCheckedNodes.length) {
      // TODO show warning dialog.
      return;
    }

    if (mode === 'single') {
      if (uniqCheckedNodes.length) {
        var members = uniqCheckedNodes.filter(function (_ref5) {
          var id = _ref5.id;
          return currentUserInfo ? id !== currentUserInfo.id : true;
        });
        onConfirm(members.length ? members : []);
      }

      return;
    } // create group session logic below.


    var newUsers = uniqCheckedNodes.filter(function (_ref6) {
      var id = _ref6.id;
      return currentUserInfo ? id !== currentUserInfo.id : true;
    }) // filter myself
    .filter(function (_ref7) {
      var isUser = _ref7.isUser;
      return isUser;
    }); // .map(({ id }) => id as string);

    onConfirm(newUsers);
  };

  var isConfirmButtonDisabled = function isConfirmButtonDisabled() {
    if (mode === 'group') {
      var notOnlyMyself = checkedNodes.filter(function (_ref8) {
        var id = _ref8.id;
        return currentUserInfo ? id !== currentUserInfo.id : true;
      }).length;
      return !notOnlyMyself;
    }

    var isMyself = checkedNodes.filter(function (_ref9) {
      var id = _ref9.id;
      return currentUserInfo ? id === currentUserInfo.id : true;
    }).length;
    return !!isMyself;
  };

  var visible = !showMyConversationTree || showMyConversationTree && !!sessionData.length;
  var newDisabledUserIds = disabledUserIds;

  if ((initInfo === null || initInfo === void 0 ? void 0 : initInfo.removable) === false) {
    newDisabledUserIds = [].concat(_toConsumableArray(newDisabledUserIds), _toConsumableArray(initInfo === null || initInfo === void 0 ? void 0 : initInfo.userIds));
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles$1.selectorContainer
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    ref: boxRef,
    className: "".concat(styles$1.left, " ").concat(mode === 'single' && styles$1.full),
    style: {
      minWidth: (size === null || size === void 0 ? void 0 : size.width) || 'auto'
    }
  }, /*#__PURE__*/React__default['default'].createElement(ContactTree, {
    checkable: mode !== 'single',
    onCheck: onCheck,
    onClicked: onClicked,
    showPosition: false,
    defaultCheckedKeys: initCheckedNodes.map(function (node) {
      return node.key;
    }),
    disabledUserIds: newDisabledUserIds,
    filteredUserIds: filteredUserIds,
    sessionData: sessionData,
    moreTreeData: moreTreeData,
    token: token,
    showMainTree: showMainTree,
    showMyConversationTree: showMyConversationTree
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(styles$1.right, " ").concat(mode === 'single' && 'hidden'),
    style: {
      minWidth: (size === null || size === void 0 ? void 0 : size.width) || 'auto'
    }
  }, getRightColumns())), /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles$1.footer
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: onClose
  }, locale.cancel), /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: styles$1.confirm,
    onClick: onCreate,
    disabled: isConfirmButtonDisabled()
  }, mode === 'single' ? locale.openChat : locale.confirm)));
});
ContactsForm.displayName = 'ContactsForm';

var SelectorContent = function SelectorContent(props) {
  return /*#__PURE__*/React__default['default'].createElement(StateContext.Provider, {
    value: props
  }, /*#__PURE__*/React__default['default'].createElement(ContactsForm, _objectSpread2({}, props)));
};
SelectorContent.displayName = 'SelectorContent';

var css_248z$7 = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-loading {\n  display: block;\n  padding: 20px;\n  text-align: center;\n}\n.ant-spin-nested-loading {\n  position: inherit;\n}\n.ant-spin-nested-loading .ant-spin-container {\n  position: inherit;\n}\n";
styleInject(css_248z$7);

var Loading$1 = function Loading(_ref) {
  var title = _ref.title,
      loading = _ref.loading,
      children = _ref.children;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('loading');
  return /*#__PURE__*/React__default['default'].createElement(_Spin__default['default'], {
    className: prefixCls,
    tip: title,
    spinning: loading
  }, children);
};

var SearchSvg = function SearchSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(-53.000000, -134.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(53.000000, 134.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18.031,16.617 L21.6064174,20.1915826 C21.9971589,20.5822328 21.9972328,21.2156759 21.6065826,21.6064174 C21.6065551,21.6064449 21.6065275,21.6064725 21.6065,21.6065 C21.2158042,21.9971958 20.582361,21.9971958 20.1916652,21.6065 C20.1916377,21.6064725 20.1916101,21.6064449 20.1915826,21.6064174 L16.617,18.031 L16.617,18.031 C15.0237382,19.3082211 13.0420011,20.0029052 11,20 C6.032,20 2,15.968 2,11 C2,6.032 6.032,2 11,2 C15.968,2 20,6.032 20,11 C20.0029052,13.0420011 19.3082211,15.0237382 18.031,16.617 Z M16.025,15.875 C17.2941129,14.5698857 18.002867,12.8204293 18,11 C18,7.132 14.867,4 11,4 C7.132,4 4,7.132 4,11 C4,14.867 7.132,18 11,18 C12.8204293,18.002867 14.5698857,17.2941129 15.875,16.025 L16.025,15.875 L16.025,15.875 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
};


var TriangleArrowSvg = function TriangleArrowSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(-53.000000, -110.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(53.000000, 110.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.64644661,10.3131133 L4.85355339,7.52022006 C4.65829124,7.32495791 4.65829124,7.00837542 4.85355339,6.81311328 C4.94732158,6.71934509 5.07449854,6.66666667 5.20710678,6.66666667 L10.7928932,6.66666667 C11.0690356,6.66666667 11.2928932,6.89052429 11.2928932,7.16666667 C11.2928932,7.29927491 11.2402148,7.42645187 11.1464466,7.52022006 L8.35355339,10.3131133 C8.15829124,10.5083754 7.84170876,10.5083754 7.64644661,10.3131133 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
};
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: SearchSvg
  }, props));
};
var TriangleArrowIcon = function TriangleArrowIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: TriangleArrowSvg
  }, props));
};

var OrganizationSvg = function OrganizationSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "drive",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-187.000000, -317.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(187.000000, 317.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.5,2.5 C12.96,2.5 13.3333333,2.87333333 13.3333333,3.33333333 L13.3333333,6.66666667 C13.3333333,7.12666667 12.96,7.5 12.5,7.5 L10.8333333,7.5 L10.8333333,9.16666667 L14.1666667,9.16666667 C14.6266667,9.16666667 15,9.54 15,10 L15,12.5 L16.6666667,12.5 C17.1266667,12.5 17.5,12.8733333 17.5,13.3333333 L17.5,16.6666667 C17.5,17.1266667 17.1266667,17.5 16.6666667,17.5 L11.6666667,17.5 C11.2066667,17.5 10.8333333,17.1266667 10.8333333,16.6666667 L10.8333333,13.3333333 C10.8333333,12.8733333 11.2066667,12.5 11.6666667,12.5 L13.3333333,12.5 L13.3333333,10.8333333 L6.66666667,10.8333333 L6.66666667,12.5 L8.33333333,12.5 C8.79333333,12.5 9.16666667,12.8733333 9.16666667,13.3333333 L9.16666667,16.6666667 C9.16666667,17.1266667 8.79333333,17.5 8.33333333,17.5 L3.33333333,17.5 C2.87333333,17.5 2.5,17.1266667 2.5,16.6666667 L2.5,13.3333333 C2.5,12.8733333 2.87333333,12.5 3.33333333,12.5 L5,12.5 L5,10 C5,9.54 5.37333333,9.16666667 5.83333333,9.16666667 L9.16666667,9.16666667 L9.16666667,7.5 L7.5,7.5 C7.04,7.5 6.66666667,7.12666667 6.66666667,6.66666667 L6.66666667,3.33333333 C6.66666667,2.87333333 7.04,2.5 7.5,2.5 L12.5,2.5 Z M7.5,14.1666667 L4.16666667,14.1666667 L4.16666667,15.8333333 L7.5,15.8333333 L7.5,14.1666667 Z M15.8333333,14.1666667 L12.5,14.1666667 L12.5,15.8333333 L15.8333333,15.8333333 L15.8333333,14.1666667 Z M11.6666667,4.16666667 L8.33333333,4.16666667 L8.33333333,5.83333333 L11.6666667,5.83333333 L11.6666667,4.16666667 Z",
    id: "\\u5F62\\u72B6",
    fill: "#9FA2A8",
    fillRule: "nonzero"
  }))))));
};

var OrganizationIcon = function OrganizationIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: OrganizationSvg
  }, props));
};

var ShareLockSvg = function ShareLockSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5.33333C6.5 3.85001 7.97777 2.5 10 2.5C12.0222 2.5 13.5 3.85001 13.5 5.33333V7.5H6.5V5.33333ZM5.5 7.5V5.33333C5.5 3.13475 7.60395 1.5 10 1.5C12.396 1.5 14.5 3.13475 14.5 5.33333V7.5H15.4444C16.6033 7.5 17.5 8.48065 17.5 9.63636V15.3636C17.5 16.5194 16.6033 17.5 15.4444 17.5H15.4195H15.3947H15.3699H15.3451H15.3204H15.2957H15.2711H15.2465H15.2219H15.1974H15.1729H15.1485H15.1241H15.0997H15.0754H15.0511H15.0269H15.0027H14.9786H14.9544H14.9304H14.9063H14.8823H14.8584H14.8345H14.8106H14.7867H14.7629H14.7392H14.7154H14.6918H14.6681H14.6445H14.6209H14.5974H14.5739H14.5504H14.527H14.5036H14.4802H14.4569H14.4336H14.4104H14.3871H14.364H14.3408H14.3177H14.2946H14.2716H14.2486H14.2256H14.2027H14.1798H14.1569H14.1341H14.1113H14.0885H14.0658H14.0431H14.0204H13.9978H13.9752H13.9526H13.9301H13.9076H13.8851H13.8627H13.8402H13.8179H13.7955H13.7732H13.7509H13.7287H13.7064H13.6842H13.6621H13.6399H13.6178H13.5958H13.5737H13.5517H13.5297H13.5078H13.4858H13.4639H13.4421H13.4202H13.3984H13.3766H13.3549H13.3331H13.3114H13.2898H13.2681H13.2465H13.2249H13.2033H13.1818H13.1603H13.1388H13.1173H13.0959H13.0745H13.0531H13.0317H13.0104H12.9891H12.9678H12.9465H12.9253H12.9041H12.8829H12.8617H12.8406H12.8195H12.7984H12.7773H12.7563H12.7353H12.7143H12.6933H12.6723H12.6514H12.6305H12.6096H12.5887H12.5679H12.5471H12.5263H12.5055H12.4847H12.464H12.4433H12.4226H12.4019H12.3813H12.3606H12.34H12.3194H12.2988H12.2783H12.2577H12.2372H12.2167H12.1962H12.1758H12.1553H12.1349H12.1145H12.0941H12.0737H12.0534H12.033H12.0127H11.9924H11.9721H11.9519H11.9316H11.9114H11.8911H11.8709H11.8508H11.8306H11.8104H11.7903H11.7702H11.75H11.7299H11.7099H11.6898H11.6697H11.6497H11.6297H11.6097H11.5897H11.5697H11.5497H11.5298H11.5098H11.4899H11.47H11.4501H11.4302H11.4103H11.3904H11.3706H11.3507H11.3309H11.311H11.2912H11.2714H11.2516H11.2319H11.2121H11.1923H11.1726H11.1528H11.1331H11.1134H11.0937H11.074H11.0543H11.0346H11.0149H10.9953H10.9756H10.956H10.9363H10.9167H10.8971H10.8775H10.8579H10.8383H10.8187H10.7991H10.7795H10.7599H10.7404H10.7208H10.7012H10.6817H10.6622H10.6426H10.6231H10.6036H10.584H10.5645H10.545H10.5255H10.506H10.4865H10.467H10.4475H10.428H10.4086H10.3891H10.3696H10.3501H10.3307H10.3112H10.2917H10.2723H10.2528H10.2334H10.2139H10.1945H10.175H10.1556H10.1361H10.1167H10.0972H10.0778H10.0583H10.0389H10.0194H10H9.98056H9.96111H9.94167H9.92223H9.90278H9.88334H9.86389H9.84444H9.82499H9.80554H9.78609H9.76664H9.74718H9.72772H9.70826H9.6888H9.66933H9.64987H9.63039H9.61092H9.59144H9.57196H9.55247H9.53299H9.51349H9.494H9.47449H9.45499H9.43548H9.41596H9.39644H9.37691H9.35738H9.33785H9.3183H9.29876H9.2792H9.25964H9.24008H9.2205H9.20092H9.18134H9.16174H9.14214H9.12253H9.10292H9.08329H9.06366H9.04402H9.02437H9.00472H8.98505H8.96538H8.9457H8.92601H8.90631H8.8866H8.86688H8.84715H8.82741H8.80766H8.7879H8.76814H8.74836H8.72857H8.70876H8.68895H8.66913H8.64929H8.62945H8.60959H8.58972H8.56984H8.54994H8.53004H8.51012H8.49019H8.47024H8.45028H8.43031H8.41033H8.39033H8.37032H8.3503H8.33026H8.3102H8.29013H8.27005H8.24996H8.22984H8.20972H8.18957H8.16942H8.14924H8.12906H8.10885H8.08863H8.06839H8.04814H8.02787H8.00758H7.98728H7.96696H7.94662H7.92627H7.9059H7.8855H7.8651H7.84467H7.82423H7.80376H7.78328H7.76278H7.74226H7.72173H7.70117H7.68059H7.66H7.63938H7.61875H7.59809H7.57741H7.55672H7.536H7.51526H7.4945H7.47373H7.45293H7.4321H7.41126H7.39039H7.36951H7.3486H7.32767H7.30671H7.28574H7.26474H7.24372H7.22267H7.2016H7.18051H7.1594H7.13826H7.11709H7.09591H7.0747H7.05346H7.0322H7.01092H6.98961H6.96827H6.94691H6.92553H6.90412H6.88268H6.86122H6.83973H6.81821H6.79667H6.77511H6.75351H6.73189H6.71024H6.68857H6.66686H6.64513H6.62338H6.60159H6.57977H6.55793H6.53606H6.51416H6.49223H6.47028H6.44829H6.42628H6.40423H6.38216H6.36005H6.33792H6.31576H6.29356H6.27134H6.24908H6.2268H6.20448H6.18213H6.15975H6.13734H6.1149H6.09243H6.06992H6.04738H6.02481H6.00221H5.97958H5.95691H5.93421H5.91147H5.88871H5.86591H5.84307H5.8202H5.7973H5.77437H5.7514H5.72839H5.70535H5.68228H5.65917H5.63603H5.61285H5.58964H5.56639H5.5431H5.51978H5.49642H5.47303H5.4496H5.42613H5.40263H5.37909H5.35551H5.33189H5.30824H5.28455H5.26083H5.23706H5.21326H5.18941H5.16553H5.14162H5.11766H5.09366H5.06963H5.04555H5.02144H4.99728H4.97309H4.94886H4.92458H4.90027H4.87592H4.85152H4.82708H4.80261H4.77809H4.75353H4.72893H4.70429H4.67961H4.65488H4.63011H4.6053H4.58045H4.55556C3.39674 17.5 2.5 16.5194 2.5 15.3636V9.63636C2.5 8.48065 3.39674 7.5 4.55556 7.5H5.5ZM14 8.5H6H4.55556C3.99615 8.5 3.5 8.9846 3.5 9.63636V15.3636C3.5 16.0154 3.99615 16.5 4.55556 16.5H4.58045H4.6053H4.63011H4.65488H4.67961H4.70429H4.72893H4.75353H4.77809H4.80261H4.82708H4.85152H4.87592H4.90027H4.92458H4.94886H4.97309H4.99728H5.02144H5.04555H5.06963H5.09366H5.11766H5.14162H5.16553H5.18941H5.21326H5.23706H5.26083H5.28455H5.30824H5.33189H5.35551H5.37909H5.40263H5.42613H5.4496H5.47303H5.49642H5.51978H5.5431H5.56639H5.58964H5.61285H5.63603H5.65917H5.68228H5.70535H5.72839H5.7514H5.77437H5.7973H5.8202H5.84307H5.86591H5.88871H5.91147H5.93421H5.95691H5.97958H6.00221H6.02481H6.04738H6.06992H6.09243H6.1149H6.13734H6.15975H6.18213H6.20448H6.2268H6.24908H6.27134H6.29356H6.31576H6.33792H6.36005H6.38216H6.40423H6.42628H6.44829H6.47028H6.49223H6.51416H6.53606H6.55793H6.57977H6.60159H6.62338H6.64513H6.66686H6.68857H6.71024H6.73189H6.75351H6.77511H6.79667H6.81821H6.83973H6.86122H6.88268H6.90412H6.92553H6.94691H6.96827H6.98961H7.01092H7.0322H7.05346H7.0747H7.09591H7.11709H7.13826H7.1594H7.18051H7.2016H7.22267H7.24372H7.26474H7.28574H7.30671H7.32767H7.3486H7.36951H7.39039H7.41126H7.4321H7.45293H7.47373H7.4945H7.51526H7.536H7.55672H7.57741H7.59809H7.61875H7.63938H7.66H7.68059H7.70117H7.72173H7.74226H7.76278H7.78328H7.80376H7.82423H7.84467H7.8651H7.8855H7.9059H7.92627H7.94662H7.96696H7.98728H8.00758H8.02787H8.04814H8.06839H8.08863H8.10885H8.12906H8.14924H8.16942H8.18957H8.20972H8.22984H8.24996H8.27005H8.29013H8.3102H8.33026H8.3503H8.37032H8.39033H8.41033H8.43031H8.45028H8.47024H8.49019H8.51012H8.53004H8.54994H8.56984H8.58972H8.60959H8.62945H8.64929H8.66913H8.68895H8.70876H8.72857H8.74836H8.76814H8.7879H8.80766H8.82741H8.84715H8.86688H8.8866H8.90631H8.92601H8.9457H8.96538H8.98505H9.00472H9.02437H9.04402H9.06366H9.08329H9.10292H9.12253H9.14214H9.16174H9.18134H9.20092H9.2205H9.24008H9.25964H9.2792H9.29876H9.3183H9.33785H9.35738H9.37691H9.39644H9.41596H9.43548H9.45499H9.47449H9.494H9.51349H9.53299H9.55247H9.57196H9.59144H9.61092H9.63039H9.64987H9.66933H9.6888H9.70826H9.72772H9.74718H9.76664H9.78609H9.80554H9.82499H9.84444H9.86389H9.88334H9.90278H9.92223H9.94167H9.96111H9.98056H10H10.0194H10.0389H10.0583H10.0778H10.0972H10.1167H10.1361H10.1556H10.175H10.1945H10.2139H10.2334H10.2528H10.2723H10.2917H10.3112H10.3307H10.3501H10.3696H10.3891H10.4086H10.428H10.4475H10.467H10.4865H10.506H10.5255H10.545H10.5645H10.584H10.6036H10.6231H10.6426H10.6622H10.6817H10.7012H10.7208H10.7404H10.7599H10.7795H10.7991H10.8187H10.8383H10.8579H10.8775H10.8971H10.9167H10.9363H10.956H10.9756H10.9953H11.0149H11.0346H11.0543H11.074H11.0937H11.1134H11.1331H11.1528H11.1726H11.1923H11.2121H11.2319H11.2516H11.2714H11.2912H11.311H11.3309H11.3507H11.3706H11.3904H11.4103H11.4302H11.4501H11.47H11.4899H11.5098H11.5298H11.5497H11.5697H11.5897H11.6097H11.6297H11.6497H11.6697H11.6898H11.7099H11.7299H11.75H11.7702H11.7903H11.8104H11.8306H11.8508H11.8709H11.8911H11.9114H11.9316H11.9519H11.9721H11.9924H12.0127H12.033H12.0534H12.0737H12.0941H12.1145H12.1349H12.1553H12.1758H12.1962H12.2167H12.2372H12.2577H12.2783H12.2988H12.3194H12.34H12.3606H12.3813H12.4019H12.4226H12.4433H12.464H12.4847H12.5055H12.5263H12.5471H12.5679H12.5887H12.6096H12.6305H12.6514H12.6723H12.6933H12.7143H12.7353H12.7563H12.7773H12.7984H12.8195H12.8406H12.8617H12.8829H12.9041H12.9253H12.9465H12.9678H12.9891H13.0104H13.0317H13.0531H13.0745H13.0959H13.1173H13.1388H13.1603H13.1818H13.2033H13.2249H13.2465H13.2681H13.2898H13.3114H13.3331H13.3549H13.3766H13.3984H13.4202H13.4421H13.4639H13.4858H13.5078H13.5297H13.5517H13.5737H13.5958H13.6178H13.6399H13.6621H13.6842H13.7064H13.7287H13.7509H13.7732H13.7955H13.8179H13.8402H13.8627H13.8851H13.9076H13.9301H13.9526H13.9752H13.9978H14.0204H14.0431H14.0658H14.0885H14.1113H14.1341H14.1569H14.1798H14.2027H14.2256H14.2486H14.2716H14.2946H14.3177H14.3408H14.364H14.3871H14.4104H14.4336H14.4569H14.4802H14.5036H14.527H14.5504H14.5739H14.5974H14.6209H14.6445H14.6681H14.6918H14.7154H14.7392H14.7629H14.7867H14.8106H14.8345H14.8584H14.8823H14.9063H14.9304H14.9544H14.9786H15.0027H15.0269H15.0511H15.0754H15.0997H15.1241H15.1485H15.1729H15.1974H15.2219H15.2465H15.2711H15.2957H15.3204H15.3451H15.3699H15.3947H15.4195H15.4444C16.0039 16.5 16.5 16.0154 16.5 15.3636V9.63636C16.5 8.9846 16.0039 8.5 15.4444 8.5H14Z",
    fill: "currentColor"
  }));
};

var ShareLockIcon = function ShareLockIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareLockSvg
  }, props));
};

var ShareAddSvg = function ShareAddSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7 1V13M1 7H13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var ShareAddIcon = function ShareAddIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareAddSvg
  }, props));
};
var ShareOrgSvg = function ShareOrgSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15.5",
    fill: "white",
    stroke: "#3AD8A9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18.1779 9.4668C18.5786 9.4668 18.9038 9.79201 18.9038 10.1927V13.0964C18.9038 13.4971 18.5786 13.8224 18.1779 13.8224H16.7261V15.2742H19.6298C20.0305 15.2742 20.3557 15.5994 20.3557 16.0001V18.1779H21.8075C22.2082 18.1779 22.5335 18.5031 22.5335 18.9038V21.8075C22.5335 22.2082 22.2082 22.5335 21.8075 22.5335H17.452C17.0513 22.5335 16.7261 22.2082 16.7261 21.8075V18.9038C16.7261 18.5031 17.0513 18.1779 17.452 18.1779H18.9038V16.7261H13.0964V18.1779H14.5483C14.949 18.1779 15.2742 18.5031 15.2742 18.9038V21.8075C15.2742 22.2082 14.949 22.5335 14.5483 22.5335H10.1927C9.79201 22.5335 9.4668 22.2082 9.4668 21.8075V18.9038C9.4668 18.5031 9.79201 18.1779 10.1927 18.1779H11.6446V16.0001C11.6446 15.5994 11.9698 15.2742 12.3705 15.2742H15.2742V13.8224H13.8224C13.4216 13.8224 13.0964 13.4971 13.0964 13.0964V10.1927C13.0964 9.79201 13.4216 9.4668 13.8224 9.4668H18.1779Z",
    fill: "#3AD8A9"
  }));
};
var ShareOrgIcon = function ShareOrgIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareOrgSvg
  }, props));
};

var ShareLinkSvg = function ShareLinkSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#69B9F8"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1377 10.6109C16.2856 8.46303 19.768 8.46303 21.9159 10.6109C24.0638 12.7588 24.0638 16.2412 21.9159 18.3891L20.8552 19.4497L20.1481 18.7426L21.2088 17.682C22.9159 15.9748 22.9647 13.2373 21.3551 11.4713L21.2088 11.318C19.5016 9.61087 16.7641 9.56209 14.9981 11.1717L14.8448 11.318L13.7842 12.3787L13.0771 11.6716L14.1377 10.6109ZM11.6716 13.0724L12.3787 13.7795L11.318 14.8402C9.61087 16.5473 9.56209 19.2849 11.1717 21.0509L11.318 21.2041C13.0252 22.9113 15.7627 22.9601 17.5287 21.3505L17.682 21.2041L18.7426 20.1435L19.4497 20.8506L18.3891 21.9112C16.2412 24.0591 12.7588 24.0591 10.6109 21.9112C8.46303 19.7634 8.46303 16.281 10.6109 14.1331L11.6716 13.0724ZM18.7339 14.5L18.0268 13.7929L13.7842 18.0355L14.4913 18.7426L18.7339 14.5Z",
    fill: "white"
  }));
};

var ShareLinkIcon = function ShareLinkIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareLinkSvg
  }, props));
};

var ShareRemoveSvg = function ShareRemoveSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35348 7.35348C6.15822 7.54874 6.15822 7.86532 6.35348 8.06058L8.82844 10.5355L6.35365 13.0103C6.15838 13.2056 6.15838 13.5222 6.35365 13.7174C6.54891 13.9127 6.86549 13.9127 7.06075 13.7174L9.53555 11.2427L12.0103 13.7174C12.2056 13.9127 12.5222 13.9127 12.7174 13.7174C12.9127 13.5222 12.9127 13.2056 12.7174 13.0103L10.2427 10.5355L12.7176 8.06059C12.9129 7.86533 12.9129 7.54875 12.7176 7.35348C12.5223 7.15822 12.2058 7.15822 12.0105 7.35348L9.53555 9.82844L7.06058 7.35348C6.86532 7.15822 6.54874 7.15822 6.35348 7.35348Z",
    fill: "#8E9197"
  }));
};

var ShareRemoveIcon = function ShareRemoveIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareRemoveSvg
  }, props));
};

var ShareRefreshSvg = function ShareRefreshSvg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 2C7.79098 2 5.79029 2.89598 4.34315 4.34315C3.99574 4.69055 3.45553 5.27705 3 5.77892V3.75C3 3.47386 2.77614 3.25 2.5 3.25C2.22386 3.25 2 3.47386 2 3.75V7.08313C2 7.08315 2 7.08317 2 7.08319V7.08333C2 7.15578 2.01541 7.22462 2.04312 7.28677C2.07121 7.34996 2.11292 7.4083 2.168 7.4572C2.18198 7.46962 2.19646 7.48111 2.21137 7.49167C2.22841 7.50374 2.246 7.5146 2.26403 7.52426C2.33432 7.56196 2.41466 7.58333 2.5 7.58333H5.83333C6.10948 7.58333 6.33333 7.35948 6.33333 7.08333C6.33333 6.80719 6.10948 6.58333 5.83333 6.58333H3.62054C3.64982 6.55098 3.67955 6.51816 3.70964 6.48499C4.17345 5.9736 4.71476 5.38575 5.05026 5.05026C6.31753 3.78296 8.06684 3 9.99999 3C13.866 3 17 6.13402 17 10C17 13.866 13.866 17 9.99999 17C8.06684 17 6.31753 16.2171 5.05026 14.9497C4.855 14.7545 4.53842 14.7545 4.34315 14.9497C4.14789 15.145 4.14788 15.4616 4.34314 15.6568C5.79029 17.104 7.79098 18 9.99999 18C14.4183 18 18 14.4183 18 10C18 5.58173 14.4183 2 9.99999 2Z",
    fill: "currentColor"
  }));
};

var ShareRefreshIcon = function ShareRefreshIcon(props) {
  return /*#__PURE__*/React__default['default'].createElement(Icon__default['default'], _objectSpread2({
    component: ShareRefreshSvg
  }, props));
};

var SearchList = function SearchList(_ref) {
  var className = _ref.className,
      data = _ref.data,
      onSelect = _ref.onSelect,
      onRenderItem = _ref.onRenderItem;
  var shareListRef = React.useRef(null);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('search');

  var handleSelect = function handleSelect(item) {
    if (onSelect) onSelect(item);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-list ").concat(className || ''),
    ref: shareListRef
  }, data.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-item"),
      key: index,
      onClick: function onClick() {
        return handleSelect(item);
      }
    }, onRenderItem(item));
  }));
};

var to$1 = "向其他用户共享";
var description$2 = "点击分享该文档给felo好友、群组或组织";
var localeData$6 = {
	to: to$1,
	description: description$2,
	"permissions.onlyView": "阅读",
	"permissions.canEdit": "可编辑",
	"permissions.edit": "编辑",
	"permissions.ownerSet": "设为拥有者",
	"permissions.owner": "拥有者",
	"add.title": "添加",
	"add.note": "添加备注",
	"add.hint": "文件/文档将与下面的注释一起发送",
	"add.notification": "允许发送通知",
	"link.copy": "复制链接",
	"link.on": "当前有效",
	"link.off": "当前无效",
	"link.title": "访问权限",
	"link.access": "通过链接访问",
	"link.org": "组织内获得链接的人可以",
	"link.any": "任何人获得链接可以",
	"link.password.title": "设置链接共享密码",
	"link.password.time": "具体时间",
	"link.password.placeholder": "设置密码",
	"link.password.set": "设置",
	"link.password.reset": "重置",
	"link.date.title": "设置链接共享的截止日期",
	"link.date.placeholder": "设置截止日期",
	"link.date.format": "将被禁用在 {date} ",
	"link.apply.edit": "申请编辑权限",
	"link.apply.success": "申请编辑权限成功",
	"manage.title": "管理协作者",
	"manage.description": "管理协作者的访问权限",
	"select.placeholder": "搜索用户、组或部门",
	"select.title": "选择联系人",
	"select.contact": "联系人",
	"select.selectedNumber": "已选：{num} 个"
};

var localValue$5 = _objectSpread2({
  locale: 'zh-CN'
}, jsonToObject(localeData$6));

var title$2 = "分享";
var description$3 = "有访问权限的成员或群组";
var localeData$7 = {
	title: title$2,
	description: description$3,
	"use.description": "可请求所有者 {name} 将文档分享给以下用户",
	"apply.description": "{name} 请求你开通本文档权限给下列用户",
	"notification.title": "通知",
	"notification.self": "{name} 向你申请本文档的 阅读/编辑权限",
	"notification.other": "{name} 请求你为其他人开通本文档的 阅读/编辑权限",
	"notification.view": "点击查看",
	"notification.unread": "未读通知",
	"notification.read": "已读通知",
	"permissions.edit": "可编辑",
	"permissions.editDescription": "可以编辑及阅读文档",
	"permissions.view": "可阅读",
	"permissions.viewDescription": "仅可阅读文档",
	"permissions.transfer": "转让所有权",
	"permissions.transferDescription": "将成为本文档的所有者",
	"permissions.owner": "拥有者",
	"permissions.noDescription": "不能阅读或编辑文档",
	"permissions.no": "无权限",
	"permissions.setTransferTitle": "确定要将此人设为拥有者吗？",
	"permissions.setTransferDescription": "此人将成为本文档的所有者。您就失去本文档的管理权限。",
	"add.title": "添加",
	"add.notification": "发送通知",
	"add.notificationReq": "发送请求通知",
	"add.apply": "同意",
	"add.ignore": "忽略",
	"add.disabled": "与文档拥有者不在同一个组织，无法申请权限。",
	"remove.title": "确定移除 {name} 的权限吗？",
	"remove.description": "移除后该用户可能会无法查看文档",
	"link.copy": "复制分享链接",
	"link.get": "获取链接",
	"link.encryption": "加密链接",
	"link.manage": "管理密码",
	"link.password.ok": "完成",
	"link.password.enable": "启用密码",
	"link.password.update": "更换",
	"link.password.copy": "复制链接和密码",
	"link.password.placeholder": "输入密码",
	"link.password.description": "提示：启用密码后，所有用户需输入密码方可访问；启用时文档权限会变更为：知道链接的任何人均可查看/编辑文档成员",
	"link.password.set": "链接密码设置",
	"link.general.title": "常规访问权限",
	"link.general.org.title": "组织内所有用户",
	"link.general.org.viewDescription": "组织内知道连接的任何人都可以查看",
	"link.general.org.editDescription": "组织内知道连接的任何人都可以编辑",
	"link.general.any.title": "知道链接的任何人",
	"link.general.any.viewDescription": "互联网上知道链接的任何人都可以查看",
	"link.general.any.editDescription": "互联网上知道链接的任何人都可以编辑",
	"select.placeholder": "搜索用户、组或部门",
	"select.all": "所有联系人",
	"select.conversation": "我的会话",
	"select.selectedNumber": "已选：{num} 个"
};

var localValue$6 = _objectSpread2({
  locale: 'zh-CN'
}, jsonToObject(localeData$7));

var cancel$3 = "取消";
var confirm$3 = "确认";
var openChat$1 = "打开会话";
var title$3 = "选择成员";
var localeData$8 = {
	cancel: cancel$3,
	confirm: confirm$3,
	openChat: openChat$1,
	title: title$3
};

var localValue$7 = _objectSpread2({
  locale: 'zh-CN'
}, jsonToObject(localeData$8));

var cancel$4 = "取消";
var confirm$4 = "确认";
var login$1 = "登录";
var titleSelectOrg$1 = "选择你的组织";
var addOrg$1 = "加入其他组织";
var logout$1 = "退出登录";
var explainCreateOtherAccount$1 = "通过其他帐号使用Felo";
var createOtherAccount$1 = "添加其他帐号";
var loginAnonymous$1 = "匿名登录";
var inviteFellows$1 = "邀请朋友";
var switchAccount$1 = "切换帐号";
var titleJoinNewOrg$1 = "加入新组织";
var descJoinNewOrg$1 = "如果你的组织正在使用 Felo，你可以使用邀请码加入 Felo";
var titleCreateNewOrg$1 = "创建一个新组织";
var descCreateNewOrg$1 = "创建组织后，你会被设置为管理员,你可以添加伙伴、管理你的组织";
var createTeamNameNow$1 = "为你的组织设置一个名称";
var labelName$1 = "名称";
var labelJoinOrgCode$1 = "使用邀请码加入";
var labelOrgCode$1 = "邀请码";
var create$1 = "创建";
var join$1 = "加入";
var errMsgWrongOrgCode$1 = "邀请码错误或已过期";
var errMsgTeamNotExist$1 = "组织不存在";
var personalInfo$1 = "账号管理";
var orgManagement$1 = "组织管理";
var invitationOrganization$1 = "邀请加入组织";
var recommendFriend$1 = "推荐给朋友";
var freeVersion$1 = "免费版";
var generalVersion$1 = "普通版";
var advancedVersion$1 = "高级版";
var enterpriseVersion$1 = "企业版";
var upgrade$1 = "升级";
var localeData$9 = {
	cancel: cancel$4,
	confirm: confirm$4,
	login: login$1,
	titleSelectOrg: titleSelectOrg$1,
	addOrg: addOrg$1,
	logout: logout$1,
	explainCreateOtherAccount: explainCreateOtherAccount$1,
	createOtherAccount: createOtherAccount$1,
	loginAnonymous: loginAnonymous$1,
	inviteFellows: inviteFellows$1,
	switchAccount: switchAccount$1,
	titleJoinNewOrg: titleJoinNewOrg$1,
	descJoinNewOrg: descJoinNewOrg$1,
	titleCreateNewOrg: titleCreateNewOrg$1,
	descCreateNewOrg: descCreateNewOrg$1,
	createTeamNameNow: createTeamNameNow$1,
	labelName: labelName$1,
	labelJoinOrgCode: labelJoinOrgCode$1,
	labelOrgCode: labelOrgCode$1,
	create: create$1,
	join: join$1,
	errMsgWrongOrgCode: errMsgWrongOrgCode$1,
	errMsgTeamNotExist: errMsgTeamNotExist$1,
	personalInfo: personalInfo$1,
	orgManagement: orgManagement$1,
	invitationOrganization: invitationOrganization$1,
	recommendFriend: recommendFriend$1,
	freeVersion: freeVersion$1,
	generalVersion: generalVersion$1,
	advancedVersion: advancedVersion$1,
	enterpriseVersion: enterpriseVersion$1,
	upgrade: upgrade$1
};

var localValue$8 = _objectSpread2({
  locale: 'zh-CN'
}, jsonToObject(localeData$9));

var ok$2 = "确定";
var localeData$a = {
	"join-organization": {
	title: "邀请朋友加入",
	share: "分享邀请",
	code: {
		title: "您的组织邀请码，有效期至 {expiredAt}",
		desc: "新成员可以使用邀请码创建新账号，创建账号后将自动加入本组织",
		desc2: "您也可以<i>复制上述文本</i>或<i>复制 QR 码</i>发送给您的朋友。",
		"copy-label": "{userName} 邀请你使用 Felo 并加入「{orgName}」。你可以使用邀请码 {invite_code} 或点击链接 {link} 加入。"
	},
	sns: {
		desc: "将邀请信息分享到"
	},
	email: {
		title: "通过邮件邀请",
		desc: "将向指定邮箱地址发送邀请链接",
		button: "发送邀请邮件",
		confirm: "确认发送邮件",
		fail: "邮箱地址格式不正确。",
		"success-send": "邀请邮件已发送。",
		"error-send": "邮件发送失败。",
		placeholder: "在这里输入您想要邀请的邮箱，每行一个。例："
	}
},
	"recommend-friend": {
	title: "推荐给朋友",
	share: "分享推荐",
	code: {
		title: "您的组织邀请码，有效期至 {expiredAt}",
		desc: "如果您觉得Felo是个不错的软件，请帮忙推荐给您的朋友注册使用，感谢支持！",
		desc2: "复制链接分享给您的朋友",
		"copy-label": "{userName} 推荐你使用 Felo，通过以下链接注册，开启你从未体检过的协作乐趣。{link}"
	},
	sns: {
		desc: "将邀请信息分享到"
	},
	email: {
		title: "通过邮件邀请",
		desc: "将向指定邮箱地址发送邀请链接",
		button: "发送邀请邮件",
		confirm: "确认发送邮件",
		fail: "邮箱地址格式不正确。",
		"success-send": "邀请邮件已发送。",
		"error-send": "邮件发送失败。",
		placeholder: "在这里输入您想要邀请的邮箱，每行一个。例："
	}
},
	"copy-text": "复制",
	"copy-success": "已复制到剪贴板。",
	ok: ok$2,
	"user-already-in-org": "用户已存在当前组织",
	"send-success": "发送成功",
	"send-failed": "发送失败",
	"send-failed-detail": "{length} 个邀请失败"
};

var localValue$9 = _objectSpread2({
  locale: 'zh-CN'
}, jsonToObject(localeData$a));

var cancel$5 = "取消";
var send$1 = "发送";
var ok$3 = "确定";
var confirm$5 = "确认";
var on$1 = "打开";
var off$1 = "关闭";
var remove$1 = "删除";
var success$1 = "成功";
var failed$1 = "失败";
var localeData$b = {
	cancel: cancel$5,
	send: send$1,
	ok: ok$3,
	confirm: confirm$5,
	on: on$1,
	off: off$1,
	remove: remove$1,
	success: success$1,
	failed: failed$1
};

var localeValue$1 = {
  locale: 'zh-CN',
  global: _objectSpread2({
    locale: 'zh-CN'
  }, localeData$b),
  Share: localValue$5,
  CommonShare: localValue$6,
  Selector: localValue$7,
  PageHeader: localValue$8,
  InvitationShare: localValue$9
};

var to$2 = "分享給";
var description$4 = "點擊分享該文檔給felo好友、群組或組織";
var localeData$c = {
	to: to$2,
	description: description$4,
	"permissions.onlyView": "閱讀",
	"permissions.canEdit": "可編輯",
	"permissions.edit": "編輯",
	"permissions.ownerSet": "設為擁有者",
	"permissions.owner": "擁有者",
	"add.title": "添加",
	"add.note": "添加備註",
	"add.hint": "文件/文檔將與下面的註釋一起發送",
	"add.notification": "允許發送通知",
	"link.copy": "複製鏈接",
	"link.on": "打開",
	"link.off": "關閉",
	"link.title": "鏈接分享",
	"link.description": "設置通過鏈接訪問的人的權限",
	"link.org": "組織內獲得鏈接的人可以",
	"link.any": "任何人獲得鏈接可以",
	"link.password.title": "設置鏈接共享密碼",
	"link.password.time": "具體時間",
	"link.password.placeholder": "設置密碼",
	"link.password.set": "設置",
	"link.password.reset": "重置",
	"link.date.title": "設置鏈接共享的截止日期",
	"link.date.placeholder": "設置截止日期",
	"link.date.format": "將被禁用在 {date} ",
	"link.apply.edit": "申請編輯權限",
	"link.apply.success": "申請編輯權限成功",
	"manage.title": "管理協作者",
	"manage.description": "管理協作者的訪問權限",
	"select.placeholder": "搜索用戶、組或部門",
	"select.title": "選擇連絡人",
	"select.contact": "連絡人",
	"select.selectedNumber": "已選：{num} 個"
};

var localValue$a = _objectSpread2({
  locale: 'en-TW'
}, jsonToObject(localeData$c));

var title$4 = "分享";
var description$5 = "有造訪權限的成員或群組";
var localeData$d = {
	title: title$4,
	description: description$5,
	"use.description": "可請求文檔所有者{name}將文檔分享給以下使用者",
	"permissions.edit": "可編輯",
	"permissions.editDescription": "可以編輯及閱讀文檔",
	"permissions.view": "可閱讀",
	"permissions.viewDescription": "僅可閱讀文檔",
	"permissions.transfer": "轉讓所有權",
	"permissions.transferDescription": "將成為文檔的所有者",
	"permissions.owner": "擁有者",
	"permissions.noDescription": "不能閱讀或編輯文檔",
	"permissions.no": "不允許",
	"permissions.setTransferTitle": "確定要將此人設為擁有者嗎?",
	"permissions.setTransferDescription": "此人將成為本文檔的所有者。您就失去本文檔的管理權限",
	"add.title": "添加",
	"add.notification": "發送通知",
	"remove.title": "確定移除{name}的權限嗎?",
	"remove.description": "移除後該使用者可能會無法查看文檔",
	"link.copy": "複製分享連結",
	"link.get": "獲取連結",
	"link.encryption": "加密連結",
	"link.password.enable": "啟用密碼",
	"link.password.update": "更換",
	"link.password.copy": "複製連結和密碼",
	"link.password.placeholder": "請輸入密碼",
	"link.password.description": "提示：啟用密碼後，所有使用者須輸入密碼方可造訪；啟用時文檔權限會變更為：知道連結的任何人均可查看/編輯文檔",
	"link.password.set": "連結密碼設定",
	"link.general.org.title": "組織內所有使用者",
	"link.general.any.title": "知道連結的任何人",
	"select.placeholder": "搜尋組織內成員、群組或部門",
	"select.all": "所有聯絡人",
	"select.conversation": "我的會話",
	"select.selectedNumber": "已選：{num} 個",
	"link.password.ok": "完成",
	"link.general.title": "常規造訪權限",
	"apply.description": "{name} 請求您開通本文檔權限給下列使用者",
	"notification.title": "通知",
	"notification.self": "{name} 向您申請本文檔的閱讀/編輯權限",
	"notification.other": "{name} 請求您為其他人開通本文檔的閱讀/編輯權限",
	"notification.view": "點擊查看",
	"notification.unread": "未讀通知",
	"notification.read": "已讀通知",
	"add.apply": "同意",
	"add.ignore": "忽略",
	"link.manage": "管理密碼",
	"add.notificationReq": "發送請求通知",
	"add.disabled": "與文檔擁有者不在同一個組織，無法申請權限。",
	"link.general.org.viewDescription": "組織內知道連結的任何人都可以查看",
	"link.general.org.editDescription": "組織內知道連結的任何人都可以編輯",
	"link.general.any.viewDescription": "網際網路上知道連結的任何人都可以查看",
	"link.general.any.editDescription": "網際網路上知道連結的任何人都可以編輯"
};

var localValue$b = _objectSpread2({
  locale: 'zh-TW'
}, jsonToObject(localeData$d));

var cancel$6 = "取消";
var confirm$6 = "確認";
var openChat$2 = "打開會話";
var title$5 = "選擇成員";
var localeData$e = {
	cancel: cancel$6,
	confirm: confirm$6,
	openChat: openChat$2,
	title: title$5
};

var localValue$c = _objectSpread2({
  locale: 'en-TW'
}, jsonToObject(localeData$e));

var cancel$7 = "取消";
var confirm$7 = "確認";
var login$2 = "登入";
var titleSelectOrg$2 = "選擇你的組織";
var addOrg$2 = "加入其他組織";
var logout$2 = "退出登入";
var explainCreateOtherAccount$2 = "通過其他帳號使用Felo";
var createOtherAccount$2 = "新增其他帳號";
var loginAnonymous$2 = "匿名登入";
var inviteFellows$2 = "邀請朋友";
var switchAccount$2 = "切換帳號";
var titleJoinNewOrg$2 = "加入新組織";
var descJoinNewOrg$2 = "如果你的組織正在使用 Felo，你可以使用邀請碼加入 Felo";
var titleCreateNewOrg$2 = "建立一個新組織";
var descCreateNewOrg$2 = "建立組織后，你會被設置為管理員,你可以添加夥伴、管理你的組織";
var createTeamNameNow$2 = "為你的組織設置一個名字";
var labelName$2 = "名称";
var labelJoinOrgCode$2 = "使用邀請碼加入";
var labelOrgCode$2 = "邀請碼";
var create$2 = "建立";
var join$2 = "加入";
var errMsgWrongOrgCode$2 = "邀請碼錯誤或已過期";
var errMsgTeamNotExist$2 = "組織不存在";
var personalInfo$2 = "帳號管理";
var orgManagement$2 = "組織管理";
var invitationOrganization$2 = "邀請加入組織";
var recommendFriend$2 = "推薦給朋友";
var freeVersion$2 = "免費套餐";
var generalVersion$2 = "標準套餐";
var advancedVersion$2 = "高級套餐";
var enterpriseVersion$2 = "企業套餐";
var upgrade$2 = "升級";
var localeData$f = {
	cancel: cancel$7,
	confirm: confirm$7,
	login: login$2,
	titleSelectOrg: titleSelectOrg$2,
	addOrg: addOrg$2,
	logout: logout$2,
	explainCreateOtherAccount: explainCreateOtherAccount$2,
	createOtherAccount: createOtherAccount$2,
	loginAnonymous: loginAnonymous$2,
	inviteFellows: inviteFellows$2,
	switchAccount: switchAccount$2,
	titleJoinNewOrg: titleJoinNewOrg$2,
	descJoinNewOrg: descJoinNewOrg$2,
	titleCreateNewOrg: titleCreateNewOrg$2,
	descCreateNewOrg: descCreateNewOrg$2,
	createTeamNameNow: createTeamNameNow$2,
	labelName: labelName$2,
	labelJoinOrgCode: labelJoinOrgCode$2,
	labelOrgCode: labelOrgCode$2,
	create: create$2,
	join: join$2,
	errMsgWrongOrgCode: errMsgWrongOrgCode$2,
	errMsgTeamNotExist: errMsgTeamNotExist$2,
	personalInfo: personalInfo$2,
	orgManagement: orgManagement$2,
	invitationOrganization: invitationOrganization$2,
	recommendFriend: recommendFriend$2,
	freeVersion: freeVersion$2,
	generalVersion: generalVersion$2,
	advancedVersion: advancedVersion$2,
	enterpriseVersion: enterpriseVersion$2,
	upgrade: upgrade$2
};

var localValue$d = _objectSpread2({
  locale: 'en-TW'
}, jsonToObject(localeData$f));

var ok$4 = "確定";
var localeData$g = {
	"join-organization": {
	title: "邀請朋友加入",
	share: "分享邀請",
	code: {
		title: "您的組織邀請碼，有效期至 {expiredAt}",
		desc: "新成員可以使用邀請碼建立新帳號，建立帳號後將自動加入本組織",
		desc2: "您也可以<i>複製上述文本</i>或<i>複製 QR 碼</i>分享給您的朋友。",
		"copy-label": "{userName} 邀請你使用 Felo 並加入「{orgName}」。你可以使用邀請碼 {invite_code} 或點選連結 {link} 加入。"
	},
	sns: {
		desc: "將邀請資訊分享到"
	},
	email: {
		title: "透過郵件邀請",
		desc: "將向指定電子郵件地址發送邀請連結",
		button: "發送邀請郵件",
		confirm: "確認發送郵件",
		fail: "電子郵件地址格式不正確。",
		"success-send": "邀請郵件已發送。",
		"error-send": "發送邀請郵件失敗。",
		placeholder: "在這裡輸入您想要邀請的郵箱，每行一個。例："
	}
},
	"recommend-friend": {
	title: "推薦給朋友",
	share: "分享推薦",
	code: {
		title: "您的組織邀請碼，有效期至 {expiredAt}",
		desc: "如果您覺得Felo是個不錯的軟體，請幫忙推薦給您的朋友註冊使用，感謝支持",
		desc2: "複製連結分享給您的朋友",
		"copy-label": "{userName} 推薦您使用Felo，通過以下連結註冊，開啟您從未體驗過的協作樂趣{link}"
	},
	sns: {
		desc: "將邀請資訊分享到"
	},
	email: {
		title: "透過郵件邀請",
		desc: "將向指定電子郵件地址發送邀請連結",
		button: "發送邀請郵件",
		confirm: "確認發送郵件",
		fail: "電子郵件地址格式不正確。",
		"success-send": "邀請郵件已發送。",
		"error-send": "發送邀請郵件失敗。",
		placeholder: "在這裡輸入您想要邀請的郵箱，每行一個。例："
	}
},
	"copy-text": "複製",
	"copy-success": "已複製到剪貼板。",
	ok: ok$4,
	"user-already-in-org": "用戶已存在當前組織",
	"send-success": "傳送成功",
	"send-failed": "傳送失敗",
	"send-failed-detail": "{length} 個邀請失敗"
};

var localValue$e = _objectSpread2({
  locale: 'en-TW'
}, jsonToObject(localeData$g));

var cancel$8 = "取消";
var send$2 = "發送";
var ok$5 = "確定";
var confirm$8 = "確認";
var on$2 = "打開";
var off$2 = "關閉";
var remove$2 = "刪除";
var success$2 = "成功";
var failed$2 = "失敗";
var localeData$h = {
	cancel: cancel$8,
	send: send$2,
	ok: ok$5,
	confirm: confirm$8,
	on: on$2,
	off: off$2,
	remove: remove$2,
	success: success$2,
	failed: failed$2
};

var localeValue$2 = {
  locale: 'zh-TW',
  global: _objectSpread2({
    locale: 'zh-TW'
  }, localeData$h),
  Share: localValue$a,
  CommonShare: localValue$b,
  Selector: localValue$c,
  PageHeader: localValue$d,
  InvitationShare: localValue$e
};

var to$3 = "と共有する";
var description$6 = "クリックしてドキュメントを友達、グループ、組織に共有します";
var localeData$i = {
	to: to$3,
	description: description$6,
	"permissions.onlyView": "閲覧可能",
	"permissions.canEdit": "編集可能",
	"permissions.edit": "編集",
	"permissions.ownerSet": "所有者として設定",
	"permissions.owner": "オーナー",
	"add.title": "追加",
	"add.note": "メモを追加",
	"add.hint": "ファイル/ドキュメントは以下のメモとともに送信されます",
	"add.notification": "通知を許可する",
	"link.copy": "リンクをコピーする",
	"link.on": "開ける",
	"link.off": "閉鎖",
	"link.title": "リンク共有",
	"link.description": "リンク経由でアクセスするユーザーの権限を設定する",
	"link.org": "リンクを取得する組織内の人々は",
	"link.any": "リンクを取得した人は誰でもできます",
	"link.password.title": "リンク共有パスワードを設定する",
	"link.password.time": "特定の時間",
	"link.password.placeholder": "パスワードを設定してください",
	"link.password.set": "設定",
	"link.password.reset": "リセット",
	"link.date.title": "リンク共有の有効期限を設定する",
	"link.date.placeholder": "期限を設定する",
	"link.date.format": "{date}に無効になります ",
	"link.apply.edit": "編集権限を申請する",
	"link.apply.success": "編集権限の申請に成功",
	"manage.title": "共同編集者を管理する",
	"manage.description": "共同編集者へのアクセスを管理する",
	"select.placeholder": "ユーザー、グループ、または部門を検索します",
	"select.title": "連絡先を選択",
	"select.contact": "連絡先",
	"select.selectedNumber": "{num} 件を選択済み"
};

var localValue$f = _objectSpread2({
  locale: 'ja-JP'
}, jsonToObject(localeData$i));

var title$6 = "共有";
var description$7 = "アクセス権限があるメンバーまたはグループ";
var localeData$j = {
	title: title$6,
	description: description$7,
	"use.description": "ドキュメントの所有者{name}に、次のユーザーとドキュメントを共有するように要求することができます",
	"permissions.edit": "編集可能",
	"permissions.editDescription": "ドキュメントは編集、閲覧ともに可能です",
	"permissions.view": "閲覧可能",
	"permissions.viewDescription": "ドキュメントは閲覧しかできません",
	"permissions.transfer": "所有権を譲渡する",
	"permissions.transferDescription": "ドキュメントの所有者になる",
	"permissions.owner": "所有者",
	"permissions.noDescription": "ドキュメントは閲覧、編集ともにできません",
	"permissions.no": "許可しない",
	"permissions.setTransferTitle": "このユーザーを所有者として設定しますか",
	"permissions.setTransferDescription": "このユーザーが本ドキュメントの所有者となり、あなたの本ドキュメントの管理権限はなくなります",
	"add.title": "追加",
	"add.notification": "通知を許可する",
	"remove.title": "{name} の権限をキャンセルしますか。",
	"remove.description": "削除後、そのユーザーはドキュメントを閲覧できなくなる可能性があります",
	"link.copy": "共有リンクをコピーする",
	"link.get": "リンクを取得する",
	"link.encryption": "リンクを暗号化する",
	"link.password.enable": "パスワードを有効にする",
	"link.password.update": "変更する",
	"link.password.copy": "リンクとパスワードをコピーする",
	"link.password.placeholder": "パスワードを入力してください",
	"link.password.description": "注意：パスワードを有効にすると、どのユーザーもアクセスするためにパスワードを入力する必要があります。また有効にした場合、ドキュメントのアクセス権限が「リンクを知っている全ての人がドキュメントを閲覧/編集できる」に変更されます",
	"link.password.set": "パスワード付きリンク",
	"link.general.org.title": "組織内のすべてのユーザー",
	"link.general.any.title": "リンクを知っているすべての人",
	"select.placeholder": "組織内のメンバー、グループまたは部門を検索する",
	"select.all": "すべての連絡先",
	"select.conversation": "マイセッション",
	"select.selectedNumber": "選択済み：{num}個",
	"link.password.ok": "完了",
	"link.general.title": "一般的なアクセス権限",
	"apply.description": "{name} は、次のユーザーにこのドキュメントのアクセス権を付与するよう求めています",
	"notification.title": "メッセージ",
	"notification.self": "{name} は、このドキュメントの読み取り/編集権限を申請しています",
	"notification.other": "{name} は、このドキュメントの読み取り/編集アクセス権を他のユーザーに付与するよう求めています",
	"notification.view": "クリックして表示",
	"notification.unread": "未読メッセージ",
	"notification.read": "既読メッセージ",
	"add.apply": "同意する",
	"add.ignore": "無視する",
	"link.manage": "パスワードの管理",
	"add.notificationReq": "リクエスト通知を送信する",
	"add.disabled": "ドキュメントの所有者と同じ組織に属していません。権限を付与できません。",
	"link.general.org.viewDescription": "リンクを知っている組織内の誰でも閲覧できる",
	"link.general.org.editDescription": "リンクを知っている組織内の誰でも編集できる",
	"link.general.any.viewDescription": "リンクを知っているインターネット上の誰もが閲覧できます",
	"link.general.any.editDescription": "リンクを知っているインターネット上の誰もが編集できます"
};

var localValue$g = _objectSpread2({
  locale: 'ja-JP'
}, jsonToObject(localeData$j));

var cancel$9 = "キャンセル";
var confirm$9 = "OK";
var openChat$3 = "チャットする";
var title$7 = "メンバーを選択";
var localeData$k = {
	cancel: cancel$9,
	confirm: confirm$9,
	openChat: openChat$3,
	title: title$7
};

var localValue$h = _objectSpread2({
  locale: 'ja-JP'
}, jsonToObject(localeData$k));

var cancel$a = "キャンセル";
var confirm$a = "OK";
var login$3 = "サインイン";
var titleSelectOrg$3 = "組織を選択してください";
var addOrg$3 = "別の組織を追加";
var logout$3 = "サインアウト";
var explainCreateOtherAccount$3 = "別のアカウントでFeloを使用する";
var createOtherAccount$3 = "別のアカウントを追加";
var loginAnonymous$3 = "匿名でサインイン";
var inviteFellows$3 = "他の人を招待";
var switchAccount$3 = "アカウントを切り替える";
var titleJoinNewOrg$3 = "他の組織に参加";
var descJoinNewOrg$3 = "作成済みの組織に参加したい場合、組織コードを使用して参加し、メンバーとコラボレーションができます。";
var titleCreateNewOrg$3 = "新しい組織の作成";
var descCreateNewOrg$3 = "新しい組織を作成すると、所有者になります。所有者はメンバーの追加や組織の管理などを行うことができます。";
var createTeamNameNow$3 = "組織の名前を設定";
var labelName$3 = "名前";
var labelJoinOrgCode$3 = "招待コードで参加する";
var labelOrgCode$3 = "招待コード";
var create$3 = "作成";
var join$3 = "参加する";
var errMsgWrongOrgCode$3 = "招待コードが間違っているか、有効期限が切れています";
var errMsgTeamNotExist$3 = "間違った組織コード";
var personalInfo$3 = "アカウント";
var orgManagement$3 = "組織管理";
var invitationOrganization$3 = "組織に招待";
var recommendFriend$3 = "友達に招待";
var freeVersion$3 = "無料";
var generalVersion$3 = "標準プラン";
var advancedVersion$3 = "チームプレミアム";
var enterpriseVersion$3 = "エンタープライズ";
var upgrade$3 = "アップグレード";
var localeData$l = {
	cancel: cancel$a,
	confirm: confirm$a,
	login: login$3,
	titleSelectOrg: titleSelectOrg$3,
	addOrg: addOrg$3,
	logout: logout$3,
	explainCreateOtherAccount: explainCreateOtherAccount$3,
	createOtherAccount: createOtherAccount$3,
	loginAnonymous: loginAnonymous$3,
	inviteFellows: inviteFellows$3,
	switchAccount: switchAccount$3,
	titleJoinNewOrg: titleJoinNewOrg$3,
	descJoinNewOrg: descJoinNewOrg$3,
	titleCreateNewOrg: titleCreateNewOrg$3,
	descCreateNewOrg: descCreateNewOrg$3,
	createTeamNameNow: createTeamNameNow$3,
	labelName: labelName$3,
	labelJoinOrgCode: labelJoinOrgCode$3,
	labelOrgCode: labelOrgCode$3,
	create: create$3,
	join: join$3,
	errMsgWrongOrgCode: errMsgWrongOrgCode$3,
	errMsgTeamNotExist: errMsgTeamNotExist$3,
	personalInfo: personalInfo$3,
	orgManagement: orgManagement$3,
	invitationOrganization: invitationOrganization$3,
	recommendFriend: recommendFriend$3,
	freeVersion: freeVersion$3,
	generalVersion: generalVersion$3,
	advancedVersion: advancedVersion$3,
	enterpriseVersion: enterpriseVersion$3,
	upgrade: upgrade$3
};

var localValue$i = _objectSpread2({
  locale: 'ja-JP'
}, jsonToObject(localeData$l));

var ok$6 = "OK";
var localeData$m = {
	"join-organization": {
	title: "新しいメンバーを招待する",
	share: "共有で招待",
	code: {
		title: "下記は組織の招待コードで、{expiredAt} まで有効です",
		desc: "新しいメンバーは、招待コードを使用して新しいアカウントを作成できます。アカウントを作成すると、自動的に組織に参加します。",
		desc2: "<i>上記のテキストをコピー</i>するか、<i>QR コードをコピー</i>して友達と共有することもできます。",
		"copy-label": "{userName}さんから Felo を使用して組織「{orgName} 」に参加するように招待されました。招待コード「{invite_code}」、またはリンク {link} で参加できます。"
	},
	sns: {
		desc: "招待メッセージを共有する"
	},
	email: {
		title: "電子メールで招待",
		desc: "招待リンクは指定されたメールアドレスに送信されます",
		button: "招待メールの送信",
		confirm: "メール送信の確認",
		fail: "メールアドレスが正しくありません。",
		"success-send": "招待メールが送信されました。",
		"error-send": "メール送信時にエラーが発生しました。",
		placeholder: "ここに招待したいメールアドレスを1行に1つずつ入力します。例:"
	}
},
	"recommend-friend": {
	title: "友達に勧める",
	share: "推奨事項を共有する",
	code: {
		title: "下記は組織の招待コードで、{expiredAt} まで有効です",
		desc: "Feloがいいソフトだと思ったら、友達に推薦してください。サポートありがとうございます。",
		desc2: "リンクをコピーして友達と共有します",
		"copy-label": "{userName}がFeloを推薦しています。以下のリンクから登録して、これまでに経験したことのない共同編集を開始して下さい{link}"
	},
	sns: {
		desc: "招待メッセージを共有する"
	},
	email: {
		title: "電子メールで招待",
		desc: "招待リンクは指定されたメールアドレスに送信されます",
		button: "招待メールの送信",
		confirm: "メール送信の確認",
		fail: "メールアドレスが正しくありません。",
		"success-send": "招待メールが送信されました。",
		"error-send": "メール送信時にエラーが発生しました。",
		placeholder: "ここに招待したいメールアドレスを1行に1つずつ入力します。例:"
	}
},
	"copy-text": "コピー",
	"copy-success": "クリップボードにコピーしました。",
	ok: ok$6,
	"user-already-in-org": "ユーザーはすでに組織に参加しています",
	"send-success": "送信済み",
	"send-failed": "送信に失敗しました",
	"send-failed-detail": "{length}の招待に失敗しました"
};

var localValue$j = _objectSpread2({
  locale: 'ja-JP'
}, jsonToObject(localeData$m));

var cancel$b = "キャンセル";
var send$3 = "送信";
var ok$7 = "OK";
var confirm$b = "確認";
var on$3 = "開く";
var off$3 = "閉じる";
var remove$3 = "削除";
var success$3 = "成功";
var failed$3 = "失敗";
var localeData$n = {
	cancel: cancel$b,
	send: send$3,
	ok: ok$7,
	confirm: confirm$b,
	on: on$3,
	off: off$3,
	remove: remove$3,
	success: success$3,
	failed: failed$3
};

var localeValue$3 = {
  locale: 'ja-JP',
  global: _objectSpread2({
    locale: 'ja-JP'
  }, localeData$n),
  Share: localValue$f,
  CommonShare: localValue$g,
  Selector: localValue$h,
  PageHeader: localValue$i,
  InvitationShare: localValue$j
};

var _excluded$1 = ["lang", "locale"];
var locales = {
  'zh-CN': _objectSpread2(_objectSpread2({}, zhCN__default['default']), localeValue$1),
  'zh-HK': _objectSpread2(_objectSpread2({}, zhHK__default['default']), localeValue$2),
  'zh-TW': _objectSpread2(_objectSpread2({}, zhTW__default['default']), localeValue$2),
  'en-US': _objectSpread2(_objectSpread2({}, enUS__default['default']), localeValue),
  'ja-JP': _objectSpread2(_objectSpread2({}, jaJP__default['default']), localeValue$3)
};
var defaultPrefixCls = 'felo';

var FeloConfigProvider = function FeloConfigProvider(_ref) {
  var lang = _ref.lang,
      locale = _ref.locale,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var children = props.children,
      csp = props.csp,
      autoInsertSpaceInButton = props.autoInsertSpaceInButton,
      form = props.form,
      componentSize = props.componentSize,
      direction = props.direction,
      space = props.space,
      virtual = props.virtual,
      dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
      iconPrefixCls = props.iconPrefixCls;
  var childNode = children;

  if (lang) {
    locale = locales[lang];
  }

  if (locale) {
    childNode = /*#__PURE__*/React__default['default'].createElement(LocaleProvider, {
      locale: locale
    }, children);
  }

  var getPrefixCls = React__default['default'].useCallback(function (suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    var mergedPrefixCls = props.prefixCls || defaultPrefixCls;
    return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
  }, [props.prefixCls]);
  var config = {
    csp: csp,
    autoInsertSpaceInButton: autoInsertSpaceInButton,
    locale: locale,
    direction: direction,
    space: space,
    virtual: virtual,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    iconPrefixCls: iconPrefixCls,
    componentSize: componentSize,
    form: form
  };
  return /*#__PURE__*/React__default['default'].createElement(ConfigContext.Provider, {
    value: {
      locale: locale,
      getPrefixCls: getPrefixCls
    }
  }, /*#__PURE__*/React__default['default'].createElement(_ConfigProvider__default['default'], _objectSpread2({}, config), childNode));
};
/** @private internal Usage. do not use in your production */


FeloConfigProvider.ConfigContext = ConfigContext;

var css_248z$8 = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-search-icon {\n  height: 38px;\n  cursor: pointer;\n}\n.felo-search-icon:not(.ant-input-affix-wrapper-focused) {\n  padding: 0;\n  border: 0 none;\n}\n.felo-search-icon .ant-input-prefix {\n  margin: 0;\n  margin-right: 0;\n}\n.felo-search-icon .ant-input-prefix .anticon {\n  margin-top: 2px;\n  color: #464e5a;\n}\n.felo-search-icon .ant-input {\n  width: 0;\n  transition: width 0.3s;\n}\n.felo-search-icon .ant-input:focus {\n  width: 172px;\n}\n.felo-search-input,\n.felo-search-icon {\n  background: #fff;\n  border: 1px solid #2994ff;\n  border-radius: 18px;\n}\n.felo-search-input .ant-input::-moz-placeholder,\n.felo-search-icon .ant-input::-moz-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input:-ms-input-placeholder,\n.felo-search-icon .ant-input:-ms-input-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input::placeholder,\n.felo-search-icon .ant-input::placeholder {\n  color: #8a9ab3;\n}\n.felo-search-value {\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item {\n  padding: 0 4px;\n  margin: 0 4px;\n  color: #464e5a;\n  font-size: 14px;\n  background: #e0e0e0;\n  border-radius: 14px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item:first-child {\n  margin-left: 0;\n}\n.felo-search-value-item:last-child {\n  margin-right: 0;\n}\n.felo-search-value-more {\n  cursor: pointer;\n}\n.felo-search-value-close {\n  margin-left: 4px;\n  margin-top: 0 !important;\n}\n.felo-search-value-close:hover {\n  color: #ff4d4f !important;\n}\n.felo-search-value-popover {\n  display: flex;\n  align-items: center;\n  max-width: 540px;\n  flex-wrap: wrap;\n}\n.felo-search-value-popover .felo-search-value-item {\n  margin: 2px 4px;\n}\n.felo-search-input {\n  padding: 6.5px 10px;\n}\n.felo-search-input .ant-input-prefix {\n  position: unset;\n  transform: none;\n}\n.felo-search-input .ant-input-prefix .anticon {\n  margin-top: 4px;\n  color: #717b8b;\n}\n.felo-search-list {\n  max-height: 270px;\n  overflow-y: auto;\n}\n.felo-search-list.scroll-y {\n  padding-right: 0 !important;\n}\n.felo-search-list .felo-search-list-item {\n  display: flex;\n  align-items: center;\n  min-width: 216px !important;\n  padding: 8px 24px;\n  cursor: pointer;\n}\n.felo-search-list .felo-search-list-item:hover {\n  background-color: #f1f1f1;\n}\n.felo-search-popover {\n  width: 440px;\n}\n.felo-search-popover .ant-popover-arrow {\n  display: none;\n}\n.felo-search-popover .ant-popover-inner {\n  background: #fff;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-search-popover .felo-search-list .item {\n  padding: 12px 20px;\n}\n";
styleInject(css_248z$8);

var _excluded$2 = ["values", "data", "loading", "defaultMode", "onRenderItem", "onChange", "onRemove", "onValuesChange", "onRenderValue", "onRenderRemove"];

var Search = function Search(_ref) {
  var values = _ref.values,
      data = _ref.data,
      loading = _ref.loading,
      defaultMode = _ref.defaultMode,
      onRenderItem = _ref.onRenderItem,
      onChange = _ref.onChange,
      onRemove = _ref.onRemove,
      onValuesChange = _ref.onValuesChange,
      onRenderValue = _ref.onRenderValue,
      onRenderRemove = _ref.onRenderRemove,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('search');

  var _useLocaleReceiver = useLocaleReceiver('global'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var containerRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useState3 = React.useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      hideIndex = _useState4[0],
      setHideIndex = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      popoverVisible = _useState6[0],
      setPopoverVisible = _useState6[1]; // 输入框值改变


  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;
    setValue(inputValue);
    if (onChange) onChange(inputValue);
  };

  var handleBlur = function handleBlur() {
    if (defaultMode === 'icon') {
      setValue('');
    }
  }; // 选择项改变


  var handleSelect = function handleSelect(item) {
    var selValue = undefined;
    if (props.onSelect) selValue = props.onSelect(item) || undefined;

    if (onValuesChange && selValue && !(values === null || values === void 0 ? void 0 : values.find(function (v) {
      var _selValue;

      return v.key === ((_selValue = selValue) === null || _selValue === void 0 ? void 0 : _selValue.key);
    }))) {
      var _inputRef$current;

      var newValues = (values === null || values === void 0 ? void 0 : values.concat()) || [];
      newValues.push(selValue);
      onValuesChange(newValues);
      setValue('');
      if (onChange) onChange('');
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }; // 按下删除键


  var handleBackspace = function handleBackspace(event) {
    if (onValuesChange && isHotkey.isHotkey('backspace', event.nativeEvent)) {
      // 输入框没有值，并且选择的值大于0
      if (!value && values && (values === null || values === void 0 ? void 0 : values.length) > 0) {
        event.preventDefault(); // 删除最后一个

        var newValues = values.concat();
        if (onRemove) onRemove(newValues[newValues.length - 1]);
        newValues.pop();
        onValuesChange(newValues);
        if (hideIndex === newValues.length - 1) setHideIndex(-1);
      }
    }
  };

  var handleRemove = function handleRemove(key) {
    if (!values || !onValuesChange) return;
    var newValues = values.concat();
    var index = newValues.findIndex(function (v) {
      return v.key === key;
    });

    if (index > -1) {
      if (onRemove) onRemove(newValues[index]);
      newValues.splice(index, 1);
    }

    onValuesChange(newValues);
    if (hideIndex === newValues.length) setHideIndex(-1);
  }; // 渲染列表


  var renderList = function renderList() {
    // 没有值，或者没有数据不展示列表
    if (!value || !data) return; // 加载中

    if (loading) return /*#__PURE__*/React__default['default'].createElement(Loading$1, null); // 没有数据

    if (data.length === 0) return props.onRenderEmpty ? props.onRenderEmpty() : /*#__PURE__*/React__default['default'].createElement(_Empty__default['default'], null); // 渲染列表

    return /*#__PURE__*/React__default['default'].createElement(SearchList, {
      className: props.listClassName,
      data: data,
      onSelect: handleSelect,
      onRenderItem: onRenderItem
    });
  }; // 处理列表渲染


  React.useEffect(function () {
    var content = renderList();
    containerRef.current = props.getListContainer ? props.getListContainer() : null;

    if (props.getListContainer && content) {
      ReactDOM__default['default'].render( /*#__PURE__*/React__default['default'].createElement(FeloConfigProvider, {
        lang: locale.locale
      }, content), containerRef.current);
    } else if (containerRef.current) {
      ReactDOM__default['default'].unmountComponentAtNode(containerRef.current);
    }
  }, [props.getListContainer, renderList]);
  React.useEffect(function () {
    if (!values || hideIndex > -1) return;

    if (inputRef.current && inputRef.current.input.offsetWidth <= 126) {
      setHideIndex(Math.min(values.length - 1, 3));
    } else {
      setHideIndex(-1);
    }
  }, [values, hideIndex]);
  React.useEffect(function () {
    setPopoverVisible(!!value);
  }, [value]); // 渲染输入框前缀和选择的值

  var renderPrefix = function renderPrefix() {
    var renderItem = function renderItem(value) {
      return /*#__PURE__*/React__default['default'].createElement("span", {
        key: value.key,
        className: "".concat(prefixCls, "-value-item")
      }, /*#__PURE__*/React__default['default'].createElement("span", {
        key: value.key
      }, onRenderValue ? onRenderValue(value) : value.key), onRenderRemove ? onRenderRemove(value, handleRemove) : /*#__PURE__*/React__default['default'].createElement(Icon.CloseCircleOutlined, {
        className: "".concat(prefixCls, "-value-close"),
        onClick: function onClick() {
          return handleRemove(value.key);
        }
      }));
    };

    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.prefix !== undefined ? props.prefix : /*#__PURE__*/React__default['default'].createElement(SearchIcon, null), values && values.length > 0 && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-value")
    }, values === null || values === void 0 ? void 0 : values.map(function (value, index) {
      if (hideIndex > -1 && index >= hideIndex) return;
      return renderItem(value);
    }), hideIndex > -1 && hideIndex < values.length && /*#__PURE__*/React__default['default'].createElement(_Popover__default['default'], {
      content: /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-value-popover")
      }, values.map(function (value, index) {
        if (index < hideIndex) return;
        return renderItem(value);
      }))
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "".concat(prefixCls, "-value-more"),
      key: hideIndex
    }, "+".concat(values.length - hideIndex, " ...")))));
  }; // 渲染输入框


  var renderInput = function renderInput() {
    return /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
      "data-role": "search",
      ref: inputRef,
      className: "".concat("".concat(prefixCls, "-").concat(defaultMode || 'input'), " ", props.className || ''),
      size: "large",
      value: value,
      placeholder: props.placeholder,
      prefix: renderPrefix(),
      suffix: props.suffix,
      onBlur: handleBlur,
      onInput: handleChange,
      onKeyDown: handleBackspace
    });
  }; // 渲染弹出框


  if (props.popover && !props.getListContainer) {
    return /*#__PURE__*/React__default['default'].createElement(_Popover__default['default'], {
      visible: popoverVisible,
      content: renderList(),
      placement: "bottomRight",
      overlayClassName: "".concat(prefixCls, "-popover")
    }, renderInput());
  } // 普通渲染


  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, renderInput(), !props.getListContainer && renderList());
};

//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

var hookCallback;

function hooks() {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}

function isArray(input) {
    return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === '[object Array]'
    );
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return (
        input != null &&
        Object.prototype.toString.call(input) === '[object Object]'
    );
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
    } else {
        var k;
        for (k in obj) {
            if (hasOwnProp(obj, k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return (
        typeof input === 'number' ||
        Object.prototype.toString.call(input) === '[object Number]'
    );
}

function isDate(input) {
    return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
    );
}

function map(arr, fn) {
    var res = [],
        i,
        arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false,
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this),
            len = t.length >>> 0,
            i;

        for (i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m),
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            }),
            isNowValid =
                !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid =
                isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    } else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = (hooks.momentProperties = []),
    updateInProgress = false;

function copyConfig(to, from) {
    var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment(obj) {
    return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
    );
}

function warn(msg) {
    if (
        hooks.suppressDeprecationWarnings === false &&
        typeof console !== 'undefined' &&
        console.warn
    ) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [],
                arg,
                i,
                key,
                argLen = arguments.length;
            for (i = 0; i < argLen; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (key in arguments[0]) {
                        if (hasOwnProp(arguments[0], key)) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(
                msg +
                    '\nArguments: ' +
                    Array.prototype.slice.call(args).join('') +
                    '\n' +
                    new Error().stack
            );
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
    );
}

function set(config) {
    var prop, i;
    for (i in config) {
        if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' +
            /\d{1,2}/.source
    );
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (
            hasOwnProp(parentConfig, prop) &&
            !hasOwnProp(childConfig, prop) &&
            isObject(parentConfig[prop])
        ) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i,
            res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L',
};

function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (
        (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
        absNumber
    );
}

var formattingTokens =
        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    formatFunctions = {},
    formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(
                func.apply(this, arguments),
                token
            );
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '',
            i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i])
                ? array[i].call(mom, format)
                : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
            localFormattingTokens,
            replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
};

function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper
        .match(formattingTokens)
        .map(function (tok) {
            if (
                tok === 'MMMM' ||
                tok === 'MM' ||
                tok === 'DD' ||
                tok === 'dddd'
            ) {
                return tok.slice(1);
            }
            return tok;
        })
        .join('');

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate() {
    return this._invalidDate;
}

var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal(number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
};

function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number);
}

function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string'
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [],
        u;
    for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
            units.push({ unit: u, priority: priorities[u] });
        }
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function absFloor(number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

function makeGetSet(unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get$1(this, unit);
        }
    };
}

function get$1(mom, unit) {
    return mom.isValid()
        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
        : NaN;
}

function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (
            unit === 'FullYear' &&
            isLeapYear(mom.year()) &&
            mom.month() === 1 &&
            mom.date() === 29
        ) {
            value = toInt(value);
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                value,
                mom.month(),
                daysInMonth(value, mom.month())
            );
        } else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}

function stringSet(units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
            i,
            prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

var match1 = /\d/, //       0 - 9
    match2 = /\d\d/, //      00 - 99
    match3 = /\d{3}/, //     000 - 999
    match4 = /\d{4}/, //    0000 - 9999
    match6 = /[+-]?\d{6}/, // -999999 - 999999
    match1to2 = /\d\d?/, //       0 - 99
    match3to4 = /\d\d\d\d?/, //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
    match1to3 = /\d{1,3}/, //       0 - 999
    match1to4 = /\d{1,4}/, //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
    matchUnsigned = /\d+/, //       0 - inf
    matchSigned = /[+-]?\d+/, //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord =
        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    regexes;

regexes = {};

function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex)
        ? regex
        : function (isStrict, localeData) {
              return isStrict && strictRegex ? strictRegex : regex;
          };
}

function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(
        s
            .replace('\\', '')
            .replace(
                /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                function (matched, p1, p2, p3, p4) {
                    return p1 || p2 || p3 || p4;
                }
            )
    );
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken(token, callback) {
    var i,
        func = callback,
        tokenLen;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    tokenLen = token.length;
    for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1
        ? isLeapYear(year)
            ? 29
            : 28
        : 31 - ((modMonth % 7) % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M', match1to2);
addRegexToken('MM', match1to2, match2);
addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var defaultLocaleMonths =
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
    defaultLocaleMonthsShort =
        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    defaultMonthsShortRegex = matchWord,
    defaultMonthsRegex = matchWord;

function localeMonths(m, format) {
    if (!m) {
        return isArray(this._months)
            ? this._months
            : this._months['standalone'];
    }
    return isArray(this._months)
        ? this._months[m.month()]
        : this._months[
              (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                  ? 'format'
                  : 'standalone'
          ][m.month()];
}

function localeMonthsShort(m, format) {
    if (!m) {
        return isArray(this._monthsShort)
            ? this._monthsShort
            : this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
              MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
          ][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp(
                '^' + this.months(mom, '').replace('.', '') + '$',
                'i'
            );
            this._shortMonthsParse[i] = new RegExp(
                '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                'i'
            );
        }
        if (!strict && !this._monthsParse[i]) {
            regex =
                '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'MMMM' &&
            this._longMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'MMM' &&
            this._shortMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth(value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get$1(this, 'Month');
    }
}

function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
}

function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict
            ? this._monthsShortStrictRegex
            : this._monthsShortRegex;
    }
}

function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict
            ? this._monthsStrictRegex
            : this._monthsRegex;
    }
}

function computeMonthsParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._monthsShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY', 4], 0, 'year');
addFormatToken(0, ['YYYYY', 5], 0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y', matchSigned);
addRegexToken('YY', match1to2, match2);
addRegexToken('YYYY', match1to4, match4);
addRegexToken('YYYYY', match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] =
        input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear() {
    return isLeapYear(this.year());
}

function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
    } else {
        date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
}

function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
    } else {
        date = new Date(Date.UTC.apply(null, arguments));
    }

    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear,
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear,
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w', match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W', match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(
    ['w', 'ww', 'W', 'WW'],
    function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    }
);

// HELPERS

// LOCALES

function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow: 0, // Sunday is the first day of the week.
    doy: 6, // The week that contains Jan 6th is the first week of the year.
};

function localeFirstDayOfWeek() {
    return this._week.dow;
}

function localeFirstDayOfYear() {
    return this._week.doy;
}

// MOMENTS

function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d', match1to2);
addRegexToken('e', match1to2);
addRegexToken('E', match1to2);
addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES
function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
}

var defaultLocaleWeekdays =
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    defaultWeekdaysRegex = matchWord,
    defaultWeekdaysShortRegex = matchWord,
    defaultWeekdaysMinRegex = matchWord;

function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays)
        ? this._weekdays
        : this._weekdays[
              m && m !== true && this._weekdays.isFormat.test(format)
                  ? 'format'
                  : 'standalone'
          ];
    return m === true
        ? shiftWeekdays(weekdays, this._week.dow)
        : m
        ? weekdays[m.day()]
        : weekdays;
}

function localeWeekdaysShort(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : m
        ? this._weekdaysShort[m.day()]
        : this._weekdaysShort;
}

function localeWeekdaysMin(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : m
        ? this._weekdaysMin[m.day()]
        : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(
                mom,
                ''
            ).toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp(
                '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._shortWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._minWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
        }
        if (!this._weekdaysParse[i]) {
            regex =
                '^' +
                this.weekdays(mom, '') +
                '|^' +
                this.weekdaysShort(mom, '') +
                '|^' +
                this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'dddd' &&
            this._fullWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'ddd' &&
            this._shortWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'dd' &&
            this._minWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict
            ? this._weekdaysStrictRegex
            : this._weekdaysRegex;
    }
}

function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict
            ? this._weekdaysShortStrictRegex
            : this._weekdaysShortRegex;
    }
}

function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict
            ? this._weekdaysMinStrictRegex
            : this._weekdaysMinRegex;
    }
}

function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._weekdaysShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
    this._weekdaysMinStrictRegex = new RegExp(
        '^(' + minPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return (
        '' +
        hFormat.apply(this) +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
    );
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return (
        '' +
        this.hours() +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
    );
});

function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            lowercase
        );
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a', matchMeridiem);
addRegexToken('A', matchMeridiem);
addRegexToken('H', match1to2);
addRegexToken('h', match1to2);
addRegexToken('k', match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}

var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse,
};

// internal storage for locale config files
var locales$1 = {},
    localeFamilies = {},
    globalLocale;

function commonPrefix(arr1, arr2) {
    var i,
        minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
            return i;
        }
    }
    return minl;
}

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (
                next &&
                next.length >= j &&
                commonPrefix(split, next) >= j - 1
            ) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function isLocaleNameSane(name) {
    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
    return name.match('^[^/\\\\]*$') != null;
}

function loadLocale(name) {
    var oldLocale = null,
        aliasedRequire;
    // TODO: Find a better way to register and load all the locales in Node
    if (
        locales$1[name] === undefined &&
        typeof module !== 'undefined' &&
        module &&
        module.exports &&
        isLocaleNameSane(name)
    ) {
        try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = require;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales$1[name] = null; // null means not found
        }
    }
    return locales$1[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        } else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        } else {
            if (typeof console !== 'undefined' && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn(
                    'Locale ' + key + ' not found. Did you forget to load it?'
                );
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale(name, config) {
    if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;
        if (locales$1[name] != null) {
            deprecateSimple(
                'defineLocaleOverride',
                'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
            );
            parentConfig = locales$1[name]._config;
        } else if (config.parentLocale != null) {
            if (locales$1[config.parentLocale] != null) {
                parentConfig = locales$1[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config,
                    });
                    return null;
                }
            }
        }
        locales$1[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);

        return locales$1[name];
    } else {
        // useful for testing
        delete locales$1[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig;

        if (locales$1[name] != null && locales$1[name].parentLocale != null) {
            // Update existing child locale in-place to avoid memory-leaks
            locales$1[name].set(mergeConfigs(locales$1[name]._config, config));
        } else {
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            if (tmpLocale == null) {
                // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
            }
            locale = new Locale(config);
            locale.parentLocale = locales$1[name];
            locales$1[name] = locale;
        }

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales$1[name] != null) {
            if (locales$1[name].parentLocale != null) {
                locales$1[name] = locales$1[name].parentLocale;
                if (name === getSetGlobalLocale()) {
                    getSetGlobalLocale(name);
                }
            } else if (locales$1[name] != null) {
                delete locales$1[name];
            }
        }
    }
    return locales$1[name];
}

// returns locale data
function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales$1);
}

function checkOverflow(m) {
    var overflow,
        a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH] < 0 || a[MONTH] > 11
                ? MONTH
                : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                ? DATE
                : a[HOUR] < 0 ||
                  a[HOUR] > 24 ||
                  (a[HOUR] === 24 &&
                      (a[MINUTE] !== 0 ||
                          a[SECOND] !== 0 ||
                          a[MILLISECOND] !== 0))
                ? HOUR
                : a[MINUTE] < 0 || a[MINUTE] > 59
                ? MINUTE
                : a[SECOND] < 0 || a[SECOND] > 59
                ? SECOND
                : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                ? MILLISECOND
                : -1;

        if (
            getParsingFlags(m)._overflowDayOfYear &&
            (overflow < YEAR || overflow > DATE)
        ) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    basicIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
    isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/],
        ['YYYYMM', /\d{6}/, false],
        ['YYYY', /\d{4}/, false],
    ],
    // iso time formats and regexes
    isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/],
    ],
    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 =
        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60,
    };

// date from iso format
function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;

    if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimesLen; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

function extractFromRFC2822Strings(
    yearStr,
    monthStr,
    dayStr,
    hourStr,
    minuteStr,
    secondStr
) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s
        .replace(/\([^()]*\)|[\n\t]/g, ' ')
        .replace(/(\s\s+)/g, ' ')
        .replace(/^\s\s*/, '')
        .replace(/\s\s*$/, '');
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(
                parsedInput[0],
                parsedInput[1],
                parsedInput[2]
            ).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10),
            m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
    if (match) {
        parsedArray = extractFromRFC2822Strings(
            match[4],
            match[3],
            match[2],
            match[5],
            match[6],
            match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    if (config._strict) {
        config._isValid = false;
    } else {
        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate(),
        ];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (
            config._dayOfYear > daysInYear(yearToUse) ||
            config._dayOfYear === 0
        ) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] =
            config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (
        config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0
    ) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
    );
    expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (
        config._w &&
        typeof config._w.d !== 'undefined' &&
        config._w.d !== expectedWeekday
    ) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(
            w.GG,
            config._a[YEAR],
            weekOfYear(createLocal(), 1, 4).year
        );
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from beginning of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to beginning of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;

    tokens =
        expandFormat(config._f, config._locale).match(formattingTokens) || [];
    tokenLen = tokens.length;
    for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
            [])[0];
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(
                string.indexOf(parsedInput) + parsedInput.length
            );
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            } else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver =
        stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (
        config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0
    ) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
    );

    // handle era
    era = getParsingFlags(config).era;
    if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }

    configFromArray(config);
    checkOverflow(config);
}

function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;

    if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (isValid(tempConfig)) {
            validFormatFound = true;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (!bestFormatIsValid) {
            if (
                scoreToBeat == null ||
                currentScore < scoreToBeat ||
                validFormatFound
            ) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
                if (validFormatFound) {
                    bestFormatIsValid = true;
                }
            }
        } else {
            if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function (obj) {
            return obj && parseInt(obj, 10);
        }
    );

    configFromArray(config);
}

function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig(config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({ nullInput: true });
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    } else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (format === true || format === false) {
        strict = format;
        format = undefined;
    }

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if (
        (isObject(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)
    ) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    ),
    prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +new Date();
};

var ordering = [
    'year',
    'quarter',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond',
];

function isDurationValid(m) {
    var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
    for (key in m) {
        if (
            hasOwnProp(m, key) &&
            !(
                indexOf.call(ordering, key) !== -1 &&
                (m[key] == null || !isNaN(m[key]))
            )
        ) {
            return false;
        }
    }

    for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds =
        +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration(obj) {
    return obj instanceof Duration;
}

function absRound(number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if (
            (dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
        ) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

// FORMATTING

function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
            sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return (
            sign +
            zeroFill(~~(offset / 60), 2) +
            separator +
            zeroFill(~~offset % 60, 2)
        );
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z', matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;

    if (matches === null) {
        return null;
    }

    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff =
            (isMoment(input) || isDate(input)
                ? input.valueOf()
                : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(
                    this,
                    createDuration(input - offset, 'm'),
                    1,
                    false
                );
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone(input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset() {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        } else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime() {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {},
        other;

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted =
            this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal() {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
}

function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex =
        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months,
        };
    } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
            duration[key] = +input;
        } else {
            duration.milliseconds = +input;
        }
    } else if ((match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: 0,
            d: toInt(match[DATE]) * sign,
            h: toInt(match[HOUR]) * sign,
            m: toInt(match[MINUTE]) * sign,
            s: toInt(match[SECOND]) * sign,
            ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
        };
    } else if ((match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: parseIso(match[2], sign),
            M: parseIso(match[3], sign),
            w: parseIso(match[4], sign),
            d: parseIso(match[5], sign),
            h: parseIso(match[6], sign),
            m: parseIso(match[7], sign),
            s: parseIso(match[8], sign),
        };
    } else if (duration == null) {
        // checks for null or undefined
        duration = {};
    } else if (
        typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)
    ) {
        diffRes = momentsDifference(
            createLocal(duration.from),
            createLocal(duration.to)
        );

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {};

    res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(
                name,
                'moment().' +
                    name +
                    '(period, number) is deprecated. Please use moment().' +
                    name +
                    '(number, period). ' +
                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
            );
            tmp = val;
            val = period;
            period = tmp;
        }

        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get$1(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get$1(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add = createAdder(1, 'add'),
    subtract = createAdder(-1, 'subtract');

function isString(input) {
    return typeof input === 'string' || input instanceof String;
}

// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
function isMomentInput(input) {
    return (
        isMoment(input) ||
        isDate(input) ||
        isString(input) ||
        isNumber(input) ||
        isNumberOrStringArray(input) ||
        isMomentInputObject(input) ||
        input === null ||
        input === undefined
    );
}

function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms',
        ],
        i,
        property,
        propertyLen = properties.length;

    for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
}

function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
        dataTypeTest = false;
    if (arrayTest) {
        dataTypeTest =
            input.filter(function (item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
    }
    return arrayTest && dataTypeTest;
}

function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse',
        ],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
}

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6
        ? 'sameElse'
        : diff < -1
        ? 'lastWeek'
        : diff < 0
        ? 'lastDay'
        : diff < 1
        ? 'sameDay'
        : diff < 2
        ? 'nextDay'
        : diff < 7
        ? 'nextWeek'
        : 'sameElse';
}

function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
        if (!arguments[0]) {
            time = undefined;
            formats = undefined;
        } else if (isMomentInput(arguments[0])) {
            time = arguments[0];
            formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
            formats = arguments[0];
            time = undefined;
        }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output =
            formats &&
            (isFunction(formats[format])
                ? formats[format].call(this, now)
                : formats[format]);

    return this.format(
        output || this.localeData().calendar(format, this, createLocal(now))
    );
}

function clone() {
    return new Moment(this);
}

function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
    }
    inclusivity = inclusivity || '()';
    return (
        (inclusivity[0] === '('
            ? this.isAfter(localFrom, units)
            : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')'
            ? this.isBefore(localTo, units)
            : !this.isAfter(localTo, units))
    );
}

function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return (
            this.clone().startOf(units).valueOf() <= inputMs &&
            inputMs <= this.clone().endOf(units).valueOf()
        );
    }
}

function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
}

function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
}

function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year':
            output = monthDiff(this, that) / 12;
            break;
        case 'month':
            output = monthDiff(this, that);
            break;
        case 'quarter':
            output = monthDiff(this, that) / 3;
            break;
        case 'second':
            output = (this - that) / 1e3;
            break; // 1000
        case 'minute':
            output = (this - that) / 6e4;
            break; // 1000 * 60
        case 'hour':
            output = (this - that) / 36e5;
            break; // 1000 * 60 * 60
        case 'day':
            output = (this - that - zoneDelta) / 864e5;
            break; // 1000 * 60 * 60 * 24, negate dst
        case 'week':
            output = (this - that - zoneDelta) / 6048e5;
            break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
            output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff(a, b) {
    if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
    }
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
            m,
            utc
                ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                .toISOString()
                .replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(
        m,
        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
    );
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect() {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format(inputString) {
    if (!inputString) {
        inputString = this.isUtc()
            ? hooks.defaultFormatUtc
            : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
    ) {
        return createDuration({ to: this, from: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to$4(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
    ) {
        return createDuration({ from: this, to: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale(key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData$o() {
    return this._locale;
}

var MS_PER_SECOND = 1000,
    MS_PER_MINUTE = 60 * MS_PER_SECOND,
    MS_PER_HOUR = 60 * MS_PER_MINUTE,
    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

// actual modulo - handles negative numbers (for dates before 1970):
function mod$1(dividend, divisor) {
    return ((dividend % divisor) + divisor) % divisor;
}

function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return new Date(y, m, d).valueOf();
    }
}

function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return Date.UTC(y, m, d);
    }
}

function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year(), 0, 1);
            break;
        case 'quarter':
            time = startOfDate(
                this.year(),
                this.month() - (this.month() % 3),
                1
            );
            break;
        case 'month':
            time = startOfDate(this.year(), this.month(), 1);
            break;
        case 'week':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - this.weekday()
            );
            break;
        case 'isoWeek':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - (this.isoWeekday() - 1)
            );
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date());
            break;
        case 'hour':
            time = this._d.valueOf();
            time -= mod$1(
                time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                MS_PER_HOUR
            );
            break;
        case 'minute':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_MINUTE);
            break;
        case 'second':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_SECOND);
            break;
    }

    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}

function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
        case 'quarter':
            time =
                startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3) + 3,
                    1
                ) - 1;
            break;
        case 'month':
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
        case 'week':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday() + 7
                ) - 1;
            break;
        case 'isoWeek':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1) + 7
                ) - 1;
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
        case 'hour':
            time = this._d.valueOf();
            time +=
                MS_PER_HOUR -
                mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                ) -
                1;
            break;
        case 'minute':
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
            break;
        case 'second':
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
            break;
    }

    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}

function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
}

function unix() {
    return Math.floor(this.valueOf() / 1000);
}

function toDate() {
    return new Date(this.valueOf());
}

function toArray() {
    var m = this;
    return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond(),
    ];
}

function toObject() {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds(),
    };
}

function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2() {
    return isValid(this);
}

function parsingFlags() {
    return extend({}, getParsingFlags(this));
}

function invalidAt() {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict,
    };
}

addFormatToken('N', 0, 0, 'eraAbbr');
addFormatToken('NN', 0, 0, 'eraAbbr');
addFormatToken('NNN', 0, 0, 'eraAbbr');
addFormatToken('NNNN', 0, 0, 'eraName');
addFormatToken('NNNNN', 0, 0, 'eraNarrow');

addFormatToken('y', ['y', 1], 'yo', 'eraYear');
addFormatToken('y', ['yy', 2], 0, 'eraYear');
addFormatToken('y', ['yyy', 3], 0, 'eraYear');
addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

addRegexToken('N', matchEraAbbr);
addRegexToken('NN', matchEraAbbr);
addRegexToken('NNN', matchEraAbbr);
addRegexToken('NNNN', matchEraName);
addRegexToken('NNNNN', matchEraNarrow);

addParseToken(
    ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
    function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    }
);

addRegexToken('y', matchUnsigned);
addRegexToken('yy', matchUnsigned);
addRegexToken('yyy', matchUnsigned);
addRegexToken('yyyy', matchUnsigned);
addRegexToken('yo', matchEraYearOrdinal);

addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
addParseToken(['yo'], function (input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
    }

    if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
        array[YEAR] = parseInt(input, 10);
    }
});

function localeEras(m, format) {
    var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
            case 'string':
                // truncate time
                date = hooks(eras[i].since).startOf('day');
                eras[i].since = date.valueOf();
                break;
        }

        switch (typeof eras[i].until) {
            case 'undefined':
                eras[i].until = +Infinity;
                break;
            case 'string':
                // truncate time
                date = hooks(eras[i].until).startOf('day').valueOf();
                eras[i].until = date.valueOf();
                break;
        }
    }
    return eras;
}

function localeErasParse(eraName, format, strict) {
    var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
    eraName = eraName.toUpperCase();

    for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();

        if (strict) {
            switch (format) {
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNN':
                    if (name === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNNN':
                    if (narrow === eraName) {
                        return eras[i];
                    }
                    break;
            }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
            return eras[i];
        }
    }
}

function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;
    if (year === undefined) {
        return hooks(era.since).year();
    } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
    }
}

function getEraName() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].name;
        }
    }

    return '';
}

function getEraNarrow() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].narrow;
        }
    }

    return '';
}

function getEraAbbr() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].abbr;
        }
    }

    return '';
}

function getEraYear() {
    var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;

        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (
            (eras[i].since <= val && val <= eras[i].until) ||
            (eras[i].until <= val && val <= eras[i].since)
        ) {
            return (
                (this.year() - hooks(eras[i].since).year()) * dir +
                eras[i].offset
            );
        }
    }

    return this.year();
}

function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
}

function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
}

function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
}

function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
}

function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
}

function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
}

function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
}

function computeErasParse() {
    var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();

    for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));

        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
    }

    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp(
        '^(' + narrowPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg', 'weekYear');
addWeekYearFormatToken('ggggg', 'weekYear');
addWeekYearFormatToken('GGGG', 'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);

// PARSING

addRegexToken('G', matchSigned);
addRegexToken('g', matchSigned);
addRegexToken('GG', match1to2, match2);
addRegexToken('gg', match1to2, match2);
addRegexToken('GGGG', match1to4, match4);
addRegexToken('gggg', match1to4, match4);
addRegexToken('GGGGG', match1to6, match6);
addRegexToken('ggggg', match1to6, match6);

addWeekParseToken(
    ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
    function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    }
);

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
    );
}

function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
    );
}

function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
}

function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
}

function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter(input) {
    return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3));
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIORITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D', match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD', match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear(input) {
    var dayOfYear =
        Math.round(
            (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
        ) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m', match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s', match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});

// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S', match1to3, match1);
addRegexToken('SS', match1to3, match2);
addRegexToken('SSS', match1to3, match3);

var token, getSetMillisecond;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}

getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z', 0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to$4;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData$o;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== 'undefined' && Symbol.for != null) {
    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
    };
}
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
    'dates accessor is deprecated. Use date instead.',
    getSetDayOfMonth
);
proto.months = deprecate(
    'months accessor is deprecated. Use month instead',
    getSetMonth
);
proto.years = deprecate(
    'years accessor is deprecated. Use year instead',
    getSetYear
);
proto.zone = deprecate(
    'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
    getSetZone
);
proto.isDSTShifted = deprecate(
    'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
    isDaylightSavingTimeShifted
);

function createUnix(input) {
    return createLocal(input * 1000);
}

function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat(string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;

proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;

proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;

proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1$1(format, index, field, setter) {
    var locale = getLocale(),
        utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1$1(format, index, field, 'month');
    }

    var i,
        out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];

    if (index != null) {
        return get$1$1(format, (index + shift) % 7, field, 'day');
    }

    for (i = 0; i < 7; i++) {
        out[i] = get$1$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    eras: [
        {
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD',
        },
        {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC',
        },
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
        var b = number % 10,
            output =
                toInt((number % 100) / 10) === 1
                    ? 'th'
                    : b === 1
                    ? 'st'
                    : b === 2
                    ? 'nd'
                    : b === 3
                    ? 'rd'
                    : 'th';
        return number + output;
    },
});

// Side effect imports

hooks.lang = deprecate(
    'moment.lang is deprecated. Use moment.locale instead.',
    getSetGlobalLocale
);
hooks.langData = deprecate(
    'moment.langData is deprecated. Use moment.localeData instead.',
    getLocale
);

var mathAbs = Math.abs;

function abs() {
    var data = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);

    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);

    return this;
}

function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil(number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble() {
    var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (
        !(
            (milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0)
        )
    ) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;

    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;

    hours = absFloor(minutes / 60);
    data.hours = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days = days;
    data.months = months;
    data.years = years;

    return this;
}

function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return (days * 4800) / 146097;
}

function monthsToDays(months) {
    // the reverse of daysToMonths
    return (months * 146097) / 4800;
}

function as(units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days,
        months,
        milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
            case 'month':
                return months;
            case 'quarter':
                return months / 3;
            case 'year':
                return months / 12;
        }
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week':
                return days / 7 + milliseconds / 6048e5;
            case 'day':
                return days + milliseconds / 864e5;
            case 'hour':
                return days * 24 + milliseconds / 36e5;
            case 'minute':
                return days * 1440 + milliseconds / 6e4;
            case 'second':
                return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond':
                return Math.floor(days * 864e5) + milliseconds;
            default:
                throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1() {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs(alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms'),
    asSeconds = makeAs('s'),
    asMinutes = makeAs('m'),
    asHours = makeAs('h'),
    asDays = makeAs('d'),
    asWeeks = makeAs('w'),
    asMonths = makeAs('M'),
    asQuarters = makeAs('Q'),
    asYears = makeAs('y');

function clone$1() {
    return createDuration(this);
}

function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds'),
    seconds = makeGetter('seconds'),
    minutes = makeGetter('minutes'),
    hours = makeGetter('hours'),
    days = makeGetter('days'),
    months = makeGetter('months'),
    years = makeGetter('years');

function weeks() {
    return absFloor(this.days() / 7);
}

var round = Math.round,
    thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11, // months to year
    };

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a =
            (seconds <= thresholds.ss && ['s', seconds]) ||
            (seconds < thresholds.s && ['ss', seconds]) ||
            (minutes <= 1 && ['m']) ||
            (minutes < thresholds.m && ['mm', minutes]) ||
            (hours <= 1 && ['h']) ||
            (hours < thresholds.h && ['hh', hours]) ||
            (days <= 1 && ['d']) ||
            (days < thresholds.d && ['dd', days]);

    if (thresholds.w != null) {
        a =
            a ||
            (weeks <= 1 && ['w']) ||
            (weeks < thresholds.w && ['ww', weeks]);
    }
    a = a ||
        (months <= 1 && ['M']) ||
        (months < thresholds.M && ['MM', months]) ||
        (years <= 1 && ['y']) || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var withSuffix = false,
        th = thresholds,
        locale,
        output;

    if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
    }
    if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
    }
    if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
            th.ss = argThresholds.s - 1;
        }
    }

    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return (x > 0) - (x < 0) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return (
        totalSign +
        'P' +
        (years ? ymSign + years + 'Y' : '') +
        (months ? ymSign + months + 'M' : '') +
        (days ? daysSign + days + 'D' : '') +
        (hours || minutes || seconds ? 'T' : '') +
        (hours ? hmsSign + hours + 'H' : '') +
        (minutes ? hmsSign + minutes + 'M' : '') +
        (seconds ? hmsSign + s + 'S' : '')
    );
}

var proto$2 = Duration.prototype;

proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData$o;

proto$2.toIsoString = deprecate(
    'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
    toISOString$1
);
proto$2.lang = lang;

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

//! moment.js

hooks.version = '2.29.4';

setHookCallback(createLocal);

hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD', // <input type="date" />
    TIME: 'HH:mm', // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW', // <input type="week" />
    MONTH: 'YYYY-MM', // <input type="month" />
};

var DeptSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var request = _ref.request,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      closeModal = _ref.closeModal,
      querying = _ref.querying,
      selectedValues = _ref.selectedValues,
      searchData = _ref.searchData,
      onValuesChange = _ref.onValuesChange;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-dept');

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var _useState3 = React.useState({
    deptes: [],
    members: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPath = _useState6[0],
      setCurrentPath = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState9 = React.useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedItems = _useState10[0],
      setSelectedItems = _useState10[1];

  var _useState11 = React.useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      searchKeyword = _useState12[0],
      setSearchKeyword = _useState12[1];

  var findData = function findData(id, child) {
    var target = child.deptes.find(function (item) {
      return item.id === id;
    });

    if (target) {
      return target;
    }

    for (var i = 0; i < child.deptes.length; i++) {
      var item = child.deptes[i];

      if (item.child) {
        var result = findData(id, item.child);
        if (result) return result;
      }
    }

    return;
  };

  var load = function load() {
    var deptId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!request) return;

    if (deptId) {
      setLoading(true);
    }

    request(deptId).then(function (res) {
      var newData = data ? _objectSpread2({}, data) : {
        deptes: [],
        members: []
      };
      var parent = findData(deptId, newData);

      if (parent) {
        parent.child = res;
        setData(newData);
      } else {
        setData(res);
      }
    }).finally(function () {
      setLoading(false);
    });
  };

  React.useImperativeHandle(ref, function () {
    return {
      updateChecked: function updateChecked(info, checked) {
        var newData = data ? _objectSpread2({}, data) : {
          deptes: [],
          members: []
        };
        findMembers(newData, function (member) {
          if (String(member.id) === String(info.id)) {
            member.checked = checked;
          }

          return false;
        });
        setData(newData);
      }
    };
  });
  React.useEffect(function () {
    load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (onValuesChange) onValuesChange(selectedItems);
  }, [selectedItems, onValuesChange]);

  var findPath = function findPath(_ref2, child) {
    var _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        name = _ref3[1];

    for (var i = 0; i < child.deptes.length; i++) {
      var item = child.deptes[i];

      if (item.id === id) {
        return [[id, name]];
      } else if (item.child) {
        var result = findPath([id, name], item.child);

        if (Array.isArray(result)) {
          result.unshift([item.id, item.name]);
          return result;
        }
      }
    }

    return [];
  };

  var handleSubDeptClick = function handleSubDeptClick(info) {
    var _findData;

    var path = findPath([info.id, info.name], data);
    setCurrentPath(path); // 未加载过就去加载

    if (!((_findData = findData(info.id, data)) === null || _findData === void 0 ? void 0 : _findData.child)) load(info.id);
  };

  var findMembers = function findMembers(dataSource, filter) {
    var filterMembers = [];

    var findByMember = function findByMember(members) {
      for (var i = 0; i < members.length; i++) {
        var member = members[i];

        if (!filter || filter(member)) {
          filterMembers.push(member);
        }
      }
    };

    var findByDept = function findByDept(data) {
      var deptes = data.deptes,
          members = data.members;
      findByMember([].concat(_toConsumableArray(deptes), _toConsumableArray(members)));
      deptes.forEach(function (dept) {
        if (!dept.child) return;
        findByMember([].concat(_toConsumableArray(dept.child.deptes), _toConsumableArray(dept.child.members)));
        dept.child.deptes.forEach(function (dept) {
          if (dept.child) {
            findByDept(dept.child);
          }
        });
      });
    };

    findByDept(dataSource);
    return filterMembers;
  };

  var handleChecked = function handleChecked(info) {
    var checkedMembers = [];
    var newData = data ? _objectSpread2({}, data) : {
      deptes: [],
      members: []
    };
    findMembers(newData, function (item) {
      if (item.id === info.id) {
        item.checked = !item.checked;
      }

      return !!item.checked;
    });
    setData(newData);

    if (onChange) {
      onChange(info, checkedMembers);
    }
  };

  var renderItem = function renderItem(_ref4) {
    var data = _ref4.data,
        suffix = _ref4.suffix;
    return /*#__PURE__*/React__default['default'].createElement("ul", null, data.map(function (v, i) {
      var id = v.id,
          name = v.name,
          type = v.type,
          checked = v.checked;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: 'li-' + id,
        onClick: function onClick() {
          if (suffix !== 'cancel') {
            if (checked) {
              setSelectedItems(function (preItem) {
                return preItem.filter(function (pre) {
                  return pre.id !== id;
                });
              });
            } else {
              setSelectedItems(function (preItem) {
                return preItem.concat(v);
              });
            }

            v.checked = !v.checked;
            handleChecked(v);
          }
        }
      }, suffix !== 'cancel' && /*#__PURE__*/React__default['default'].createElement(_Checkbox__default['default'], {
        checked: checked
      }), /*#__PURE__*/React__default['default'].createElement(AvatarComponent, _objectSpread2({
        shape: "circle",
        size: 36
      }, v)), /*#__PURE__*/React__default['default'].createElement("span", null, name), suffix === 'arrowRight' && type === 3 && /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
          handleSubDeptClick(v);
        }
      }, /*#__PURE__*/React__default['default'].createElement(Icon.RightOutlined, {
        style: {
          fontSize: 12,
          color: '#a7afbd'
        }
      })), suffix === 'cancel' && /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
          setSelectedItems(function (preItem) {
            return preItem.filter(function (pre) {
              return pre.id !== id;
            });
          });
          v.checked = !v.checked;
          handleChecked(v);
        }
      }, /*#__PURE__*/React__default['default'].createElement(Icon.CloseOutlined, {
        style: {
          fontSize: 12,
          color: '#a7afbd'
        }
      })));
    }));
  };

  var handleCloseModal = function handleCloseModal() {
    setModalVisible(false);
    setCurrentPath([]);
    setSearchKeyword('');
    closeModal(selectedItems);
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(OrganizationIcon, {
    onClick: function onClick() {
      setSelectedItems(selectedValues || []);
      setModalVisible(true);
    }
  }), /*#__PURE__*/React__default['default'].createElement(_Modal__default['default'], {
    title: locale.select.title,
    centered: true,
    width: "960px",
    visible: modalVisible,
    onOk: handleCloseModal,
    onCancel: handleCloseModal
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-select-contact")
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-container")
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
    placeholder: locale.select.placeholder,
    onChange: function onChange(e) {
      setSearchKeyword(e.target.value);
      onSearch(e.target.value);
    }
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-leftBottom-container")
  }, querying && /*#__PURE__*/React__default['default'].createElement(Loading$1, null), !querying && (searchKeyword ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-result-container")
  }, renderItem({
    data: formatSearchData(searchData, selectedItems)
  })) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-breadcrumb-container")
  }, /*#__PURE__*/React__default['default'].createElement(_Breadcrumb__default['default'], {
    separator: ">"
  }, /*#__PURE__*/React__default['default'].createElement(_Breadcrumb__default['default'].Item, {
    onClick: function onClick() {
      return setCurrentPath([]);
    }
  }, locale.select.contact), currentPath.map(function (v, i) {
    return /*#__PURE__*/React__default['default'].createElement(_Breadcrumb__default['default'].Item, {
      key: 'breadcrumb-' + v[0],
      onClick: function onClick() {
        return setCurrentPath(currentPath.slice(0, i + 1));
      }
    }, v[1]);
  }))), loading ? /*#__PURE__*/React__default['default'].createElement(Loading$1, null) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-list-container")
  }, renderItem({
    data: convertData(data, currentPath.map(function (v) {
      return v[0];
    })),
    suffix: 'arrowRight'
  })))))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-rightPart-container")
  }, /*#__PURE__*/React__default['default'].createElement("div", null, locale.select.selectedNumber.replace('{num}', String(selectedItems.length))), /*#__PURE__*/React__default['default'].createElement("div", null, renderItem({
    data: selectedItems,
    suffix: 'cancel'
  }))))));
});

var convertData = function convertData(preData, path) {
  if (isEmpty__default['default'](preData)) return [];
  var data = preData;

  if (path.length) {
    var _iterator = _createForOfIteratorHelper(path),
        _step;

    try {
      var _loop = function _loop() {
        var _data$deptes$find;

        var key = _step.value;
        data = ((_data$deptes$find = data.deptes.find(function (v) {
          return v.id === key;
        })) === null || _data$deptes$find === void 0 ? void 0 : _data$deptes$find.child) || {
          deptes: [],
          members: []
        };
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (isEmpty__default['default'](data)) return [];
  }

  return [].concat(_toConsumableArray(data.deptes.map(function (v) {
    return Object.assign({
      type: 3,
      checked: false
    }, v);
  })), _toConsumableArray(data.members.map(function (v) {
    return Object.assign({
      checked: false
    }, v);
  })));
};

var formatSearchData = function formatSearchData(data, selectedItems) {
  var newData = [];

  var _iterator2 = _createForOfIteratorHelper(data),
      _step2;

  try {
    var _loop2 = function _loop2() {
      var d = _step2.value;
      var matchItem = selectedItems.find(function (v) {
        return String(v.id) === String(d.id);
      });

      if (matchItem) {
        newData.push(Object.assign(d, {
          checked: matchItem.checked
        }));
      } else {
        newData.push(Object.assign(d, {
          checked: false
        }));
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return newData;
};

var ShareSelect = function ShareSelect(props) {
  var _classnames;

  var searchContainerRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var deptRef = React.useRef(null);

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-select');

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      querying = _useState2[0],
      setQuerying = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      searchData = _useState6[0],
      setSearchData = _useState6[1];

  var values = React.useMemo(function () {
    var _props$values;

    return (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        key: item.id
      });
    });
  }, [props.values]);

  var query = function query(value) {
    if (props.request) {
      setQuerying(true);
      props.request(value).then(function (data) {
        setSearchData(data.map(function (item) {
          return _objectSpread2(_objectSpread2({}, item), {}, {
            key: item.id
          });
        }));
        setQuerying(false);
      });
    }
  };

  var requestDept = function requestDept(id) {
    var _ref = props.dept || {},
        request = _ref.request;

    if (!request) return Promise.resolve({});
    return new Promise(function (resolve) {
      request(id).then(function (data) {
        data.members = data.members.map(function (item) {
          return _objectSpread2(_objectSpread2({}, item), {}, {
            checked: !!(values === null || values === void 0 ? void 0 : values.find(function (v) {
              return String(v.id) === String(item.id);
            }))
          });
        });
        resolve(data);
      });
    });
  };

  var onChange = function onChange(value) {
    if (props.onChange) props.onChange(value);
    setSearchValue(value);

    if (value) {
      query(value);
    } else {
      setSearchData([]);
    }
  };

  var closeModal = function closeModal(val) {
    if (props.onSelect) props.onSelect(val);
  };

  var handleSelect = function handleSelect(member) {
    var _deptRef$current;

    if (props.onSelect) props.onSelect([member]);
    (_deptRef$current = deptRef.current) === null || _deptRef$current === void 0 ? void 0 : _deptRef$current.updateChecked(member, true);
    return member;
  };

  var handleDeptChange = function handleDeptChange(info, data) {
    var _props$dept;

    if (info.checked) {
      // if (props.onSelect) props.onSelect(info);
      var _values = props.values || [];

      if (props.onValuesChange) props.onValuesChange([].concat(_toConsumableArray(_values), [info]));
    } else if (props.onValuesChange) {
      var _props$values2;

      // 移除
      var _values2 = (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.filter(function (item) {
        return item.id !== info.id;
      });

      props.onValuesChange(_values2 || []);
    }

    if ((_props$dept = props.dept) === null || _props$dept === void 0 ? void 0 : _props$dept.onChange) props.dept.onChange(info, data);
  };

  var renderSearchItem = function renderSearchItem(_ref2) {
    var src = _ref2.src,
        name = _ref2.name,
        type = _ref2.type;
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      shape: "circle",
      size: 32,
      src: src,
      name: name,
      type: type
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta")
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta-name")
    }, name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta-desc")
    })));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, " ").concat(props.className || ''),
    ref: containerRef
  }, /*#__PURE__*/React__default['default'].createElement(Search, {
    data: searchData.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        key: item.id
      });
    }),
    loading: querying,
    placeholder: props.placeholder !== undefined ? props.placeholder : locale.select.placeholder,
    onChange: onChange,
    onRenderItem: renderSearchItem,
    onRenderValue: function onRenderValue(value) {
      return /*#__PURE__*/React__default['default'].createElement("span", {
        className: "".concat(prefixCls, "-value")
      }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
        size: 18,
        src: value.src,
        name: value.name,
        type: value.type
      }), /*#__PURE__*/React__default['default'].createElement("span", null, value.name));
    },
    onSelect: function onSelect(value) {
      var item = handleSelect(value);
      return item;
    },
    getListContainer: function getListContainer() {
      return searchContainerRef.current;
    },
    values: values,
    onValuesChange: function onValuesChange(value) {
      return props.onValuesChange && props.onValuesChange(value);
    },
    onRemove: function onRemove(value) {
      var _deptRef$current2;

      (_deptRef$current2 = deptRef.current) === null || _deptRef$current2 === void 0 ? void 0 : _deptRef$current2.updateChecked(value, false);
    },
    prefix: null,
    suffix: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.suffix, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-group")
    }, /*#__PURE__*/React__default['default'].createElement(DeptSelect, {
      ref: deptRef,
      request: requestDept,
      onChange: function onChange(info, data) {
        return handleDeptChange(info, data);
      },
      selectedValues: props.values,
      onSearch: onChange,
      searchData: searchData,
      querying: querying,
      closeModal: closeModal
    })))
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default']("".concat(prefixCls, "-result"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-active"), !!searchValue), _defineProperty(_classnames, "".concat(prefixCls, "-absolute"), props.position === 'absolute'), _classnames)),
    ref: searchContainerRef
  })));
};

var _excluded$3 = ["member", "request", "deptData", "onSelect", "enable"];
var locales$2 = {
  'zh-CN': zhCN__default$1['default'],
  'zh-HK': zhHK__default$1['default'],
  'zh-TW': zhHK__default$1['default'],
  'en-US': enUS__default$1['default'],
  'ja-JP': jaJP__default$1['default']
};

var ShareLink = function ShareLink(_ref) {
  var member = _ref.member,
      request = _ref.request,
      deptData = _ref.deptData,
      onSelect = _ref.onSelect,
      enable = _ref.enable,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      linkVisible = _useState2[0],
      setLinkVisible = _useState2[1];

  var _useState3 = React.useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      linkLayerVisible = _useState4[0],
      setLinkLayerVisible = _useState4[1];

  var _useState5 = React.useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      linkValue = _useState6[0],
      setLinkValue = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = React.useState((props === null || props === void 0 ? void 0 : props.datetime) ? hooks(props.datetime) : null),
      _useState10 = _slicedToArray(_useState9, 2),
      dupDate = _useState10[0],
      setDupDate = _useState10[1];

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-link');
  var lockPrefixCls = getPrefixCls('share-lock');

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState11 = React.useState((props === null || props === void 0 ? void 0 : props.password) || ''),
      _useState12 = _slicedToArray(_useState11, 2),
      password = _useState12[0],
      setPassword = _useState12[1];

  var _useState13 = React.useState(!!password),
      _useState14 = _slicedToArray(_useState13, 2),
      pwdVisible = _useState14[0],
      setPwdVisible = _useState14[1];

  var _useState15 = React.useState(!!dupDate),
      _useState16 = _slicedToArray(_useState15, 2),
      dateVisible = _useState16[0],
      setDateVisible = _useState16[1];

  var _useState17 = React.useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      applyEditLoading = _useState18[0],
      setApplyEditLoading = _useState18[1];

  var datePickerRef = React.useRef(null);
  var pickerInputRef = React.useRef(null);
  var passwordRef = React.useRef(null);

  var _ref2 = member || {
    power: 0
  },
      power = _ref2.power;

  var handelCopy = React.useCallback(function () {
    if (props.onCopy) {
      props.onCopy();
    }
  }, [props.onCopy]);

  var handelChange = function handelChange(_ref3) {
    var _ref3$share_type = _ref3.share_type,
        share_type = _ref3$share_type === void 0 ? linkValue : _ref3$share_type,
        _ref3$access_password = _ref3.access_password,
        access_password = _ref3$access_password === void 0 ? password : _ref3$access_password,
        _ref3$expiration_time = _ref3.expiration_time,
        expiration_time = _ref3$expiration_time === void 0 ? undefined : _ref3$expiration_time;
    if (expiration_time === undefined) expiration_time = dupDate === null || dupDate === void 0 ? void 0 : dupDate.utc().format();
    if (loading || (props === null || props === void 0 ? void 0 : props.type) === share_type && access_password === (props === null || props === void 0 ? void 0 : props.password) && (expiration_time == null ? undefined : expiration_time) === (props === null || props === void 0 ? void 0 : props.datetime)) return;
    var set_password = undefined; // 如果是所有者，才更新密码权限

    if (power === 3) {
      set_password = access_password ? 2 : 1;
    }

    var newPassword = set_password ? access_password : undefined;
    var newTime = set_password ? expiration_time : undefined;

    if (props.post) {
      setLoading(true);
      props.post(share_type, newPassword, set_password, expiration_time ? expiration_time : undefined).then(function (res) {
        setPwdVisible(!!newPassword);
        setDateVisible(!!newTime); // 无权限时不更改权限选择值

        if ((res === null || res === void 0 ? void 0 : res.code) !== 403) {
          setLinkValue(share_type);
        }
      }).finally(function () {
        return setLoading(false);
      });
    }
  };

  React.useEffect(function () {
    setLinkVisible(linkValue > 0);
  }, [linkValue]);
  React.useEffect(function () {
    if (props.type !== undefined) setLinkValue(props.type);
  }, [props.type]);

  var handleFormat = function handleFormat(date) {
    return locale.link.date.format.replace('{date}', date.local().format('YYYY-MM-DD HH:mm'));
  };

  var getDateValueWidth = function getDateValueWidth(value) {
    var div = document.createElement('div');
    div.append(value);
    div.style.position = 'absolute';
    div.style.left = '-999999px';
    div.style.top = '-999999px';
    document.body.appendChild(div);
    var width = window.getComputedStyle(div, null).width;
    div.remove();
    return parseInt(width.replace('px', '')) + 20;
  };

  var handleDateChange = function handleDateChange(value) {
    setDupDate(value);

    if (pickerInputRef.current && value) {
      var width = getDateValueWidth(handleFormat(value));
      if (width > 0) pickerInputRef.current.style.width = "".concat(width, "px");
    }

    handelChange({
      expiration_time: value ? value.utc().format() : null
    });
  }; // 日期选择弹出时赋默认值


  var handleDateOpen = function handleDateOpen(val) {
    if (val && !dupDate) {
      var defaultValue = hooks().add(1, 'days');
      setDupDate(defaultValue);
      handleDateChange(defaultValue);
    }
  };

  React.useEffect(function () {
    if (!datePickerRef.current) return;
    var element = datePickerRef.current.querySelector('.ant-picker');
    if (!element) return;
    pickerInputRef.current = element; // 重写input原生value属性，在选择器中预览时拦截值计算宽度

    var input = pickerInputRef.current.querySelector('input');

    var _val = input === null || input === void 0 ? void 0 : input.value;

    if (_val) {
      setTimeout(function () {
        pickerInputRef.current.style.width = "".concat(getDateValueWidth(handleFormat(hooks(_val))), "px");
      }, 0);
    }

    Object.defineProperty(input, 'value', {
      get: function get() {
        return _val;
      },
      set: function set(val) {
        pickerInputRef.current.style.width = "".concat(getDateValueWidth(val), "px");
        _val = val;
      }
    });
  }, []); // 申请编辑权限

  var handleApplyEdit = function handleApplyEdit() {
    setApplyEditLoading(true);
    setTimeout(function () {
      setApplyEditLoading(false);

      _message__default['default'].success(locale.link.apply.success);
    }, 2000);
  };

  var renderLink = function renderLink() {
    if (!linkLayerVisible || enable === false) return;
    return /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "".concat(prefixCls, " ").concat(props.enableSelect === false ? "".concat(prefixCls, "-single") : '', " ").concat(props.className || ''),
      direction: "vertical"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, locale.link.title), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-desc")
    }, !!props.applyConfig && power <= 1 && /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      type: "link",
      size: "small",
      loading: applyEditLoading,
      className: "".concat(prefixCls, "-edit"),
      onClick: handleApplyEdit
    }, locale.link.apply.edit)), power === 3 && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-switch")
    }, /*#__PURE__*/React__default['default'].createElement(_Switch__default['default'], {
      checked: linkVisible,
      loading: loading,
      onChange: function onChange(checked) {
        setLinkValue(checked ? 1 : 0);
        handelChange({
          share_type: checked ? 1 : 0
        });
      }
    }), /*#__PURE__*/React__default['default'].createElement("div", null, locale.link.access, ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, linkVisible ? locale.link.on : locale.link.off))), // 权限大于 0 就可以显示，只读就显示他当前只读的状态
    linkVisible && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-select")
    }, /*#__PURE__*/React__default['default'].createElement(_Select__default['default'], {
      defaultValue: 1,
      value: linkValue,
      onChange: function onChange(value) {
        // setLinkValue(value);
        handelChange({
          share_type: value
        });
      },
      loading: loading,
      disabled: loading
    }, /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 1
    }, locale.link.org, ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, locale.permissions.onlyView)), power > 1 && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 2
    }, locale.link.org, " ", /*#__PURE__*/React__default['default'].createElement("strong", null, locale.permissions.edit)), (power === 3 || props.type === 3) && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 3
    }, locale.link.any, ' ', /*#__PURE__*/React__default['default'].createElement("strong", null, locale.permissions.onlyView)), (power === 3 || (props === null || props === void 0 ? void 0 : props.type) === 4) && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 4
    }, locale.link.any, " ", /*#__PURE__*/React__default['default'].createElement("strong", null, locale.permissions.edit))), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      type: "primary",
      onClick: handelCopy
    }, locale.link.copy)));
  };

  var handleSetPwd = function handleSetPwd() {
    handelChange({});
  };

  var handlePwdVisible = function handlePwdVisible() {
    var visible = !password ? !pwdVisible : true;
    setPwdVisible(visible);

    if (visible && !!password) {
      var _passwordRef$current;

      (_passwordRef$current = passwordRef.current) === null || _passwordRef$current === void 0 ? void 0 : _passwordRef$current.focus();
    }
  };

  React.useEffect(function () {
    if (pwdVisible && passwordRef.current) {
      passwordRef.current.focus();
    }
  }, [pwdVisible]);

  var disabledDate = function disabledDate(current) {
    // Can not select days before today and today
    return current && current < hooks().endOf('second');
  };

  var range = function range(start, end) {
    var result = [];

    for (var i = start; i < end; i++) {
      result.push(i);
    }

    return result;
  };

  var disabledDateTime = function disabledDateTime(current) {
    var hours = hooks().hours(); //0~23

    var minutes = hooks().minutes(); //0~59

    var seconds = hooks().seconds(); //0~59
    // if(current?.format('YYYY-MM-DD').valueOf() === moment().format('YYYY-MM-DD').valueOf()) {

    if (current && current <= hooks()) {
      //当日只能选择当前时间之后的时间点
      return {
        disabledHours: function disabledHours() {
          return range(0, 24).splice(0, hours);
        },
        disabledMinutes: function disabledMinutes() {
          return range(0, minutes + 1);
        },
        disabledSeconds: function disabledSeconds() {
          return range(0, seconds + 1);
        }
      };
    }

    return {};
  };

  var renderPwd = function renderPwd() {
    if (!linkLayerVisible || enable === false) return;
    return /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: lockPrefixCls,
      size: 16
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      size: 4,
      className: "".concat(lockPrefixCls, "-pwd")
    }, /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
      title: locale.link.password.title,
      placement: "bottom"
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      loading: loading,
      icon: /*#__PURE__*/React__default['default'].createElement(Icon.LockOutlined, null),
      onClick: handlePwdVisible
    })), /*#__PURE__*/React__default['default'].createElement(_Input__default['default'].Password, {
      ref: passwordRef,
      className: classNames__default['default']("".concat(lockPrefixCls, "-content"), _defineProperty({}, "".concat(lockPrefixCls, "-visible"), pwdVisible)),
      placeholder: locale.link.password.placeholder,
      value: password,
      onChange: function onChange(e) {
        return setPassword(e.target.value);
      }
    }), // 没有设置密码，或者设置的密码与之前的一致就展示 reset 按钮
    (!props.password || props.password !== password) && /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      loading: loading,
      className: classNames__default['default']("".concat(lockPrefixCls, "-content"), _defineProperty({}, "".concat(lockPrefixCls, "-visible"), pwdVisible)),
      type: "primary",
      disabled: !password && !props.password,
      onClick: handleSetPwd
    }, props.password ? locale.link.password.reset : locale.link.password.set)), /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      size: 4,
      className: "".concat(lockPrefixCls, "-dup")
    }, /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
      title: locale.link.date.title,
      placement: "bottom"
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      loading: loading,
      icon: /*#__PURE__*/React__default['default'].createElement(Icon.ClockCircleOutlined, null),
      onClick: function onClick() {
        return setDateVisible(!dupDate ? !dateVisible : true);
      }
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      ref: datePickerRef,
      className: classNames__default['default']("".concat(lockPrefixCls, "-content"), _defineProperty({}, "".concat(lockPrefixCls, "-visible"), dateVisible))
    }, /*#__PURE__*/React__default['default'].createElement(_DatePicker__default['default'], {
      value: dupDate,
      placeholder: locale.link.date.placeholder,
      defaultPickerValue: dupDate || hooks().days(1),
      inputReadOnly: true,
      locale: locales$2[locale.locale] || locales$2['en-US'],
      showTime: {
        format: 'HH:mm'
      },
      format: function format(value) {
        return handleFormat(value);
      },
      showToday: false,
      onChange: handleDateChange,
      showNow: false,
      suffixIcon: null,
      onOpenChange: handleDateOpen,
      disabledDate: disabledDate,
      disabledTime: disabledDateTime
    }))));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.enableSelect !== false && /*#__PURE__*/React__default['default'].createElement(ShareSelect, {
    onChange: function onChange(value) {
      return setLinkLayerVisible(!value);
    },
    onSelect: onSelect,
    request: request,
    dept: deptData ? {
      request: deptData
    } : undefined
  }), renderLink(), power === 3 && linkVisible && renderPwd());
};

var _excluded$4 = ["member", "request", "deptData", "onCancel", "powerConfig"];

var ShareAdd = function ShareAdd(_ref) {
  var member = _ref.member,
      request = _ref.request,
      deptData = _ref.deptData,
      onCancel = _ref.onCancel,
      powerConfig = _ref.powerConfig,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-add');

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useLocaleReceiver3 = useLocaleReceiver('global'),
      _useLocaleReceiver4 = _slicedToArray(_useLocaleReceiver3, 1),
      globalLocale = _useLocaleReceiver4[0];

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = React.useState(props.values || []),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  var _useState5 = React.useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isSendNotification = _useState6[0],
      setIsSendNotification = _useState6[1];

  var _useState7 = React.useState(1),
      _useState8 = _slicedToArray(_useState7, 2),
      authority = _useState8[0],
      setAuthority = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      sending = _useState10[0],
      setSending = _useState10[1];

  var _useState11 = React.useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      description = _useState12[0],
      setDescription = _useState12[1]; // 通过关键字查询


  var query = function query(keyword) {
    return new Promise(function (resolve) {
      if (request) {
        request(keyword).then(function (resultDatas) {
          // 过滤掉当前values的会员信息
          var valuesKeys = values === null || values === void 0 ? void 0 : values.map(function (v) {
            return v.id;
          });
          var newData = resultDatas.filter(function (item) {
            return !valuesKeys.includes(item.id);
          });
          resolve(newData);
        });
      } else {
        resolve([]);
      }
    });
  };

  React.useEffect(function () {
    if (values.length > 1 && authority === 3) {
      setAuthority(1);
    }
  }, [values, authority]);

  var handleSend = function handleSend() {
    if (!props.post) return;
    setSending(true);
    props.post(authority, values, isSendNotification, description).then(function () {
      setSending(false);
    });
  };

  var getPowerConfig = function getPowerConfig(power) {
    if (powerConfig) {
      return powerConfig[power];
    }

    return;
  };

  var viewPowerConfig = getPowerConfig(1);
  var editPowerConfig = getPowerConfig(2);
  var ownerPowerConfig = getPowerConfig(3);

  var _ref2 = member || {
    power: 0
  },
      power = _ref2.power;

  var renderAuthority = function renderAuthority() {
    return /*#__PURE__*/React__default['default'].createElement(_Select__default['default'], {
      disabled: power === 1,
      value: authority,
      onChange: setAuthority,
      bordered: false,
      size: "small"
    }, (viewPowerConfig === null || viewPowerConfig === void 0 ? void 0 : viewPowerConfig.disabled) !== true && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 1
    }, (viewPowerConfig === null || viewPowerConfig === void 0 ? void 0 : viewPowerConfig.title) || locale.permissions.onlyView), (editPowerConfig === null || editPowerConfig === void 0 ? void 0 : editPowerConfig.disabled) !== true && power !== 1 && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 2
    }, (editPowerConfig === null || editPowerConfig === void 0 ? void 0 : editPowerConfig.title) || locale.permissions.canEdit), (ownerPowerConfig === null || ownerPowerConfig === void 0 ? void 0 : ownerPowerConfig.disabled) !== true && values.length < 2 && power === 3 && values[0] && values[0].type === 1 && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 3
    }, (ownerPowerConfig === null || ownerPowerConfig === void 0 ? void 0 : ownerPowerConfig.title) || locale.permissions.owner));
  };

  var renderAddPanle = function renderAddPanle() {
    if (!!searchValue) return;
    return /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: prefixCls,
      direction: "vertical"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, locale.add.note), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-desc")
    }, locale.add.hint), /*#__PURE__*/React__default['default'].createElement(_Input__default['default'].TextArea, {
      value: description,
      onChange: function onChange(e) {
        return setDescription(e.target.value);
      }
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-notification")
    }, /*#__PURE__*/React__default['default'].createElement(_Checkbox__default['default'], {
      checked: isSendNotification,
      onChange: function onChange(e) {
        return setIsSendNotification(e.target.checked);
      }
    }), locale.add.notification), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      onClick: onCancel
    }, globalLocale.cancel), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      type: "primary",
      disabled: values.length === 0,
      loading: sending,
      onClick: handleSend
    }, globalLocale.send)));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareSelect, {
    className: "".concat(prefixCls, "-select"),
    values: values,
    onChange: setSearchValue,
    onValuesChange: setValues,
    placeholder: values.length > 0 ? '' : undefined,
    suffix: renderAuthority(),
    request: query,
    dept: deptData ? {
      request: deptData
    } : undefined
  }), renderAddPanle());
};

var ShareManageHeader = function ShareManageHeader(_ref) {
  var members = _ref.members,
      onTo = _ref.onTo;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-manage-header');
  var memberRecords = members.filter(function (m) {
    return m.power !== 3;
  });
  var owner = members.find(function (m) {
    return m.power === 3;
  });
  if (!owner) return /*#__PURE__*/React__default['default'].createElement("div", null);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-author"),
    style: {
      marginRight: members.length <= 1 ? '0px' : ''
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
    title: owner.name
  }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
    size: 26,
    src: owner.src,
    name: owner.name,
    type: owner.type
  }))), memberRecords.length > 0 && /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    size: 5
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(prefixCls, "-separate-line")
  }), memberRecords.slice(0, 2).map(function (member) {
    return /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
      key: member.id,
      title: member.name
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      size: 26,
      src: member.src,
      name: member.name,
      type: member.type
    }));
  }), memberRecords.length > 2 && /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
    title: "".concat(memberRecords.length, " collaborators in total")
  }, /*#__PURE__*/React__default['default'].createElement(_Avatar__default['default'], {
    size: 26,
    className: "".concat(prefixCls, "-more")
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: onTo
  }, "+", memberRecords.length - 2))), /*#__PURE__*/React__default['default'].createElement(TriangleArrowIcon, {
    className: "".concat(prefixCls, "-btn"),
    onClick: onTo
  })));
};

var ShareManage = function ShareManage(_ref) {
  var members = _ref.members,
      member = _ref.member,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onUpdate = _ref.onUpdate,
      onConfirm = _ref.onConfirm,
      powerConfig = _ref.powerConfig;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-manage');

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useLocaleReceiver3 = useLocaleReceiver('global'),
      _useLocaleReceiver4 = _slicedToArray(_useLocaleReceiver3, 1),
      globalLocale = _useLocaleReceiver4[0];

  var handleChange = function handleChange(item) {
    if (item.power > -1) {
      if (onUpdate) {
        setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, true)));
        onUpdate(item).then(function () {
          if (!onChange) return;
          var newMembers = members.concat();
          var updateMember = newMembers.find(function (m) {
            return m.id === item.id;
          });

          if (updateMember) {
            if (item.power === 3) {
              var curOwner = newMembers.find(function (m) {
                return m.power === 3;
              });

              if (curOwner) {
                curOwner.power = 2;
              }
            }

            updateMember.power = item.power;
            onChange(newMembers);
          }
        }).finally(function () {
          setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, false)));
        });
      }
    } else if (onDelete) {
      setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, true)));
      onDelete(item).then(function () {
        if (!onChange) return;
        var newMembers = members.concat();
        var index = newMembers.findIndex(function (m) {
          return m.id === (item === null || item === void 0 ? void 0 : item.id);
        });

        if (index > -1) {
          newMembers.splice(index, 1);
          onChange(newMembers);
        }
      }).finally(function () {
        return setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, false)));
      });
    }
  };

  var getPowerConfig = function getPowerConfig(power) {
    if (powerConfig) {
      return powerConfig[power];
    }

    return;
  };

  var viewPowerConfig = getPowerConfig(1);
  var editPowerConfig = getPowerConfig(2);
  var ownerPowerConfig = getPowerConfig(3);

  var renderItem = function renderItem(item) {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      shape: "circle",
      size: 32,
      src: item.src,
      name: item.name,
      type: item.type
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-meta")
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-meta-name")
    }, item.name), item.description && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-meta-desc")
    }, item.description)), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-action")
    }, /*#__PURE__*/React__default['default'].createElement(_Select__default['default'], {
      disabled: // 当前用户不少拥有者，但是当前项是拥有者，禁用
      item.power === 3 && (member === null || member === void 0 ? void 0 : member.power) !== 3 || // 当前用户只读，禁用
      (member === null || member === void 0 ? void 0 : member.power) === 1 || // 当前用户和当前项是一个人，禁用
      item.id === (member === null || member === void 0 ? void 0 : member.id) || // 加载中，禁用
      loading[item.id],
      loading: loading[item.id],
      value: item.power < 1 ? 1 : item.power,
      onChange: function onChange(value) {
        return handleChange(_objectSpread2(_objectSpread2({}, item), {}, {
          power: value
        }));
      },
      bordered: false,
      size: "small",
      dropdownMatchSelectWidth: 140
    }, (viewPowerConfig === null || viewPowerConfig === void 0 ? void 0 : viewPowerConfig.disabled) !== true && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 1
    }, (viewPowerConfig === null || viewPowerConfig === void 0 ? void 0 : viewPowerConfig.title) || locale.permissions.onlyView), (editPowerConfig === null || editPowerConfig === void 0 ? void 0 : editPowerConfig.disabled) !== true && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 2
    }, (editPowerConfig === null || editPowerConfig === void 0 ? void 0 : editPowerConfig.title) || locale.permissions.canEdit), // 只有类型为1才能设置为所有者
    (ownerPowerConfig === null || ownerPowerConfig === void 0 ? void 0 : ownerPowerConfig.disabled) !== true && item.type === 1 && (item.power === 3 || (member === null || member === void 0 ? void 0 : member.power) === 3) && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: 3
    }, (ownerPowerConfig === null || ownerPowerConfig === void 0 ? void 0 : ownerPowerConfig.title) || locale.permissions.owner), member && member.power > 1 && item.id !== (member === null || member === void 0 ? void 0 : member.id) && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      value: -1
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        color: '#FF807E'
      }
    }, globalLocale.remove)))));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(SearchList, {
    className: "".concat(prefixCls, "-list"),
    data: members,
    onRenderItem: renderItem
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-footer"),
    onClick: function onClick() {
      if (onConfirm) onConfirm(members);
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon.PlusCircleOutlined, null), " ", locale.add.title));
};

var ShareModalTitle = function ShareModalTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      back = _ref.back,
      showMember = _ref.showMember,
      members = _ref.members,
      onBack = _ref.onBack;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share-title');
  var handleBack = React.useCallback(function () {
    if (back && onBack) onBack(back);
  }, [back]);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-text")
  }, back && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-back"),
    onClick: handleBack
  }, /*#__PURE__*/React__default['default'].createElement(Icon.LeftOutlined, null)), title), showMember !== false && /*#__PURE__*/React__default['default'].createElement(ShareManageHeader, {
    members: members || [],
    onTo: function onTo() {
      if (onBack) onBack('manage');
    }
  })), description && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-desc")
  }, description));
};

var css_248z$9 = ".felo-search-icon {\n  height: 38px;\n  cursor: pointer;\n}\n.felo-search-icon:not(.ant-input-affix-wrapper-focused) {\n  padding: 0;\n  border: 0 none;\n}\n.felo-search-icon .ant-input-prefix {\n  margin: 0;\n  margin-right: 0;\n}\n.felo-search-icon .ant-input-prefix .anticon {\n  margin-top: 2px;\n  color: #464e5a;\n}\n.felo-search-icon .ant-input {\n  width: 0;\n  transition: width 0.3s;\n}\n.felo-search-icon .ant-input:focus {\n  width: 172px;\n}\n.felo-search-input,\n.felo-search-icon {\n  background: #fff;\n  border: 1px solid #2994ff;\n  border-radius: 18px;\n}\n.felo-search-input .ant-input::-moz-placeholder,\n.felo-search-icon .ant-input::-moz-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input:-ms-input-placeholder,\n.felo-search-icon .ant-input:-ms-input-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input::placeholder,\n.felo-search-icon .ant-input::placeholder {\n  color: #8a9ab3;\n}\n.felo-search-value {\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item {\n  padding: 0 4px;\n  margin: 0 4px;\n  color: #464e5a;\n  font-size: 14px;\n  background: #e0e0e0;\n  border-radius: 14px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item:first-child {\n  margin-left: 0;\n}\n.felo-search-value-item:last-child {\n  margin-right: 0;\n}\n.felo-search-value-more {\n  cursor: pointer;\n}\n.felo-search-value-close {\n  margin-left: 4px;\n  margin-top: 0 !important;\n}\n.felo-search-value-close:hover {\n  color: #ff4d4f !important;\n}\n.felo-search-value-popover {\n  display: flex;\n  align-items: center;\n  max-width: 540px;\n  flex-wrap: wrap;\n}\n.felo-search-value-popover .felo-search-value-item {\n  margin: 2px 4px;\n}\n.felo-search-input {\n  padding: 6.5px 10px;\n}\n.felo-search-input .ant-input-prefix {\n  position: unset;\n  transform: none;\n}\n.felo-search-input .ant-input-prefix .anticon {\n  margin-top: 4px;\n  color: #717b8b;\n}\n.felo-search-list {\n  max-height: 270px;\n  overflow-y: auto;\n}\n.felo-search-list.scroll-y {\n  padding-right: 0 !important;\n}\n.felo-search-list .felo-search-list-item {\n  display: flex;\n  align-items: center;\n  min-width: 216px !important;\n  padding: 8px 24px;\n  cursor: pointer;\n}\n.felo-search-list .felo-search-list-item:hover {\n  background-color: #f1f1f1;\n}\n.felo-search-popover {\n  width: 440px;\n}\n.felo-search-popover .ant-popover-arrow {\n  display: none;\n}\n.felo-search-popover .ant-popover-inner {\n  background: #fff;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-search-popover .felo-search-list .item {\n  padding: 12px 20px;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-share-modal .ant-modal-body {\n  padding: 32px 24px;\n}\n.felo-share-add-select .ant-select {\n  min-width: 104px;\n  margin-right: 4px;\n  line-height: 24px;\n  background: #d6dce6;\n  border-radius: 12px;\n}\n.felo-share-add {\n  width: 100%;\n  margin-top: 40px;\n}\n.felo-share-add-title {\n  font-weight: 600;\n  font-size: 20px;\n}\n.felo-share-add-desc {\n  color: #717b8b;\n  font-size: 12px;\n}\n.felo-share-add .ant-input {\n  min-height: 241px;\n  background: #fff;\n  border: 1px solid #d6dce6;\n}\n.felo-share-add-notification .ant-checkbox-wrapper {\n  margin-right: 12px;\n}\n.felo-share-add-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n.felo-share-add-footer .ant-btn:first-child {\n  color: #464e5a;\n  border: 1px solid #a7afbd;\n  border-radius: 4px;\n}\n.felo-share-add-footer .ant-btn-primary {\n  margin-left: 16px;\n  color: #fff;\n  background: #2994ff;\n  border-color: #2994ff;\n}\n.felo-share-link {\n  width: 100%;\n  margin-top: 36px;\n}\n.felo-share-link-single {\n  margin: 0;\n}\n.felo-share-link-title {\n  font-weight: 600;\n  font-size: 20px;\n}\n.felo-share-link-desc {\n  color: #717b8b;\n  font-size: 12px;\n}\n.felo-share-link-switch {\n  display: inline-flex;\n}\n.felo-share-link-switch .ant-switch {\n  margin-right: 12px;\n}\n.felo-share-link-select {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n.felo-share-link-select .ant-select {\n  width: 100%;\n}\n.felo-share-link-select .ant-select.ant-select-focused .ant-select-selector {\n  border: 0;\n  box-shadow: none;\n}\n.felo-share-link-select .ant-select .ant-select-selector {\n  height: 44px;\n  padding: 0 18px 0 11px;\n  background: #f5f5f5;\n  border: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.felo-share-link-select .ant-select .ant-select-selector .ant-select-selection-item {\n  line-height: 44px;\n}\n.felo-share-link-select .ant-select .ant-select-arrow {\n  right: 18px;\n}\n.felo-share-link-select .ant-btn {\n  height: 44px;\n  border-radius: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.felo-share-lock {\n  margin-top: 12px;\n}\n.felo-share-lock .ant-input-affix-wrapper,\n.felo-share-lock .ant-picker {\n  width: 112px;\n  height: 24px;\n  padding: 2px 4px;\n  font-size: 14px;\n}\n.felo-share-lock .ant-input-affix-wrapper {\n  display: flex;\n}\n.felo-share-lock .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-focused):not(:hover),\n.felo-share-lock .ant-input:not(:focus):not(:hover),\n.felo-share-lock .ant-picker:not(:focus):not(:hover) {\n  background: #f5f5f5;\n  border-color: transparent;\n}\n.felo-share-lock-pwd .ant-space-item:first-child .ant-btn {\n  background: #14be14;\n}\n.felo-share-lock-dup .ant-space-item:first-child .ant-btn {\n  background: #ff9716;\n}\n.felo-share-lock-dup .ant-picker {\n  min-width: 198px;\n}\n.felo-share-lock .felo-share-lock-content {\n  display: none;\n}\n.felo-share-lock .felo-share-lock-visible {\n  display: flex;\n  -webkit-animation: fadein 1s;\n  animation: fadein 1s;\n}\n.felo-share-lock-pwd .ant-btn,\n.felo-share-lock-dup .ant-btn {\n  height: 24px;\n  line-height: 18px;\n  border: 0;\n  border-radius: 4px;\n}\n.felo-share-lock-pwd .ant-space-item:first-child .ant-btn,\n.felo-share-lock-dup .ant-space-item:first-child .ant-btn {\n  width: 24px;\n  color: #fff;\n}\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.felo-share-manage-list {\n  margin: 0 -24px;\n}\n.felo-share-manage-list-avatar {\n  width: 32px;\n  height: 32px;\n  margin-right: 12px;\n  overflow: hidden;\n  border-radius: 16px;\n}\n.felo-share-manage-list-avatar img {\n  width: 32px;\n}\n.felo-share-manage-list-meta-name {\n  color: #464e5a;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-share-manage-list-meta-desc {\n  color: #717b8b;\n  line-height: 18px;\n}\n.felo-share-manage-list-action {\n  display: flex;\n  flex: 1 1;\n  justify-content: flex-end;\n  color: #464e5a;\n}\n.felo-share-manage-footer {\n  display: flex;\n  align-items: center;\n  margin-top: 18px;\n  color: #464e5a;\n  cursor: pointer;\n}\n.felo-share-manage-footer .anticon:first-child {\n  margin-right: 4px;\n}\n.felo-share-manage-header {\n  display: flex;\n  padding: 4px;\n  background: #f1f2f3;\n  border-radius: 17px;\n}\n.felo-share-manage-header-author {\n  margin-right: 5px;\n}\n.felo-share-manage-header-separate-line {\n  display: block;\n  width: 1px;\n  height: 18px;\n  margin-left: 2px;\n  background: #ddd;\n}\n.felo-share-manage-header-more {\n  color: #363e4b;\n  font-size: 12px;\n  background: #e3e7ea;\n  cursor: pointer;\n}\n.felo-share-manage-header-btn {\n  display: flex;\n  align-items: center;\n  color: #838d9b;\n  line-height: 14px;\n}\n.felo-share-select {\n  position: relative;\n}\n.felo-share-modal .felo-share-select {\n  margin-top: 12px;\n}\n.felo-share-select-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 5px;\n  padding-left: 10px;\n  color: #9fa2a8;\n  font-size: 20px;\n  line-height: 16px;\n  cursor: pointer;\n}\n.felo-share-select-group::before {\n  position: absolute;\n  top: -9px;\n  left: 0;\n  height: 38px;\n  border-left: 1px solid #e3e7ea;\n  content: ' ';\n}\n.felo-share-select-group-popover {\n  min-width: 120px;\n}\n.felo-share-select-group-popover .ant-popover-inner-content {\n  padding: 0;\n}\n.felo-share-select .felo-search-input {\n  height: 40px;\n  padding: 6.5px 5px;\n  background: #fff;\n  border: 1px solid #a7afbd;\n  border-radius: 4px;\n}\n.felo-share-select .felo-search-input .ant-input-prefix .anticon {\n  margin-top: 2px;\n  color: #717b8b;\n}\n.felo-share-select-value .ant-avatar {\n  margin-top: -3px;\n  margin-right: 4px;\n}\n.felo-share-select-result {\n  display: none;\n  min-height: 166px;\n  padding-top: 20px;\n}\n.felo-share-select-result.felo-share-select-active {\n  display: block;\n}\n.felo-share-select-result.felo-share-select-absolute {\n  position: absolute;\n  width: 100%;\n  min-height: auto;\n  padding: 12px;\n  background: #fff;\n  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;\n}\n.felo-share-select-result.felo-share-select-absolute .felo-search-list {\n  margin: 0 -12px;\n}\n.felo-share-select-result .felo-search-list {\n  margin: 0 -24px;\n}\n.felo-share-select-result-avatar {\n  width: 32px;\n  height: 32px;\n  margin-right: 12px;\n  overflow: hidden;\n  border-radius: 16px;\n}\n.felo-share-select-result-avatar img {\n  width: 32px;\n}\n.felo-share-select-result-meta-name {\n  color: #464e5a;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-share-select-result-meta-desc {\n  color: #717b8b;\n  line-height: 18px;\n}\n.felo-share-dept {\n  display: flex;\n}\n.felo-share-dept-column {\n  max-height: 240px;\n  overflow: auto;\n  border-right: 1px solid #e3e7ea;\n}\n.felo-share-dept-column:first-child {\n  padding-left: 0;\n}\n.felo-share-dept-column:last-child {\n  padding-right: 0;\n  border-left: 0;\n}\n.felo-share-dept-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  min-width: 111px;\n  padding: 5px 12px;\n  overflow: hidden;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.felo-share-dept-item:hover {\n  background: #f5f5f5;\n}\n.felo-share-dept-item-active {\n  background: #e6f7ff;\n}\n.felo-share-dept-item .anticon {\n  margin-right: 4px;\n  color: #00000073;\n  font-size: 12px;\n}\n.felo-share-dept-item-content {\n  flex: auto;\n}\n.felo-share-dept-select-contact {\n  display: flex;\n  justify-content: center;\n  height: 430px;\n  border: 1px solid #d8d6d6;\n  border-radius: 4px;\n}\n.felo-share-dept-select-contact > div {\n  width: 455px;\n}\n.felo-share-dept-select-contact > div:first-child {\n  border-right: 1px solid #d8d6d6;\n}\n.felo-share-dept-select-contact *::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\n.felo-share-dept-select-contact *::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px #fff;\n}\n.felo-share-dept-select-contact *::-webkit-scrollbar-thumb {\n  background-color: #d8d6d6;\n  border-radius: 4px;\n  outline: 1px solid #d8d6d6;\n}\n.felo-share-dept-search-container {\n  margin: 16px;\n}\n.felo-share-dept-search-container > input {\n  padding: 7px 8px;\n  color: #1c202a;\n  border: 1px solid #a7afbd;\n  border-radius: 4px;\n}\n.felo-share-dept-leftBottom-container {\n  overflow: hidden;\n}\n.felo-share-dept-breadcrumb-container {\n  width: calc(100% - 32px);\n  margin: 0 16px 10px;\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n.felo-share-dept-breadcrumb-container > div {\n  padding: 4px 0;\n}\n.felo-share-dept-breadcrumb-container > div > span:not(:last-child) > span:first-child {\n  color: #2a94ff;\n}\n.felo-share-dept-breadcrumb-container > div > span:not(:last-child) > span:first-child:hover {\n  background: rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n}\n.felo-share-dept-search-list-container,\n.felo-share-dept-search-result-container {\n  height: 314px;\n  overflow-y: scroll;\n}\n.felo-share-dept-search-list-container > ul,\n.felo-share-dept-search-result-container > ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.felo-share-dept-search-list-container > ul > li,\n.felo-share-dept-search-result-container > ul > li {\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  cursor: pointer;\n}\n.felo-share-dept-search-list-container > ul > li:hover,\n.felo-share-dept-search-result-container > ul > li:hover {\n  background: #f1f1f1;\n}\n.felo-share-dept-search-list-container > ul > li > label,\n.felo-share-dept-search-result-container > ul > li > label {\n  margin-right: 10px;\n}\n.felo-share-dept-search-list-container > ul > li > span:nth-of-type(1),\n.felo-share-dept-search-result-container > ul > li > span:nth-of-type(1) {\n  margin-right: 10px;\n}\n.felo-share-dept-search-list-container > ul > li > span:nth-of-type(2),\n.felo-share-dept-search-result-container > ul > li > span:nth-of-type(2) {\n  flex: 1;\n}\n.felo-share-dept-search-list-container > ul > li > div:last-child,\n.felo-share-dept-search-result-container > ul > li > div:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n.felo-share-dept-search-list-container > ul > li > div:last-child:hover,\n.felo-share-dept-search-result-container > ul > li > div:last-child:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n.felo-share-dept-search-list-container > ul > li > div:last-child:hover > span > svg,\n.felo-share-dept-search-result-container > ul > li > div:last-child:hover > span > svg {\n  color: #1890ff;\n}\n.felo-share-dept-search-result-container {\n  height: 358px;\n}\n.felo-share-dept-rightPart-container > div:first-child {\n  height: 38px;\n  margin: 16px;\n  font-size: 14px;\n  line-height: 38px;\n}\n.felo-share-dept-rightPart-container > div:last-child {\n  height: 357px;\n  overflow-y: scroll;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li {\n  display: flex;\n  align-items: center;\n  padding: 6px 20px;\n  cursor: pointer;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li:hover {\n  background: #f1f1f1;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li > label {\n  margin-right: 10px;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li > span:nth-of-type(1) {\n  margin-right: 10px;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li > span:nth-of-type(2) {\n  flex: 1;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li > div:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n.felo-share-dept-rightPart-container > div:last-child > ul > li > div:last-child:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n.felo-share-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.felo-share-title-text {\n  display: flex;\n  font-weight: 600;\n  font-size: 20px;\n}\n.felo-share-title-back {\n  margin-right: 12px;\n  cursor: pointer;\n}\n.felo-share-title-desc {\n  margin: 8px 0;\n  color: #717b8b;\n  font-size: 12px;\n}\n";
styleInject(css_248z$9);

var Share = function Share(_ref) {
  var request = _ref.request,
      deptData = _ref.deptData,
      search = _ref.search,
      _post = _ref.post,
      powerConfig = _ref.powerConfig,
      visible = _ref.visible,
      link = _ref.link,
      defaultAction = _ref.defaultAction,
      onVisibleChange = _ref.onVisibleChange,
      onUpdate = _ref.onUpdate,
      onDelete = _ref.onDelete,
      member = _ref.member,
      modalProps = _ref.modalProps;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('share');

  var _useLocaleReceiver = useLocaleReceiver('Share'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState({
    type: defaultAction || 'link'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      action = _useState2[0],
      setAction = _useState2[1];

  var _useState3 = React.useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1]; // 通过关键字查询


  var query = function query(keyword) {
    return new Promise(function (resolve) {
      if (search) {
        search(keyword).then(function (resultDatas) {
          // 过滤掉当前已有的会员信息
          var newData = resultDatas.filter(function (item) {
            return !data.find(function (c) {
              return c.id === item.id;
            });
          });
          resolve(newData);
        });
      } else {
        resolve([]);
      }
    });
  };

  React.useEffect(function () {
    // 获取当前所有的会员信息
    if (!visible) setAction({
      type: defaultAction || 'link'
    });else if (request) {
      request().then(function (resData) {
        // 按 power 排序
        resData = resData.sort(function (a, b) {
          return b.power - a.power;
        });
        setData(resData);
      });
    }
  }, [visible]);
  var titleConfig = {
    title: (link === null || link === void 0 ? void 0 : link.title) || locale.to,
    members: data || [],
    onBack: function onBack(type) {
      return setAction({
        type: type
      });
    }
  };

  var renderContent = function renderContent() {
    switch (action.type) {
      case 'link':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, (link === null || link === void 0 ? void 0 : link.enableSelect) !== false && /*#__PURE__*/React__default['default'].createElement(ShareModalTitle, _objectSpread2({}, titleConfig)), /*#__PURE__*/React__default['default'].createElement(ShareLink, _objectSpread2({
          request: query,
          deptData: deptData,
          member: member,
          onSelect: function onSelect(v) {
            return v.length > 0 ? setAction({
              type: 'add',
              data: v
            }) : null;
          }
        }, link)));

      case 'add':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle, _objectSpread2(_objectSpread2({}, titleConfig), {}, {
          back: "link"
        })), /*#__PURE__*/React__default['default'].createElement(ShareAdd, {
          member: member,
          values: action.data ? action.data : [],
          request: query,
          deptData: deptData,
          powerConfig: powerConfig,
          post: function post() {
            for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = arguments[_key];
            }

            return new Promise(function (resolve) {
              if (_post) {
                _post.apply(void 0, params).then(function (v) {
                  var newData = data.concat(params[1].map(function (item) {
                    return _objectSpread2(_objectSpread2({}, item), {}, {
                      power: params[0]
                    });
                  })); // 增加为所有者，就把当前所有者权限设置为可编辑

                  if (params[0] === 3) {
                    var updateMember = newData.find(function (m) {
                      return m.power === 3;
                    });

                    if (updateMember) {
                      updateMember.power = 2;
                    }
                  }

                  setData(newData);
                  setAction({
                    type: 'manage'
                  });
                  resolve(v);
                });
              }
            });
          },
          onCancel: function onCancel() {
            return setAction({
              type: 'link'
            });
          }
        }));

      case 'manage':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle, _objectSpread2(_objectSpread2({}, titleConfig), {}, {
          title: locale.manage.title,
          description: locale.manage.description,
          back: "link",
          showMember: false
        })), /*#__PURE__*/React__default['default'].createElement(ShareManage, {
          member: member,
          members: data || [],
          onChange: function onChange(members) {
            return setData(members);
          },
          onUpdate: onUpdate,
          onDelete: onDelete,
          onConfirm: function onConfirm() {
            return setAction({
              type: 'add'
            });
          },
          powerConfig: powerConfig
        }));
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(_Modal__default['default'], _objectSpread2({
    className: "".concat(prefixCls, "-modal"),
    visible: visible,
    destroyOnClose: true,
    onCancel: function onCancel() {
      return onVisibleChange ? onVisibleChange(false) : undefined;
    },
    centered: true,
    footer: null,
    closable: false,
    width: 640
  }, modalProps), renderContent());
};

Share.Select = ShareSelect;
Share.Link = ShareLink;
Share.Add = ShareAdd;
Share.Manage = ShareManage;

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInviteEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.562 90H109V9.4c0-6.227-2.943-8.385-5.909-8.385H29a4.9 4.9 0 012.971.723 4.842 4.842 0 011.95 2.338c.253.642.364 1.33.327 2.017v32.758",
    fill: "#E7EAF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25H47v1.152h49V25zm0 14.512H47v1.153h49v-1.153zM64.81 52.837H47V54h17.81v-1.163z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 100s7.8-36.87 37.333-35.285c14.406.773 8.928 16.547-.883 9.645-13.153-9.22-1.2-27.153 19.55-26.333",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 36H85v31h46V36z",
    fill: "#E7EAF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v32h47V36l-23.904 16.198L84 36z",
    fill: "#2994FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36l23.72-16L131 36H84zm4.979 28.645L107.6 46.221 127.898 65l-38.92-.355z",
    fill: "#2994FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93 60.854L107.5 45.5 123 61",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20a5 5 0 100-10.001A5 5 0 0053 20z",
    fill: "#FE5274"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.136 43c.567 0 1.11-.21 1.511-.586.4-.375.625-.884.625-1.414 0-.53-.225-1.04-.625-1.414a2.213 2.213 0 00-1.511-.586c-.566 0-1.11.21-1.51.586-.4.375-.626.884-.626 1.414 0 .53.225 1.04.626 1.414.4.375.944.586 1.51.586zm7.449 0c.566 0 1.109-.21 1.51-.586.401-.375.626-.884.626-1.414 0-.53-.225-1.04-.626-1.414a2.213 2.213 0 00-1.51-.586c-.567 0-1.11.21-1.511.586a1.936 1.936 0 00-.626 1.414c0 .53.225 1.04.626 1.414.401.375.944.586 1.511.586zm7.279 0c.566 0 1.11-.21 1.51-.586.401-.375.626-.884.626-1.414 0-.53-.225-1.04-.626-1.414a2.21 2.21 0 00-1.51-.586c-.567 0-1.11.21-1.511.586a1.94 1.94 0 00-.625 1.414c0 .53.225 1.04.625 1.414.401.375.944.586 1.511.586z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.786 22.822s.07-9.517.07-11.94c0-2.424 1.19-4.882 4.625-4.882s5.277 1.978 5.277 5.069v7.024",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var _path$1, _path2$1, _g;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgRecommend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 112,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.92 14.772a.806.806 0 00-.332-.089c-4.287-1.385-8.816-1.865-13.295-1.49-8.53.867-14.87 5.337-18.931 13.279-4.885 9.583-12.514 11.459-12.82 11.555a1.16 1.16 0 00-.645.413.964.964 0 00.004 1.125.97.97 0 001.036.407l.078-.005c.892-.194 8.908-2.373 14.083-12.568 8.231-16.186 24.921-12.354 29.855-10.82.319.138.707.114 1.026-.03a.942.942 0 00.408-.477c.218-.528.013-1.094-.467-1.3z",
    fill: "#FE5274"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "recommend_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.844 110c30.29 0 54.844-24.624 54.844-55S85.133 0 54.844 0C24.554 0 0 24.624 0 55s24.555 55 54.844 55z",
    fill: "#D6DAE1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#recommend_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.687 94.957c.732 3.424 4.07 7.243 7.384 10.266 1.5 1.368.617 4.083-1.41 4.13l-25.324.597c-1.187.028-2.166-.932-2.333-2.111-.552-3.883-2.5-9.552-6.38-16.166-4.678-7.974-5.146-25.33-3.742-27.675 1.403-2.345 2.888-20.704 3.741-26.267.936-6.099 4.366-5.004 6.549-4.691 0-4.69 1.564-8.524 4.21-9.85 1.87-.939 4.209-.47 4.677 1.407.468-2.814 2.339-5.16 6.08-4.691 3.714.465 3.535 5.393 3.223 7.895.624-1.251 3.588-3.464 6.132-2.735 2.339.67 2.806 2.345 2.806 4.222 0 1.875-1.87 7.973-4.209 18.762-1.871 8.63-.156 17.668.935 21.108-.311-2.814 3.274-9.978 9.355-12.196 7.718-2.815 9.823 3.284 8.419 5.16-3.742 3.283-6.548 5.629-10.29 15.48-6.712 17.67-11.226 10.788-9.823 17.355z",
    fill: "#288FFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.64 80.917c4.291 10.319 1.75 19.195-1.53 24.592-1.029 1.693.169 4.489 2.145 4.487l25.19-.025c1.375-.001 2.431-1.311 2.368-2.689-.172-3.759.474-10.167 3.78-17.994 5.407-12.802 1.966-21.665 0-27.574-.778-2.336-6.39-19.696-9.34-23.635-2.36-3.15-5.408-3.775-6.392-3.447-.49-.984-.49-3.446-2.457-7.385-1.541-3.087-5.08-3.283-6.883-2.955-.49-1.477-1.76-3.446-4.424-3.446-3.73 0-4.424 2.954-3.932 4.923-4.917.493-5.924 5.314-4.325 10.532 2.643 8.622 5.424 19.012 6.29 26.89-.819-2.133-4.404-6.8-10.323-7.878-5.407-.985-5.68 4.431-3.932 6.4 3.932 4.433 7.865 5.024 13.764 19.204z",
    fill: "#FE5274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.963 24.596c-1.403.47-.937 3.486 0 5.991 1.403 3.753 6.59 16.59 8.488 28.285M20.637 26.78c.468 1.47 2.334 6.39 3.151 8.739 2.244 6.445 4.882 14.414 6.51 23.389m7.37-23.993c-.705.637-1.27 2.41 0 4.7 1.588 2.863 5.476 12.457 6.562 19.528M73.888 85.22c-.61-1.2-1.425-3.306-.917-5.642.833-3.937 4.9-6.295 6.995-7.5 3.802-2.201 5.412-1.53 6.512-3.55M75.948 54.677a44.004 44.004 0 00-9.636 1.185c-4.778 1.156-8.594 3.016-11.324 4.595m20.505-5.859c.172-3.903.248-6.444 1.308-12.2.866-4.697 1.837-8.042 3.752-14.626m-13.41 27.871c-.119-4.459.477-7.46 1.118-14.099.524-5.416 1.262-9.765 2.848-16.129m-11.105 32.35c-.104-3.735.265-6.364.83-11.488.496-4.517.627-6.248 1.55-12.642",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.892 65.4c2.17 6.8 2.17 16.318-1.67 24.398",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.144-8.965a1.25 1.25 0 00-.814-.287c-.277 0-.496.156-.652.402-.431.712-4.367 6.96-6.025 12.375A8.76 8.76 0 0059.52 6.18c-3.84 5.843-3.143 15.865-3.135 16.263.06.626.577 1.194 1.163 1.24a.872.872 0 00.602-.163l.109-.079c.187-.202.275-.466.263-.793 0 0-.621-9.607 2.834-14.906.192-.272.38-.474.603-.702-.219 3.174 1.088 4.848 2.442 5.35 1.353.501 2.962-.187 4.053-1.909.582-.888 1.001-1.926 1.283-3 .74-2.677-.246-3.979-1.176-4.584-.93-.605-2.113-.559-3.096-.388 1.453-3.457 3.137-6.746 5.085-9.822.156-.247.175-.528.127-.828a2.41 2.41 0 00-.533-.824zm-2.527 15.49c-.833 3.012-2.284 3.92-2.892 3.688-.305-.116-.765-.992-.643-2.755.085-.731.202-1.419.387-2.088 1.363-.645 2.66-.84 3.16-.53.168.081.229.708-.012 1.685z",
    fill: "#FE5274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.04 6.672C3.507 9.218-1.467-6.104-1.528-6.24c-.1-.31-.302-.536-.57-.656-.551-.299-1.283-.071-1.58.48a1.24 1.24 0 00-.07.893A35.413 35.413 0 00.5 3.127c3.534 5.094 7.751 7.068 12.183 5.727 8.612-2.594 13.211 8.004 13.408 8.473.21.527.782.79 1.333.695a.573.573 0 00.194-.074c.217-.11.398-.242.53-.454l.112-.176a1.11 1.11 0 00.012-.88c-1.05-2.241-2.431-4.347-4.127-6.108-3.544-3.67-7.755-4.95-12.106-3.658z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.86 1.762c.718 0 1.408-.287 1.917-.797a2.724 2.724 0 000-3.846 2.708 2.708 0 00-3.835 0 2.724 2.724 0 000 3.846c.508.51 1.198.797 1.917.797z",
    fill: "#00EADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52 6.179c1.159 0 2.27-.462 3.09-1.284a4.39 4.39 0 000-6.2 4.365 4.365 0 00-6.182 0 4.39 4.39 0 000 6.2 4.366 4.366 0 003.091 1.284z",
    fill: "#FE5275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.387 16.623a2.792 2.792 0 001.98-.823 2.807 2.807 0 00.606-3.06 2.807 2.807 0 00-1.515-1.519 2.794 2.794 0 00-3.051.61 2.811 2.811 0 000 3.97 2.795 2.795 0 001.98.822z",
    fill: "#00EADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.591 53.812a2.79 2.79 0 001.98-.822 2.809 2.809 0 00.606-3.06A2.808 2.808 0 00.48 48.41a2.794 2.794 0 00-3.05.61 2.812 2.812 0 000 3.97 2.795 2.795 0 001.979.822zm107.427-14.738a3.924 3.924 0 002.78-1.155 3.953 3.953 0 00.853-4.297 3.955 3.955 0 00-2.128-2.134 3.924 3.924 0 00-4.285.854 3.947 3.947 0 002.78 6.732z",
    fill: "#2450F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.807 51.154c2.966 0 5.37-2.412 5.37-5.387 0-2.975-2.404-5.387-5.37-5.387-2.967 0-5.372 2.412-5.372 5.387 0 2.975 2.405 5.386 5.372 5.386zM5.4 31.572c2.967 0 5.371-2.412 5.371-5.387 0-2.975-2.404-5.386-5.37-5.386-2.967 0-5.372 2.412-5.372 5.386 0 2.975 2.405 5.387 5.371 5.387z",
    fill: "#E5E5E5"
  }))));
}

var prefixCls = 'felo-invitation-share';
var success$4 = function success(_ref) {
  var content = _ref.content;

  _message__default['default'].open({
    content: content,
    duration: 1,
    type: 'success',
    prefixCls: 'invitation'
  });
};
var error = function error(_ref2) {
  var content = _ref2.content;

  _message__default['default'].open({
    content: content,
    duration: 1,
    type: 'error',
    prefixCls: 'invitation',
    getPopupContainer: function getPopupContainer() {
      var container = document.getElementsByClassName(prefixCls)[0];
      return container || document.body;
    }
  });
};

var iconTick = "data:image/png;base64,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";

var iconErr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAA1VBMVEUAAAD/AAD/Zmb/YmL/cGD/cHD/bWH/cWn/bWb/bmn/b2j/cGf/b2b/cGj/bmf/b2b/b2j/b2f/bmb/bmj/cGf/b2b/b2j/bmf/bmf/cGf/cGj/b2j/b2f/b2f/b2f/b2b/b2j/bmf/b2f/bmf/b2f/b2f/b2b/cGf/b2f/bmf/b2f/bmb/b2f/b2f/cmr/dW3/f3j/hX7/iYL/k43/nZj/p6L/q6b/sa3/u7f/u7j/xcL/z83/1tP/2df/5OL/5+b/7ez/7u3/9fT/9fX/9/f/+Pf////lmxJUAAAALXRSTlMAAQUNEBAVIiMzU1RVYGFzc35/f4uMjI2kpKSltMPL0dHS1NXe3+rr7fD4/v4EX6wcAAACEUlEQVRYw61X6VrCQAzcgkWoYqVyqlRASm0h3hfegPb9H0niDXZnty3zd5L5ut0kmxFCgoJVabp9Pwz9vtusWAWRCKX6wZAWMOw0SrrZebtHsejZeY30NeeIpDhyTEW6UR4QxKBsoPz1NinRLsrzNwLSQLAh+/zqiLQwqsUeI9cibbRyMfn7lAD7/xSMFiVCa/kUVUqI2tL/HyUVGC3cxXpAiRH8qQejTSnQ/v0NZUqF8ne+OUgnMPjuLIdSwvnqf9C/1y8v16C7P+eDLY+4iea4kfP2h0BPHjBjgZmc733MP3DINxZ4AwE8JxuAn7DABAQ05gIdwD+xwBMI6Mzn/xDwjyzwCAKGBWGhi75ngXsUYYkKou9Y4A5FVEQT0bcscIsimsJFtKqQiFzhIfqKBa5QhCd8RF+ywCWK8EWI6AsWuEARIRY4Z4FzLACPcMoCp/gIfUSfsMAJiujja6TXKHolfI2wkOghih4IFxIsZTp7fj4jXMoWZYKF21mJeTvDgaJEVzHSjsfT6fhYMdLQUB1zHYwVQxWN9SkLTOX8oephUQnYqqdNcYSvpw08roqf6KzqeU+7YGytbsURxYxLVqo1b3NxUawlFahnXHV3jVUv28nW/d1crOGo6RqOupHN8mzKTVMxo+nSsX1bhsI5mtB47phZrO/hdl7bfDe6y+a7q2++f+z/nuux/ffcPWD/3wEmmz4R/I8kigAAAABJRU5ErkJggg==";

var Title = _Typography__default['default'].Title;

var checkEmail = function checkEmail(email) {
  if (!email) {
    return false;
  }

  var regx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regx.test(String(email).toLowerCase());
};

var checkEmailSelect = function checkEmailSelect(emailSelect) {
  var ok = [];
  var error = [];

  if (!emailSelect.length) {
    return [ok, error];
  } // unique email list


  var emailList = _toConsumableArray(new Set(emailSelect));

  emailList.map(function (str) {
    // empty line
    if (!str.trim()) {
      return;
    }

    if (checkEmail(str)) {
      ok.push(str);
    } else {
      error.push(str);
    }
  });
  return [ok, error];
};

var EmailResult = function EmailResult(_ref) {
  var failed = _ref.failed;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var translateEmailList = function translateEmailList(emailList) {
    var list = [];
    emailList.map(function (item) {
      var errText = '';

      switch (item.code) {
        case '0000':
          break;

        case 'A010':
          errText = locale['user-already-in-org'];
          break;

        default:
          errText = locale['send-failed'];
          break;
      }

      var failItem = {
        email: item.email,
        message: errText
      };
      list.push(failItem);
    });
    return list;
  };

  var failedEmailList = translateEmailList(failed);
  var hasError = failedEmailList.length > 0;
  var title = /*#__PURE__*/React__default['default'].createElement("div", {
    className: "title"
  }, hasError ? /*#__PURE__*/React__default['default'].createElement("img", {
    src: iconErr,
    alt: ""
  }) : /*#__PURE__*/React__default['default'].createElement("img", {
    src: iconTick,
    alt: ""
  }), !hasError ? /*#__PURE__*/React__default['default'].createElement(Title, {
    level: 4
  }, locale['send-success']) : /*#__PURE__*/React__default['default'].createElement(Title, {
    level: 4
  }, locale['send-failed']));
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-email-result'
  }, title, hasError && /*#__PURE__*/React__default['default'].createElement("div", {
    className: 'email-list'
  }, failedEmailList.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: index,
      className: "email-item"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "email-item-email"
    }, item.email), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "email-item-err"
    }, item.message));
  })));
};
var EmailPrimitive = function EmailPrimitive(_ref2) {
  var onSubmit = _ref2.onSubmit;

  var _useContext2 = React.useContext(ConfigContext),
      getPrefixCls = _useContext2.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver3 = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver4 = _slicedToArray(_useLocaleReceiver3, 1),
      locale = _useLocaleReceiver4[0];

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var handleSubmit = function handleSubmit() {
    var _checkEmailSelect = checkEmailSelect(inputValue.split('\n')),
        _checkEmailSelect2 = _slicedToArray(_checkEmailSelect, 2),
        ok = _checkEmailSelect2[0],
        errors = _checkEmailSelect2[1];

    if (errors.length > 0) {
      _Modal__default['default'].error({
        title: locale['join-organization'].email.fail,
        content: /*#__PURE__*/React__default['default'].createElement("div", {
          style: {
            maxHeight: '150px',
            overflowY: 'auto'
          }
        }, errors.map(function (item, index) {
          return /*#__PURE__*/React__default['default'].createElement("div", {
            key: item + '_' + index
          }, item);
        }))
      });

      return;
    }

    if (ok.length === 0) {
      return;
    }

    _Modal__default['default'].confirm({
      title: locale['join-organization'].email.confirm,
      content: /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          maxHeight: '150px',
          overflowY: 'auto'
        }
      }, ok.map(function (item, index) {
        return /*#__PURE__*/React__default['default'].createElement("div", {
          key: item + '_' + index
        }, item);
      })),
      onOk: function onOk() {
        if (onSubmit) {
          return onSubmit(ok).then(function () {
            setInputValue('');
            success$4({
              content: locale['join-organization'].email['success-send']
            });
          }).catch(function () {
            error({
              content: locale['join-organization'].email['error-send']
            });
          });
        } else {
          setInputValue('');
          success$4({
            content: locale['join-organization'].email['success-send']
          });
          return Promise.resolve();
        }
      }
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-email-primitive'
  }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    className: 'tags-container'
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'].TextArea, {
    autoCapitalize: "off",
    autoCorrect: "off",
    autoComplete: "off",
    autoSave: "off",
    autoSize: {
      minRows: 5,
      maxRows: 10
    },
    value: inputValue,
    onChange: function onChange(e) {
      return setInputValue(e.target.value);
    },
    placeholder: "".concat(locale['join-organization'].email.placeholder, "\nhoge@example.com\nfuga@example.com\nbar@example.com\nfoo@example.com"),
    style: {
      resize: 'none',
      borderRadius: '5px'
    }
  })), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "end",
    style: {
      margin: '20px 0 24px 0'
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "primary",
    onClick: function onClick() {
      return handleSubmit();
    }
  }, locale['join-organization'].email.button))));
};

var _rect, _path$2, _path2$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#14BE14"
  })), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4C7.816 4 4 7.057 4 10.814c0 3.368 3.023 6.189 7.108 6.722.277.059.654.18.75.414.085.212.055.545.026.759l-.121.719c-.037.212-.171.83.736.452.907-.377 4.895-2.847 6.678-4.875 1.231-1.334 1.821-2.69 1.821-4.191C21 7.057 17.188 4 12.501 4z",
    fill: "#fff"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10.756c0 .09-.077.164-.172.164h-1.686v.62h1.684c.095 0 .172.074.172.165v.59c0 .091-.077.165-.172.165h-1.684v.62h1.684c.095 0 .172.074.172.164v.592c0 .09-.077.164-.172.164H16.35a.174.174 0 01-.119-.046l-.004-.005a.158.158 0 01-.048-.113v-3.672a.159.159 0 01.052-.117.182.182 0 01.121-.047h2.476c.095 0 .172.074.172.165v.591zM5.964 13.08h1.683c.095 0 .172.073.172.164v.591c0 .09-.077.165-.172.165H5.172a.179.179 0 01-.119-.047l-.005-.004A.159.159 0 015 13.835v-3.671c0-.091.077-.164.172-.164h.62c.095 0 .172.073.172.164v2.916zm8.28-3.078h.591c.091 0 .165.073.165.164v3.67c0 .091-.074.164-.165.164h-.592a.16.16 0 01-.044-.006l-.012-.003-.005-.002-.008-.004-.008-.003-.004-.003-.012-.008a.155.155 0 01-.042-.04l-1.689-2.275v2.18c0 .091-.073.164-.164.164h-.593a.164.164 0 01-.165-.163v-3.673c0-.09.074-.164.165-.164h.607l.009.002.007.001.009.002.006.001.01.004.005.002.01.003.004.003.01.005a.02.02 0 01.004.003l.009.006c.002 0 .003.002.004.003l.01.007.012.013v.002c.006.005.01.01.014.016l1.687 2.271v-2.178c0-.091.074-.164.164-.164zm-5.08 0h.593c.09 0 .165.073.165.164v3.67c0 .091-.074.164-.165.164h-.593A.163.163 0 019 13.837v-3.671c0-.091.073-.164.164-.164z",
    fill: "#00B900"
  })));
}

var _rect$1, _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#415E9D"
  })), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.66 24v-8.21H10v-3.2h2.66v-2.36C12.66 7.49 14.27 6 16.622 6c1.127 0 2.096.087 2.378.126V8.99h-1.631c-1.28 0-1.527.632-1.527 1.558v2.043h3.05l-.397 3.2H15.84V24h-3.18z",
    fill: "#fff"
  })));
}

var _rect$2, _path$4;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#55ACEE"
  })), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.776a7.217 7.217 0 01-2.12.595 3.776 3.776 0 001.623-2.094c-.723.44-1.517.75-2.346.917A3.646 3.646 0 0015.462 4c-2.038 0-3.691 1.695-3.691 3.786 0 .297.031.585.094.862-3.069-.157-5.79-1.664-7.612-3.957a3.861 3.861 0 00-.5 1.905c0 1.314.653 2.474 1.643 3.153a3.625 3.625 0 01-1.672-.472v.046c0 1.835 1.272 3.366 2.962 3.713a3.48 3.48 0 01-.972.133c-.237 0-.47-.023-.695-.068.47 1.505 1.833 2.6 3.448 2.63A7.294 7.294 0 013 17.3 10.278 10.278 0 008.661 19c6.793 0 10.508-5.769 10.508-10.774 0-.164-.004-.33-.01-.49A7.55 7.55 0 0021 5.776z",
    fill: "#fff"
  })));
}

var getSNSIcon = function getSNSIcon(type) {
  switch (type) {
    case 'line':
      return /*#__PURE__*/React__default['default'].createElement(SvgLine, null);

    case 'facebook':
      return /*#__PURE__*/React__default['default'].createElement(SvgFacebook, null);

    case 'twitter':
      return /*#__PURE__*/React__default['default'].createElement(SvgTwitter, null);

    default:
      return null;
  }
};

var SNSPrimitive = function SNSPrimitive(_ref) {
  var type = _ref.type,
      link = _ref.link,
      title = _ref.title;
  var icon = getSNSIcon(type);

  var handleClick = function handleClick() {
    switch (type) {
      case 'line':
        vanillaSharing.line({
          url: link,
          title: title
        });
        break;

      case 'facebook':
        vanillaSharing.fbButton({
          url: link
        });
        break;

      case 'twitter':
        vanillaSharing.tw({
          title: title
        });
        break;
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sns-primitive",
    onClick: function onClick() {
      return handleClick();
    }
  }, icon);
};
var Container = function Container(_ref2) {
  var children = _ref2.children;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-sns-container")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "desc"
  }, locale['join-organization'].sns.desc), /*#__PURE__*/React__default['default'].createElement("div", {
    className: 'icons'
  }, children));
};

var copyToClipboard = function copyToClipboard(text) {
  var input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', text);
  input.select();

  if (document.execCommand('copy')) {
    document.execCommand('copy');
  }

  document.body.removeChild(input);
};
var useCopyView = function useCopyView(_ref) {
  var placeholder = _ref.placeholder,
      text = _ref.text,
      onCopy = _ref.onCopy;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var overlay = /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-copy-overlay',
    style: {
      display: visible ? 'flex' : 'none'
    },
    onClick: function onClick() {
      if (text) {
        copyToClipboard(text);
        success$4({
          content: locale['copy-success']
        });
      } else {
        onCopy === null || onCopy === void 0 ? void 0 : onCopy();
        success$4({
          content: locale['copy-success']
        });
      }
    }
  }, placeholder || locale['copy-text']);

  var onMouseEnter = function onMouseEnter() {
    setVisible(true);
  };

  var onMouseLeave = function onMouseLeave() {
    setVisible(false);
  };

  return {
    events: {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    },
    overlay: overlay
  };
};

var TabPane = _Tabs__default['default'].TabPane;
var Content = function Content(_ref) {
  var code = _ref.code,
      expiredAt = _ref.expiredAt,
      organizationName = _ref.organizationName,
      userName = _ref.userName,
      _ref$defaultIndex = _ref.defaultIndex,
      defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
      link = _ref.link,
      dialog = _ref.dialog,
      onVisibleChange = _ref.onVisibleChange,
      onSendEmail = _ref.onSendEmail;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var label = locale['recommend-friend'].code['copy-label'].replace('{userName}', userName);
  var htmlLabel = label.replace('{link}', "<a>".concat(link, "</a>"));
  var copyLabel = label.replace('{link}', link);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sendResult = _useState2[0],
      setResult = _useState2[1];

  var handleSubmit = function handleSubmit(emailList) {
    if (onSendEmail) {
      return onSendEmail === null || onSendEmail === void 0 ? void 0 : onSendEmail(emailList).then(function (res) {
        setResult({
          failed: res.failed ? res.failed : []
        });
      });
    }

    return Promise.resolve();
  };

  var copyText = function copyText() {
    copyToClipboard(copyLabel);
    success$4({
      content: locale['copy-success']
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "title"
  }, locale['recommend-friend'].title), dialog && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "text",
    icon: /*#__PURE__*/React__default['default'].createElement(Icon.CloseOutlined, null),
    onClick: function onClick() {
      return onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
    }
  }))), /*#__PURE__*/React__default['default'].createElement(_Tabs__default['default'], {
    defaultActiveKey: defaultIndex + ''
  }, /*#__PURE__*/React__default['default'].createElement(TabPane, {
    tab: locale['recommend-friend'].share,
    key: '0'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center",
    style: {
      margin: '10px 0 0 0'
    }
  }, /*#__PURE__*/React__default['default'].createElement(SvgRecommend, null)), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      margin: '16px 0 32px 0',
      fontSize: '18px'
    }
  }, locale['recommend-friend'].code.desc)), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], null, /*#__PURE__*/React__default['default'].createElement("span", {
    className: 'copy-text-highlight',
    style: {
      margin: '0px 0 8px 0',
      color: '#666666'
    },
    dangerouslySetInnerHTML: {
      __html: locale['recommend-friend'].code.desc2
    }
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-rows',
    style: {
      margin: '0px 0 84px 0px'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-text-primitive'
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: htmlLabel
    }
  })), /*#__PURE__*/React__default['default'].createElement("span", {
    onClick: copyText,
    style: {
      margin: '0px 0 0px 12px',
      color: '#007FFF',
      cursor: 'pointer'
    }
  }, locale['copy-text']), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      width: '30px'
    }
  }))), /*#__PURE__*/React__default['default'].createElement(Container, null, /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "line",
    link: link,
    title: copyLabel
  }), /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "facebook",
    link: link,
    title: copyLabel
  }), /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "twitter",
    link: link,
    title: copyLabel
  }))), /*#__PURE__*/React__default['default'].createElement(TabPane, {
    tab: locale['recommend-friend'].email.title,
    key: "1"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, sendResult && sendResult.failed.length > 0 ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "invite-results"
  }, /*#__PURE__*/React__default['default'].createElement(EmailResult, {
    failed: sendResult.failed
  }), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "primary",
    style: {
      margin: '15px auto'
    },
    onClick: function onClick() {
      return setResult(null);
    }
  }, locale.ok)) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center",
    style: {
      margin: '10px 0 0 0'
    }
  }, /*#__PURE__*/React__default['default'].createElement(SvgInviteEmail, null)), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      margin: '10px 0 20px 0'
    }
  }, locale['recommend-friend'].email.desc)), /*#__PURE__*/React__default['default'].createElement(EmailPrimitive, {
    onSubmit: handleSubmit
  }))))));
};

var _path$5, _path2$3, _path3$1, _path4$1, _path5$1, _path6$1, _path7$1, _path8$1, _path9$1, _path10$1, _path11;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgInviteShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 140,
    height: 103,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.998 11.827A4 4 0 0065.12 9.01L7.9 24.074a4 4 0 00-2.841 4.919l10.942 40.18a4 4 0 004.878 2.817L78.1 56.926a4 4 0 002.841-4.919l-10.942-40.18z",
    fill: "#DDE2EC"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.672 10.165l-2.877.28c-.1.02-.188-.03-.264-.109l-1.844-2.225c-.183-.23-.556-.075-.521.217l.28 2.877c.02.1-.032.188-.11.264l-2.225 1.844c-.23.183-.075.556.217.522l2.877-.28c.1-.02.188.03.264.108l1.844 2.226c.183.23.556.075.521-.217l-.28-2.877c-.02-.1.032-.188.11-.264l2.225-1.844c.23-.183.075-.556-.217-.522z",
    fill: "#2994FF"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8 29l-5.622 4.455 4.556 6.216-5.782 4.145 4.05 6.787-6.687 4.008 3.987 6.229-6.81 4.268 4.024 6.638-6.228 4.653 4.841 6.552L71 87.765l34.979 10.966a4 4 0 005.077-2.847l13.908-55.653a4 4 0 00-3.169-4.906L86.799 29z",
    fill: "#EFF2F4"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.248 53l14.549-4.03M14 33.81L34.902 28 14 33.811zm2.162 6.545l20.902-5.811-20.902 5.81zm1.936 6.111L39 40.657l-20.902 5.81z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.676 21.855a4 4 0 00-4.762 3.06L32.845 76.014a4 4 0 003.056 4.755l70.423 15.377a4 4 0 004.762-3.06l11.069-51.098a4 4 0 00-3.056-4.755L48.676 21.855z",
    fill: "#E7EAF0"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.671 25.421L83.575 13.92l25.873-9.86-24.777 21.362z",
    fill: "#2450F5"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.804 1.774l-13.316 26.56a1.209 1.209 0 01-1.439.613 1.26 1.26 0 01-.405-.228l-6.533-5.42a1.055 1.055 0 00-1.256-.066l-5.392 3.586c-.305.213-.645.257-1.015.142a1.082 1.082 0 01-.38-.198 1.182 1.182 0 01-.417-.6 1.198 1.198 0 01-.005-.732l1.748-5.63c.145-.47.448-.876.856-1.15l20.977-14.028-24.253 10.722a.528.528 0 01-.549-.076l-5.971-4.962c-.394-.308-.535-.716-.41-1.23.125-.493.43-.794.914-.899L113.46.036c.207-.053.425-.047.629.018.235.07.442.213.592.408.313.412.346.853.123 1.312z",
    fill: "#2994FF"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.258 18.7l5.825 4.62a.816.816 0 01.036.028l-.036-.028a1.055 1.055 0 00-1.221-.038l-5.39 3.586c-.306.213-.646.258-1.016.143a1.074 1.074 0 01-.38-.199 1.181 1.181 0 01-.417-.599 1.198 1.198 0 01-.005-.733l1.747-5.63c.146-.47.448-.876.857-1.15z",
    fill: "#0E3AC4"
  })), _path9$1 || (_path9$1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.991 92.982a3.991 3.991 0 100-7.982 3.991 3.991 0 000 7.982z",
    fill: "#FE5274"
  })), _path10$1 || (_path10$1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.463 70.316l11.02 2.331m-9.565-7.982l18.5 3.878-18.5-3.878z",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.596 70.113s5.672-27.732 27.108-26.541c12.376 0 6.876 12.696-.588 7.265-9.547-6.946-.872-20.423 14.19-19.817",
    stroke: "#414970",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var CodePrimitive = function CodePrimitive(_ref) {
  var code = _ref.code,
      _ref$length = _ref.length,
      length = _ref$length === void 0 ? 6 : _ref$length;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');
  var fillCode = code || Array(length).fill('-').join('');

  var _useCopyView = useCopyView({
    placeholder: '',
    text: fillCode
  }),
      overlay = _useCopyView.overlay,
      events = _useCopyView.events;

  return /*#__PURE__*/React__default['default'].createElement("div", _objectSpread2({
    className: prefixCls + '-code-primitive'
  }, events), overlay, fillCode.split('').map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("span", {
      className: 'code-box-item',
      key: item + '_' + index
    }, item);
  }));
};

var dataURItoBlob = function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], {
    type: mimeString
  });
};

var saveImageFromDataUrl = function saveImageFromDataUrl(dataUrl, fileName) {
  var blob = dataURItoBlob(dataUrl);
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

var QRCodePrimitive = function QRCodePrimitive(_ref) {
  var url = _ref.url;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      dataUrl = _useState2[0],
      setDataUrl = _useState2[1];

  var _useCopyView = useCopyView({
    onCopy: function onCopy() {
      try {
        navigator.clipboard.write([new ClipboardItem({
          'image/png': dataURItoBlob(dataUrl)
        })]);
      } catch (error) {
        saveImageFromDataUrl(dataUrl, 'qrcode.png');
      }
    }
  }),
      overlay = _useCopyView.overlay,
      events = _useCopyView.events;

  React.useEffect(function () {
    if (!url) {
      return;
    }

    QRCode.toDataURL(url).then(function (imageDataUrl) {
      setDataUrl(imageDataUrl);
    }).catch(function (error) {
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.log(error);
      }
    });
  }, [url]);
  return /*#__PURE__*/React__default['default'].createElement("div", _objectSpread2({
    className: prefixCls + '-qrcode-primitive'
  }, events), overlay, dataUrl && /*#__PURE__*/React__default['default'].createElement("img", {
    src: dataUrl
  }));
};

var TextPrimitive = function TextPrimitive(_ref) {
  var copyText = _ref.copyText,
      children = _ref.children;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useCopyView = useCopyView({
    text: copyText || (children === null || children === void 0 ? void 0 : children.toString())
  }),
      overlay = _useCopyView.overlay,
      events = _useCopyView.events;

  return /*#__PURE__*/React__default['default'].createElement("div", _objectSpread2({
    className: prefixCls + '-text-primitive'
  }, events), overlay, children);
};

var TabPane$1 = _Tabs__default['default'].TabPane;
var Content$1 = function Content(_ref) {
  var code = _ref.code,
      expiredAt = _ref.expiredAt,
      organizationName = _ref.organizationName,
      userName = _ref.userName,
      _ref$defaultIndex = _ref.defaultIndex,
      defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
      link = _ref.link,
      dialog = _ref.dialog,
      onVisibleChange = _ref.onVisibleChange,
      onSendEmail = _ref.onSendEmail;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');

  var _useLocaleReceiver = useLocaleReceiver('InvitationShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var label = locale['join-organization'].code['copy-label'].replace('{userName}', userName).replace('{orgName}', organizationName).replace('{invite_code}', code);
  var htmlLabel = label.replace('{link}', "<a>".concat(link, "</a>"));
  var copyLabel = label.replace('{link}', link);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sendResult = _useState2[0],
      setResult = _useState2[1];

  var handleSubmit = function handleSubmit(emailList) {
    if (onSendEmail) {
      return onSendEmail === null || onSendEmail === void 0 ? void 0 : onSendEmail(emailList).then(function (res) {
        setResult({
          failed: res.failed ? res.failed : []
        });
      });
    }

    return Promise.resolve();
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "title"
  }, locale['join-organization'].title), dialog && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "text",
    icon: /*#__PURE__*/React__default['default'].createElement(Icon.CloseOutlined, null),
    onClick: function onClick() {
      return onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
    }
  }))), /*#__PURE__*/React__default['default'].createElement(_Tabs__default['default'], {
    defaultActiveKey: defaultIndex + ''
  }, /*#__PURE__*/React__default['default'].createElement(TabPane$1, {
    tab: locale['join-organization'].share,
    key: '0'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center",
    style: {
      margin: '10px 0 0 0'
    }
  }, /*#__PURE__*/React__default['default'].createElement(SvgInviteShare, null)), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      margin: '10px 0 20px 0'
    }
  }, locale['join-organization'].code.title.replace('{expiredAt}', expiredAt))), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement(CodePrimitive, {
    code: code
  })), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      margin: '16px 0 32px 0'
    }
  }, locale['join-organization'].code.desc)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls + '-rows'
  }, /*#__PURE__*/React__default['default'].createElement(TextPrimitive, {
    copyText: copyLabel
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: htmlLabel
    }
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      width: '30px'
    }
  }), /*#__PURE__*/React__default['default'].createElement(QRCodePrimitive, {
    url: link
  })), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: 'copy-text-highlight',
    style: {
      margin: '16px 0 32px 0'
    },
    dangerouslySetInnerHTML: {
      __html: locale['join-organization'].code.desc2
    }
  }))), /*#__PURE__*/React__default['default'].createElement(Container, null, /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "line",
    link: link,
    title: copyLabel
  }), /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "facebook",
    link: link,
    title: copyLabel
  }), /*#__PURE__*/React__default['default'].createElement(SNSPrimitive, {
    type: "twitter",
    link: link,
    title: copyLabel
  }))), /*#__PURE__*/React__default['default'].createElement(TabPane$1, {
    tab: locale['join-organization'].email.title,
    key: "1"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, sendResult && sendResult.failed.length > 0 ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "invite-results"
  }, /*#__PURE__*/React__default['default'].createElement(EmailResult, {
    failed: sendResult.failed
  }), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "primary",
    style: {
      margin: '15px auto'
    },
    onClick: function onClick() {
      return setResult(null);
    }
  }, locale.ok)) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center",
    style: {
      margin: '10px 0 0 0'
    }
  }, /*#__PURE__*/React__default['default'].createElement(SvgInviteEmail, null)), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    justify: "center"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      margin: '10px 0 20px 0'
    }
  }, locale['join-organization'].email.desc)), /*#__PURE__*/React__default['default'].createElement(EmailPrimitive, {
    onSubmit: handleSubmit
  }))))));
};

var InvitationShareDialog = function InvitationShareDialog(_ref) {
  var visible = _ref.visible,
      onVisibleChange = _ref.onVisibleChange,
      children = _ref.children;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('invitation-share');
  return /*#__PURE__*/React__default['default'].createElement(_Modal__default['default'], {
    className: "".concat(prefixCls, "-modal"),
    visible: visible,
    destroyOnClose: true,
    onCancel: function onCancel() {
      return onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
    },
    centered: true,
    footer: null,
    closable: false,
    width: 600
  }, children);
};

var css_248z$a = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 24px 0 24px;\n}\n.header .title {\n  color: #333;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n}\n.invitation {\n  position: absolute;\n  top: 20%;\n  left: 50%;\n  z-index: 1010;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.85);\n  list-style: none;\n  transform: translateX(-50%);\n  pointer-events: none;\n}\n.invitation-notice {\n  padding: 8px;\n  text-align: center;\n}\n.invitation-notice-content {\n  display: inline-block;\n  min-width: 111px;\n  min-height: 40px;\n  padding: 10px 16px;\n  color: #fff;\n  background: rgba(44, 45, 47, 0.98);\n  border-radius: 36px;\n  pointer-events: all;\n}\n.invitation-notice-content span.anticon {\n  margin-right: 8px;\n  color: #0aa882;\n}\n.felo-invitation-share-modal .ant-modal-content {\n  border-radius: 8px;\n}\n.felo-invitation-share-modal .ant-modal-body {\n  padding: 0;\n}\n.felo-invitation-share {\n  position: relative;\n  color: #333;\n  font-size: 14px;\n}\n.felo-invitation-share .copy-text-highlight i {\n  color: #2994ff;\n  font-style: normal;\n}\n.felo-invitation-share .ant-tabs-nav::before {\n  display: none;\n}\n.felo-invitation-share .ant-tabs-nav .ant-tabs-nav-wrap {\n  justify-content: center;\n}\n.felo-invitation-share .invite-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.felo-invitation-share-qrcode-primitive {\n  position: relative;\n  width: 68px;\n  height: 68px;\n}\n.felo-invitation-share-qrcode-primitive img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.felo-invitation-share-email-primitive {\n  position: relative;\n}\n.felo-invitation-share-email-primitive .tags-container {\n  padding: 14px 0;\n}\n.felo-invitation-share-code-primitive {\n  position: relative;\n  display: flex;\n  gap: 12px;\n}\n.felo-invitation-share-code-primitive .code-box-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  color: #333;\n  font-weight: 600;\n  font-size: 20px;\n  background-color: #fff;\n  border: 1px solid #dadada;\n  border-radius: 4px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.felo-invitation-share-text-primitive {\n  position: relative;\n  flex: 1;\n  padding: 11px 12px;\n  color: #333;\n  font-size: 14px;\n  border: 1px solid #dadada;\n  border-radius: 4px;\n}\n.felo-invitation-share-text-primitive a {\n  color: #2994ff;\n  text-decoration: underline;\n}\n.felo-invitation-share-sns-container {\n  display: flex;\n  align-items: center;\n  padding: 20px 23px;\n  background: #f5f5f5;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.felo-invitation-share-sns-container .desc {\n  margin-right: 16px;\n  color: #333;\n  font-weight: 400;\n  font-size: 14px;\n}\n.felo-invitation-share-sns-container .icons {\n  display: flex;\n  gap: 16px;\n}\n.felo-invitation-share-sns-container .sns-primitive {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.15s ease-in;\n}\n.felo-invitation-share-sns-container .sns-primitive:hover {\n  opacity: 0.9;\n}\n.felo-invitation-share-sns-container .sns-primitive > svg {\n  max-width: 100%;\n  max-height: 100%;\n}\n.felo-invitation-share-email-result .title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.felo-invitation-share-email-result .title img {\n  width: 50px;\n  margin-bottom: 10px;\n}\n.felo-invitation-share-email-result .email-list {\n  max-height: 150px;\n  overflow-y: auto;\n}\n.felo-invitation-share-email-result .email-list .email-item {\n  display: flex;\n}\n.felo-invitation-share-email-result .email-list .email-item-email {\n  margin-right: 20px;\n}\n.felo-invitation-share-email-result .email-list .email-item-error {\n  color: #f5222d;\n}\n.felo-invitation-share-rows {\n  display: flex;\n  align-items: center;\n}\n.felo-invitation-share-copy-overlay {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: rgba(51, 51, 51, 0.8);\n  border-radius: 4px;\n  cursor: pointer;\n  inset: 0;\n}\n";
styleInject(css_248z$a);

var _excluded$5 = ["dialog", "children"],
    _excluded2 = ["dialog", "visible", "onVisibleChange"];

var Wrap = function Wrap(_ref) {
  var dialog = _ref.dialog,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$5);

  if (dialog) {
    return /*#__PURE__*/React__default['default'].createElement(InvitationShareDialog, _objectSpread2({}, rest), children);
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, children);
};

var ContentMaps = {
  JoinOrganization: Content$1,
  RecommendFriend: Content,
  Unknown: function Unknown(_) {
    return null;
  }
};

var InvitationShare = function InvitationShare(_ref2) {
  var _ref2$dialog = _ref2.dialog,
      dialog = _ref2$dialog === void 0 ? true : _ref2$dialog,
      visible = _ref2.visible,
      onVisibleChange = _ref2.onVisibleChange,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var Component = ContentMaps[rest.type || 'Unknown'];
  return /*#__PURE__*/React__default['default'].createElement(Wrap, {
    dialog: dialog,
    visible: visible,
    onVisibleChange: onVisibleChange
  }, /*#__PURE__*/React__default['default'].createElement(Component, _objectSpread2(_objectSpread2({}, rest.data), {}, {
    dialog: dialog,
    onVisibleChange: onVisibleChange
  })));
};

var CommonShareContext = /*#__PURE__*/React.createContext({});

var isDept = function isDept(value) {
  return value.children !== undefined;
};

var DeptSelect$1 = function DeptSelect(_ref) {
  var onLoad = _ref.onLoad,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      onValuesChange = _ref.onValuesChange,
      defaultCheckedValues = _ref.defaultCheckedValues;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var _useLocaleReceiver = useLocaleReceiver('global'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      globalLocale = _useLocaleReceiver2[0];

  var _useLocaleReceiver3 = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver4 = _slicedToArray(_useLocaleReceiver3, 1),
      locale = _useLocaleReceiver4[0];

  var prefixCls = getPrefixCls('common-share-dept');

  var _useState = React.useState([{
    id: 'all',
    power: -1,
    avatar: /*#__PURE__*/React__default['default'].createElement(ShareOrgIcon, null),
    name: locale.select.all,
    type: 3,
    checkable: false,
    children: []
  } // {
  //   id: 'conversation',
  //   power: -1,
  //   src: <ShareOrgIcon />,
  //   name: locale.select.conversation,
  //   type: 3,
  //   checkable: false,
  //   children: [],
  // },
  ]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = React.useState(defaultCheckedValues || []),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedItems = _useState6[0],
      setSelectedItems = _useState6[1];

  var _useState7 = React.useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      searchKeyword = _useState8[0],
      setSearchKeyword = _useState8[1];

  var _useState9 = React.useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      searchData = _useState10[0],
      setSearchData = _useState10[1];

  var _useState11 = React.useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      querying = _useState12[0],
      setQuerying = _useState12[1];

  var _useContext = React.useContext(CommonShareContext),
      prevAction = _useContext.prevAction,
      setAction = _useContext.setAction;

  var getCurrentData = function getCurrentData() {
    var clone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var currentData = searchKeyword ? searchData : data;
    return clone ? currentData.concat() : currentData;
  };

  var setCurrentData = function setCurrentData(data) {
    if (searchKeyword) setSearchData(data);else setData(data);
  };

  var findById = function findById(id) {
    var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var target = child.find(function (item) {
      return item.id === id;
    });

    if (target) {
      return target;
    }

    for (var i = 0; i < child.length; i++) {
      var item = child[i];

      if ('children' in item) {
        var result = findById(id, item.children);
        if (result) return result;
      }
    }

    return null;
  };

  var filterData = function filterData(data, callback) {
    var values = [];

    for (var i = 0; i < data.length; i++) {
      var item = data[i];

      if (callback(item)) {
        values.push(item);
      }

      if ('children' in item) {
        values.push.apply(values, _toConsumableArray(filterData(item.children, callback)));
      }
    }

    return values;
  };

  var load = function load() {
    var deptId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!onLoad) return;

    if (deptId) {
      var newData = getCurrentData(true);
      var info = findById(deptId, newData);

      if (info && isDept(info)) {
        info.loading = true;
        setCurrentData(newData);
      }
    } else {
      setLoading(true);
    }

    onLoad(deptId).then(function (res) {
      var newData = getCurrentData(true);
      var info = findById(deptId, newData);

      if (info && isDept(info)) {
        info.children = res;
        info.loading = false;
        info.loaded = true;
        info.opened = true;
        setCurrentData(newData);
      } else {
        setCurrentData(res);
      }
    }).finally(function () {
      setLoading(false);
    });
  };

  var handleSearch = function handleSearch(keyword) {
    if (!onSearch) return;
    setQuerying(true);
    onSearch(keyword).then(function (res) {
      setSearchData(res);
    }).finally(function () {
      return setQuerying(false);
    });
  };

  React.useEffect(function () {
    load('all'); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (onValuesChange) onValuesChange(selectedItems);
  }, [selectedItems, onValuesChange]);

  var handleSubDeptClick = function handleSubDeptClick(info) {
    if (!info.loaded) load(info.id);else {
      var newData = getCurrentData(true);
      var target = findById(info.id, newData);

      if (target && isDept(target)) {
        target.opened = !target.opened;
        setCurrentData(newData);
      }
    }
  };

  var handleChecked = function handleChecked(info) {
    var checkedMembers = [];
    var newData = getCurrentData(true);
    filterData(newData, function (item) {
      if (item.id === info.id) {
        item.checked = !item.checked;
      }

      return !!item.checked;
    });
    setCurrentData(newData);

    if (onChange) {
      onChange(info, checkedMembers);
    }
  };

  var handleClick = function handleClick(item) {
    if (item.checked) {
      setSelectedItems(function (preItem) {
        return preItem.filter(function (pre) {
          return pre.id !== item.id;
        });
      });
    } else {
      setSelectedItems(function (preItem) {
        if (preItem.find(function (p) {
          return p.id === item.id;
        })) return preItem;
        return preItem.concat(item);
      });
    }

    handleChecked(item);
  };

  var renderList = function renderList(data) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'select';
    var selectMode = mode === 'select';
    if (loading && selectMode) return /*#__PURE__*/React__default['default'].createElement(Loading$1, null);
    var openedIconStyle = {
      fontSize: 12,
      color: '#666'
    };
    return /*#__PURE__*/React__default['default'].createElement("ul", null, data.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: "".concat(item.type, "-").concat(item.id),
        onClick: function onClick(e) {
          e.stopPropagation();
          if (item.checkable !== false && selectMode) handleClick(item);
        }
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-item")
      }, selectMode && isDept(item) && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-arrow-right"),
        onClick: function onClick(e) {
          e.stopPropagation();
          handleSubDeptClick(item);
        }
      }, item.loading ? /*#__PURE__*/React__default['default'].createElement(Icon.LoadingOutlined, null) : item.opened ? /*#__PURE__*/React__default['default'].createElement(Icon.CaretDownFilled, {
        style: openedIconStyle
      }) : /*#__PURE__*/React__default['default'].createElement(Icon.CaretRightFilled, {
        style: openedIconStyle
      }))), selectMode && item.checkable !== false && /*#__PURE__*/React__default['default'].createElement(_Checkbox__default['default'], {
        disabled: item.disabled,
        checked: item.checked
      }), /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
        shape: "circle",
        size: 32,
        name: item.name,
        src: item.avatar
      }), /*#__PURE__*/React__default['default'].createElement("span", null, item.name), !selectMode && /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
          item.checked = true;
          item.power = 1;
          handleClick(item);
        }
      }, /*#__PURE__*/React__default['default'].createElement(Icon.CloseOutlined, {
        style: {
          fontSize: 14,
          color: '#666'
        }
      }))), selectMode && isDept(item) && item.opened && renderList(item.children));
    }));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-select-contact")
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-container")
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
    placeholder: locale.select.placeholder,
    onChange: function onChange(e) {
      setSearchKeyword(e.target.value);
      handleSearch(e.target.value);
    }
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-leftBottom-container")
  }, querying && /*#__PURE__*/React__default['default'].createElement(Loading$1, null), !querying && (searchKeyword ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-result-container")
  }, renderList(formatSearchData$1(searchData, selectedItems))) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, loading ? /*#__PURE__*/React__default['default'].createElement(Loading$1, null) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-search-list-container")
  }, renderList(data)))))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-rightPart-container")
  }, /*#__PURE__*/React__default['default'].createElement("div", null, locale.select.selectedNumber.replace('{num}', String(selectedItems.length))), /*#__PURE__*/React__default['default'].createElement("div", null, renderList(selectedItems, 'value')))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    onClick: function onClick() {
      return setAction(prevAction ? {
        type: prevAction.type,
        data: defaultCheckedValues !== null && defaultCheckedValues !== void 0 ? defaultCheckedValues : []
      } : {
        type: 'link'
      });
    }
  }, globalLocale.cancel), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "primary",
    onClick: function onClick() {
      return setAction({
        type: 'add',
        data: selectedItems
      });
    }
  }, globalLocale.ok)));
};

var formatSearchData$1 = function formatSearchData(data, selectedItems) {
  var newData = [];

  var _iterator = _createForOfIteratorHelper(data),
      _step;

  try {
    var _loop = function _loop() {
      var d = _step.value;
      var matchItem = selectedItems.find(function (v) {
        return String(v.id) === String(d.id);
      });

      if (matchItem) {
        newData.push(Object.assign(d, {
          checked: matchItem.checked
        }));
      } else {
        newData.push(Object.assign(d, {
          checked: false
        }));
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return newData;
};

var ShareSelect$1 = function ShareSelect(props) {
  var searchContainerRef = React.useRef(null);
  var containerRef = React.useRef(null);

  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('common-share-select');

  var _useContext = React.useContext(CommonShareContext),
      setAction = _useContext.setAction;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      querying = _useState2[0],
      setQuerying = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      searchData = _useState6[0],
      setSearchData = _useState6[1];

  var values = React.useMemo(function () {
    var _props$values;

    return (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        key: item.id
      });
    });
  }, [props.values]);

  var query = function query(value) {
    if (props.onSearch) {
      setQuerying(true);
      props.onSearch(value).then(function (data) {
        setSearchData(data.map(function (item) {
          return _objectSpread2(_objectSpread2({}, item), {}, {
            key: item.id
          });
        }));
        setQuerying(false);
      });
    }
  };

  var onChange = function onChange(value) {
    if (props.onChange) props.onChange(value);
    setSearchValue(value);

    if (value) {
      query(value);
    } else {
      setSearchData([]);
    }
  };

  var handleSelect = function handleSelect(member) {
    if (props.onSelect) props.onSelect([member]);
    return member;
  };

  var renderSearchItem = function renderSearchItem(_ref) {
    var avatar = _ref.avatar,
        name = _ref.name,
        type = _ref.type;
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      shape: "circle",
      size: 32,
      src: avatar,
      name: name,
      type: type
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta")
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta-name")
    }, name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-result-meta-desc")
    })));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, " ").concat(props.className || ''),
    ref: containerRef
  }, /*#__PURE__*/React__default['default'].createElement(Search, {
    data: searchData.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        key: item.id
      });
    }),
    loading: querying,
    placeholder: props.placeholder !== undefined ? props.placeholder : locale.select.placeholder,
    onChange: onChange,
    onRenderItem: renderSearchItem,
    onRenderValue: function onRenderValue(value) {
      return /*#__PURE__*/React__default['default'].createElement("span", {
        className: "".concat(prefixCls, "-value")
      }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
        size: 24,
        src: value.avatar,
        name: value.name,
        type: value.type
      }), /*#__PURE__*/React__default['default'].createElement("span", null, value.name));
    },
    onRenderRemove: function onRenderRemove(value, callback) {
      return /*#__PURE__*/React__default['default'].createElement(ShareRemoveIcon, {
        className: "".concat(prefixCls, "-value-remove"),
        onClick: function onClick() {
          return callback(value.key);
        }
      });
    },
    onSelect: function onSelect(value) {
      var item = handleSelect(value);
      return item;
    },
    getListContainer: function getListContainer() {
      return searchContainerRef.current;
    },
    values: values,
    onValuesChange: function onValuesChange(value) {
      return props.onValuesChange && props.onValuesChange(value);
    },
    prefix: null,
    suffix: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.suffix || /*#__PURE__*/React__default['default'].createElement(ShareAddIcon, {
      className: "".concat(prefixCls, "-add"),
      onClick: function onClick() {
        return setAction({
          type: 'dept',
          data: values
        });
      }
    }))
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default']("".concat(prefixCls, "-result"), _defineProperty({}, "".concat(prefixCls, "-active"), !!searchValue)),
    ref: searchContainerRef
  })));
};

var css_248z$b = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-dropdown,\n.felo-dropdown-sub {\n  min-width: 152px;\n  border-radius: 4px;\n}\n.felo-dropdown .ant-menu-item,\n.felo-dropdown-sub .ant-menu-item,\n.felo-dropdown .ant-menu-submenu,\n.felo-dropdown-sub .ant-menu-submenu,\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title {\n  align-items: center;\n  height: 28px;\n  margin: 0 !important;\n  padding: 0 14px;\n  line-height: 28px;\n  cursor: pointer;\n}\n.felo-dropdown .ant-menu-item:hover,\n.felo-dropdown-sub .ant-menu-item:hover,\n.felo-dropdown .ant-menu-submenu:hover,\n.felo-dropdown-sub .ant-menu-submenu:hover,\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title:hover,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title:hover,\n.felo-dropdown .ant-menu-item.ant-menu-item-active,\n.felo-dropdown-sub .ant-menu-item.ant-menu-item-active,\n.felo-dropdown .ant-menu-submenu.ant-menu-item-active,\n.felo-dropdown-sub .ant-menu-submenu.ant-menu-item-active,\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-active,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-active,\n.felo-dropdown .ant-menu-item.ant-menu-item-active:hover,\n.felo-dropdown-sub .ant-menu-item.ant-menu-item-active:hover,\n.felo-dropdown .ant-menu-submenu.ant-menu-item-active:hover,\n.felo-dropdown-sub .ant-menu-submenu.ant-menu-item-active:hover,\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-active:hover,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-active:hover {\n  color: unset;\n  background-color: #f1f1f1;\n}\n.felo-dropdown .ant-menu-item.ant-menu-item-selected,\n.felo-dropdown-sub .ant-menu-item.ant-menu-item-selected,\n.felo-dropdown .ant-menu-submenu.ant-menu-item-selected,\n.felo-dropdown-sub .ant-menu-submenu.ant-menu-item-selected,\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-selected,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title.ant-menu-item-selected {\n  color: unset;\n  background-color: transparent;\n}\n.felo-dropdown .ant-menu-submenu,\n.felo-dropdown-sub .ant-menu-submenu {\n  padding-right: 0;\n}\n.felo-dropdown .ant-menu-submenu.ant-menu-submenu-selected,\n.felo-dropdown-sub .ant-menu-submenu.ant-menu-submenu-selected {\n  color: unset;\n}\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title {\n  padding: 0;\n}\n.felo-dropdown .ant-menu-submenu .ant-menu-submenu-title:hover,\n.felo-dropdown-sub .ant-menu-submenu .ant-menu-submenu-title:hover {\n  color: unset;\n}\n.felo-dropdown-trigger[disabled] {\n  color: rgba(17, 31, 44, 0.24);\n  cursor: not-allowed;\n}\n.felo-dropdown-sub .ant-dropdown-menu {\n  background: #fff;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-dropdown-wrapper.ant-dropdown {\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-dropdown-arrow {\n  position: relative;\n  left: 4px;\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n}\n.felo-dropdown-arrow::before {\n  position: absolute;\n  top: 6px;\n  left: 5px;\n  width: 0;\n  height: 0;\n  border-top: 4px solid #838d9b;\n  border-right: 3px solid transparent;\n  border-left: 3px solid transparent;\n  content: ' ';\n}\n.felo-dropdown-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-color: #d6dce6;\n  border-radius: 4px;\n}\n.felo-dropdown-button:hover,\n.felo-dropdown-button:focus {\n  color: #1c202a;\n  border-color: #2994ff;\n}\n.felo-dropdown-button:hover .felo-dropdown-arrow,\n.felo-dropdown-button:focus .felo-dropdown-arrow {\n  background: #f0f0f0;\n}\n";
styleInject(css_248z$b);

var _excluded$6 = ["items", "children", "placement", "defaultOpenKeys", "trigger", "onVisbleChange", "popupOffset", "onChange", "outline", "disabled", "arrow", "getPopupContainer", "icon", "renderItem", "renderContent"];
var SubMenu = _Menu__default['default'].SubMenu;

var Dropdown = function Dropdown(_ref) {
  var items = _ref.items,
      children = _ref.children,
      placement = _ref.placement,
      defaultOpenKeys = _ref.defaultOpenKeys,
      trigger = _ref.trigger,
      onVisbleChange = _ref.onVisbleChange,
      popupOffset = _ref.popupOffset,
      onChange = _ref.onChange,
      outline = _ref.outline,
      disabled = _ref.disabled,
      arrow = _ref.arrow,
      getPopupContainer = _ref.getPopupContainer,
      icon = _ref.icon,
      renderItem = _ref.renderItem,
      renderContent = _ref.renderContent,
      props = _objectWithoutProperties(_ref, _excluded$6);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('dropdown');
  var findActiveItem = React.useCallback(function (items) {
    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item.key === props.activeKey) return item;

        if (item.children) {
          var result = findActiveItem(item.children);
          if (result) return result;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  }, [props.activeKey]);

  var defaultRenderItem = function defaultRenderItem(item) {
    var _item$link, _item$link2, _item$link3, _item$link4;

    var renderSubMenu = function renderSubMenu(subItem) {
      return /*#__PURE__*/React__default['default'].createElement(SubMenu, {
        popupClassName: "".concat(prefixCls, "-sub"),
        key: subItem.key,
        title: subItem.title,
        popupOffset: popupOffset
      }, subItem.children && subItem.children.map(defaultRenderItem));
    };

    return item.children ? renderSubMenu(item) : ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.href) ? /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: item.key
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.href,
      target: ((_item$link3 = item.link) === null || _item$link3 === void 0 ? void 0 : _item$link3.target) ? (_item$link4 = item.link) === null || _item$link4 === void 0 ? void 0 : _item$link4.target : '_self'
    }, renderItem ? renderItem(item) : item.title)) : /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: item.key,
      onClick: item.onClick
    }, renderItem ? renderItem(item) : item.title);
  };

  var renderMenuContent = function renderMenuContent() {
    return /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'], _objectSpread2({
      className: prefixCls,
      defaultOpenKeys: defaultOpenKeys,
      defaultSelectedKeys: props.activeKey ? [props.activeKey] : [],
      selectedKeys: props.activeKey ? [props.activeKey] : [],
      defaultActiveFirst: true,
      onClick: function onClick(_ref2) {
        var key = _ref2.key;
        return onChange ? onChange(key) : undefined;
      }
    }, props), items.map(defaultRenderItem));
  };

  var renderChildren = React.useCallback(function () {
    var _findActiveItem;

    var activeItem = (_findActiveItem = findActiveItem(items)) !== null && _findActiveItem !== void 0 ? _findActiveItem : items[0];
    if (renderContent) return renderContent(activeItem);
    return children && !outline ? children : /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "".concat(prefixCls, "-button")
    }, children || (activeItem ? activeItem.title : 'Unknown'), ' ', arrow !== false && (icon || /*#__PURE__*/React__default['default'].createElement("span", {
      className: "".concat(prefixCls, "-arrow")
    }, " ")));
  }, [arrow, children, findActiveItem, icon, items, outline, prefixCls, renderContent]);
  return /*#__PURE__*/React__default['default'].createElement(_Dropdown__default['default'], {
    className: "".concat(prefixCls, "-trigger"),
    overlay: renderMenuContent(),
    overlayClassName: "".concat(prefixCls, "-wrapper"),
    trigger: trigger,
    onVisibleChange: onVisbleChange,
    placement: placement || 'bottomLeft',
    getPopupContainer: getPopupContainer,
    disabled: disabled
  }, renderChildren());
};

var getPermissionKey = function getPermissionKey(item) {
  switch (item.power) {
    case 1:
      return 'view';

    case 2:
      return 'edit';

    case 3:
      return 'transfer';
  }

  return 'nopermission';
};
var getPermissionValue = function getPermissionValue(key) {
  switch (key) {
    case 'view':
      return 1;

    case 'edit':
      return 2;

    case 'transfer':
      return 3;

    default:
      return 0;
  }
};

var PermissionSelect = function PermissionSelect(_ref) {
  var itemsProps = _ref.items,
      disabled = _ref.disabled,
      loading = _ref.loading,
      activeKeyProps = _ref.activeKey,
      onChange = _ref.onChange;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('common-share-permission');

  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(activeKeyProps),
      _useState2 = _slicedToArray(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1];

  var removeModal = React.useRef();
  var items = [];
  var isEmpty = itemsProps.length === 0;
  if (isEmpty || itemsProps.includes('edit')) items.push({
    key: 'edit',
    title: locale.permissions.edit
  });
  if (isEmpty || itemsProps.includes('view')) items.push({
    key: 'view',
    title: locale.permissions.view
  });
  if (isEmpty || itemsProps.includes('nopermission')) items.push({
    key: 'nopermission',
    title: locale.permissions.no
  });

  if (isEmpty || itemsProps.includes('transfer')) {
    items.push({
      key: 'transfer',
      title: locale.permissions.transfer
    });
  }

  React.useEffect(function () {
    setActiveKey(activeKeyProps);
  }, [activeKeyProps]);
  var description = {
    edit: locale.permissions.editDescription,
    view: locale.permissions.viewDescription,
    nopermission: locale.permissions.noDescription,
    transfer: locale.permissions.transferDescription
  };

  var handleChange = function handleChange(key) {
    if (key === 'separation') return;
    var type = key;

    var change = function change() {
      setActiveKey(type);
      if (onChange) onChange(type);
    };

    if (type === 'transfer') {
      if (removeModal.current) {
        removeModal.current.destroy();
      }

      removeModal.current = _Modal__default['default'].confirm({
        title: locale.permissions.setTransferTitle,
        className: "".concat(prefixCls, "-remove-confirm"),
        zIndex: 1080,
        mask: false,
        maskClosable: true,
        width: 480,
        closable: true,
        centered: true,
        icon: null,
        content: locale.permissions.setTransferDescription,
        okButtonProps: {
          danger: true
        },
        onOk: function onOk() {
          change();
        }
      });
    } else {
      change();
    }
  };

  var renderContent = function renderContent(item) {
    var text = (item === null || item === void 0 ? void 0 : item.title) || 'Unknow';

    if ((item === null || item === void 0 ? void 0 : item.key) === 'transfer') {
      text = locale.permissions.owner;
    }

    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, text, loading ? /*#__PURE__*/React__default['default'].createElement(Icon.LoadingOutlined, null) : /*#__PURE__*/React__default['default'].createElement(Icon.DownOutlined, null));
  };

  return /*#__PURE__*/React__default['default'].createElement(Dropdown, {
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentElement.parentElement;
    },
    className: "".concat(prefixCls),
    disabled: disabled,
    items: items,
    activeKey: activeKey,
    onChange: function onChange(key) {
      return handleChange(key);
    },
    placement: "bottomRight",
    arrow: false,
    outline: false,
    renderItem: function renderItem(item) {
      if (item.key === 'separation') {
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: "".concat(prefixCls, "-separation")
        });
      }

      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-item").concat(item.key === 'transfer' ? ' ' + prefixCls + '-transfer' : '')
      }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-item-title")
      }, item.title), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "".concat(prefixCls, "-item-desc")
      }, description[item.key])), /*#__PURE__*/React__default['default'].createElement("div", null, activeKey === item.key && /*#__PURE__*/React__default['default'].createElement(Icon.CheckOutlined, {
        style: {
          color: '#2994FF'
        }
      })));
    },
    renderContent: renderContent
  });
};

var SharePasswordSetting = function SharePasswordSetting(_ref) {
  var locale = _ref.locale,
      prefixCls = _ref.prefixCls,
      onCopy = _ref.onCopy,
      defaultPassword = _ref.defaultPassword,
      isEnabled = _ref.isEnabled,
      onChange = _ref.onChange,
      onOk = _ref.onOk;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState(defaultPassword !== null && defaultPassword !== void 0 ? defaultPassword : '8888'),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1];

  var _useState5 = React.useState(isEnabled),
      _useState6 = _slicedToArray(_useState5, 2),
      enabled = _useState6[0],
      setEnabled = _useState6[1];

  var refreshPassword = function refreshPassword() {
    var newPwd = randomPassword();
    setPassword(newPwd);
  };

  React.useEffect(function () {
    onChange(enabled, password);
  }, [enabled, password, onChange]);

  var handleOk = function handleOk() {
    setLoading(true);
    var result = onOk();

    if (result) {
      result.finally(function () {
        setLoading(false);
      });
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-password-content")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-password-body")
  }, /*#__PURE__*/React__default['default'].createElement(_Checkbox__default['default'], {
    checked: enabled,
    onChange: function onChange(e) {
      return setEnabled(e.target.checked);
    }
  }, locale.link.password.enable)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-password-input")
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'].Group, {
    compact: true
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    placeholder: locale.link.password.placeholder,
    maxLength: 4
  }), /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
    title: locale.link.password.update
  }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "link",
    icon: /*#__PURE__*/React__default['default'].createElement(ShareRefreshIcon, null),
    onClick: refreshPassword
  }))), /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "link",
    disabled: !password,
    onClick: function onClick() {
      return onCopy(enabled ? password : '');
    }
  }, locale.link.password.copy)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-password-desc")
  }, locale.link.password.description), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      marginTop: 24,
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "primary",
    loading: loading,
    disabled: enabled && !password,
    onClick: handleOk
  }, locale.link.password.ok)));
};

var ShareLink$1 = function ShareLink(_ref2) {
  var loadingProp = _ref2.loading,
      onSearch = _ref2.onSearch,
      onSelect = _ref2.onSelect,
      onChange = _ref2.onChange,
      onDelete = _ref2.onDelete,
      onUpdate = _ref2.onUpdate,
      onSearchValueChange = _ref2.onSearchValueChange,
      onCopy = _ref2.onCopy,
      onSettingsUpdate = _ref2.onSettingsUpdate,
      getCopyLink = _ref2.getCopyLink,
      _ref2$settings = _ref2.settings,
      settings = _ref2$settings === void 0 ? {
    dept_power: 0,
    internet_power: 0,
    enabled_password: false
  } : _ref2$settings;

  var _useState7 = React.useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      linkLayerVisible = _useState8[0],
      setLinkLayerVisible = _useState8[1];

  var settingsRef = React.useRef(settings);

  var _useState9 = React.useState(settings.dept_power),
      _useState10 = _slicedToArray(_useState9, 2),
      deptPower = _useState10[0],
      setDeptPower = _useState10[1];

  var _useState11 = React.useState(settings.internet_power),
      _useState12 = _slicedToArray(_useState11, 2),
      internetPower = _useState12[0],
      setInternetPower = _useState12[1];

  var _useState13 = React.useState(settings.deptAllowEdit),
      _useState14 = _slicedToArray(_useState13, 2),
      deptAllowEdit = _useState14[0],
      setDeptAllowEdit = _useState14[1];

  var _useState15 = React.useState(settings.internetAllowEdit),
      _useState16 = _slicedToArray(_useState15, 2),
      internetAllowEdit = _useState16[0],
      setInternetAllowEdit = _useState16[1];

  var passwordModal = React.useRef();
  var removeModal = React.useRef();

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var isMobile = isMobileJs__default['default']().any;
  var prefixCls = getPrefixCls('common-share-link');

  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var getLink = React.useCallback(function () {
    if (getCopyLink) {
      return getCopyLink();
    }

    return window.location.href;
  }, [getCopyLink]);
  React.useEffect(function () {
    setDeptPower(settings.dept_power);
    setDeptAllowEdit(settings.deptAllowEdit);
    setInternetPower(settings.internet_power);
    setInternetAllowEdit(settings.internetAllowEdit);
    settingsRef.current = _objectSpread2({}, settings);
  }, [settings]);
  var handleCopy = React.useCallback(function (pwd) {
    if (onCopy) onCopy(getLink(), pwd);
  }, [onCopy, getLink]);

  var _useContext = React.useContext(CommonShareContext),
      members = _useContext.members,
      member = _useContext.member;

  var _useState17 = React.useState({}),
      _useState18 = _slicedToArray(_useState17, 2),
      loading = _useState18[0],
      setLoading = _useState18[1];

  var _useState19 = React.useState({}),
      _useState20 = _slicedToArray(_useState19, 2),
      removing = _useState20[0],
      setRemoving = _useState20[1];

  var handleChange = function handleChange(item) {
    if (~['dept_power', 'internet_power'].indexOf(String(item.id))) {
      if (!onSettingsUpdate) return;
      setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, true)));
      var _settingsRef$current = settingsRef.current,
          dept_power = _settingsRef$current.dept_power,
          internet_power = _settingsRef$current.internet_power,
          password = _settingsRef$current.password;

      if (item.id === 'dept_power') {
        settingsRef.current.dept_power = item.power;
        setDeptPower(item.power);
        onSettingsUpdate(item.power, internet_power, password).finally(function () {
          return setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, false)));
        });
      } else if (item.id === 'internet_power') {
        settingsRef.current.internet_power = item.power;
        setInternetPower(item.power);
        onSettingsUpdate(dept_power, item.power, password).finally(function () {
          return setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, false)));
        });
      }

      return;
    }

    if (item.power > -1) {
      if (onUpdate) {
        setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, true)));
        onUpdate(item).then(function () {
          if (!onChange) return;
          var newMembers = members.concat();
          var updateMember = newMembers.find(function (m) {
            return m.id === item.id;
          });

          if (updateMember) {
            if (item.power === 3) {
              var curOwner = newMembers.find(function (m) {
                return m.power === 3;
              });

              if (curOwner) {
                curOwner.power = 2;
              }
            }

            updateMember.power = item.power;
            onChange(newMembers);
          }
        }).finally(function () {
          setLoading(_objectSpread2(_objectSpread2({}, loading), {}, _defineProperty({}, item.id, false)));
        });
      }
    } else if (onDelete) {
      setRemoving(_objectSpread2(_objectSpread2({}, removing), {}, _defineProperty({}, item.id, true)));
      onDelete(item).then(function () {
        if (!onChange) return;
        var newMembers = members.concat();
        var index = newMembers.findIndex(function (m) {
          return m.id === (item === null || item === void 0 ? void 0 : item.id);
        });

        if (index > -1) {
          newMembers.splice(index, 1);
          onChange(newMembers);
        }
      }).finally(function () {
        return setRemoving(_objectSpread2(_objectSpread2({}, removing), {}, _defineProperty({}, item.id, false)));
      });
    }
  };

  var handleRemove = function handleRemove(item) {
    if (removeModal.current) {
      removeModal.current.destroy();
    }

    removeModal.current = _Modal__default['default'].confirm({
      className: "".concat(prefixCls, "-remove-confirm"),
      zIndex: 1080,
      width: 480,
      closable: true,
      centered: true,
      icon: null,
      mask: false,
      maskClosable: true,
      title: locale.remove.title.replace('{name}', item.name),
      content: locale.remove.description,
      okButtonProps: {
        danger: true
      },
      onOk: function onOk() {
        handleChange(_objectSpread2(_objectSpread2({}, item), {}, {
          power: -1
        }));
      }
    });
  };

  var isOwner = (member === null || member === void 0 ? void 0 : member.power) === 3;

  var renderItem = function renderItem(item) {
    var canRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var avatar = item.avatar,
        name = item.name,
        type = item.type;
    var permissionItems = [];
    permissionItems.push('view');
    if (item.allowEdit !== false) permissionItems.push('edit');
    if (!canRemove) permissionItems.push('nopermission');
    if (item.allowTransfer !== false && item.type !== -1 && item.type === 1 && (item.power === 3 || isOwner)) permissionItems.push('transfer');
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      shape: "circle",
      size: 32,
      src: avatar,
      name: name,
      type: type
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta")
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta-name")
    }, name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta-desc")
    }, item.description)), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-action")
    }, /*#__PURE__*/React__default['default'].createElement(PermissionSelect, {
      disabled: member && String(item.id) === String(member.id) || removing[item.id],
      loading: loading[item.id] || loadingProp && ['dept_power', 'internet_power'].indexOf(String(item.id)) > -1,
      activeKey: getPermissionKey(item),
      items: // 启用密码保护时，不允许设置没权限
      ['internet_power'].indexOf(String(item.id)) > -1 && settingsRef.current.enabled_password ? permissionItems.filter(function (p) {
        return p !== 'nopermission';
      }) : permissionItems,
      onChange: function onChange(key) {
        handleChange(_objectSpread2(_objectSpread2({}, item), {}, {
          power: getPermissionValue(key)
        }));
      }
    }), canRemove && item.power !== 3 && isOwner && (removing[item.id] ? /*#__PURE__*/React__default['default'].createElement(Icon.LoadingOutlined, null) : /*#__PURE__*/React__default['default'].createElement(ShareRemoveIcon, {
      onClick: function onClick() {
        return handleRemove(item);
      }
    }))));
  };

  var renderGeneral = function renderGeneral() {
    if (!linkLayerVisible) return;
    var deptDesc = '';

    switch (deptPower) {
      case 1:
        deptDesc = locale.link.general.org.viewDescription;
        break;

      case 2:
        deptDesc = locale.link.general.org.editDescription;
        break;
    }

    var internetDesc = '';

    switch (internetPower) {
      case 1:
        internetDesc = locale.link.general.any.viewDescription;
        break;

      case 2:
        internetDesc = locale.link.general.any.editDescription;
        break;
    }

    var datas = [{
      id: 'dept_power',
      avatar: /*#__PURE__*/React__default['default'].createElement(ShareOrgIcon, null),
      name: locale.link.general.org.title,
      type: -1,
      power: deptPower,
      allowEdit: deptAllowEdit,
      description: deptDesc
    }, {
      id: 'internet_power',
      avatar: /*#__PURE__*/React__default['default'].createElement(ShareLinkIcon, null),
      name: locale.link.general.any.title,
      type: -1,
      power: internetPower,
      allowEdit: internetAllowEdit,
      description: internetDesc
    }];
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-general")
    }, /*#__PURE__*/React__default['default'].createElement("h2", null, locale.link.general.title), /*#__PURE__*/React__default['default'].createElement(SearchList, {
      className: "".concat(prefixCls, "-list ").concat(isMobile ? prefixCls + '-list-mobile2' : ''),
      data: datas,
      onRenderItem: renderItem
    }));
  };

  var renderSetting = function renderSetting() {
    if (!linkLayerVisible) return;
    var enabledPwd = isOwner && settingsRef.current.enabled_password && !!settingsRef.current.password;
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !isOwner && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-setting-title")
    }, locale.link.get), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-setting")
    }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
      onKeyDown: function onKeyDown(e) {
        return e.preventDefault();
      },
      defaultValue: getLink(),
      addonAfter: /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
        onClick: function onClick() {
          return handleCopy(enabledPwd ? settingsRef.current.password : undefined);
        },
        size: "small",
        type: "text"
      }, enabledPwd ? locale.link.password.copy : locale.link.copy)
    })), isOwner && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-password")
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      icon: /*#__PURE__*/React__default['default'].createElement(ShareLockIcon, null),
      style: {
        border: 'none'
      },
      onClick: passwordSetting,
      loading: loadingProp
    }, enabledPwd ? locale.link.manage : locale.link.encryption)));
  };

  var passwordSetting = function passwordSetting() {
    if (passwordModal.current) {
      passwordModal.current.destroy();
    }

    passwordModal.current = _Modal__default['default'].info({
      className: "".concat(prefixCls, "-password-confirm"),
      zIndex: 1080,
      width: 436,
      closable: true,
      centered: true,
      icon: null,
      title: locale.link.password.set,
      content: /*#__PURE__*/React__default['default'].createElement(SharePasswordSetting, {
        locale: locale,
        onCopy: function onCopy(pwd) {
          return handleCopy(pwd);
        },
        prefixCls: prefixCls,
        defaultPassword: settingsRef.current.password,
        isEnabled: settingsRef.current.enabled_password,
        onChange: function onChange(enabled, password) {
          settingsRef.current.enabled_password = enabled;
          settingsRef.current.password = password;
        },
        onOk: function onOk() {
          if (onSettingsUpdate) {
            var _settingsRef$current2 = settingsRef.current,
                dept_power = _settingsRef$current2.dept_power,
                internet_power = _settingsRef$current2.internet_power,
                password = _settingsRef$current2.password,
                enabled_password = _settingsRef$current2.enabled_password;

            if (enabled_password && internet_power < 1) {
              setInternetPower(1);
              settingsRef.current.internet_power = 1;
            }

            return onSettingsUpdate(dept_power, settingsRef.current.internet_power, password, enabled_password).finally(function () {
              var _passwordModal$curren;

              (_passwordModal$curren = passwordModal.current) === null || _passwordModal$curren === void 0 ? void 0 : _passwordModal$curren.destroy();
            });
          } else {
            var _passwordModal$curren2;

            (_passwordModal$curren2 = passwordModal.current) === null || _passwordModal$curren2 === void 0 ? void 0 : _passwordModal$curren2.destroy();
          }

          return;
        }
      }),
      mask: false,
      maskClosable: true,
      cancelText: null,
      okButtonProps: {
        style: {
          display: 'none'
        }
      }
    });
  };

  var render = function render() {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, isOwner && linkLayerVisible && (loadingProp ? /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        textAlign: 'center',
        margin: '12px 0'
      }
    }, /*#__PURE__*/React__default['default'].createElement(Icon.LoadingOutlined, null)) : /*#__PURE__*/React__default['default'].createElement(SearchList, {
      className: "".concat(prefixCls, "-list ").concat(isMobile ? prefixCls + '-list-mobile' : ''),
      data: members,
      onRenderItem: function onRenderItem(item) {
        return renderItem(item, item.allowDelete !== false);
      }
    })), isOwner && renderGeneral(), renderSetting());
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareSelect$1, {
    onChange: function onChange(value) {
      setLinkLayerVisible(!value);
      if (onSearchValueChange) onSearchValueChange(value);
    },
    onSelect: onSelect,
    onSearch: onSearch
  }), render());
};

var _excluded$7 = ["mode", "readonly", "onInit", "onSearch", "onCancel"];

var ShareAdd$1 = function ShareAdd(_ref) {
  var mode = _ref.mode,
      readonly = _ref.readonly,
      onInit = _ref.onInit,
      onSearch = _ref.onSearch,
      onCancel = _ref.onCancel,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('common-share-add');

  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useLocaleReceiver3 = useLocaleReceiver('global'),
      _useLocaleReceiver4 = _slicedToArray(_useLocaleReceiver3, 1),
      globalLocale = _useLocaleReceiver4[0];

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = React.useState(!!onInit),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = React.useState((props.values || []).map(function (v) {
    v.power = v.power ? v.power : 1;
    return v;
  })),
      _useState6 = _slicedToArray(_useState5, 2),
      values = _useState6[0],
      setValues = _useState6[1];

  var _useContext = React.useContext(CommonShareContext),
      member = _useContext.member,
      owner = _useContext.owner;

  var _useState7 = React.useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isSendNotification = _useState8[0],
      setIsSendNotification = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      sending = _useState10[0],
      setSending = _useState10[1];

  var _useState11 = React.useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      canceling = _useState12[0],
      setCanceling = _useState12[1];

  React.useEffect(function () {
    if (onInit) {
      onInit().then(setValues).finally(function () {
        return setLoading(false);
      });
    }
  }, [onInit]); // 通过关键字查询

  var query = function query(keyword) {
    return new Promise(function (resolve) {
      if (onSearch) {
        onSearch(keyword).then(function (resultDatas) {
          // 过滤掉当前values的会员信息
          var valuesKeys = values === null || values === void 0 ? void 0 : values.map(function (v) {
            return v.id;
          });
          var newData = resultDatas.filter(function (item) {
            return !valuesKeys.includes(item.id);
          });
          resolve(newData);
        });
      } else {
        resolve([]);
      }
    });
  };

  var handleSend = function handleSend() {
    if (!props.onPost) return;
    setSending(true);
    props.onPost(values, isSendNotification).then(function () {
      setSending(false);
    });
  };

  var handleCancel = function handleCancel() {
    if (!onCancel) return;
    setCanceling(true);
    var result = onCancel(values);

    if (result) {
      result.finally(function () {
        return setCanceling(false);
      });
    } else {
      setCanceling(false);
    }
  };

  var handleChange = function handleChange(item) {
    setValues(function (values) {
      var index = values.findIndex(function (v) {
        return v.id === item.id;
      });

      if (index > -1) {
        var newValues = values.concat();

        if (item.power === -1) {
          newValues.splice(index, 1);
        } else newValues.splice(index, 1, item);

        return newValues;
      }

      return values;
    });
  };

  var renderSearchItem = function renderSearchItem(item) {
    var avatar = item.avatar,
        name = item.name,
        type = item.type;
    var permissionItems = [];
    permissionItems.push('view');
    if (item.allowEdit !== false) permissionItems.push('edit'); // permissionItems.push('nopermission');

    if (item.allowTransfer !== false && item.type !== -1 && item.type === 1 && (item.power === 3 || (member === null || member === void 0 ? void 0 : member.power) === 3)) permissionItems.push('transfer');
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
      shape: "circle",
      size: 32,
      src: avatar,
      name: name,
      type: type
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta")
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta-name")
    }, name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-item-meta-desc")
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-list-action")
    }, /*#__PURE__*/React__default['default'].createElement(PermissionSelect, {
      disabled: readonly === true,
      activeKey: getPermissionKey(item),
      items: permissionItems,
      onChange: function onChange(key) {
        return handleChange(_objectSpread2(_objectSpread2({}, item), {}, {
          power: getPermissionValue(key)
        }));
      }
    })));
  };

  var renderFooter = function renderFooter() {
    if (!!searchValue) return;
    var isOwner = (member === null || member === void 0 ? void 0 : member.power) === 3;
    var isSameOrg = (member === null || member === void 0 ? void 0 : member.orgId) === (owner === null || owner === void 0 ? void 0 : owner.orgId);
    var isApply = mode === 'apply';

    var renderSend = function renderSend() {
      var isDiabled = values.length === 0 || isApply && !isSameOrg;
      var btn = /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
        type: "primary",
        disabled: isDiabled,
        loading: sending,
        onClick: handleSend
      }, isApply ? locale.add.apply : globalLocale.send);

      if (isApply && !isSameOrg) {
        return /*#__PURE__*/React__default['default'].createElement(_Tooltip__default['default'], {
          title: locale.add.disabled
        }, btn);
      }

      return btn;
    };

    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      loading: canceling,
      onClick: handleCancel
    }, isApply && !readonly ? locale.add.ignore : globalLocale.cancel), readonly !== true && renderSend());
  };

  if (loading) return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      padding: 12,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon.LoadingOutlined, null));
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, mode !== 'apply' && /*#__PURE__*/React__default['default'].createElement(ShareSelect$1, {
    className: "".concat(prefixCls, "-select"),
    values: values,
    onChange: setSearchValue,
    onValuesChange: function onValuesChange(values) {
      setValues(values.map(function (v) {
        return _objectSpread2(_objectSpread2({}, v), {}, {
          power: v.power ? v.power : 1
        });
      }));
    },
    placeholder: values.length > 0 ? '' : undefined,
    onSearch: query
  }), !searchValue && /*#__PURE__*/React__default['default'].createElement(SearchList, {
    className: "".concat(prefixCls, "-list"),
    data: values,
    onRenderItem: renderSearchItem
  }), renderFooter());
};

var ShareModalTitle$1 = function ShareModalTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      highlightDescription = _ref.highlightDescription,
      onClose = _ref.onClose;

  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('common-share-title');
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, title && /*#__PURE__*/React__default['default'].createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-text")
  }, title), onClose && /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    onClick: onClose,
    type: "link",
    icon: /*#__PURE__*/React__default['default'].createElement(Icon.CloseCircleOutlined, null),
    danger: true
  })), description && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-desc").concat(highlightDescription ? " ".concat(prefixCls, "-desc-highlight") : '')
  }, description));
};

var css_248z$c = ".felo-search-icon {\n  height: 38px;\n  cursor: pointer;\n}\n.felo-search-icon:not(.ant-input-affix-wrapper-focused) {\n  padding: 0;\n  border: 0 none;\n}\n.felo-search-icon .ant-input-prefix {\n  margin: 0;\n  margin-right: 0;\n}\n.felo-search-icon .ant-input-prefix .anticon {\n  margin-top: 2px;\n  color: #464e5a;\n}\n.felo-search-icon .ant-input {\n  width: 0;\n  transition: width 0.3s;\n}\n.felo-search-icon .ant-input:focus {\n  width: 172px;\n}\n.felo-search-input,\n.felo-search-icon {\n  background: #fff;\n  border: 1px solid #2994ff;\n  border-radius: 18px;\n}\n.felo-search-input .ant-input::-moz-placeholder,\n.felo-search-icon .ant-input::-moz-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input:-ms-input-placeholder,\n.felo-search-icon .ant-input:-ms-input-placeholder {\n  color: #8a9ab3;\n}\n.felo-search-input .ant-input::placeholder,\n.felo-search-icon .ant-input::placeholder {\n  color: #8a9ab3;\n}\n.felo-search-value {\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item {\n  padding: 0 4px;\n  margin: 0 4px;\n  color: #464e5a;\n  font-size: 14px;\n  background: #e0e0e0;\n  border-radius: 14px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.felo-search-value-item:first-child {\n  margin-left: 0;\n}\n.felo-search-value-item:last-child {\n  margin-right: 0;\n}\n.felo-search-value-more {\n  cursor: pointer;\n}\n.felo-search-value-close {\n  margin-left: 4px;\n  margin-top: 0 !important;\n}\n.felo-search-value-close:hover {\n  color: #ff4d4f !important;\n}\n.felo-search-value-popover {\n  display: flex;\n  align-items: center;\n  max-width: 540px;\n  flex-wrap: wrap;\n}\n.felo-search-value-popover .felo-search-value-item {\n  margin: 2px 4px;\n}\n.felo-search-input {\n  padding: 6.5px 10px;\n}\n.felo-search-input .ant-input-prefix {\n  position: unset;\n  transform: none;\n}\n.felo-search-input .ant-input-prefix .anticon {\n  margin-top: 4px;\n  color: #717b8b;\n}\n.felo-search-list {\n  max-height: 270px;\n  overflow-y: auto;\n}\n.felo-search-list.scroll-y {\n  padding-right: 0 !important;\n}\n.felo-search-list .felo-search-list-item {\n  display: flex;\n  align-items: center;\n  min-width: 216px !important;\n  padding: 8px 24px;\n  cursor: pointer;\n}\n.felo-search-list .felo-search-list-item:hover {\n  background-color: #f1f1f1;\n}\n.felo-search-popover {\n  width: 440px;\n}\n.felo-search-popover .ant-popover-arrow {\n  display: none;\n}\n.felo-search-popover .ant-popover-inner {\n  background: #fff;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-search-popover .felo-search-list .item {\n  padding: 12px 20px;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-common-share-add-select .ant-select {\n  min-width: 104px;\n  margin-right: 4px;\n  line-height: 24px;\n  background: #d6dce6;\n  border-radius: 12px;\n}\n.felo-common-share-add-select .felo-search-input {\n  padding: 4px 0 4px 8px !important;\n}\n.felo-common-share-add {\n  width: 100%;\n  margin-top: 40px;\n}\n.felo-common-share-add-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n.felo-common-share-add-footer .ant-checkbox-wrapper {\n  flex: 1;\n}\n.felo-common-share-add-footer .ant-btn:first-child {\n  color: #464e5a;\n  border: 1px solid #a7afbd;\n  border-radius: 4px;\n}\n.felo-common-share-add-footer .ant-btn-primary {\n  margin-left: 16px;\n}\n.felo-common-share-add-footer .ant-btn-primary:not(:disabled) {\n  color: #fff;\n  background: #2994ff;\n  border-color: #2994ff;\n}\n.felo-common-share-add-list {\n  min-height: 260px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.felo-common-share-add-list .felo-search-list-item {\n  padding: 10px 0;\n}\n.felo-common-share-add-list .felo-search-list-item:hover {\n  background: transparent;\n}\n.felo-common-share-add-list-action {\n  display: flex;\n  flex: none;\n  justify-content: flex-end;\n  color: #666;\n}\n.felo-common-share-add-list-action .ant-select,\n.felo-common-share-add-list-action .ant-select-arrow {\n  color: #666;\n}\n.felo-common-share-add-item-avatar {\n  margin-right: 8px;\n}\n.felo-common-share-add-item-meta {\n  flex: 1;\n  margin-right: 12px;\n}\n.felo-common-share-link {\n  width: 100%;\n  margin-top: 36px;\n}\n.felo-common-share-link-single {\n  margin: 0;\n}\n.felo-common-share-link-title {\n  font-weight: 600;\n  font-size: 20px;\n}\n.felo-common-share-link-desc {\n  color: #717b8b;\n  font-size: 12px;\n}\n.felo-common-share-link-switch {\n  display: inline-flex;\n}\n.felo-common-share-link-switch .ant-switch {\n  margin-right: 12px;\n}\n.felo-common-share-link-select {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n.felo-common-share-link-select .ant-select {\n  width: 100%;\n}\n.felo-common-share-link-select .ant-select.ant-select-focused .ant-select-selector {\n  border: 0;\n  box-shadow: none;\n}\n.felo-common-share-link-select .ant-select .ant-select-selector {\n  height: 44px;\n  padding: 0 18px 0 11px;\n  background: #f5f5f5;\n  border: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.felo-common-share-link-select .ant-select .ant-select-selector .ant-select-selection-item {\n  line-height: 44px;\n}\n.felo-common-share-link-select .ant-select .ant-select-arrow {\n  right: 18px;\n}\n.felo-common-share-link-select .ant-btn {\n  height: 44px;\n  border-radius: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.felo-common-share-link-list {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.felo-common-share-link-list .felo-search-list-item {\n  padding: 10px 0;\n  overflow: hidden;\n}\n.felo-common-share-link-list .felo-search-list-item:hover {\n  background: transparent;\n}\n.felo-common-share-link-list-action {\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: flex-end;\n  color: #666;\n}\n.felo-common-share-link-list-action .ant-select,\n.felo-common-share-link-list-action .ant-select-arrow {\n  color: #666;\n}\n.felo-common-share-link-list-mobile {\n  max-height: 52px;\n}\n.felo-common-share-link-list-mobile2 {\n  max-height: 58px;\n}\n.felo-common-share-link-item-avatar {\n  margin-right: 8px;\n}\n.felo-common-share-link-item-meta {\n  flex: 1;\n  margin-right: 12px;\n}\n.felo-common-share-link-item-meta-desc {\n  color: #999999;\n  font-size: 12px;\n}\n.felo-common-share-link-item-meta-name {\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.felo-common-share-link-general h2 {\n  margin: 18px 0 14px 0;\n  font-weight: bold;\n  font-size: 14px;\n  font-style: normal;\n  line-height: 20px;\n}\n.felo-common-share-link-setting {\n  margin: 12px 0 14px;\n}\n.felo-common-share-link-setting .ant-input-group-addon .ant-btn {\n  padding: 0;\n}\n.felo-common-share-link-setting .ant-input-group-addon .ant-btn:hover,\n.felo-common-share-link-setting .ant-input-group-addon .ant-btn:focus {\n  background: transparent;\n}\n.felo-common-share-link-setting-title {\n  padding: 10px 0 0;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-link-password .ant-btn {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  padding: 4px 8px;\n  background: #f6f6f6;\n}\n.felo-common-share-link-password .ant-btn > .anticon + span {\n  margin-left: 4px;\n}\n.felo-common-share-link-password .ant-btn > .anticon {\n  margin-top: 3px;\n}\n.felo-common-share-link-password-confirm .ant-modal-content {\n  border-radius: 8px;\n}\n.felo-common-share-link-password-confirm .ant-modal-content .ant-modal-body {\n  padding: 20px 16px;\n}\n.felo-common-share-link-password-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-title {\n  font-size: 16px;\n  line-height: 22px;\n}\n.felo-common-share-link-password-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-content {\n  margin-top: 24px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-link-password-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {\n  margin: 0;\n}\n.felo-common-share-link-password-body {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.felo-common-share-link-password-body .ant-checkbox + span {\n  padding-right: 0;\n  padding-left: 4px;\n}\n.felo-common-share-link-password-input {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  margin-top: 16px;\n}\n.felo-common-share-link-password-input .ant-input-group,\n.felo-common-share-link-password-input .ant-input-group.ant-input-group-compact {\n  display: flex !important;\n  flex: 1;\n  margin-right: 4px;\n}\n.felo-common-share-link-password-input .ant-input-group .ant-input,\n.felo-common-share-link-password-input .ant-input-group.ant-input-group-compact .ant-input {\n  border-color: #d6dce6;\n}\n.felo-common-share-link-password-input .ant-input-group .ant-btn,\n.felo-common-share-link-password-input .ant-input-group.ant-input-group-compact .ant-btn {\n  width: 44px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #d6dce6;\n  border-left: none;\n}\n.felo-common-share-link-password-input > .ant-btn-link {\n  padding: 0;\n}\n.felo-common-share-link-password-desc {\n  margin-top: 16px;\n  color: #666;\n  font-size: 12px;\n  line-height: 24px;\n}\n.felo-common-share-link-remove-confirm .ant-modal-content {\n  border-radius: 12px;\n}\n.felo-common-share-link-remove-confirm .ant-modal-content .ant-modal-body {\n  padding: 24px;\n}\n.felo-common-share-link-remove-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-title {\n  padding-right: 10px;\n  font-size: 20px;\n  line-height: 28px;\n}\n.felo-common-share-link-remove-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-content {\n  margin-top: 20px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-lock {\n  margin-top: 12px;\n}\n.felo-common-share-lock .ant-input-affix-wrapper,\n.felo-common-share-lock .ant-picker {\n  width: 112px;\n  height: 24px;\n  padding: 2px 4px;\n  font-size: 14px;\n}\n.felo-common-share-lock .ant-input-affix-wrapper {\n  display: flex;\n}\n.felo-common-share-lock .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-focused):not(:hover),\n.felo-common-share-lock .ant-input:not(:focus):not(:hover),\n.felo-common-share-lock .ant-picker:not(:focus):not(:hover) {\n  background: #f5f5f5;\n  border-color: transparent;\n}\n.felo-common-share-lock-pwd .ant-space-item:first-child .ant-btn {\n  background: #14be14;\n}\n.felo-common-share-lock-dup .ant-space-item:first-child .ant-btn {\n  background: #ff9716;\n}\n.felo-common-share-lock-dup .ant-picker {\n  min-width: 198px;\n}\n.felo-common-share-lock .felo-common-share-lock-content {\n  display: none;\n}\n.felo-common-share-lock .felo-common-share-lock-visible {\n  display: flex;\n  -webkit-animation: fadein 1s;\n  animation: fadein 1s;\n}\n.felo-common-share-lock-pwd .ant-btn,\n.felo-common-share-lock-dup .ant-btn {\n  height: 24px;\n  line-height: 18px;\n  border: 0;\n  border-radius: 4px;\n}\n.felo-common-share-lock-pwd .ant-space-item:first-child .ant-btn,\n.felo-common-share-lock-dup .ant-space-item:first-child .ant-btn {\n  width: 24px;\n  color: #fff;\n}\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.felo-common-share-select {\n  position: relative;\n}\n.felo-common-share-select .felo-common-share-select-add {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  font-size: 20px;\n  cursor: pointer;\n}\n.felo-common-share-select .felo-common-share-select-add::after {\n  position: absolute;\n  left: 0;\n  height: 32px;\n  border-left: 1px solid #d6dce6;\n  content: ' ';\n}\n.felo-common-share-select .felo-search-input {\n  height: 32px;\n  padding: 6px 0 6px 12px;\n  background: #fff;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-common-share-select .felo-search-input .ant-input-prefix .anticon {\n  margin-top: 2px;\n  color: #717b8b;\n}\n.felo-common-share-select .felo-search-input .ant-input {\n  font-size: 14px;\n}\n.felo-common-share-select .felo-search-input:hover {\n  border-color: #2994ff;\n}\n.felo-common-share-select .felo-search-input:hover .felo-common-share-select-add::after {\n  border-color: #2994ff;\n}\n.felo-common-share-select .felo-search-input.ant-input-affix-wrapper:focus,\n.felo-common-share-select .felo-search-input.ant-input-affix-wrapper-focused {\n  border-color: #2994ff;\n  box-shadow: none;\n}\n.felo-common-share-select .felo-search-input.ant-input-affix-wrapper:focus .felo-common-share-select-add::after,\n.felo-common-share-select .felo-search-input.ant-input-affix-wrapper-focused .felo-common-share-select-add::after {\n  border-color: #2994ff;\n}\n.felo-common-share-select-value .ant-avatar {\n  margin-top: -3px;\n  margin-right: 4px;\n}\n.felo-common-share-select-value-remove {\n  margin: 0 4px 0 8px;\n}\n.felo-common-share-select .felo-search-value-item {\n  padding-left: 0;\n  background: rgba(41, 148, 255, 0.1);\n  border-radius: 38px;\n}\n.felo-common-share-select-result {\n  display: none;\n  min-height: 166px;\n  padding-top: 20px;\n}\n.felo-common-share-select-result.felo-common-share-select-active {\n  display: block;\n}\n.felo-common-share-select-result.felo-common-share-select-absolute {\n  position: absolute;\n  width: 100%;\n  min-height: auto;\n  padding: 12px;\n  background: #fff;\n  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;\n}\n.felo-common-share-select-result.felo-common-share-select-absolute .felo-search-list {\n  margin: 0 -12px;\n}\n.felo-common-share-select-result .felo-search-list {\n  margin: 0 -16px;\n}\n.felo-common-share-select-result .felo-search-list-item {\n  padding: 10px 16px;\n}\n.felo-common-share-select-result-avatar {\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  overflow: hidden;\n  border-radius: 16px;\n}\n.felo-common-share-select-result-avatar img {\n  width: 32px;\n}\n.felo-common-share-select-result-meta {\n  margin-right: 12px;\n}\n.felo-common-share-select-result-meta-name {\n  color: #464e5a;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-select-result-meta-desc {\n  color: #717b8b;\n  font-size: 12px;\n  line-height: 18px;\n}\n.felo-common-share-dept {\n  display: flex;\n}\n.felo-common-share-dept-arrow-right {\n  margin-right: 14px;\n}\n.felo-common-share-dept-select-contact {\n  display: flex;\n  justify-content: space-between;\n  min-width: 552px;\n  height: 430px;\n  border: 1px solid #d8d6d6;\n  border-radius: 4px;\n}\n@media screen and (max-width: 768px) {\n  .felo-common-share-dept-select-contact {\n    min-width: 0;\n  }\n}\n.felo-common-share-dept-select-contact > div {\n  flex: 1;\n}\n.felo-common-share-dept-select-contact > div:first-child {\n  border-right: 1px solid #d8d6d6;\n}\n.felo-common-share-dept-select-contact *::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\n.felo-common-share-dept-select-contact *::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px #fff;\n}\n.felo-common-share-dept-select-contact *::-webkit-scrollbar-thumb {\n  background-color: #d8d6d6;\n  border-radius: 4px;\n  outline: 1px solid #d8d6d6;\n}\n.felo-common-share-dept-search-container {\n  margin: 16px 16px 8px 16px;\n}\n.felo-common-share-dept-search-container > input {\n  color: #1c202a;\n  border: 1px solid #d6dce6;\n  border-radius: 4px;\n}\n.felo-common-share-dept-leftBottom-container {\n  overflow: hidden;\n}\n.felo-common-share-dept-search-list-container,\n.felo-common-share-dept-search-result-container {\n  height: 366px;\n  padding: 0 8px;\n  overflow-y: scroll;\n}\n.felo-common-share-dept-search-list-container ul,\n.felo-common-share-dept-search-result-container ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.felo-common-share-dept-search-list-container li ul,\n.felo-common-share-dept-search-result-container li ul {\n  padding: 0 8px;\n}\n.felo-common-share-dept-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.felo-common-share-dept-item:hover {\n  background: #f1f1f1;\n}\n.felo-common-share-dept-item > label {\n  margin-right: 8px;\n}\n.felo-common-share-dept-item > span:nth-of-type(1) {\n  margin-right: 8px;\n}\n.felo-common-share-dept-item > span:nth-of-type(2) {\n  flex: 1;\n}\n.felo-common-share-dept-item > div:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n.felo-common-share-dept-search-result-container {\n  height: 368px;\n}\n.felo-common-share-dept-rightPart-container > div:first-child {\n  padding: 12px 16px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-dept-rightPart-container > div:last-child {\n  height: 386px;\n  padding: 0 8px;\n  overflow-y: scroll;\n}\n.felo-common-share-dept-rightPart-container > div:last-child > ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.felo-common-share-dept-footer {\n  display: flex;\n  gap: 8px;\n  justify-content: end;\n  margin-top: 32px;\n}\n.felo-common-share-dept-footer .ant-btn {\n  min-width: 84px;\n}\n.felo-common-share-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 18px;\n}\n.felo-common-share-title-text {\n  display: flex;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 25px;\n}\n.felo-common-share-title-back {\n  margin-right: 12px;\n  cursor: pointer;\n}\n.felo-common-share-title-desc {\n  margin: 0 0 18px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.felo-common-share-title-desc.felo-common-share-title-desc-highlight {\n  padding: 8px 12px;\n  background: rgba(41, 148, 255, 0.1);\n  border-radius: 4px;\n}\n.felo-common-share-permission {\n  white-space: nowrap;\n}\n.felo-common-share-permission-item {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n}\n.felo-common-share-permission-separation {\n  height: 1px;\n  background: #d6dce6;\n}\n.felo-common-share-permission-item-desc {\n  color: #999;\n  font-size: 12px;\n  line-height: 17px;\n}\n.felo-common-share-permission-content .anticon-down {\n  padding: 5px;\n}\n.felo-common-share-permission-content.ant-dropdown-open {\n  color: #2994ff;\n}\n.felo-common-share-notification {\n  border-top: 1px solid #d6dce6;\n}\n.felo-common-share-notification .ant-tabs-nav::before {\n  border: none;\n}\n.felo-common-share-notification .ant-list .ant-list-item {\n  padding: 6px 0;\n  border: none;\n  cursor: pointer;\n}\n";
styleInject(css_248z$c);

var TabPane$2 = _Tabs__default['default'].TabPane;

var ShareNotification = function ShareNotification(_ref) {
  var messages = _ref.messages;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var prefixCls = getPrefixCls('common-share');

  var _useContext2 = React.useContext(CommonShareContext),
      setAction = _useContext2.setAction;

  var _useMemo = React.useMemo(function () {
    return [messages.filter(function (item) {
      return !item.read;
    }), messages.filter(function (item) {
      return item.read;
    })];
  }, [messages]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      unreadData = _useMemo2[0],
      readData = _useMemo2[1];

  var renderList = function renderList() {
    var isRead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/React__default['default'].createElement(_List__default['default'], {
      itemLayout: "horizontal",
      dataSource: isRead ? readData : unreadData,
      renderItem: function renderItem(item) {
        var sender = item.sender,
            sta = item.sta;
        var isSelf = sta === false;
        var titleMsg = isSelf ? locale.notification.self : locale.notification.other;
        return /*#__PURE__*/React__default['default'].createElement(_List__default['default'].Item, {
          onClick: function onClick() {
            setAction({
              type: 'apply',
              data: [item]
            });
          }
        }, /*#__PURE__*/React__default['default'].createElement(_List__default['default'].Item.Meta, {
          avatar: /*#__PURE__*/React__default['default'].createElement(AvatarComponent, {
            src: sender.avatar,
            size: 40
          }),
          title: /*#__PURE__*/React__default['default'].createElement("span", {
            dangerouslySetInnerHTML: {
              __html: titleMsg.replace(/{name}/, "<strong>".concat(sender.name, "</strong>"))
            }
          }),
          description: locale.notification.view
        }));
      }
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(_Tabs__default['default'], {
    className: "".concat(prefixCls, "-notification")
  }, /*#__PURE__*/React__default['default'].createElement(TabPane$2, {
    key: "unread",
    tab: locale.notification.unread
  }, renderList()), /*#__PURE__*/React__default['default'].createElement(TabPane$2, {
    key: "read",
    tab: locale.notification.read
  }, renderList(true)));
};

var CommonShare = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onFetchMembers = _ref.onFetchMembers,
      onFetchDept = _ref.onFetchDept,
      onSearch = _ref.onSearch,
      _onPost = _ref.onPost,
      link = _ref.link,
      defaultAction = _ref.defaultAction,
      onUpdate = _ref.onUpdate,
      onDelete = _ref.onDelete,
      member = _ref.member,
      owner = _ref.owner,
      notification = _ref.notification,
      onClose = _ref.onClose,
      refreshState = _ref.refreshState;

  // const { getPrefixCls } = React.useContext(ConfigContext);
  // const prefixCls = getPrefixCls('common-share');
  var _useLocaleReceiver = useLocaleReceiver('CommonShare'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      prevAction = _useState4[0],
      setPrevAction = _useState4[1];

  var _useState5 = React.useState({
    type: _typeof(defaultAction) === 'object' ? defaultAction.type : defaultAction || 'link',
    data: _typeof(defaultAction) === 'object' ? defaultAction.data : undefined
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      action = _useState6[0],
      setAction = _useState6[1];

  var handleSetAction = React.useCallback(function (newAction) {
    setAction(function (prevAction) {
      setPrevAction(prevAction);
      return typeof newAction === 'function' ? newAction(prevAction) : newAction;
    });
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      setAction: handleSetAction
    };
  }, [handleSetAction]);

  var _useState7 = React.useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      members = _useState8[0],
      setMembers = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      linkHighlightDescription = _useState10[0],
      setLinkHighlightDescription = _useState10[1];

  var isOwner = (member === null || member === void 0 ? void 0 : member.power) === 3;

  var _useState11 = React.useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      ownerData = _useState12[0],
      setOwnerData = _useState12[1]; // 通过关键字查询


  var query = function query(keyword) {
    return new Promise(function (resolve) {
      if (onSearch) {
        onSearch(keyword).then(function (resultDatas) {
          // 过滤掉当前已有的会员信息
          var newData = resultDatas.filter(function (item) {
            // 不是所有者，可以让他自己搜自己，给自己申请更高级权限
            if (!isOwner && item.id === (member === null || member === void 0 ? void 0 : member.id)) {
              return true;
            }

            return !members.find(function (c) {
              return c.id === item.id;
            });
          });
          resolve(newData);
        });
      } else {
        resolve([]);
      }
    });
  };

  var handleRequestDept = function handleRequestDept(id) {
    if (!onFetchDept) return Promise.resolve([]);
    return new Promise(function (resolve) {
      onFetchDept(id).then(function (data) {
        data.map(function (item) {
          var has = !!(members === null || members === void 0 ? void 0 : members.find(function (v) {
            return String(v.id) === String(item.id);
          }));
          return _objectSpread2(_objectSpread2({}, item), {}, {
            checked: has,
            disabled: has
          });
        });
        resolve(data);
      });
    });
  };

  var getMembers = React.useCallback(function () {
    // 获取当前所有的会员信息
    if (onFetchMembers) {
      onFetchMembers().then(function (resData) {
        // 按 power 排序
        resData = resData.sort(function (a, b) {
          return b.power - a.power;
        });
        setMembers(resData);
      }).finally(function () {
        setLoading(false);
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [onFetchMembers]);
  React.useEffect(function () {
    if (!isEqual__default['default'](ownerData, owner) || (refreshState === null || refreshState === void 0 ? void 0 : refreshState.isRefreshList)) {
      if (refreshState && (refreshState === null || refreshState === void 0 ? void 0 : refreshState.setIsRefreshList)) {
        refreshState.setIsRefreshList(false);
      }

      setOwnerData(owner);
      getMembers();
    }
  }, [owner, ownerData, getMembers, refreshState]); // useEffect(() => {
  //   getMembers();
  // }, [getMembers]);

  var getUseDescription = function getUseDescription() {
    var _owner$name;

    var texts = locale.use.description.split(/{name}/);
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, texts[0], /*#__PURE__*/React__default['default'].createElement("strong", null, (_owner$name = owner === null || owner === void 0 ? void 0 : owner.name) !== null && _owner$name !== void 0 ? _owner$name : 'Unknow'), texts[1]);
  };

  var getApplyDescription = function getApplyDescription() {
    var _user$name;

    var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : owner;
    var texts = locale.apply.description.split(/{name}/);
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, texts[0], /*#__PURE__*/React__default['default'].createElement("strong", null, (_user$name = user === null || user === void 0 ? void 0 : user.name) !== null && _user$name !== void 0 ? _user$name : 'Unknow'), texts[1]);
  };

  var renderContent = function renderContent() {
    var _notification$message;

    switch (action.type) {
      case 'link':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle$1, {
          title: locale.title,
          description: isOwner ? /*#__PURE__*/React__default['default'].createElement("strong", null, locale.description) : getUseDescription(),
          highlightDescription: linkHighlightDescription,
          onClose: onClose
        }), /*#__PURE__*/React__default['default'].createElement(ShareLink$1, _objectSpread2({
          loading: loading,
          onSearch: query,
          onChange: function onChange(members) {
            return setMembers(members);
          },
          onUpdate: onUpdate,
          onDelete: onDelete,
          onSelect: function onSelect(v) {
            return v.length > 0 ? handleSetAction({
              type: 'add',
              data: v
            }) : null;
          },
          onSearchValueChange: function onSearchValueChange(v) {
            return setLinkHighlightDescription(!!v && !isOwner);
          }
        }, link)));

      case 'add':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle$1, {
          title: locale.title,
          description: isOwner || !owner ? /*#__PURE__*/React__default['default'].createElement("strong", null, locale.description) : getUseDescription(),
          highlightDescription: !isOwner
        }), /*#__PURE__*/React__default['default'].createElement(ShareAdd$1, {
          values: action.data ? action.data : [],
          onSearch: query,
          onPost: function onPost() {
            for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = arguments[_key];
            }

            return new Promise(function (resolve) {
              if (_onPost) {
                _onPost.apply(void 0, params).then(function (v) {
                  var newData = members.concat();
                  params[0].forEach(function (item) {
                    var index = members.findIndex(function (c) {
                      return c.id === item.id;
                    }); // 已存在的，更新

                    if (~index) {
                      newData[index] = item;
                    } else {
                      // 所有权转移，重新设置原来所有者权限为2
                      if (item.power === 3 && item.id !== (owner === null || owner === void 0 ? void 0 : owner.id)) {
                        var ownerMember = newData.find(function (m) {
                          return m.power === 3;
                        });
                        if (ownerMember) ownerMember.power = 2;
                      } // 新增


                      newData.push(item);
                    }
                  });
                  setMembers(newData);
                  handleSetAction({
                    type: 'link'
                  });
                  resolve(v);
                });
              }
            });
          },
          onCancel: function onCancel() {
            return handleSetAction({
              type: 'link'
            });
          }
        }));

      case 'dept':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle$1, {
          title: locale.add.title,
          description: isOwner ? undefined : getUseDescription()
        }), /*#__PURE__*/React__default['default'].createElement(DeptSelect$1, {
          defaultCheckedValues: action.data ? action.data : [],
          onLoad: handleRequestDept,
          onSearch: query
        }));

      case 'notification':
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle$1, {
          title: locale.notification.title
        }), /*#__PURE__*/React__default['default'].createElement(ShareNotification, {
          messages: (_notification$message = notification === null || notification === void 0 ? void 0 : notification.messages) !== null && _notification$message !== void 0 ? _notification$message : []
        }));

      case 'apply':
        if (!notification) return;
        var onNFFetchMembers = notification.onFetchMembers,
            onApply = notification.onApply;
        var activeItem = action.data[0];
        var key = activeItem.key;
        return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ShareModalTitle$1, {
          description: getApplyDescription(activeItem.sender),
          highlightDescription: true
        }), /*#__PURE__*/React__default['default'].createElement(ShareAdd$1, {
          mode: "apply",
          // readonly={activeItem.read}
          onInit: function onInit() {
            return onNFFetchMembers(key);
          },
          onPost: function onPost() {
            for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              params[_key2] = arguments[_key2];
            }

            return new Promise(function (resolve) {
              onApply.apply(void 0, [key].concat(params)).then(function (v) {
                var newData = members.concat();
                params[0].forEach(function (item) {
                  var index = members.findIndex(function (c) {
                    return c.id === item.id;
                  }); // 已存在的，更新

                  if (~index) {
                    newData[index] = item;
                  } else {
                    // 所有权转移，重新设置原来所有者权限为2
                    if (item.power === 3 && item.id !== (owner === null || owner === void 0 ? void 0 : owner.id)) {
                      var ownerMember = newData.find(function (m) {
                        return m.power === 3;
                      });
                      if (ownerMember) ownerMember.power = 2;
                    } // 新增


                    newData.push(item);
                  }
                });
                setMembers(newData); // handleSetAction({ type: 'notification' });

                resolve(v);
              });
            });
          },
          onCancel: function () {
            var _onCancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return onApply(key, values.map(function (v) {
                        v.power = -1;
                        return v;
                      }), false);

                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function onCancel(_x) {
              return _onCancel.apply(this, arguments);
            }

            return onCancel;
          }()
        }));
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(CommonShareContext.Provider, {
    value: {
      member: member,
      owner: owner,
      prevAction: prevAction,
      action: action,
      setAction: handleSetAction,
      members: members,
      setMembers: setMembers
    }
  }, renderContent());
});

var css_248z$d = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-custom-search-input {\n  width: 320px;\n}\n.felo-custom-search-input .felo-custom-search-item {\n  display: none;\n}\n.felo-custom-search-input .ant-select-selector {\n  background: #67758d !important;\n  border: unset !important;\n  border-radius: 4px !important;\n  box-shadow: unset !important;\n}\n.felo-custom-search-input .ant-select-selector input,\n.felo-custom-search-input .ant-select-selector .ant-select-selection-placeholder,\n.felo-custom-search-input .ant-select-selector .ant-select-selection-item {\n  padding-left: 29px !important;\n  color: white;\n}\n.felo-custom-search-input .ant-select-arrow {\n  top: 40%;\n  right: unset;\n  left: 14px;\n  width: 16.25px;\n  height: 16.25px;\n}\n.felo-custom-search-input .ant-select-clear {\n  background: unset !important;\n}\n.felo-custom-search-input .ant-select-clear svg {\n  width: 14px;\n  height: 14px;\n  background: #cbcbcb;\n  border-radius: 8px;\n  fill: #666;\n}\n.felo-custom-search-menu {\n  border: 1px solid #e4e4e4;\n  border-radius: 4px;\n  box-shadow: 0px 2px 6px 0px rgba(216, 216, 216, 0.5);\n}\n.felo-custom-search-menu .rc-virtual-list-holder,\n.felo-custom-search-menu .ant-select-item-empty {\n  padding: 16px 20px !important;\n}\n.felo-custom-search-menu .rc-virtual-list-scrollbar-thumb {\n  background: #dadada !important;\n  border-radius: 4px !important;\n}\n.felo-custom-search-menu .ant-select-item-empty {\n  padding: 0;\n}\n.felo-custom-search-menu .ant-select-item-option-disabled {\n  padding: 0;\n  background: unset;\n  cursor: auto !important;\n}\n.felo-custom-search-menu .result-container .count {\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  color: #666;\n}\n.felo-custom-search-menu .result-container .ant-divider {\n  margin: 0;\n}\n.felo-custom-search-menu .result-container .ant-empty-normal {\n  margin: 80px 0;\n}\n.felo-custom-search-menu .ant-select-item-group {\n  padding: 16px 0 8px;\n  color: #666;\n  font-size: 14px;\n}\n.felo-custom-search-menu .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: #f1f1f1;\n}\n.felo-custom-search-menu .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  font-weight: normal;\n  background-color: #f1f1f1;\n}\n.felo-custom-search-menu .ant-select-item-option-grouped {\n  padding: 0;\n  border-radius: 4px;\n}\n.felo-custom-search-menu .felo-custom-search-item {\n  display: flex;\n  height: 64px;\n  padding: 16px 0 16px 12px;\n}\n.felo-custom-search-menu .felo-custom-search-item .felo-avatar {\n  width: 32px;\n  height: 32px;\n  margin-right: 12px;\n}\n.felo-custom-search-menu .felo-custom-search-item div {\n  flex: 1;\n  overflow: hidden;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n}\n.felo-custom-search-menu .felo-custom-search-item div .felo-custom-search-title {\n  color: #333;\n}\n.felo-custom-search-menu .felo-custom-search-item div .felo-custom-search-subtitle {\n  color: #666;\n  font-size: 12px;\n}\n.felo-custom-search-menu .felo-custom-search-item div .matched {\n  color: #2994ff;\n}\n.felo-custom-search-menu .felo-custom-search-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  margin-top: 8px;\n  color: #2994ff;\n  cursor: pointer;\n}\n";
styleInject(css_248z$d);

var CustomSearch = function CustomSearch(_ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder,
      _ref$resultText = _ref.resultText,
      resultText = _ref$resultText === void 0 ? 'Found $COUNT results' : _ref$resultText,
      _ref$loadMoreText = _ref.loadMoreText,
      loadMoreText = _ref$loadMoreText === void 0 ? 'More' : _ref$loadMoreText,
      menuHeight = _ref.menuHeight,
      onSearch = _ref.onSearch,
      onSelect = _ref.onSelect,
      popupContainer = _ref.popupContainer,
      matchedStyle = _ref.matchedStyle;

  var _useContext = React.useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var inputPrefixCls = getPrefixCls('custom-search-input');
  var menuPrefixCls = getPrefixCls('custom-search-menu');
  var morePrefixCls = getPrefixCls('custom-search-more');

  var getPopupContainer = function getPopupContainer() {
    var dom = document.body;

    if (popupContainer) {
      var _document$querySelect;

      dom = (_document$querySelect = document.querySelector(popupContainer)) !== null && _document$querySelect !== void 0 ? _document$querySelect : dom;
    }

    return dom;
  };

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      lastCode = _useState2[0],
      setLastCode = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      result = _useState6[0],
      setResult = _useState6[1];

  var handleOnSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
      var _yield$onSearch;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(value || !value && lastCode === 'Backspace')) {
                _context.next = 16;
                break;
              }

              setSearchValue(value);
              _context.t0 = setResult;
              _context.next = 5;
              return onSearch(value);

            case 5:
              _context.t2 = _yield$onSearch = _context.sent;
              _context.t1 = _context.t2 !== null;

              if (!_context.t1) {
                _context.next = 9;
                break;
              }

              _context.t1 = _yield$onSearch !== void 0;

            case 9:
              if (!_context.t1) {
                _context.next = 13;
                break;
              }

              _context.t3 = _yield$onSearch;
              _context.next = 14;
              break;

            case 13:
              _context.t3 = [];

            case 14:
              _context.t4 = _context.t3;
              (0, _context.t0)(_context.t4);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOnSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var ref = React.useRef(null);

  var handleSelect = function handleSelect(key, option) {
    var _ref$current;

    setSearchValue('');
    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.blur();
    onSelect(key, option);
  };

  return /*#__PURE__*/React__default['default'].createElement(_Select__default['default'], {
    ref: ref,
    allowClear: true,
    filterOption: false,
    placeholder: placeholder,
    className: inputPrefixCls,
    dropdownClassName: menuPrefixCls,
    listHeight: menuHeight,
    getPopupContainer: getPopupContainer,
    clearIcon: clearIcon,
    suffixIcon: suffixIcon,
    showSearch: true,
    searchValue: searchValue,
    onSearch: handleOnSearch,
    onClear: function onClear() {
      return setSearchValue('');
    },
    onInputKeyDown: function onInputKeyDown(ev) {
      return setLastCode(ev.nativeEvent.code);
    },
    onSelect: handleSelect,
    notFoundContent: searchValue ? /*#__PURE__*/React__default['default'].createElement(ResultCount, {
      text: resultText.replace('$COUNT', '0'),
      isEmpty: true
    }) : null
  }, searchValue && result.map(function (g) {
    return g.data;
  }).flat().length && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
    disabled: true,
    value: "RESULT"
  }, /*#__PURE__*/React__default['default'].createElement(ResultCount, {
    text: resultText.replace('$COUNT', result.map(function (g) {
      return g.data;
    }).flat().length.toString()),
    isEmpty: false
  })), result.map(function (group) {
    return /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].OptGroup, {
      key: group.id,
      title: group.title
    }, group.data.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
        key: item.id,
        value: item.id
      }, /*#__PURE__*/React__default['default'].createElement(ResultItem, {
        getPrefixCls: getPrefixCls,
        item: item,
        matchedStyle: matchedStyle,
        searchValue: searchValue
      }));
    }), group.hasMore && /*#__PURE__*/React__default['default'].createElement(_Select__default['default'].Option, {
      disabled: true,
      value: "MORE"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: morePrefixCls,
      onClick: function () {
        var _onClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _yield$group$loadMore, data, hasMore;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (group.loadMore) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", console.error("Group `".concat(group.title, "` loadMore not exist!")));

                case 2:
                  _context2.next = 4;
                  return group.loadMore(group.id);

                case 4:
                  _yield$group$loadMore = _context2.sent;
                  data = _yield$group$loadMore.data;
                  hasMore = _yield$group$loadMore.hasMore;
                  group.hasMore = hasMore;
                  group.data = [].concat(_toConsumableArray(group.data), _toConsumableArray(data));
                  setResult(Array.from(result));

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onClick() {
          return _onClick.apply(this, arguments);
        }

        return onClick;
      }()
    }, loadMoreText)));
  })));
};

var ResultCount = function ResultCount(_ref3) {
  var text = _ref3.text,
      isEmpty = _ref3.isEmpty;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "result-container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "count"
  }, text), /*#__PURE__*/React__default['default'].createElement(_Divider__default['default'], {
    style: {
      background: '#E4E4E4'
    }
  }), isEmpty && /*#__PURE__*/React__default['default'].createElement(_Empty__default['default'], {
    image: _Empty__default['default'].PRESENTED_IMAGE_SIMPLE
  }));
};

var ResultItem = function ResultItem(_ref4) {
  var getPrefixCls = _ref4.getPrefixCls,
      item = _ref4.item,
      matchedStyle = _ref4.matchedStyle,
      searchValue = _ref4.searchValue;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: getPrefixCls('custom-search-item')
  }, item.avatar, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: getPrefixCls('custom-search-title')
  }, /*#__PURE__*/React__default['default'].createElement(ResultRegex, {
    text: item.title,
    matchedStyle: matchedStyle,
    searchValue: searchValue
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: getPrefixCls('custom-search-subtitle')
  }, /*#__PURE__*/React__default['default'].createElement(ResultRegex, {
    text: item.subtitle,
    matchedStyle: matchedStyle,
    searchValue: searchValue
  }))));
};

var ResultRegex = function ResultRegex(_ref5) {
  var _rst$index;

  var text = _ref5.text,
      matchedStyle = _ref5.matchedStyle,
      searchValue = _ref5.searchValue;
  var reg = new RegExp(searchValue, 'ig');
  var rst = reg.exec(text);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, text.slice(0, (_rst$index = rst === null || rst === void 0 ? void 0 : rst.index) !== null && _rst$index !== void 0 ? _rst$index : 0), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "matched",
    style: matchedStyle
  }, rst === null || rst === void 0 ? void 0 : rst[0]), text.slice(reg.lastIndex));
};

var clearIcon = /*#__PURE__*/React__default['default'].createElement("svg", {
  viewBox: "0 0 16 16",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default['default'].createElement("path", {
  d: "M10.8680038,5.13199623 C11.0439987,5.3079912 11.0439987,5.59333543 10.8680038,5.7693304 L8.638,8 L10.8680038,10.2306696 C11.0439987,10.4066646 11.0439987,10.6920088 10.8680038,10.8680038 C10.6920088,11.0439987 10.4066646,11.0439987 10.2306696,10.8680038 L8,8.638 L5.7693304,10.8680038 C5.59333543,11.0439987 5.3079912,11.0439987 5.13199623,10.8680038 C4.95600126,10.6920088 4.95600126,10.4066646 5.13199623,10.2306696 L7.362,8 L5.13199623,5.7693304 C4.95600126,5.59333543 4.95600126,5.3079912 5.13199623,5.13199623 C5.3079912,4.95600126 5.59333543,4.95600126 5.7693304,5.13199623 L8,7.362 L10.2306696,5.13199623 C10.4066646,4.95600126 10.6920088,4.95600126 10.8680038,5.13199623 Z"
}));
var suffixIcon = /*#__PURE__*/React__default['default'].createElement("svg", {
  viewBox: "0 0 20 20",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default['default'].createElement("path", {
  d: "M16.1262266,15.4191198 L18.2475469,17.5404401 L17.5404401,18.2475469 L15.4191198,16.1262266 L16.1262266,15.4191198 Z M9.5,2 C13.64,2 17,5.36 17,9.5 C17,13.64 13.64,17 9.5,17 C5.36,17 2,13.64 2,9.5 C2,5.36 5.36,2 9.5,2 Z M9.5,3 C5.91228475,3 3,5.91228475 3,9.5 C3,13.0877153 5.91228475,16 9.5,16 C13.0877153,16 16,13.0877153 16,9.5 C16,5.91228475 13.0877153,3 9.5,3 Z"
}));

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgAppDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 0l7.777 7.778v8.82a7.009 7.009 0 00-12.18 2.473 5.455 5.455 0 00-3.375 5.04A5.4 5.4 0 0012.522 28H4.667A4.66 4.66 0 010 23.333V4.667A4.66 4.66 0 014.667 0h14zM21 15.556a5.443 5.443 0 015.398 4.728 3.891 3.891 0 013.158 3.827A3.89 3.89 0 0125.666 28h-9.333a3.89 3.89 0 01-3.889-3.889 3.891 3.891 0 013.158-3.827A5.443 5.443 0 0121 15.556zm-15.222-7c0-.43.348-.778.778-.778H19a.778.778 0 010 1.555H6.556a.778.778 0 01-.778-.777zM6.556 14a.778.778 0 100 1.556h7.777a.778.778 0 000-1.556H6.556z",
    fill: "#2994FF"
  })));
}

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgAppForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 27,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 4.667A4.667 4.667 0 0022.333 0H5.223A4.667 4.667 0 00.555 4.667v20.222a4.667 4.667 0 004.666 4.667h12.445v-7.778c0-.86.696-1.556 1.555-1.556H27V4.667zm-6.222 17.11c-.86 0-1.556.697-1.556 1.556v6.223L27 21.778h-6.222zm-14-13.221c0-.43.348-.778.778-.778H20a.778.778 0 110 1.555H7.556a.778.778 0 01-.778-.777zm0 6.222c0-.43.348-.778.778-.778h7.777a.778.778 0 010 1.556H7.556a.778.778 0 01-.778-.778z",
    fill: "#2994FF"
  })));
}

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgAppIm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.778 29.556c8.161 0 14.778-6.617 14.778-14.778C29.556 6.616 22.939 0 14.778 0 6.616 0 0 6.616 0 14.778c0 2.57.656 4.985 1.809 7.09L.227 28.591c-.094.4.307.737.685.579 1.656-.693 5.04-2.077 5.656-2.077.01 0 .02-.002.03-.006a14.709 14.709 0 008.18 2.469zm-7-18.167a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v.556a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-.556zm.5 5.722a.5.5 0 00-.5.5v.556a.5.5 0 00.5.5h8.333a.5.5 0 00.5-.5v-.556a.5.5 0 00-.5-.5H8.277z",
    fill: "#2994FF"
  })));
}

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgAppMeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 36,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.222.556a4.667 4.667 0 014.667 4.666v3.5l4.954-4.025a.778.778 0 011.268.604v15.398a.778.778 0 01-1.268.604l-4.954-4.025v3.5a4.667 4.667 0 01-4.667 4.666H5.555A4.667 4.667 0 01.89 20.778V5.222A4.667 4.667 0 015.555.556h18.667zm-7.778 6.222V5.222H8.667v1.556h7.777z",
    fill: "#2994FF"
  })));
}

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgAppTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4.667A4.667 4.667 0 0023.333 0H4.667A4.667 4.667 0 000 4.667v18.666A4.667 4.667 0 004.667 28h18.666A4.667 4.667 0 0028 23.333V4.667zm-6.795 5.994a.778.778 0 00-1.1-1.1l-7.15 7.149-3.85-3.849a.778.778 0 00-1.1 1.1l4.4 4.4c.135.135.308.21.484.225h.133l.13-.023a.774.774 0 00.353-.202l7.7-7.7z",
    fill: "#2994FF"
  })));
}

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M6 7a1 1 0 100-2 1 1 0 000 2zM6 13a1 1 0 100-2 1 1 0 000 2zM6 19a1 1 0 100-2 1 1 0 000 2zM12 7a1 1 0 100-2 1 1 0 000 2zM12 13a1 1 0 100-2 1 1 0 000 2zM12 19a1 1 0 100-2 1 1 0 000 2zM18 7a1 1 0 100-2 1 1 0 000 2zM18 13a1 1 0 100-2 1 1 0 000 2zM18 19a1 1 0 100-2 1 1 0 000 2z",
    fill: "#333"
  })));
}

var _circle, _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#fff"
  })), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M6.85 5.286a.1.1 0 01-.1-.1V2.004a.3.3 0 00-.55-.165L3.202 6.405a.2.2 0 00.167.31h1.78a.1.1 0 01.1.1v3.181a.3.3 0 00.55.165l2.997-4.566a.2.2 0 00-.167-.31H6.85z",
    fill: "#FCA800"
  })));
}

var _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M14.985 15.604A6.24 6.24 0 0010 13.124a6.239 6.239 0 00-4.985 2.48m9.97 0a7.5 7.5 0 10-9.97 0m9.97 0A7.472 7.472 0 0110 17.5a7.472 7.472 0 01-4.985-1.896m7.485-7.48a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0v0z",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 6.25v2.5m0 0v2.5m0-2.5h2.5m-2.5 0h-2.5m-1.875-3.438a2.813 2.813 0 11-5.626 0 2.813 2.813 0 015.626 0v0zM3.333 16.03v-.091a5.312 5.312 0 1110.625 0v.09A10.265 10.265 0 018.645 17.5c-1.942 0-3.76-.538-5.312-1.472v.001z",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$f, _path2$4, _path3$2;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgRecommend$1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 6.667a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167zM5.417 12.083a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z",
    stroke: "#333",
    strokeLinejoin: "round"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.656L7.225 8.852M7.224 11.068l5.559 3.285",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 13.334a2.083 2.083 0 110 4.167 2.083 2.083 0 010-4.167z",
    stroke: "#333",
    strokeLinejoin: "round"
  })));
}

var _path$g;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function SvgSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.187 2.146a.5.5 0 10-.707.708l1.814 1.814H7.167A3.167 3.167 0 004 7.835v1.333a.5.5 0 001 0V7.835a2.167 2.167 0 012.167-2.167h8.125L13.48 7.48a.5.5 0 00.707.707l2.646-2.646a.499.499 0 00.02-.728l-2.666-2.667zM7.52 11.48a.5.5 0 010 .707L5.708 14h8.125A2.167 2.167 0 0016 11.833V10.5a.5.5 0 011 0v1.333A3.167 3.167 0 0113.833 15H5.706l1.814 1.814a.5.5 0 11-.707.707l-2.667-2.667a.499.499 0 01.016-.723l2.651-2.65a.5.5 0 01.707 0z",
    fill: "#333"
  })));
}

var _path$h;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 4A.833.833 0 005 4.833v9.334a.833.833 0 00.833.833H8.5a.5.5 0 010 1H5.833A1.833 1.833 0 014 14.167V4.833A1.833 1.833 0 015.833 3H8.5a.5.5 0 010 1H5.833zm6.98 1.812a.5.5 0 01.707 0l3.333 3.334a.498.498 0 01-.017.724l-3.316 3.316a.5.5 0 11-.707-.707L15.293 10H8.5a.5.5 0 010-1h6.793l-2.48-2.48a.5.5 0 010-.708z",
    fill: "#333"
  })));
}

var css_248z$e = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.felo-header-dark {\n  background-color: #324367;\n}\n.felo-header-dark .felo-header-title h2 {\n  color: #fff;\n}\n.felo-header-dark .felo-header-animation-svg svg {\n  color: #fff;\n}\n.felo-header-dark .felo-header-current-info .felo-header-current-account {\n  color: #fff;\n}\n.felo-header-dark .felo-header-current-info .felo-header-current-corp {\n  color: #ccc;\n}\n.felo-header-dark .felo-header-info-box:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.felo-header-dark.avatar {\n  background-color: transparent;\n}\n.felo-header-mobile .felo-header-space-wrap .avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  font-size: 20px;\n}\n.felo-header-mobile .felo-header-space-wrap .skeleton {\n  display: flex;\n  align-items: center;\n}\n.felo-header-mobile .felo-header-space-wrap .skeleton .ant-skeleton-header {\n  padding: 1px 8px;\n}\n.felo-header-menu-current-info.mobile {\n  display: flex;\n  flex-direction: column;\n  width: auto;\n  min-width: 260px;\n  padding: 20px 0 8px 0;\n}\n.felo-header-menu-current-info.mobile .userinfo {\n  margin: 0 0 10px 16px;\n}\n.felo-header-menu-current-info.mobile .userinfo .userinfo-content-mobile {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-left: 5px;\n}\n.felo-header-menu-current-info.mobile .userinfo .userinfo-content-mobile .account {\n  font-size: 14px;\n  margin-top: 6px;\n  margin-left: 0;\n}\n.felo-header-menu-current-info.mobile .versions {\n  border-width: 0;\n}\n.felo-header-menu-current-info.mobile .avatar {\n  margin-bottom: 5px;\n  font-size: 40px;\n}\n.felo-header-menu-current-info.mobile .corp {\n  font-size: 14px;\n  line-height: 12px;\n  word-break: break-all;\n  margin-left: 0;\n}\n.felo-header-title {\n  padding: 0 8px;\n}\n.felo-header-title h2 {\n  margin: 0;\n}\n.felo-header-animation-svg svg {\n  color: #666;\n  transition: all 0.2s linear;\n}\n.felo-header-space-wrap {\n  height: 100%;\n}\n.felo-header-space-wrap .avatar img {\n  background: linear-gradient(90deg, rgba(190, 190, 190, 0.2) 25%, rgba(129, 129, 129, 0.24) 37%, rgba(190, 190, 190, 0.2) 63%);\n  background-size: 400% 100%;\n  -webkit-animation: 1.4s ease 0s infinite normal none running skeletonLoading;\n          animation: 1.4s ease 0s infinite normal none running skeletonLoading;\n}\n.felo-header-info-box {\n  padding: 4px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.felo-header-info-box:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.felo-header-icon-wrap {\n  margin-right: 8px;\n  font-size: 0;\n}\n.felo-header-current-info {\n  margin: 0 12px 0 10px;\n}\n.felo-header-current-info-box {\n  max-width: 150px;\n}\n.felo-header-current-info .felo-header-current-account {\n  overflow: hidden;\n  color: #000;\n  font-size: 14px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.felo-header-current-info .felo-header-current-corp {\n  overflow: hidden;\n  color: #666;\n  font-size: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.felo-header-menu-current-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: auto;\n  min-width: 310px;\n  padding: 20px 0 16px;\n}\n.felo-header-menu-current-info .userinfo {\n  display: flex;\n  align-items: center;\n  margin: 16px 24px;\n}\n.felo-header-menu-current-info .userinfo-avatar {\n  margin-bottom: 8px;\n}\n.felo-header-menu-current-info .userinfo .account {\n  font-weight: 500;\n  word-break: break-all;\n  margin-left: 8px;\n  font-size: 14px;\n  line-height: 22px;\n}\n.felo-header-menu-current-info .corp {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  word-break: break-all;\n  margin-left: 24px;\n}\n.felo-header-menu-current-info .versions {\n  width: 100%;\n  height: anto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 8px 0;\n}\n.felo-header-menu-current-info .versions .freeVer {\n  cursor: pointer;\n}\n.felo-header-menu-current-info .versions .otherVer {\n  color: #fca800;\n  cursor: pointer;\n}\n.felo-header-menu-current-info .upgradeButton {\n  background-color: #fca800;\n  border: 0;\n  color: #fff;\n  outline: none;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 0 8px;\n  border-radius: 4px;\n  height: 24px;\n}\n.felo-header-menu-current-info .upgradeButton .upgradeContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.felo-header-menu-current-info .upgradeButton .upgradeContent .upgradediv {\n  margin-left: 4px;\n}\n.felo-header-menu-current-info .button:focus {\n  outline: none;\n}\n.account-menu-content-light {\n  color: #1b2029;\n  padding-bottom: 20px;\n}\n.account-menu-content-light .ant-dropdown-menu-item,\n.account-menu-content-light .ant-dropdown-menu-submenu-title {\n  margin: 0 8px;\n  border-radius: 4px;\n  color: #1b2029;\n  height: 48px;\n}\n.account-menu-content-light .versions {\n  border-top: 1.5px solid #d6dce6;\n  border-bottom: 1.5px solid #d6dce6;\n}\n.account-menu-content-light .ant-dropdown-menu-title-content {\n  display: flex;\n  align-items: center;\n}\n.account-menu-content-light.mobile {\n  padding-bottom: 8px;\n}\n.account-menu-content-light.mobile .ant-dropdown-menu-item,\n.account-menu-content-light.mobile .ant-dropdown-menu-submenu-title {\n  height: 40px;\n}\n.account-menu-content-dark {\n  background-color: #393c48 !important;\n  color: #e1e4e8;\n  padding-bottom: 20px;\n}\n.account-menu-content-dark .ant-dropdown-menu-item,\n.account-menu-content-dark .ant-dropdown-menu-submenu-title {\n  margin: 0 8px;\n  border-radius: 4px;\n  color: #e1e4e8;\n  height: 48px;\n}\n.account-menu-content-dark .ant-dropdown-menu-title-content {\n  display: flex;\n  align-items: center;\n}\n.account-menu-content-dark .ant-dropdown-menu-item-active,\n.account-menu-content-dark .ant-dropdown-menu-submenu-title-active {\n  background-color: #434757 !important;\n}\n.account-menu-content-dark .versions {\n  border-top: 1.5px solid #434757;\n  border-bottom: 1.5px solid #434757;\n}\n.account-menu-content-dark svg path {\n  stroke: #e1e4e8;\n}\n.account-menu-content-dark.mobile {\n  padding-bottom: 8px;\n}\n.account-menu-content-dark.mobile .ant-dropdown-menu-item,\n.account-menu-content-dark.mobile .ant-dropdown-menu-submenu-title {\n  height: 40px;\n}\n.mobile-header-menu-item {\n  color: #ff3b30;\n  font-size: 10px;\n  line-height: 12px;\n  background-color: #f5f5f5;\n}\n.menu-item-disabled-hover {\n  background-color: unset !important;\n  cursor: default !important;\n}\n.menu-item-disabled-hover:hover,\n.menu-item-disabled-hover:active {\n  background: unset !important;\n  background-color: unset !important;\n}\n.menu-item-disabled-hover button:hover {\n  background: unset !important;\n}\n.menu-item-disabled-hover button:hover .menu-item-app-icon-wrap {\n  background-color: #f1f1f1 !important;\n}\n.felo-dropdown-wrap {\n  overflow: hidden;\n  border: 1px solid #d6dce6;\n  border-radius: 12px;\n}\n.felo-dropdown-wrap .menu-item-app-btn {\n  height: auto;\n  border-radius: 4px;\n}\n.felo-dropdown-wrap .menu-item-app-btn:hover,\n.felo-dropdown-wrap .menu-item-app-btn:focus,\n.felo-dropdown-wrap .menu-item-app-btn:active {\n  background: unset;\n  background-color: unset;\n}\n.felo-dropdown-wrap .menu-item-app-btn .menu-item-app-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 56px;\n}\n.felo-dropdown-wrap .menu-item-app-btn .menu-item-app-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  transition: all 0.1s ease-in;\n}\n.felo-dropdown-wrap .menu-item-app-btn .menu-item-app-icon-wrap svg {\n  margin: 15px 0;\n}\n.felo-dropdown-wrap.mobile {\n  border-width: 0;\n}\n.felo-dropdown-apps .ant-dropdown-menu {\n  padding: 23px 6px;\n}\n.menu-item-wrap .ant-space-item {\n  display: flex;\n  align-items: center;\n}\n.menu-item-wrap svg {\n  vertical-align: baseline;\n}\n@-webkit-keyframes skeletonLoading {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n@keyframes skeletonLoading {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n";
styleInject(css_248z$e);

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate$1(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

function convertToFP(fn, arity) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (a.length >= arity) {
    return fn.apply(null, a.slice(0, arity).reverse());
  }

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return convertToFP(fn, arity, a.concat(args));
  };
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate$1(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate$1(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$2(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid$3(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate$1(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate$1(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters$1 = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale$1;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate$1(dirtyDate);

  if (!isValid$3(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var format$2 = convertToFP(format$1, 2);

axios__default['default'].defaults.timeout = 10000;
axios__default['default'].defaults.withCredentials = true;
axios__default['default'].interceptors.request.use(function (config) {
  config.headers = _objectSpread2(_objectSpread2({}, config.headers), {}, {
    Accept: 'application/json',
    'content-type': 'application/json'
  });
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios__default['default'].interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});
var post$1 = function post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var token = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    axios__default['default'].post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        authorization: token || ''
      }
    }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    });
  });
};
var get$3 = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var token = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    axios__default['default'].get(url, {
      params: params,
      headers: {
        authorization: token
      }
    }).then(function (response) {
      resolve(response.data);
    }).catch(function (err) {
      reject(err);
    });
  });
};

var emptyState = {
  expiredAt: '',
  link: '',
  code: '',
  organizationName: '',
  userName: ''
};

var InvitationOrganizationDialog = function InvitationOrganizationDialog(props) {
  var visible = props.visible,
      onVisibleChange = props.onVisibleChange,
      teamInfo = props.teamInfo,
      diglogType = props.diglogType,
      loginUrl = props.loginUrl;

  var _useState = React.useState(emptyState),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      code = _useState4[0],
      setCode = _useState4[1];

  var shareLink = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return post$1(props.baseURL + '/v5/share/link', data, teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.access_token);

            case 3:
              res = _context.sent;

              if (!res.status.ok) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", res.data);

            case 6:
              return _context.abrupt("return", '');

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function shareLink(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var invateCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return post$1(props.meetUrl + '/api/v5/felo-minutes/public/proxy/genInviteCode', {}, 'Bearer ' + (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.access_token));

            case 3:
              res = _context2.sent;
              console.log(res);

              if (!res.success) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", res.result.proxy_invite_code);

            case 7:
              return _context2.abrupt("return", res);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function invateCode() {
      return _ref2.apply(this, arguments);
    };
  }();

  var shareInvite = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
      var emails, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              emails = _ref3.emails;
              _context3.prev = 1;
              _context3.next = 4;
              return post$1(props.baseURL + '/v5/web/email.invite.send', {
                emails: emails,
                code: code,
                invite_type: diglogType === 'RecommendFriend' ? 1 : 0
              }, teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.access_token);

            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", _context3.t0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }));

    return function shareInvite(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var reset = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(org_id, hasReset, type, loginUrl) {
      var res, _code;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return shareLink({
                org_id: org_id,
                path: '/invite/member',
                reset: hasReset
              });

            case 3:
              res = _context4.sent;
              _context4.next = 6;
              return invateCode();

            case 6:
              _code = _context4.sent;

              if (type === 'RecommendFriend') {
                res.linkUrl = loginUrl;
              }

              if (_code) {
                res.linkUrl = res.linkUrl + '?recommend=' + _code;
                setCode(_code);
              }

              setData({
                code: res.inviteCode,
                expiredAt: format$2('yyyy-MM-dd HH:mm', res.expireTime * 1000),
                link: res.linkUrl,
                organizationName: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.team_name) || '',
                userName: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.userName) || ''
              });
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](0);
              console.log('Parse share link data fail', _context4.t0);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 12]]);
    }));

    return function (_x3, _x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }(), [teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.team_name, teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.userName]);

  var handleVisibleChange = function handleVisibleChange(dialogVisible) {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(dialogVisible);

    if (!dialogVisible) {
      setData(emptyState);
    }
  };

  React.useEffect(function () {
    if (visible && teamInfo && diglogType) {
      reset(teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.team_id, false, diglogType, props.meetUrl);
    }
  }, [teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.team_id, reset, visible, diglogType]);
  return /*#__PURE__*/React__default['default'].createElement(InvitationShare, {
    type: diglogType,
    data: _objectSpread2(_objectSpread2({}, data), {}, {
      dialog: true,
      onSendEmail: function () {
        var _onSendEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(emails) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", shareInvite({
                    emails: emails
                  }).then(function (res) {
                    return res;
                  }));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function onSendEmail(_x7) {
          return _onSendEmail.apply(this, arguments);
        }

        return onSendEmail;
      }()
    }),
    visible: visible,
    onVisibleChange: handleVisibleChange
  });
};

var createOrgBg = function createOrgBg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    id: "ae636c83-9a69-4d8f-8683-8786b472330f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "643.45103",
    height: "542.33898",
    viewBox: "0 0 643.45103 542.33898"
  }, /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "567",
    cy: "537",
    rx: "70",
    ry: "5.33898",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "226",
    cy: "537",
    rx: "70",
    ry: "5.33898",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M814.77448,650.83051h-476a7.5082,7.5082,0,0,1-7.5-7.5v-457a7.5082,7.5082,0,0,1,7.5-7.5h476a7.5082,7.5082,0,0,1,7.5,7.5v457A7.5082,7.5082,0,0,1,814.77448,650.83051Zm-476-469a4.50492,4.50492,0,0,0-4.5,4.5v457a4.50493,4.50493,0,0,0,4.5,4.5h476a4.50492,4.50492,0,0,0,4.5-4.5v-457a4.50491,4.50491,0,0,0-4.5-4.5Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M366.27448,218.83051a3.00328,3.00328,0,0,0-3,3v124a3.00328,3.00328,0,0,0,3,3h124a3.00328,3.00328,0,0,0,3-3v-124a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "b9d15c13-74bb-46fd-a6fd-5a7002be597d",
    "data-name": "Path 40",
    d: "M561.31441,308.581a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,1,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "fb98932a-aea9-43a1-946e-96a095a0002f",
    "data-name": "Path 40",
    d: "M561.31441,275.581a3.625,3.625,0,0,0,0,7.249h48.878a3.625,3.625,0,1,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "a8382d7c-76a2-4f66-b41d-b5784413a475",
    "data-name": "Path 40",
    d: "M561.31441,342.581a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "a69b3c31-ebec-4776-89b9-9c88b713759e",
    "data-name": "Path 78",
    d: "M764.58325,473.54293h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C772.87226,470.899,769.16126,473.53893,764.58325,473.54293Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "ac481be8-039b-4a38-bb10-2d9a81406e5c",
    "data-name": "Path 78",
    d: "M605.58325,597.54293h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C613.87226,594.899,610.16126,597.53893,605.58325,597.54293Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "e05581d0-cd6a-412e-af3c-57495fab8d46",
    "data-name": "Path 78",
    d: "M534.74073,625.661h-234.838c-4.578,0-8.288-2.643-8.293-5.9V568.719c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9V619.76C543.02974,623.017,539.31874,625.657,534.74073,625.661Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54h234.838c2.747,0,4.973-1.586,4.976-3.54V568.719c0-1.954-2.229-3.538-4.976-3.54Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#607d8b"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "341",
    cy: "288",
    r: "19",
    fill: "#607d8b"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "56",
    cy: "415",
    r: "19",
    fill: "#607d8b"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "f4993879-8a0d-4ea4-907e-e549be7081a0",
    "data-name": "Path 40",
    d: "M660.31441,453.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "a649136c-96b9-48c7-9686-75389104c34a",
    "data-name": "Path 40",
    d: "M660.31441,473.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "bf4cb793-0df2-4753-9628-c376ea3545d1",
    "data-name": "Path 40",
    d: "M375.31441,580.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "bf2170fd-291c-4664-b596-01f8e04656d6",
    "data-name": "Path 40",
    d: "M375.31441,600.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "568.97297",
    cy: "475.93056",
    r: "43.06733",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "575.51484",
    y: "509.73025",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "549.34736",
    y: "509.73025",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "577.6955",
    cy: "533.44455",
    rx: "10.90314",
    ry: "4.08868",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "551.52796",
    cy: "532.89938",
    rx: "10.90314",
    ry: "4.08868",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "567.88264",
    cy: "465.02746",
    r: "14.71922",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "567.88264",
    cy: "465.02746",
    r: "4.90642",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M889.02425,614.70972c3.47747-15.57379-7.63868-31.31043-24.82862-35.14881s-33.94421,5.67511-37.42169,21.24891,7.91492,21.31768,25.10486,25.156S885.54671,630.28357,889.02425,614.70972Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#2ec787"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M388.58448,368.79047a42.8306,42.8306,0,0,1-4.43,19.04c-.33.68-.68,1.34-1.05,2h-75.17c-.37-.66-.72-1.32-1.05-2a43.07126,43.07126,0,1,1,81.7-19.04Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "68.33625",
    cy: "179.05228",
    r: "14.71922",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "68.33625",
    cy: "179.05228",
    r: "4.90642",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M303.74361,328.73454c-3.47748-15.57379,7.63867-31.31043,24.82861-35.14881s33.94422,5.67511,37.42169,21.24891-7.91491,21.31768-25.10485,25.156S307.22115,344.30839,303.74361,328.73454Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#f3c026"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M407.27448,255.83051h-124a5.00181,5.00181,0,0,0-5,5v124a5.00181,5.00181,0,0,0,5,5h124a5.00181,5.00181,0,0,0,5-5v-124A5.00181,5.00181,0,0,0,407.27448,255.83051Zm3,129a3.00883,3.00883,0,0,1-3,3h-124a3.00883,3.00883,0,0,1-3-3v-124a3.00879,3.00879,0,0,1,3-3h124a3.00878,3.00878,0,0,1,3,3Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "537.06537",
    cy: "622.23907",
    rx: "21.53369",
    ry: "6.76007",
    transform: "translate(-514.18629 722.92057) rotate(-69.08217)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "497.2582",
    cy: "654.76108",
    r: "43.06735",
    transform: "translate(-506.97468 861.88678) rotate(-80.78252)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "199.35811",
    y: "509.73025",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "225.52559",
    y: "509.73025",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "210.26125",
    cy: "533.44455",
    rx: "10.90314",
    ry: "4.08868",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "236.42873",
    cy: "532.89941",
    rx: "10.90314",
    ry: "4.08868",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M455.48148,614.70969c-3.47748-15.57379,7.63867-31.31046,24.82861-35.14884s33.94421,5.67508,37.42169,21.24887-7.91492,21.31766-25.10486,25.156S458.959,630.28351,455.48148,614.70969Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3DB8FF"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "448.75004",
    cy: "634.77768",
    rx: "6.76007",
    ry: "21.53368",
    transform: "translate(-595.36631 589.38455) rotate(-64.62574)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "581.96808",
    cy: "344.64255",
    r: "42.01233",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "866.8304",
    y: "556.38495",
    width: "12.76324",
    height: "22.86749",
    transform: "translate(-280.90454 -174.76527) rotate(-0.26634)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "841.30427",
    y: "556.50355",
    width: "12.76324",
    height: "22.86749",
    transform: "translate(-280.90537 -174.88393) rotate(-0.26634)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "845.09117",
    cy: "581.77645",
    rx: "10.63602",
    ry: "3.98853",
    transform: "translate(-456.30877 326.41344) rotate(-30.26634)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "870.08559",
    cy: "581.66024",
    rx: "10.63605",
    ry: "3.98853",
    transform: "translate(-452.84325 338.99529) rotate(-30.26634)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "580.85505",
    cy: "334.01157",
    r: "14.35864",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "575.93651",
    cy: "327.91867",
    r: "4.78622",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M900.81388,484.21377c3.32162-15.20789-7.5934-30.50849-24.37949-34.17481s-33.08659,5.68993-36.40825,20.89782,7.81762,20.75932,24.60367,24.4257S897.49225,499.42167,900.81388,484.21377Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#f5574b"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "816.3671",
    cy: "502.20254",
    rx: "6.59448",
    ry: "21.00616",
    transform: "translate(-242.24392 879.91271) rotate(-67.09517)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "902.20392",
    cy: "537.02192",
    rx: "6.59448",
    ry: "21.00616",
    transform: "translate(-221.88888 980.24914) rotate(-67.09517)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M868.73264,541.781a9.57243,9.57243,0,1,1-19.14455.10779l-.0001-.01879c-.02458-5.28665,4.256-6.40152,9.54268-6.42606S868.70809,536.49432,868.73264,541.781Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "acccf4df-3a09-4c7b-a8c8-af469fe66e6d",
    "data-name": "Path 78",
    d: "M825.67774,498.49559h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C833.96674,495.85161,830.25575,498.4916,825.67774,498.49559Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54h234.838c2.747,0,4.973-1.586,4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54Z",
    transform: "translate(-278.27448 -178.83051)",
    fill: "#3f3d56"
  }));
};

var joinOrgBg = function joinOrgBg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    id: "ae81c40f-6eb7-45b1-b509-6cf6baf1840d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "808",
    height: "607.0183",
    viewBox: "0 0 808 607.0183"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "203.7002",
    y: "186.04004",
    width: "405.23975",
    height: "2",
    fill: "#ccc"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "405",
    y: "1.00172",
    width: "2",
    height: "186.03613",
    fill: "#ccc"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "235.3501",
    y: "93.02002",
    width: "341.2998",
    height: "2",
    fill: "#ccc"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M666.54,476.8326a41.97008,41.97008,0,0,1-10.39014,27.66c-.6001.69-1.23,1.35-1.86963,2h-59.5c-.64013-.65-1.2705-1.31-1.87011-2a41.84634,41.84634,0,0,1-8.59034-15.45s.01026,0,0-.01a42.01722,42.01722,0,0,1-1.7998-12.2,40.808,40.808,0,0,1,.31006-5.09,42.01253,42.01253,0,0,1,83.39013-.11A42.46344,42.46344,0,0,1,666.54,476.8326Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "375.58 360.002 370.44 360.002 374.43 358.002 374.55 357.942 374.58 358.002 375.58 360.002",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "410.61 360.002 405.47 360.002 406.47 358.002 406.5 357.942 406.62 358.002 410.61 360.002",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "425.58781",
    cy: "320.06702",
    r: "14.35864",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "616.68644",
    cy: "469.41108",
    rx: "4.76624",
    ry: "4.8",
    transform: "translate(-347.30048 427.05964) rotate(-45)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M657.67091,431.1294c.63177-15.55358-12.77314-28.7276-29.9408-29.42492s-31.59692,11.346-32.22873,26.89959,11.30191,19.08747,28.46957,19.78486S657.03907,446.683,657.67091,431.1294Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3DB8FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M636.06776,493.39088a9.57244,9.57244,0,1,1-18.83533,3.42883l-.00336-.01849c-.94177-5.20215,3.08039-7.043,8.28253-7.98474S635.12605,488.18873,636.06776,493.39088Z",
    transform: "translate(-196 -146.49085)",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M843,504.49085H351a18,18,0,0,0,0,36H843a18,18,0,0,0,0-36Z",
    transform: "translate(-196 -146.49085)",
    fill: "#ccc"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M806,350.49085v155h-2v-155q0-8.055-.62988-15.96c-.0503-.67005-.1001-1.33-.16016-2a200.66158,200.66158,0,0,0-31.20019-91.02c-.42969-.67-.85987-1.33-1.29981-2a201.96864,201.96864,0,0,0-167.71-91.01c-.33008-.01-.66992-.01-1-.01s-.66992,0-1,.01q-5.68506.015-11.27979.36a200.46931,200.46931,0,0,0-43.17041,7.37,199.60082,199.60082,0,0,0-23.42968,8.3,203.2477,203.2477,0,0,0-89.83008,74.98c-.43994.67-.87012,1.33-1.29981,2a200.66158,200.66158,0,0,0-31.20019,91.02c-.06006.67-.10986,1.32995-.16016,2Q400,342.43583,400,350.49085v155h-2v-155q0-9.12.79-18.03a202.46542,202.46542,0,0,1,32.25-93.15,204.17371,204.17371,0,0,1,116.58008-85.46,202.84863,202.84863,0,0,1,43.02-7.04q5.63964-.315,11.35986-.32a204.228,204.228,0,0,1,203.21,186.02Q805.99,341.39084,806,350.49085Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M545.63543,648.56507c56.612.96685,56.60308,85.176-.00182,86.13458C489.02347,733.73287,489.03234,649.52372,545.63543,648.56507Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "330.00982",
    y: "578.94123",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "356.1773",
    y: "578.94123",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M536.9129,745.05769c14.1376-.1004,14.13775,8.27842-.00059,8.17732C522.77529,753.33545,522.77513,744.95663,536.9129,745.05769Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M563.08044,744.51252c14.1376-.10039,14.13776,8.27843-.00059,8.17733C548.94283,752.79029,548.94268,744.41147,563.08044,744.51252Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M546.72575,666.01c19.24961.08648,19.248,29.35467-.00089,29.43843C527.47615,695.362,527.47781,666.09382,546.72575,666.01Z",
    transform: "translate(-196 -146.49085)",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M546.72575,675.82282c6.36583-.093,6.36592,9.90663-.00044,9.81284C540.35993,685.72865,540.35984,675.72907,546.72575,675.82282Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M503.85863,651.581c-8.0912-36.89139,53.88818-50.7244,62.25067-13.898,3.47716,15.57193-7.91523,21.31583-25.10517,25.15415S507.33617,667.15489,503.85863,651.581Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2ec787"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M564.40884,532.9464c10.03272-26.27355,22.67887-21.43935,12.62875,4.82779C567.0052,564.047,554.35905,559.21283,564.40884,532.9464Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M488.405,560.98342c10.02257-55.72612,93.143-42.22852,85.02207,13.799C563.40481,630.5068,480.28435,617.0092,488.405,560.98342Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "315.29058",
    y: "455.1908",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "341.45805",
    y: "455.1908",
    width: "13.08374",
    height: "23.44171",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M522.19372,621.30726c14.1376-.10039,14.13776,8.27842-.00058,8.17733C508.05611,629.585,508.056,621.20621,522.19372,621.30726Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M548.3612,620.76209c14.1376-.10039,14.13776,8.27843-.00058,8.17733C534.22359,629.03986,534.22344,620.661,548.3612,620.76209Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M489.13946,527.83055c-8.09119-36.89141,53.88807-50.72437,62.25063-13.89811,3.47717,15.57187-7.91523,21.31577-25.10517,25.15415S492.61694,543.4044,489.13946,527.83055Z",
    transform: "translate(-196 -146.49085)",
    fill: "#f5574b"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M462.95174,538.67072c3.04378-8.19044,43.33234,10.91771,38.912,18.45666C498.82053,565.3168,458.532,546.20865,462.95174,538.67072Z",
    transform: "translate(-196 -146.49085)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "668.20504",
    cy: "492.89483",
    rx: "6.59448",
    ry: "21.00616",
    transform: "translate(-355.85909 407.66642) rotate(-40.64516)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "580.97057",
    cy: "492.89483",
    rx: "21.00616",
    ry: "6.59448",
    transform: "translate(-367.44563 466.16198) rotate(-49.35484)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M959,282.49257H900a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M898,335.49257H839a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M975,387.49257v-2a8,8,0,0,0,0-16H916v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M994,205.49257v-2a8,8,0,0,0,0-16H935v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M902,224.49257H843a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M326,414.49257H267a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M357,448.49257v-2a8,8,0,0,0,0-16H298v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M265,467.49257H206a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M330,303.49257H271a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M361,337.49257v-2a8,8,0,0,0,0-16H302v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M269,356.49257H210a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M755,611.49257H696a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M821,665.49257v-2a8,8,0,0,0,0-16H762v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M701,675.49257H642a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M487,670.49257v-2a8,8,0,0,0,0-16H428v-2h59a10,10,0,0,1,0,20Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M309,695.49257H250a10,10,0,0,1,0-20v2a8,8,0,0,0,0,16h59Z",
    transform: "translate(-196 -146.49085)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M706.88583,753.49257h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M382.53027,752.72255c-.7705,1.77-3.35009.24-2.59033-1.51a100.85971,100.85971,0,0,0,7.16992-25.9,109.44309,109.44309,0,0,0-3.4497-45.66c-.16016-.53-.32032-1.06994-.48-1.6-.38038-1.22-.78028-2.44-1.2002-3.64a103.06206,103.06206,0,0,0-22.68018-37.46c-1.32959-1.4.79-3.52,2.12012-2.12a103.41725,103.41725,0,0,1,16.33985,22.51995,108.082,108.082,0,0,1,5.58007,12.08c.63037,1.61,1.22022,3.24,1.78028,4.87a114.2409,114.2409,0,0,1,5.81006,30.06A107.16153,107.16153,0,0,1,382.53027,752.72255Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M405.43018,599.89259q-4.99512,18.285-9.98,36.56995-5.1753,18.93009-10.33008,37.84-.73536,2.685-1.46,5.35c-.16016-.53-.32032-1.06994-.48-1.6-.38038-1.22-.78028-2.44-1.2002-3.64.4502-1.66.8999-3.32,1.35986-4.98q.93018-3.405,1.86036-6.81,8.66967-31.77,17.33984-63.53A1.50026,1.50026,0,0,1,405.43018,599.89259Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M343.74317,604.26147c-1.74844,3.83636-3.51256,7.72169-4.26924,11.86923s-.41209,8.65208,1.83118,12.22172a20.33914,20.33914,0,0,0,7.42114,6.45937c4.18676,2.38768,9.631,4.07456,13.6351,1.39181,4.04426-2.70966,4.474-8.83284,2.20829-13.14155s-6.47538-7.19855-10.58188-9.81294-7.32483-4.68135-9.98776-8.75654Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M414.9958,565.17144c-4.00563,1.31514-8.0579,2.652-11.62,4.90715s-6.64018,5.562-7.74388,9.631a20.339,20.339,0,0,0,.28178,9.83449c1.0827,4.69656,3.533,9.84256,8.2196,10.96774,4.73358,1.13646,9.52652-2.69834,11.15836-7.28479s.90276-9.64026.04113-14.4315S413.80912,570.2371,415,565.51691Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M343.11562,651.74288c1.11272,4.06651,2.24474,8.18069,4.31857,11.85137s5.22222,6.91062,9.23075,8.21687a20.33914,20.33914,0,0,0,9.83626.2115c4.74493-.846,10.00727-3.03526,11.36593-7.65955,1.37229-4.67067-2.21746-9.64979-6.71635-11.50946s-9.5829-1.38481-14.4113-.76441-8.624,1.09277-13.27861-.3332Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M355.11562,704.74288c1.11272,4.06651,2.24474,8.18069,4.31857,11.85137s5.22222,6.91062,9.23075,8.21687a20.33914,20.33914,0,0,0,9.83626.2115c4.74493-.846,10.00727-3.03526,11.36593-7.65955,1.37229-4.67067-2.21746-9.64979-6.71635-11.50946s-9.5829-1.38481-14.4113-.76441-8.624,1.09277-13.27861-.3332Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M420.88438,669.74288c-1.11272,4.06651-2.24474,8.18069-4.31857,11.85137s-5.22222,6.91062-9.23075,8.21687a20.33914,20.33914,0,0,1-9.83626.2115c-4.74493-.846-10.00727-3.03526-11.36593-7.65955-1.37229-4.67067,2.21746-9.64979,6.71635-11.50946s9.5829-1.38481,14.4113-.76441,8.624,1.09277,13.27861-.3332Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M432.88438,615.74288c-1.11272,4.06651-2.24474,8.18069-4.31857,11.85137s-5.22222,6.91062-9.23075,8.21687a20.33914,20.33914,0,0,1-9.83626.2115c-4.74493-.846-10.00727-3.03526-11.36593-7.65955-1.37229-4.67067,2.21746-9.64979,6.71635-11.50946s9.5829-1.38481,14.4113-.76441,8.624,1.09277,13.27861-.3332Z",
    transform: "translate(-196 -146.49085)",
    fill: "#3dc190"
  }));
};

var SigninOrgBg = function SigninOrgBg() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "363",
    height: "240",
    viewBox: "0 0 363 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.168 198.842C327.969 144.463 332.146 140.875 332.322 140.742L332.056 140.267C331.875 140.357 327.49 143.046 323.603 198.823L324.168 198.842Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.244 198.842L320.804 198.804C318.31 159.078 321.023 137.412 321.051 137.198L320.496 137.126C320.467 137.34 317.744 159.054 320.244 198.842Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.828 200.025C319.849 175.251 312.147 156.379 312.076 156.189L311.558 156.407C311.634 156.593 319.284 175.337 316.276 199.958L316.828 200.025Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.663 203.052C314.923 194.208 314.854 185.225 313.459 176.401L312.908 176.506C314.291 185.267 314.359 194.186 313.107 202.966L313.663 203.052Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.972 156.636L309.529 156.436C307.794 156.287 306.111 155.769 304.593 154.916C303.852 154.48 303.084 154.093 302.293 153.756C299.271 152.545 295.902 152.763 292.652 152.602C287.328 152.33 282.111 150.996 277.31 148.677C277.029 148.548 276.795 148.336 276.64 148.069C276.141 147.157 277.073 146.344 277.876 145.85C281.99 143.313 286.181 140.742 290.852 139.483C295.522 138.224 300.83 138.438 304.802 141.179C309.477 144.396 311.183 151.005 311.972 156.626",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.602 147.788C276.746 147.737 276.884 147.672 277.016 147.594L278.175 146.99C279.178 146.463 280.622 145.684 282.451 144.805C284.579 143.761 286.796 142.907 289.075 142.253C291.86 141.454 294.777 141.218 297.656 141.559C300.538 141.88 303.26 143.049 305.476 144.919C307.208 146.523 308.595 148.463 309.553 150.62C310.218 152.075 310.809 153.563 311.325 155.077C311.506 155.585 311.648 155.999 311.758 156.308C311.803 156.453 311.86 156.595 311.929 156.731C311.911 156.579 311.876 156.431 311.824 156.289C311.724 155.97 311.601 155.557 311.444 155.034C310.973 153.5 310.411 151.994 309.762 150.525C308.822 148.313 307.43 146.32 305.676 144.676C303.422 142.752 300.643 141.548 297.698 141.217C294.764 140.869 291.79 141.12 288.956 141.954C286.661 142.624 284.434 143.507 282.304 144.591C280.484 145.494 279.054 146.306 278.066 146.871L276.935 147.532C276.8 147.601 276.673 147.684 276.555 147.779",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.456 150.934C282.503 151.005 285.701 148.938 289.583 146.316C293.465 143.693 296.601 141.502 296.558 141.431C296.515 141.36 293.313 143.422 289.431 146.045C285.549 148.667 282.423 150.858 282.475 150.934",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.863 141.26C286.613 141.518 287.398 141.659 288.191 141.678C288.98 141.787 289.78 141.778 290.567 141.65C289.794 141.507 289.01 141.426 288.224 141.408C287.437 141.297 286.643 141.248 285.849 141.26",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.856 139.435C299.775 139.473 300.245 140.205 300.901 141.075C301.27 141.639 301.718 142.148 302.231 142.586C302.307 142.548 301.837 141.816 301.181 140.946C300.812 140.383 300.366 139.874 299.856 139.435Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.991 152.815C297.53 152.588 298.046 152.308 298.53 151.979C299.452 151.419 300.701 150.601 302.032 149.632C303.362 148.663 304.54 147.732 305.386 147.081C305.862 146.742 306.306 146.36 306.712 145.94C306.197 146.213 305.707 146.531 305.248 146.891L301.842 149.366C300.511 150.316 299.29 151.176 298.402 151.784C297.899 152.086 297.422 152.429 296.976 152.811",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.344 234.264H329.533L334.032 201.075H300.839L305.344 234.264Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.031 206.135H336.845L337.406 198.823H297.466L298.031 206.135Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.528 206.135H333.343L329.528 234.263L325.708 234.002L327.841 208.387L301.77 207.946L301.528 206.135Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.926 198.875L327.796 206.135H337.232L337.797 198.823L328.926 198.875Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.661 140.49C333.989 138.723 336.451 138.376 339.373 138.49C342.296 138.684 345.158 139.42 347.811 140.661C352.377 142.657 356.668 145.603 359.395 149.774C362.122 153.946 363.068 159.467 361.03 164.029C360.869 164.504 360.539 164.903 360.103 165.15C359.596 165.295 359.052 165.253 358.573 165.031C353.385 163.34 348.153 161.629 343.369 158.978C338.584 156.327 334.265 152.635 331.718 147.812C331.061 146.674 330.643 145.412 330.492 144.106C330.42 143.453 330.488 142.793 330.693 142.169C330.898 141.545 331.235 140.973 331.68 140.49",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.614 139.939C331.732 140.006 331.858 140.056 331.989 140.091L333.077 140.466L333.866 140.728C334.151 140.833 334.455 140.961 334.788 141.089C335.443 141.355 336.213 141.621 337.006 142.011L338.28 142.59C338.722 142.795 339.164 143.065 339.629 143.279C340.58 143.754 341.53 144.334 342.537 144.933C346.89 147.631 350.761 151.038 353.993 155.011C354.715 155.937 355.418 156.807 355.998 157.681C356.292 158.113 356.601 158.522 356.858 158.931L357.594 160.142C358.069 160.888 358.445 161.61 358.792 162.228C358.958 162.537 359.124 162.827 359.267 163.092C359.409 163.359 359.519 163.615 359.628 163.844L360.141 164.874C360.195 164.997 360.26 165.115 360.336 165.226C360.302 165.095 360.256 164.968 360.198 164.846C360.079 164.575 359.932 164.223 359.723 163.786L359.39 163.026C359.257 162.751 359.1 162.461 358.939 162.142C358.602 161.515 358.255 160.779 357.78 160.024L357.053 158.816C356.801 158.399 356.497 157.989 356.207 157.548C355.632 156.664 354.929 155.781 354.206 154.839C350.982 150.815 347.082 147.382 342.68 144.696C341.653 144.102 340.689 143.517 339.739 143.061C339.263 142.828 338.822 142.585 338.375 142.382L337.087 141.816C336.27 141.44 335.5 141.189 334.835 140.937C334.498 140.818 334.189 140.695 333.885 140.604L333.087 140.367L331.98 140.048C331.851 140.007 331.719 139.977 331.585 139.958",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.807 149.789C349.783 149.874 352.315 150.692 355.47 151.613C358.625 152.535 361.201 153.215 361.224 153.129C361.248 153.044 358.716 152.226 355.561 151.305C352.406 150.383 349.83 149.703 349.807 149.789Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.04 162.289C350.138 161.705 350.179 161.113 350.163 160.522C350.192 159.434 350.196 157.923 350.163 156.246C350.13 154.568 350.03 153.077 349.94 151.969C349.922 151.377 349.848 150.789 349.717 150.211C349.664 150.799 349.664 151.391 349.717 151.979C349.75 153.176 349.797 154.631 349.845 156.256C349.892 157.881 349.921 159.315 349.954 160.508C349.936 161.099 349.971 161.69 350.059 162.276",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.32 156.816C339.406 156.816 339.691 153.756 339.952 149.969C340.214 146.182 340.356 143.113 340.266 143.104C340.176 143.094 339.891 146.163 339.629 149.95C339.368 153.737 339.244 156.816 339.32 156.816Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.658 142.828C352.056 142.75 351.448 142.732 350.843 142.771C349.726 142.771 348.177 142.814 346.471 142.866C344.765 142.918 343.221 142.995 342.105 143.061C341.499 143.063 340.895 143.121 340.299 143.236C340.9 143.308 341.506 143.325 342.109 143.289C343.231 143.289 344.775 143.251 346.485 143.194C348.196 143.137 349.735 143.065 350.852 142.999C351.458 142.995 352.062 142.937 352.658 142.828Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.341 128.659L339.32 134.095C339.387 134.223 339.482 134.366 339.625 134.375C339.767 134.385 339.9 134.238 339.986 134.109L347.925 121.927L346.096 120.891L336.341 128.659Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.341 128.659L339.32 134.095C339.387 134.223 339.482 134.366 339.625 134.375C339.767 134.385 339.9 134.238 339.986 134.109L347.925 121.927L346.096 120.891L336.341 128.659Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.244 138.457L347.327 122.483C347.602 122.316 347.906 122.126 347.987 121.817C348.096 121.414 347.797 121.028 347.512 120.729C345.652 118.795 343.397 117.283 340.9 116.299C338.403 115.316 335.723 114.882 333.044 115.027C327.708 115.413 322.591 118.491 319.963 123.162C317.336 127.833 317.265 134.005 320.263 138.438",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.411 117.38C343.296 117.353 343.178 117.339 343.06 117.337C342.827 117.337 342.48 117.285 342.033 117.289C340.776 117.27 339.52 117.369 338.28 117.584C334.151 118.279 330.307 120.141 327.202 122.951C324.097 125.761 321.861 129.4 320.757 133.439C320.418 134.653 320.194 135.895 320.087 137.15C320.059 137.412 320.045 137.675 320.044 137.939C320.067 138.149 320.139 138.351 320.253 138.528C320.169 138.077 320.154 137.615 320.21 137.16C320.368 135.923 320.624 134.701 320.975 133.506C322.112 129.533 324.34 125.958 327.405 123.187C330.471 120.415 334.251 118.558 338.318 117.826C339.545 117.593 340.79 117.459 342.038 117.427C342.922 117.427 343.411 117.427 343.411 117.394",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.907 127.429C324.338 127.688 324.797 127.897 325.275 128.051C326.14 128.389 327.342 128.825 328.692 129.254C330.041 129.681 331.276 130.023 332.174 130.242C332.654 130.394 333.15 130.488 333.652 130.522C333.194 130.316 332.717 130.157 332.227 130.047L328.782 128.968L325.351 127.833C324.891 127.652 324.414 127.517 323.926 127.429",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.169 115.978C328.083 115.978 327.889 117.318 327.851 119C327.813 120.682 327.931 122.036 328.017 122.031C328.102 122.026 328.131 120.672 328.174 119.005C328.216 117.337 328.259 115.988 328.174 115.978",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.55 122.178C346.916 121.89 346.257 121.658 345.583 121.485C344.352 121.105 342.642 120.625 340.732 120.164C338.822 119.703 337.078 119.352 335.809 119.133C335.13 118.981 334.438 118.886 333.742 118.852C334.405 119.065 335.081 119.234 335.766 119.356C337.021 119.636 338.75 120.021 340.656 120.483C342.561 120.943 344.276 121.385 345.521 121.708C346.186 121.912 346.864 122.07 347.55 122.184",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.912 168.695C311.245 168.082 314.019 170.348 314.499 172.709C314.979 175.071 314.095 177.489 313.074 179.661C310.774 184.479 307.61 188.95 303.433 192.271C299.257 195.592 294.035 197.725 288.704 197.697C289.688 193.121 288.443 188.341 288.989 183.69C289.479 179.601 291.34 175.8 294.267 172.904C297.195 170.008 301.017 168.19 305.111 167.744C306.598 167.583 308.318 167.35 308.912 168.723",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.709 197.706C288.825 197.669 288.937 197.617 289.041 197.555C289.348 197.385 289.639 197.19 289.911 196.97C290.887 196.118 291.671 195.069 292.211 193.891C292.586 193.169 292.999 192.385 293.403 191.516C293.807 190.646 294.22 189.715 294.657 188.741C295.111 187.723 295.627 186.734 296.202 185.78C296.831 184.765 297.54 183.8 298.321 182.896C299.917 181.02 301.647 179.4 303.11 177.85C304.453 176.498 305.676 175.03 306.764 173.465C307.495 172.406 308.095 171.262 308.551 170.058C308.703 169.626 308.807 169.293 308.864 169.055C308.894 168.937 308.91 168.816 308.912 168.694C308.883 168.694 308.75 169.169 308.408 170.006C307.912 171.18 307.289 172.295 306.55 173.332C305.445 174.866 304.215 176.306 302.873 177.637C301.385 179.171 299.661 180.787 298.05 182.683C297.258 183.6 296.54 184.579 295.902 185.609C295.325 186.576 294.81 187.58 294.363 188.612L293.137 191.397C292.747 192.261 292.344 193.05 291.982 193.773C291.475 194.938 290.734 195.987 289.806 196.856C289.127 197.445 288.666 197.664 288.685 197.692",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.758 193.905C300.748 193.376 300.677 192.85 300.544 192.337C300.364 191.387 300.069 190.057 299.661 188.622C299.252 187.187 298.824 185.909 298.478 184.992C298.317 184.495 298.103 184.018 297.841 183.566C297.934 184.086 298.074 184.597 298.259 185.091C298.549 186.042 298.943 187.305 299.347 188.736C299.751 190.166 300.084 191.463 300.321 192.409C300.42 192.928 300.566 193.437 300.758 193.929",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.151 182.673C289.707 182.595 290.256 182.467 290.79 182.293C291.797 182.032 293.166 181.675 294.724 181.343C296.283 181.01 297.675 180.725 298.696 180.53C299.254 180.459 299.804 180.339 300.34 180.169C299.776 180.154 299.212 180.2 298.658 180.307C297.627 180.44 296.207 180.677 294.653 181.029C293.099 181.381 291.717 181.775 290.728 182.093C290.182 182.233 289.653 182.434 289.151 182.692",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.387 185.937C309.364 185.324 309.28 184.714 309.135 184.118C308.931 183.006 308.608 181.476 308.185 179.808C307.762 178.14 307.287 176.639 306.921 175.57C306.755 174.981 306.53 174.409 306.251 173.864C306.354 174.466 306.505 175.059 306.702 175.636C307.011 176.724 307.434 178.221 307.871 179.889C308.308 181.557 308.665 183.068 308.926 184.165C309.038 184.768 309.197 185.36 309.401 185.937",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.496 172.88C294.496 172.971 297.413 172.733 300.996 172.353C304.578 171.973 307.467 171.598 307.458 171.507C307.448 171.417 304.54 171.655 300.958 172.035C297.375 172.415 294.487 172.791 294.496 172.88Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.424 145.655C320.624 143.536 322.767 141.935 324.9 141.911C327.033 141.887 329.019 143.165 330.321 144.852C331.623 146.539 332.345 148.596 332.93 150.649C334.355 155.647 335.153 160.902 334.536 166.067C333.918 171.232 331.828 176.316 328.121 179.965C327.518 180.559 326.739 181.153 325.912 180.977C325.467 180.839 325.065 180.59 324.743 180.255C321.114 176.932 318.238 172.872 316.307 168.347C314.377 163.822 313.436 158.936 313.549 154.018C313.606 152.056 313.863 150.007 314.951 148.373C316.039 146.738 318.576 144.999 320.424 145.655Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.967 180.677C326.993 180.559 327.005 180.438 327.005 180.316C327.005 180.041 327.033 179.699 327.052 179.271C327.095 178.369 327.1 177.057 327.052 175.437C327.005 173.817 326.915 171.893 326.72 169.735C326.525 167.578 326.202 165.269 325.77 162.836C325.337 160.403 324.786 158.085 324.23 156.032C323.674 153.98 323.085 152.117 322.543 150.587C322.002 149.057 321.531 147.831 321.175 146.995L320.762 146.045C320.721 145.929 320.667 145.82 320.6 145.717C320.617 145.838 320.65 145.956 320.7 146.068C320.795 146.325 320.914 146.648 321.056 147.052C321.379 147.898 321.816 149.133 322.325 150.668C322.833 152.202 323.389 154.051 323.94 156.113C324.491 158.175 325.005 160.475 325.451 162.898C325.898 165.321 326.202 167.649 326.425 169.773C326.649 171.897 326.767 173.817 326.829 175.432C326.891 177.047 326.919 178.354 326.915 179.233V180.274C326.906 180.396 326.916 180.52 326.943 180.639",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.541 162.95C325.857 163.384 326.219 163.782 326.62 164.138C327.323 164.836 328.316 165.772 329.471 166.77C330.625 167.768 331.666 168.628 332.45 169.232C332.853 169.583 333.295 169.889 333.766 170.144C333.41 169.744 333.017 169.377 332.593 169.051L329.685 166.523L326.796 163.971C326.418 163.592 326.004 163.25 325.56 162.95",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.965 169.854C317.388 169.352 317.772 168.821 318.115 168.262L320.79 164.357L323.522 160.494C323.925 159.976 324.291 159.43 324.615 158.859C324.145 159.318 323.717 159.82 323.337 160.356C322.586 161.306 321.584 162.651 320.524 164.157C319.465 165.663 318.557 167.089 317.92 168.124C317.553 168.667 317.235 169.241 316.97 169.84",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.451 148.145C321.403 148.221 324.249 150.14 327.808 152.421C331.367 154.702 334.294 156.502 334.341 156.426C334.389 156.35 331.543 154.436 327.984 152.15C324.425 149.865 321.503 148.069 321.451 148.14",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.425 156.816C313.487 156.878 315.416 155.096 317.73 152.834C320.044 150.573 321.873 148.691 321.812 148.625C321.75 148.558 319.821 150.345 317.507 152.606C315.193 154.868 313.364 156.75 313.425 156.816Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.821 92.5678H36.1789C35.2742 92.5678 34.407 92.2072 33.7674 91.5652C33.1276 90.9229 32.7684 90.0523 32.7684 89.1441V9.51689C32.7684 8.60877 33.1276 7.73814 33.7674 7.09585C34.407 6.45388 35.2742 6.09323 36.1789 6.09323H153.821C154.725 6.09323 155.593 6.45388 156.233 7.09585C156.872 7.73814 157.231 8.60877 157.231 9.51689V89.1441C157.233 89.5943 157.146 90.0405 156.976 90.4566C156.805 90.873 156.554 91.2513 156.237 91.5695C155.92 91.888 155.543 92.1399 155.129 92.3113C154.714 92.4826 154.269 92.57 153.821 92.5678Z",
    fill: "#EBF6FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8546 87.5052H152.145V11.2087H37.8546V87.5052Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5617 54.164H69.1882V26.059H45.5617V54.164Z",
    fill: "#F4F5F9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2252 27.9706C58.2252 28.1392 58.1755 28.304 58.0823 28.4441C57.9888 28.5841 57.8564 28.6935 57.7011 28.7579C57.5462 28.8224 57.3755 28.8391 57.211 28.8063C57.0462 28.7734 56.895 28.6922 56.7764 28.5733C56.6576 28.454 56.5767 28.3022 56.544 28.137C56.5113 27.9716 56.528 27.8002 56.5922 27.6447C56.6567 27.4888 56.7653 27.3559 56.9048 27.262C57.0443 27.1685 57.2085 27.1186 57.3764 27.1186C57.6014 27.1186 57.8175 27.2084 57.9767 27.368C58.1357 27.5279 58.2252 27.7448 58.2252 27.9706Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1049 73.5565H115.062V40.3021H87.1049V73.5565Z",
    fill: "#F4F5F9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.932 44.7884C101.932 44.9569 101.882 45.1218 101.789 45.2618C101.696 45.4019 101.563 45.5112 101.408 45.5757C101.253 45.6401 101.082 45.6568 100.917 45.624C100.753 45.5912 100.602 45.51 100.483 45.391C100.364 45.2717 100.283 45.1199 100.251 44.9545C100.218 44.7893 100.235 44.618 100.299 44.4624C100.363 44.3066 100.472 44.1737 100.612 44.0798C100.751 43.9862 100.915 43.9363 101.083 43.9363C101.308 43.9363 101.524 44.0262 101.683 44.1858C101.842 44.3456 101.932 44.5625 101.932 44.7884Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0154 32.6058H81.2315V18.3349H67.0154V32.6058Z",
    fill: "#44D0B5"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2252 27.9706C58.2252 28.1392 58.1755 28.304 58.0823 28.4441C57.9888 28.5841 57.8564 28.6935 57.7011 28.7579C57.5462 28.8224 57.3755 28.8391 57.211 28.8063C57.0462 28.7734 56.895 28.6922 56.7764 28.5733C56.6576 28.454 56.5767 28.3022 56.544 28.137C56.5113 27.9716 56.528 27.8002 56.5922 27.6447C56.6567 27.4888 56.7653 27.3559 56.9048 27.262C57.0443 27.1685 57.2085 27.1186 57.3764 27.1186C57.6014 27.1186 57.8175 27.2084 57.9767 27.368C58.1357 27.5279 58.2252 27.7448 58.2252 27.9706Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.932 44.7884C101.932 44.9569 101.882 45.1218 101.789 45.2618C101.696 45.4019 101.563 45.5112 101.408 45.5757C101.253 45.6401 101.082 45.6568 100.917 45.624C100.753 45.5912 100.602 45.51 100.483 45.391C100.364 45.2717 100.283 45.1199 100.251 44.9545C100.218 44.7893 100.235 44.618 100.299 44.4624C100.363 44.3066 100.472 44.1737 100.612 44.0798C100.751 43.9862 100.915 43.9363 101.083 43.9363C101.308 43.9363 101.524 44.0262 101.683 44.1858C101.842 44.3456 101.932 44.5625 101.932 44.7884Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9721 19.7817C74.9696 19.9497 74.9177 20.1133 74.823 20.2518C74.7282 20.3902 74.5949 20.4974 74.4397 20.56C74.2844 20.6226 74.114 20.6378 73.9502 20.6034C73.7866 20.5693 73.6363 20.4872 73.519 20.3673C73.4014 20.2477 73.3218 20.0959 73.29 19.9311C73.2582 19.7662 73.2758 19.5955 73.3403 19.4406C73.4051 19.2854 73.5137 19.1531 73.6529 19.0601C73.7924 18.9669 73.956 18.9173 74.1233 18.9173C74.236 18.9173 74.3471 18.9396 74.4511 18.9833C74.5548 19.027 74.6489 19.0908 74.7279 19.1714C74.8069 19.2516 74.869 19.347 74.911 19.4518C74.9529 19.5568 74.9736 19.669 74.9721 19.7817Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1019 217.827H169.593V136.137H16.1019V217.827Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1019 217.827H169.593V136.137H16.1019V217.827Z",
    fill: "#484E74"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8241 214.091H165.87V139.873H19.8241V214.091Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9287 214.091H165.765V139.873H19.9287V214.091Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.589 217.827H178.852V136.137H169.589V217.827Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.589 217.827H178.852V136.137H169.589V217.827Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3271 178.974H169.367V174.99H16.3271V178.974Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3271 178.974H169.367V174.99H16.3271V178.974Z",
    fill: "#484E74"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3733 174.99L74.6356 147.948H61.5863V142.588H33.0307V174.99H61.5863H78.3733Z",
    fill: "#C7E5FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0309 174.99H40.8056V142.587H33.0309V174.99Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3271 174.99H47.7068V146.296H43.3271V174.99Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0307 174.99H54.5431L50.8054 147.948H57.2931L61.0307 174.99Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3826 214.091H52.2962L47.4073 187.052H24.7283L28.3826 214.091Z",
    fill: "#C7E5FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9536 214.091H28.4659L24.7283 187.052H31.2159L34.9536 214.091Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.037 205.685V199.135H88.2747V205.685V214.091H128.127V205.685H123.037Z",
    fill: "#C7E5FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2744 199.132H116.382V192.337H88.2744V199.132Z",
    fill: "#C7E5FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.975 151.74V148.738H115.062V174.99H129.018H145.404V151.74H137.975Z",
    fill: "#C7E5FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.843 174.99H121.142V148.738H114.843V174.99Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.019 174.99H135.065V151.74H129.019V174.99Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2744 199.135H116.382V198.001H88.2744V199.135Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2747 205.688H123.037V204.554H88.2747V205.688Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2747 214.094H128.127V212.96H88.2747V214.094Z",
    fill: "#41BDFC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.639 217.83L178.068 233.753C178.094 233.889 178.091 234.029 178.058 234.162C178.025 234.298 177.963 234.422 177.876 234.53C177.79 234.639 177.681 234.726 177.557 234.788C177.434 234.847 177.298 234.881 177.16 234.884C176.968 234.884 176.78 234.825 176.622 234.716C176.464 234.605 176.345 234.447 176.281 234.264L172.13 217.843L176.639 217.83Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.639 217.83L178.068 233.753C178.094 233.889 178.091 234.029 178.058 234.162C178.025 234.298 177.963 234.422 177.876 234.53C177.79 234.639 177.681 234.726 177.557 234.788C177.434 234.847 177.298 234.881 177.16 234.884C176.968 234.884 176.78 234.825 176.622 234.716C176.464 234.605 176.345 234.447 176.281 234.264L172.13 217.843L176.639 217.83Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.117 227.101L174.386 226.685L172.16 217.855H176.67L178.099 233.778C178.137 233.988 178.104 234.208 178.004 234.397C177.905 234.586 177.745 234.738 177.549 234.825L176.117 227.101Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.45 217.83L161.879 233.753C161.906 233.889 161.903 234.029 161.87 234.162C161.837 234.298 161.775 234.422 161.688 234.53C161.602 234.639 161.493 234.726 161.369 234.788C161.246 234.847 161.11 234.881 160.972 234.884C160.779 234.884 160.591 234.825 160.434 234.716C160.276 234.605 160.157 234.447 160.092 234.264L155.941 217.843L160.45 217.83Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.45 217.83L161.879 233.753C161.906 233.889 161.903 234.029 161.87 234.162C161.837 234.298 161.775 234.422 161.688 234.53C161.602 234.639 161.493 234.726 161.369 234.788C161.246 234.847 161.11 234.881 160.972 234.884C160.779 234.884 160.591 234.825 160.434 234.716C160.276 234.605 160.157 234.447 160.092 234.264L155.941 217.843L160.45 217.83Z",
    fill: "#848ECB"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.938 219.594L156.355 219.098L155.913 217.831H160.423L161.852 233.753C161.89 233.964 161.857 234.184 161.758 234.372C161.658 234.562 161.497 234.713 161.302 234.8L158.938 219.594Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3888 217.83L38.9598 233.753C38.9332 233.889 38.9366 234.029 38.9696 234.162C39.0027 234.298 39.0644 234.422 39.1508 234.53C39.2375 234.639 39.3465 234.726 39.4699 234.788C39.5937 234.847 39.7292 234.881 39.8672 234.884C40.0598 234.884 40.248 234.825 40.4057 234.716C40.5635 234.605 40.6826 234.447 40.7468 234.264L44.898 217.843L40.3888 217.83Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3888 217.83L38.9598 233.753C38.9332 233.889 38.9366 234.029 38.9696 234.162C39.0027 234.298 39.0644 234.422 39.1508 234.53C39.2375 234.639 39.3465 234.726 39.4699 234.788C39.5937 234.847 39.7292 234.881 39.8672 234.884C40.0598 234.884 40.248 234.825 40.4057 234.716C40.5635 234.605 40.6826 234.447 40.7468 234.264L44.898 217.843L40.3888 217.83Z",
    fill: "#848ECB"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1727 226.298L39.6295 225.911L40.3888 217.831H44.898L40.7468 234.252C40.6826 234.434 40.5635 234.593 40.4058 234.704C40.248 234.812 40.0598 234.871 39.8672 234.871H39.8116L41.1727 226.298Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7468 217.83L22.3178 233.753C22.2912 233.889 22.2946 234.029 22.3277 234.162C22.3607 234.298 22.4224 234.422 22.5088 234.53C22.5956 234.639 22.7045 234.726 22.8283 234.788C22.9517 234.847 23.0875 234.881 23.2252 234.884C23.4178 234.884 23.6061 234.825 23.7638 234.716C23.9215 234.605 24.0406 234.447 24.1048 234.264L28.2561 217.843L23.7468 217.83Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7468 217.83L22.3178 233.753C22.2912 233.889 22.2946 234.029 22.3277 234.162C22.3607 234.298 22.4224 234.422 22.5088 234.53C22.5956 234.639 22.7045 234.726 22.8283 234.788C22.9517 234.847 23.0875 234.881 23.2252 234.884C23.4178 234.884 23.6061 234.825 23.7638 234.716C23.9215 234.605 24.0406 234.447 24.1048 234.264L28.2561 217.843L23.7468 217.83Z",
    fill: "#848ECB"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.506 219.206L23.5276 218.847L23.7467 217.824H28.256L24.1047 234.246C24.0405 234.428 23.9214 234.586 23.7637 234.698C23.606 234.806 23.4177 234.865 23.2251 234.865H23.1696L25.506 219.206Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.117 227.063L174.386 226.645L172.16 217.83H176.67L178.099 233.756C178.136 233.967 178.103 234.183 178.003 234.376C177.903 234.565 177.744 234.713 177.549 234.803L176.117 227.063Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.938 219.556L156.355 219.06L155.913 217.79H160.423L161.852 233.712C161.89 233.923 161.857 234.143 161.758 234.332C161.658 234.521 161.497 234.673 161.302 234.76L158.938 219.556Z",
    fill: "#484E74"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1727 226.261L39.6295 225.874L40.3703 217.787H44.8795L40.7283 234.208C40.6641 234.391 40.5449 234.549 40.3872 234.661C40.2295 234.769 40.0412 234.828 39.8487 234.828H39.7931L41.1727 226.261Z",
    fill: "#484E74"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.506 219.169L23.5276 218.81L23.7467 217.787H28.256L24.1047 234.208C24.0405 234.391 23.9214 234.549 23.7637 234.661C23.606 234.769 23.4177 234.828 23.2251 234.828H23.1696L25.506 219.169Z",
    fill: "#484E74"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.281 45.6869L188.701 79.6632C188.17 80.2327 187.493 80.6445 186.745 80.8536C185.996 81.0627 185.205 81.0615 184.457 80.8493C183.71 80.637 183.034 80.2228 182.506 79.6511C181.977 79.0795 181.616 78.3731 181.46 77.609L178.009 60.2273L187.237 38.8643L190.744 61.1723L213.056 42.3035L220.281 45.6869Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.414 77.1382C186.963 76.7939 186.595 76.3543 186.334 75.8502C186.073 75.3461 185.926 74.7902 185.904 74.2226L184.935 56.3483L179.808 56.0602L178.009 60.2274L181.46 77.6091C181.615 78.3732 181.977 79.0796 182.506 79.6512C183.035 80.2229 183.71 80.6371 184.457 80.8493C185.205 81.0616 185.996 81.0628 186.745 80.8537C187.493 80.6446 188.169 80.2328 188.701 79.6633L191.602 76.5402C189.772 78.1389 188.367 77.8384 187.414 77.1382Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.519 235.138H202.697C202.119 235.138 201.546 235.023 201.011 234.803C200.477 234.58 199.991 234.255 199.582 233.842C199.173 233.434 198.849 232.944 198.628 232.408C198.406 231.872 198.293 231.296 198.293 230.716V49.247C198.293 48.6664 198.406 48.091 198.628 47.5547C198.849 47.0178 199.173 46.5304 199.582 46.1199C199.991 45.709 200.477 45.3834 201.011 45.1615C201.546 44.9391 202.119 44.8254 202.697 44.8257H301.519C302.095 44.8254 302.67 44.9391 303.203 45.1615C303.737 45.3834 304.225 45.709 304.633 46.1199C305.043 46.5304 305.367 47.0178 305.589 47.5547C305.808 48.091 305.923 48.6664 305.923 49.247V230.716C305.926 231.299 305.815 231.875 305.592 232.411C305.373 232.95 305.049 233.437 304.639 233.849C304.228 234.261 303.744 234.586 303.207 234.806C302.673 235.029 302.099 235.141 301.519 235.138Z",
    fill: "#FFA700"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.478 235.138H199.648C199.07 235.138 198.496 235.023 197.962 234.803C197.428 234.58 196.942 234.255 196.533 233.842C196.124 233.434 195.799 232.944 195.578 232.408C195.357 231.872 195.243 231.296 195.244 230.716V49.247C195.243 48.6664 195.357 48.091 195.578 47.5547C195.799 47.0178 196.124 46.5304 196.533 46.1199C196.942 45.709 197.428 45.3834 197.962 45.1615C198.496 44.9391 199.07 44.8254 199.648 44.8257H298.469C299.046 44.8254 299.62 44.9391 300.154 45.1615C300.688 45.3834 301.176 45.709 301.583 46.1199C301.994 46.5304 302.318 47.0178 302.54 47.5547C302.759 48.091 302.873 48.6664 302.873 49.247V230.716C302.876 231.296 302.765 231.872 302.543 232.408C302.324 232.947 302 233.434 301.592 233.846C301.185 234.255 300.697 234.583 300.163 234.803C299.629 235.026 299.055 235.138 298.478 235.138Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.478 235.138H199.648C199.07 235.138 198.496 235.023 197.962 234.803C197.428 234.58 196.942 234.255 196.533 233.842C196.124 233.434 195.799 232.944 195.578 232.408C195.357 231.872 195.243 231.296 195.244 230.716V49.247C195.243 48.6664 195.357 48.091 195.578 47.5547C195.799 47.0178 196.124 46.5304 196.533 46.1199C196.942 45.709 197.428 45.3834 197.962 45.1615C198.496 44.9391 199.07 44.8254 199.648 44.8257H298.469C299.046 44.8254 299.62 44.9391 300.154 45.1615C300.688 45.3834 301.176 45.709 301.583 46.1199C301.994 46.5304 302.318 47.0178 302.54 47.5547C302.759 48.091 302.873 48.6664 302.873 49.247V230.716C302.876 231.296 302.765 231.872 302.543 232.408C302.324 232.947 302 233.434 301.592 233.846C301.185 234.255 300.697 234.583 300.163 234.803C299.629 235.026 299.055 235.138 298.478 235.138Z",
    fill: "#FFD055"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.506 107.378H218.627C218.456 107.378 218.286 107.345 218.129 107.28C217.971 107.214 217.828 107.118 217.707 106.997C217.586 106.876 217.49 106.732 217.425 106.573C217.36 106.415 217.327 106.245 217.327 106.073V85.5067C217.327 85.3353 217.36 85.1655 217.425 85.0069C217.49 84.8486 217.586 84.7045 217.707 84.5834C217.828 84.4622 217.971 84.3662 218.129 84.3008C218.286 84.2354 218.456 84.202 218.627 84.2023H284.525C284.694 84.202 284.864 84.2354 285.022 84.3008C285.179 84.3662 285.324 84.4622 285.444 84.5834C285.565 84.7045 285.66 84.8486 285.725 85.0069C285.79 85.1655 285.824 85.3353 285.824 85.5067V106.073C285.824 106.247 285.793 106.418 285.725 106.578C285.66 106.739 285.562 106.884 285.441 107.005C285.318 107.127 285.169 107.223 285.009 107.286C284.849 107.351 284.679 107.382 284.506 107.378Z",
    fill: "#FFA700"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.808 107.378H216.932C216.761 107.378 216.592 107.345 216.434 107.28C216.277 107.214 216.133 107.118 216.012 106.997C215.891 106.876 215.796 106.732 215.731 106.573C215.665 106.415 215.632 106.245 215.633 106.073V85.5067C215.632 85.3353 215.665 85.1655 215.731 85.0069C215.796 84.8486 215.891 84.7045 216.012 84.5834C216.133 84.4622 216.277 84.3662 216.434 84.3008C216.592 84.2354 216.761 84.202 216.932 84.2023H282.815C282.984 84.202 283.154 84.2354 283.312 84.3008C283.469 84.3662 283.614 84.4622 283.734 84.5834C283.855 84.7045 283.95 84.8486 284.015 85.0069C284.08 85.1655 284.114 85.3353 284.114 85.5067V106.073C284.117 106.246 284.086 106.418 284.022 106.578C283.957 106.738 283.861 106.884 283.738 107.005C283.617 107.127 283.472 107.223 283.312 107.287C283.151 107.351 282.982 107.382 282.808 107.378Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.429 92.9086H247.059C246.367 92.9086 245.824 92.4377 245.824 91.8831C245.824 91.3099 246.388 90.8575 247.059 90.8575H266.429C267.12 90.8575 267.663 91.3285 267.663 91.8831C267.663 92.4563 267.12 92.9086 266.429 92.9086Z",
    fill: "#FF7574"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.926 96.9273H246.472C246.315 96.9363 246.163 96.8857 246.043 96.7857C245.923 96.6859 245.842 96.5437 245.824 96.3882C245.842 96.2326 245.923 96.0904 246.043 95.9906C246.163 95.8906 246.315 95.8397 246.472 95.849H275.926C276.083 95.8397 276.234 95.8906 276.355 95.9906C276.475 96.0904 276.552 96.2326 276.574 96.3882C276.596 96.6856 276.281 96.9273 275.926 96.9273Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.025 100.27H246.475C246.318 100.279 246.167 100.229 246.046 100.129C245.926 100.029 245.848 99.8866 245.827 99.7311C245.848 99.5756 245.926 99.4334 246.046 99.3336C246.167 99.2335 246.318 99.183 246.475 99.192H264.025C264.182 99.183 264.333 99.2335 264.454 99.3336C264.574 99.4334 264.654 99.5756 264.673 99.7311C264.654 99.8866 264.574 100.029 264.454 100.129C264.333 100.229 264.182 100.279 264.025 100.27Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.108 88.4811H230.722V88.6299C229.125 88.9527 227.688 89.8209 226.656 91.0865C225.624 92.3522 225.059 93.9376 225.059 95.5732C225.059 97.2088 225.624 98.7943 226.656 100.06C227.688 101.326 229.125 102.194 230.722 102.517V102.656H232.108C233.979 102.656 235.774 101.91 237.096 100.581C238.42 99.2531 239.163 97.4518 239.163 95.5732C239.163 93.6947 238.42 91.8933 237.096 90.5651C235.774 89.2365 233.979 88.4904 232.108 88.4904V88.4811Z",
    fill: "#EF5756"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.719 102.628C234.616 102.628 237.775 99.457 237.775 95.5454C237.775 91.6337 234.616 88.4626 230.719 88.4626C226.822 88.4626 223.663 91.6337 223.663 95.5454C223.663 99.457 226.822 102.628 230.719 102.628Z",
    fill: "#FF8988"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.404 98.5043L227.031 96.1217C226.972 96.0572 226.94 95.9733 226.94 95.8862C226.94 95.7992 226.972 95.7152 227.031 95.6507L227.648 95.0311C227.712 94.9725 227.796 94.94 227.883 94.94C227.969 94.94 228.053 94.9725 228.117 95.0311L229.642 96.5617L233.318 92.8437C233.382 92.7851 233.466 92.7526 233.552 92.7526C233.639 92.7526 233.723 92.7851 233.787 92.8437L234.404 93.4633C234.463 93.5278 234.495 93.6117 234.495 93.6988C234.495 93.7859 234.463 93.8698 234.404 93.9343L229.864 98.4919C229.835 98.5232 229.8 98.5483 229.761 98.566C229.721 98.5833 229.68 98.5929 229.637 98.5942C229.594 98.5954 229.551 98.588 229.512 98.5725C229.472 98.5573 229.435 98.5341 229.404 98.5043Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.506 143.873H218.627C218.456 143.873 218.286 143.84 218.129 143.775C217.971 143.71 217.828 143.613 217.707 143.492C217.586 143.371 217.49 143.227 217.425 143.068C217.36 142.91 217.327 142.74 217.327 142.569V122.002C217.327 121.831 217.36 121.661 217.425 121.502C217.49 121.344 217.586 121.2 217.707 121.079C217.828 120.958 217.971 120.861 218.129 120.796C218.286 120.731 218.456 120.697 218.627 120.698H284.525C284.694 120.697 284.864 120.731 285.022 120.796C285.179 120.861 285.324 120.958 285.444 121.079C285.565 121.2 285.66 121.344 285.725 121.502C285.79 121.661 285.824 121.831 285.824 122.002V142.569C285.824 142.742 285.793 142.914 285.725 143.074C285.66 143.234 285.562 143.379 285.441 143.501C285.318 143.622 285.169 143.718 285.009 143.782C284.849 143.846 284.679 143.877 284.506 143.873Z",
    fill: "#FFA700"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.808 143.873H216.932C216.761 143.873 216.592 143.84 216.434 143.775C216.277 143.71 216.133 143.613 216.012 143.492C215.891 143.371 215.796 143.227 215.731 143.068C215.665 142.91 215.632 142.74 215.633 142.569V122.002C215.632 121.831 215.665 121.661 215.731 121.502C215.796 121.344 215.891 121.2 216.012 121.079C216.133 120.958 216.277 120.861 216.434 120.796C216.592 120.731 216.761 120.697 216.932 120.698H282.815C282.984 120.697 283.154 120.731 283.312 120.796C283.469 120.861 283.614 120.958 283.734 121.079C283.855 121.2 283.95 121.344 284.015 121.502C284.08 121.661 284.114 121.831 284.114 122.002V142.569C284.117 142.742 284.086 142.913 284.022 143.073C283.957 143.234 283.861 143.379 283.738 143.501C283.617 143.623 283.472 143.719 283.312 143.783C283.151 143.846 282.982 143.878 282.808 143.873Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.429 129.404H247.059C246.367 129.404 245.824 128.933 245.824 128.378C245.824 127.805 246.388 127.353 247.059 127.353H266.429C267.12 127.353 267.663 127.824 267.663 128.378C267.663 128.951 267.12 129.404 266.429 129.404Z",
    fill: "#FF7574"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.926 133.423H246.472C246.315 133.431 246.163 133.381 246.043 133.281C245.923 133.181 245.842 133.039 245.824 132.883C245.842 132.728 245.923 132.586 246.043 132.486C246.163 132.386 246.315 132.335 246.472 132.344H275.926C276.083 132.335 276.234 132.386 276.355 132.486C276.475 132.586 276.552 132.728 276.574 132.883C276.596 133.181 276.281 133.423 275.926 133.423Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.025 136.762H246.475C246.318 136.771 246.167 136.721 246.046 136.621C245.926 136.521 245.848 136.379 245.827 136.224C245.848 136.068 245.926 135.926 246.046 135.826C246.167 135.726 246.318 135.675 246.475 135.685H264.025C264.182 135.675 264.333 135.726 264.454 135.826C264.574 135.926 264.654 136.068 264.673 136.224C264.654 136.379 264.574 136.521 264.454 136.621C264.333 136.721 264.182 136.771 264.025 136.762Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.108 124.976H230.722V125.116C229.125 125.439 227.688 126.307 226.656 127.573C225.624 128.838 225.059 130.423 225.059 132.059C225.059 133.695 225.624 135.28 226.656 136.546C227.688 137.812 229.125 138.68 230.722 139.003V139.133H232.108C233.979 139.133 235.774 138.386 237.096 137.058C238.42 135.73 239.163 133.929 239.163 132.05C239.163 130.172 238.42 128.37 237.096 127.042C235.774 125.713 233.979 124.967 232.108 124.967V124.976Z",
    fill: "#EF5756"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.719 139.123C234.616 139.123 237.775 135.953 237.775 132.041C237.775 128.129 234.616 124.958 230.719 124.958C226.822 124.958 223.663 128.129 223.663 132.041C223.663 135.953 226.822 139.123 230.719 139.123Z",
    fill: "#FF8988"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.404 134.997L227.031 132.626C226.972 132.562 226.94 132.478 226.94 132.391C226.94 132.304 226.972 132.22 227.031 132.155L227.648 131.536C227.712 131.477 227.796 131.444 227.883 131.444C227.969 131.444 228.053 131.477 228.117 131.536L229.642 133.066L233.318 129.348C233.382 129.29 233.466 129.257 233.552 129.257C233.639 129.257 233.723 129.29 233.787 129.348L234.404 129.968C234.463 130.032 234.495 130.116 234.495 130.203C234.495 130.29 234.463 130.374 234.404 130.439L229.864 134.997C229.835 135.029 229.8 135.055 229.76 135.073C229.72 135.09 229.678 135.1 229.634 135.1C229.591 135.1 229.548 135.09 229.508 135.073C229.469 135.055 229.433 135.029 229.404 134.997Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.506 180.368H218.627C218.456 180.369 218.286 180.336 218.129 180.27C217.971 180.205 217.828 180.108 217.707 179.988C217.586 179.866 217.49 179.722 217.425 179.564C217.36 179.405 217.327 179.235 217.327 179.064V158.497C217.327 158.326 217.36 158.156 217.425 157.998C217.49 157.839 217.586 157.695 217.707 157.574C217.828 157.453 217.971 157.357 218.129 157.292C218.286 157.226 218.456 157.193 218.627 157.193H284.525C284.694 157.193 284.864 157.226 285.022 157.292C285.179 157.357 285.324 157.453 285.444 157.574C285.565 157.695 285.66 157.839 285.725 157.998C285.79 158.156 285.824 158.326 285.824 158.497V179.064C285.824 179.238 285.793 179.409 285.725 179.569C285.66 179.729 285.562 179.874 285.441 179.996C285.318 180.117 285.169 180.213 285.009 180.277C284.849 180.341 284.679 180.372 284.506 180.368Z",
    fill: "#FFA700"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.808 180.368H216.932C216.761 180.369 216.592 180.336 216.434 180.27C216.277 180.205 216.133 180.108 216.012 179.988C215.891 179.866 215.796 179.722 215.731 179.564C215.665 179.405 215.632 179.235 215.633 179.064V158.497C215.632 158.326 215.665 158.156 215.731 157.998C215.796 157.839 215.891 157.695 216.012 157.574C216.133 157.453 216.277 157.357 216.434 157.292C216.592 157.226 216.761 157.193 216.932 157.193H282.815C282.984 157.193 283.154 157.226 283.312 157.292C283.469 157.357 283.614 157.453 283.734 157.574C283.855 157.695 283.95 157.839 284.015 157.998C284.08 158.156 284.114 158.326 284.114 158.497V179.064C284.117 179.237 284.086 179.409 284.022 179.569C283.957 179.729 283.861 179.874 283.738 179.996C283.617 180.118 283.472 180.214 283.312 180.278C283.151 180.342 282.982 180.373 282.808 180.368Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.429 165.899H247.059C246.367 165.899 245.824 165.428 245.824 164.874C245.824 164.301 246.388 163.848 247.059 163.848H266.429C267.12 163.848 267.663 164.319 267.663 164.874C267.663 165.447 267.12 165.899 266.429 165.899Z",
    fill: "#FF7574"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.926 169.918H246.472C246.315 169.927 246.163 169.876 246.043 169.776C245.923 169.677 245.842 169.534 245.824 169.379C245.842 169.223 245.923 169.081 246.043 168.981C246.163 168.881 246.315 168.83 246.472 168.84H275.926C276.083 168.83 276.234 168.881 276.355 168.981C276.475 169.081 276.552 169.223 276.574 169.379C276.596 169.676 276.281 169.918 275.926 169.918Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.025 173.258H246.475C246.318 173.267 246.167 173.216 246.046 173.116C245.926 173.016 245.848 172.874 245.827 172.719C245.848 172.563 245.926 172.421 246.046 172.321C246.167 172.221 246.318 172.17 246.475 172.18H264.025C264.182 172.17 264.333 172.221 264.454 172.321C264.574 172.421 264.654 172.563 264.673 172.719C264.654 172.874 264.574 173.016 264.454 173.116C264.333 173.216 264.182 173.267 264.025 173.258Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.108 161.472H230.722V161.611C229.125 161.934 227.688 162.802 226.656 164.068C225.624 165.334 225.059 166.919 225.059 168.554C225.059 170.19 225.624 171.776 226.656 173.041C227.688 174.307 229.125 175.175 230.722 175.498V175.638H232.108C233.979 175.638 235.774 174.891 237.096 173.563C238.42 172.234 239.163 170.433 239.163 168.554C239.163 166.676 238.42 164.875 237.096 163.546C235.774 162.218 233.979 161.472 232.108 161.472Z",
    fill: "#EF5756"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.719 175.619C234.616 175.619 237.775 172.448 237.775 168.536C237.775 164.625 234.616 161.453 230.719 161.453C226.822 161.453 223.663 164.625 223.663 168.536C223.663 172.448 226.822 175.619 230.719 175.619Z",
    fill: "#FF8988"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.404 171.492L227.031 169.109C226.972 169.045 226.94 168.961 226.94 168.874C226.94 168.787 226.972 168.702 227.031 168.638L227.648 168.019C227.712 167.96 227.796 167.927 227.883 167.927C227.969 167.927 228.053 167.96 228.117 168.019L229.642 169.549L233.318 165.831C233.382 165.773 233.466 165.74 233.552 165.74C233.639 165.74 233.723 165.773 233.787 165.831L234.404 166.451C234.463 166.515 234.495 166.599 234.495 166.686C234.495 166.773 234.463 166.857 234.404 166.922L229.864 171.479C229.836 171.512 229.801 171.539 229.762 171.558C229.723 171.577 229.68 171.588 229.637 171.589C229.593 171.59 229.55 171.582 229.51 171.565C229.47 171.549 229.434 171.523 229.404 171.492Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.506 217.641H218.627C218.456 217.642 218.286 217.609 218.129 217.543C217.971 217.478 217.828 217.381 217.707 217.261C217.586 217.139 217.49 216.995 217.425 216.837C217.36 216.678 217.327 216.509 217.327 216.337V195.77C217.327 195.599 217.36 195.429 217.425 195.271C217.49 195.112 217.586 194.968 217.707 194.847C217.828 194.726 217.971 194.63 218.129 194.565C218.286 194.499 218.456 194.466 218.627 194.466H284.525C284.694 194.466 284.864 194.499 285.022 194.565C285.179 194.63 285.324 194.726 285.444 194.847C285.565 194.968 285.66 195.112 285.725 195.271C285.79 195.429 285.824 195.599 285.824 195.77V216.337C285.824 216.51 285.793 216.682 285.725 216.842C285.66 217.002 285.562 217.147 285.441 217.269C285.318 217.39 285.169 217.486 285.009 217.55C284.849 217.614 284.679 217.645 284.506 217.641Z",
    fill: "#FFA700"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.808 217.641H216.932C216.761 217.642 216.592 217.609 216.434 217.543C216.277 217.478 216.133 217.381 216.012 217.261C215.891 217.139 215.796 216.995 215.731 216.837C215.665 216.678 215.632 216.509 215.633 216.337V195.77C215.632 195.599 215.665 195.429 215.731 195.271C215.796 195.112 215.891 194.968 216.012 194.847C216.133 194.726 216.277 194.63 216.434 194.565C216.592 194.499 216.761 194.466 216.932 194.466H282.815C282.984 194.466 283.154 194.499 283.312 194.565C283.469 194.63 283.614 194.726 283.734 194.847C283.855 194.968 283.95 195.112 284.015 195.271C284.08 195.429 284.114 195.599 284.114 195.77V216.337C284.117 216.51 284.086 216.682 284.022 216.842C283.957 217.002 283.861 217.147 283.738 217.269C283.617 217.391 283.472 217.487 283.312 217.551C283.151 217.615 282.982 217.646 282.808 217.641Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.429 203.172H247.059C246.367 203.172 245.824 202.701 245.824 202.147C245.824 201.574 246.388 201.121 247.059 201.121H266.429C267.12 201.121 267.663 201.592 267.663 202.147C267.663 202.72 267.12 203.172 266.429 203.172Z",
    fill: "#FF7574"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.926 207.191H246.472C246.315 207.2 246.163 207.149 246.043 207.049C245.923 206.949 245.842 206.807 245.824 206.652C245.842 206.496 245.923 206.354 246.043 206.254C246.163 206.154 246.315 206.103 246.472 206.113H275.926C276.083 206.103 276.234 206.154 276.355 206.254C276.475 206.354 276.552 206.496 276.574 206.652C276.596 206.949 276.281 207.191 275.926 207.191Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.025 210.531H246.475C246.318 210.54 246.167 210.489 246.046 210.389C245.926 210.29 245.848 210.147 245.827 209.992C245.848 209.836 245.926 209.694 246.046 209.594C246.167 209.494 246.318 209.443 246.475 209.453H264.025C264.182 209.443 264.333 209.494 264.454 209.594C264.574 209.694 264.654 209.836 264.673 209.992C264.654 210.147 264.574 210.29 264.454 210.389C264.333 210.489 264.182 210.54 264.025 210.531Z",
    fill: "#FFCFCF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.108 198.745H230.722V198.884C229.125 199.207 227.688 200.075 226.656 201.341C225.624 202.607 225.059 204.192 225.059 205.827C225.059 207.463 225.624 209.049 226.656 210.314C227.688 211.58 229.125 212.448 230.722 212.771V212.91H232.108C233.979 212.91 235.774 212.164 237.096 210.835C238.42 209.507 239.163 207.706 239.163 205.827C239.163 203.949 238.42 202.147 237.096 200.819C235.774 199.491 233.979 198.745 232.108 198.745Z",
    fill: "#EF5756"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.719 212.892C234.616 212.892 237.775 209.721 237.775 205.809C237.775 201.897 234.616 198.726 230.719 198.726C226.822 198.726 223.663 201.897 223.663 205.809C223.663 209.721 226.822 212.892 230.719 212.892Z",
    fill: "#FF8988"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.404 208.765L227.031 206.382C226.972 206.318 226.94 206.234 226.94 206.147C226.94 206.06 226.972 205.976 227.031 205.911L227.648 205.292C227.712 205.233 227.796 205.2 227.883 205.2C227.969 205.2 228.053 205.233 228.117 205.292L229.642 206.822L233.318 203.104C233.382 203.046 233.466 203.013 233.552 203.013C233.639 203.013 233.723 203.046 233.787 203.104L234.404 203.724C234.463 203.788 234.495 203.872 234.495 203.959C234.495 204.046 234.463 204.13 234.404 204.195L229.864 208.752C229.836 208.785 229.801 208.812 229.762 208.831C229.723 208.85 229.68 208.861 229.637 208.861C229.593 208.863 229.55 208.855 229.51 208.838C229.47 208.822 229.434 208.796 229.404 208.765Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.361 59.8493H223.194V58.3405H233.339V59.8493H229.151V72.094H227.361V59.8493Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.046 66.3807L238.707 62.421C238.398 61.5225 238.198 60.7076 237.994 59.9114H237.954C237.75 60.7262 237.528 61.5628 237.262 62.39L235.92 66.3683L240.046 66.3807ZM235.555 67.7687L234.133 72.1064H232.302L236.957 58.3529H239.092L243.784 72.094H241.892L240.429 67.7564L235.555 67.7687Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.537 69.9313C246.497 70.5098 247.592 70.8199 248.71 70.8299C250.519 70.8299 251.574 69.8725 251.574 68.4844C251.574 67.1986 250.842 66.4612 248.994 65.7486C246.756 64.9523 245.374 63.7904 245.374 61.8509C245.374 59.7068 247.142 58.1143 249.805 58.1143C250.855 58.079 251.898 58.3113 252.836 58.7897L252.349 60.2366C251.549 59.8047 250.654 59.5801 249.744 59.5829C247.873 59.5829 247.164 60.7076 247.164 61.6464C247.164 62.9322 247.997 63.5643 249.889 64.2986C252.207 65.1971 253.386 66.3187 253.386 68.3264C253.386 70.4519 251.818 72.2861 248.587 72.2861C247.266 72.2861 245.809 71.8988 245.09 71.4092L245.537 69.9313Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.802 58.3406H257.571V64.9741H257.633C258 64.4412 258.364 63.9517 258.71 63.5024L262.898 58.3406H265.095L260.142 64.1778L265.491 72.0941H263.395L258.882 65.3397L257.58 66.8517V72.0941H255.811L255.802 58.3406Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.577 69.9313C267.537 70.5092 268.632 70.8193 269.75 70.8299C271.559 70.8299 272.617 69.8725 272.617 68.4844C272.617 67.1986 271.886 66.4612 270.034 65.7486C267.799 64.9523 266.416 63.7904 266.416 61.8509C266.416 59.7068 268.185 58.1143 270.849 58.1143C271.898 58.079 272.941 58.3113 273.876 58.7897L273.389 60.2366C272.589 59.8047 271.694 59.5801 270.787 59.5829C268.916 59.5829 268.204 60.7076 268.204 61.6464C268.204 62.9322 269.037 63.5643 270.929 64.2986C273.247 65.1971 274.426 66.3187 274.426 68.3264C274.426 70.4519 272.861 72.2861 269.627 72.2861C268.306 72.2861 266.849 71.8988 266.13 71.4092L266.577 69.9313Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.852 43.1183C208.841 43.5552 209.003 43.9787 209.303 44.2957C209.603 44.613 210.015 44.7979 210.451 44.81L212.706 44.8689L213.114 50.3746C213.132 50.5794 213.224 50.7709 213.371 50.9137C213.518 51.0566 213.712 51.1412 213.917 51.1523C214.128 51.1576 214.334 51.0807 214.49 50.9373C214.646 50.7941 214.742 50.5958 214.756 50.3839L215.231 45.1415C215.237 45.1006 215.26 45.0638 215.292 45.039C215.325 45.0139 215.366 45.003 215.407 45.0083C215.445 45.0157 215.48 45.0331 215.509 45.0579C215.538 45.0827 215.56 45.1149 215.574 45.1508L215.784 50.3436C215.789 50.5738 215.882 50.7929 216.043 50.9565C216.204 51.1201 216.422 51.2158 216.651 51.2236C216.768 51.2276 216.885 51.2084 216.994 51.1666C217.104 51.1247 217.204 51.0615 217.289 50.9804C217.373 50.8995 217.441 50.8022 217.488 50.6944C217.535 50.5866 217.56 50.4704 217.562 50.3529L217.87 45.1044L217.562 50.2166C217.555 50.3498 217.575 50.4831 217.62 50.6086C217.665 50.734 217.734 50.8493 217.824 50.9478C217.914 51.046 218.023 51.1254 218.143 51.1814C218.264 51.2372 218.395 51.2685 218.528 51.2731C218.773 51.2784 219.013 51.1932 219.2 51.0333C219.387 50.8735 219.509 50.6501 219.543 50.4056L220.16 45.2004L219.71 49.0702C219.698 49.1855 219.709 49.3017 219.743 49.4123C219.777 49.5229 219.833 49.6258 219.907 49.7141C219.982 49.8027 220.073 49.8752 220.176 49.9275C220.278 49.9796 220.391 50.0106 220.506 50.0183C220.702 50.0276 220.895 49.9653 221.05 49.843C221.204 49.7206 221.309 49.5461 221.345 49.3522L222.08 46.0741C222.175 45.6571 222.158 45.2224 222.03 44.8144C221.902 44.4066 221.668 44.0404 221.352 43.7535C220.1 42.5919 218.523 41.8437 216.834 41.6101C215.145 41.3761 213.426 41.668 211.907 42.446L208.985 42.9541C208.926 42.9138 208.855 43.0161 208.852 43.1183Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.691 45.1068L217.406 49.9408L217.884 49.9693L218.168 45.135L217.691 45.1068Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.881 45.4639L219.458 49.3572L219.933 49.4093L220.357 45.5159L219.881 45.4639Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.793 44.768L214.369 48.6614L214.845 48.7134L215.268 44.8201L214.793 44.768Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.707 44.8999L210.45 44.841L211.852 43.5707C211.917 43.51 211.998 43.4694 212.086 43.4536C212.174 43.4381 212.264 43.4483 212.346 43.483C212.428 43.5177 212.499 43.5753 212.549 43.6491C212.599 43.7228 212.627 43.8099 212.629 43.8991L212.707 44.8999Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4381 120.072L57.9196 97.8847L57.7838 97.8599L53.3023 120.044L53.4381 120.072Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1758 90.4247L52.0369 90.4278L52.6233 119.258L52.7622 119.255L52.1758 90.4247Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6162 95.7176L45.5076 95.8043L52.3548 104.443L52.4634 104.356L45.6162 95.7176Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9567 125.59L50.6449 124.567C51.3307 123.539 51.694 122.329 51.6881 121.091V118.634H54.327V121.091C54.3187 122.328 54.6789 123.54 55.361 124.571L56.0493 125.593C56.7536 126.662 57.2273 127.868 57.44 129.132C57.6526 130.396 57.5993 131.691 57.2838 132.933L56.5153 135.969H49.4783L48.7221 132.936C48.4119 131.692 48.3616 130.398 48.5743 129.133C48.7866 127.869 49.2573 126.663 49.9567 125.59Z",
    fill: "#FFD055"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9567 125.59L50.645 124.567C51.3308 123.539 51.694 122.329 51.6882 121.091V118.634H52.4567V120.868C52.4502 122.249 52.0496 123.6 51.3024 124.76C50.148 126.885 50.148 129.314 50.5616 131.3C50.8141 132.483 51.2693 133.614 51.9073 134.64L52.4289 135.495C52.5221 135.646 52.6514 135.77 52.8055 135.857C52.9592 135.943 53.1323 135.989 53.3085 135.991H49.4505L48.682 132.955C48.3863 131.704 48.3468 130.407 48.5659 129.141C48.7851 127.875 49.2582 126.667 49.9567 125.59Z",
    fill: "#DEA50F"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0187 104.605L46.9301 104.712L55.0739 111.497L55.1628 111.39L47.0187 104.605Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0986 116.76L61.3023 109.918L61.219 109.835L54.0153 116.651L54.0986 116.76Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.648 100.893L48.5215 95.9357C48.4264 95.5302 48.2307 95.155 47.953 94.8451C47.6752 94.5353 47.3243 94.3011 46.9323 94.1635C46.5403 94.0259 46.1199 93.99 45.7107 94.0588C45.3011 94.1276 44.9153 94.2989 44.5894 94.557C44.2699 94.8194 44.0209 95.1578 43.8653 95.5416C43.7098 95.9255 43.6527 96.3422 43.699 96.754C43.7452 97.1658 43.8937 97.5593 44.1307 97.8989C44.3678 98.2381 44.6857 98.5123 45.0554 98.6964L49.648 100.893Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.648 100.893L48.5215 95.9357C48.4264 95.5302 48.2307 95.155 47.953 94.8451C47.6752 94.5353 47.3243 94.3011 46.9323 94.1635C46.5403 94.0259 46.1199 93.99 45.7107 94.0588C45.3011 94.1276 44.9153 94.2989 44.5894 94.557C44.2699 94.8194 44.0209 95.1578 43.8653 95.5416C43.7098 95.9255 43.6527 96.3422 43.699 96.754C43.7452 97.1658 43.8937 97.5593 44.1307 97.8989C44.3678 98.2381 44.6857 98.5123 45.0554 98.6964L49.648 100.893Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.682 96.5058C43.6838 96.964 43.8172 97.412 44.0656 97.7965C44.3141 98.181 44.6672 98.4859 45.0832 98.6746L49.6727 100.884L44.6141 94.5383C44.3101 94.7645 44.0659 95.0623 43.9033 95.4052C43.7409 95.7482 43.6647 96.1262 43.682 96.5058Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2561 98.687L55.5123 91.9543C55.7787 91.4025 55.9006 90.7915 55.8666 90.1793C55.8327 89.5671 55.6438 88.9737 55.3179 88.4551C54.9922 87.9364 54.5401 87.5095 54.0043 87.2148C53.4688 86.9201 52.8669 86.7674 52.2561 86.7708C51.6472 86.7727 51.0484 86.9288 50.516 87.2256C49.9836 87.5222 49.5345 87.9491 49.2108 88.4668C48.8867 88.9846 48.6987 89.5764 48.6641 90.1864C48.6296 90.7968 48.7493 91.4062 49.0123 91.9574L52.2561 98.687Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2561 98.687L55.5123 91.9543C55.7787 91.4025 55.9006 90.7915 55.8666 90.1793C55.8327 89.5671 55.6438 88.9737 55.3179 88.4551C54.9922 87.9364 54.5401 87.5095 54.0043 87.2148C53.4688 86.9201 52.8669 86.7674 52.2561 86.7708C51.6472 86.7727 51.0484 86.9288 50.516 87.2256C49.9836 87.5222 49.5345 87.9491 49.2108 88.4668C48.8867 88.9846 48.6987 89.5764 48.6641 90.1864C48.6296 90.7968 48.7493 91.4062 49.0123 91.9574L52.2561 98.687Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0924 86.7925L52.256 98.687L49.0122 91.9543C48.7532 91.4171 48.6313 90.8234 48.6575 90.227C48.6841 89.6306 48.8579 89.0502 49.1634 88.5381C49.469 88.0259 49.8967 87.5984 50.4082 87.2935C50.9196 86.9889 51.4983 86.8166 52.0924 86.7925Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8579 107.654L60.5585 102.024C60.944 101.562 61.2064 101.008 61.3209 100.417C61.4354 99.8246 61.3983 99.2133 61.2135 98.6398C61.0283 98.066 60.7014 97.5488 60.2628 97.1368C59.8246 96.7244 59.2891 96.4303 58.7067 96.2829C58.1249 96.1379 57.5159 96.1428 56.9366 96.2974C56.3573 96.452 55.8264 96.751 55.3931 97.1665C54.9598 97.5826 54.6382 98.1016 54.4582 98.6754C54.2783 99.2495 54.2459 99.8602 54.3641 100.45L55.8579 107.654Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3734 100.453C54.2555 99.8632 54.2879 99.2528 54.4678 98.6787C54.6474 98.1049 54.969 97.5856 55.4024 97.1698C55.8357 96.754 56.3669 96.455 56.9462 96.3004C57.5255 96.1458 58.1342 96.1409 58.716 96.2859L55.8209 107.625L54.3734 100.453Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5183 114.361L58.6634 108.98C58.8359 108.538 59.118 108.147 59.4828 107.845C59.8476 107.543 60.2834 107.339 60.7486 107.254C61.214 107.168 61.6933 107.203 62.1411 107.356C62.589 107.508 62.9908 107.773 63.3084 108.125C63.6319 108.473 63.8609 108.9 63.9732 109.363C64.0859 109.826 64.0785 110.31 63.9516 110.77C63.8245 111.229 63.5825 111.648 63.2482 111.986C62.9143 112.325 62.4992 112.572 62.043 112.704L56.5183 114.361Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5183 114.361L58.6634 108.98C58.8359 108.538 59.118 108.147 59.4828 107.845C59.8476 107.543 60.2834 107.339 60.7486 107.254C61.214 107.168 61.6933 107.203 62.1411 107.356C62.589 107.508 62.9908 107.773 63.3084 108.125C63.6319 108.473 63.8609 108.9 63.9732 109.363C64.0859 109.826 64.0785 110.31 63.9516 110.77C63.8245 111.229 63.5825 111.648 63.2482 111.986C62.9143 112.325 62.4992 112.572 62.043 112.704L56.5183 114.361Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2282 108.013L56.5184 114.346L58.6634 108.964C58.8378 108.537 59.1144 108.159 59.4684 107.863C59.8224 107.568 60.2431 107.364 60.694 107.271C61.1446 107.176 61.6113 107.195 62.0532 107.324C62.4952 107.454 62.8986 107.69 63.2282 108.013Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9444 109.643L50.608 103.957C50.4148 103.495 50.1089 103.089 49.7182 102.777C49.3274 102.465 48.8645 102.256 48.3725 102.171C47.8802 102.086 47.3746 102.127 46.9024 102.289C46.4299 102.452 46.0061 102.732 45.6697 103.102C45.3348 103.477 45.1006 103.931 44.9891 104.422C44.8777 104.914 44.8929 105.425 45.0333 105.908C45.1734 106.392 45.4342 106.831 45.7907 107.186C46.1472 107.54 46.5879 107.797 47.0709 107.932L52.9444 109.643Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9444 109.643L50.608 103.957C50.4148 103.495 50.1089 103.089 49.7182 102.777C49.3274 102.465 48.8645 102.256 48.3725 102.171C47.8802 102.086 47.3746 102.127 46.9024 102.289C46.4299 102.452 46.0061 102.732 45.6697 103.102C45.3348 103.477 45.1006 103.931 44.9891 104.422C44.8777 104.914 44.8929 105.425 45.0333 105.908C45.1734 106.392 45.4342 106.831 45.7907 107.186C46.1472 107.54 46.5879 107.797 47.0709 107.932L52.9444 109.643Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6696 116.623L52.753 116.512L41.5925 110.386L41.5369 110.498L52.6696 116.623Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8826 115.548L46.8425 110.008C46.5144 109.553 46.0761 109.19 45.5693 108.952C45.0625 108.714 44.5036 108.609 43.9453 108.648C43.3869 108.687 42.8477 108.867 42.3786 109.173C41.9092 109.479 41.5249 109.9 41.2622 110.396C41.0005 110.891 40.8678 111.446 40.8764 112.006C40.8851 112.568 41.0351 113.117 41.3122 113.605C41.5894 114.092 41.9851 114.501 42.4619 114.793C42.9388 115.086 43.4817 115.253 44.04 115.279L50.8826 115.548Z",
    fill: "#3562FF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8826 115.548L46.8425 110.008C46.5144 109.553 46.0761 109.19 45.5693 108.952C45.0625 108.714 44.5036 108.609 43.9453 108.648C43.3869 108.687 42.8477 108.867 42.3786 109.173C41.9092 109.479 41.5249 109.9 41.2622 110.396C41.0005 110.891 40.8678 111.446 40.8764 112.006C40.8851 112.568 41.0351 113.117 41.3122 113.605C41.5894 114.092 41.9851 114.501 42.4619 114.793C42.9388 115.086 43.4817 115.253 44.04 115.279L50.8826 115.548Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1512 113.311C41.403 113.875 41.8067 114.357 42.3166 114.702C42.8262 115.048 43.4222 115.245 44.037 115.269L50.8827 115.545L41.2623 110.386C41.0228 110.833 40.8885 111.329 40.8691 111.836C40.8499 112.343 40.9462 112.847 41.1512 113.311Z",
    fill: "#17AAB9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6078 103.957L52.9442 109.643L45.6603 103.102C45.9979 102.732 46.4226 102.454 46.8955 102.292C47.3683 102.129 47.8742 102.089 48.3665 102.174C48.859 102.26 49.3223 102.467 49.7137 102.779C50.1053 103.09 50.4127 103.496 50.6078 103.957Z",
    fill: "#83CEBC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.274 239.434H0.188128C0.162938 239.434 0.139024 239.355 0.116066 239.277C0.0934265 239.16 0.0723816 238.964 0.0551631 238.768C0.0373068 238.534 0.0232769 238.299 0.0143488 238.025C0.00446406 237.712 0 237.438 0 237.125C0 236.812 0.00446406 236.538 0.0143488 236.224C0.0232769 235.951 0.0373068 235.716 0.0551631 235.481C0.0723816 235.285 0.0934265 235.09 0.116066 234.972C0.139024 234.894 0.162938 234.816 0.188128 234.816H361.312C361.337 234.816 361.363 234.855 361.385 234.972C361.408 235.05 361.43 235.246 361.449 235.442C361.465 235.677 361.481 235.951 361.487 236.224C361.496 236.498 361.5 236.812 361.5 237.125C361.493 237.79 361.468 238.416 361.426 238.847C361.382 239.277 361.328 239.473 361.274 239.434Z",
    fill: "#EFF0F3"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.376 1.67188C157.611 0.940674 155.531 4.93133 154.543 10.0374C153.555 15.1434 154.105 18.3688 157.87 19.1C161.636 19.8312 165.278 17.43 166.253 12.3147C167.228 7.19931 165.151 2.40619 161.376 1.67188Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.861 228.272L191.139 228.749L183.339 222.927C182.61 222.386 182.059 221.637 181.759 220.777C181.414 219.848 181.775 219.2 181.87 218.686C182.13 217.298 182.836 212.799 182.836 212.799L170.926 212.83L169.861 228.272Z",
    fill: "#FCA176"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.775 220.477V220.353C173.742 220.021 173.837 219.689 174.042 219.426C174.247 219.164 174.545 218.991 174.873 218.943L181.87 218.686L182.129 217.298H170.617V217.338L170.102 224.799L180.512 226.89L177.673 225.756C175.688 224.957 173.96 222.593 173.775 220.477Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.349 226.986L157.083 225.697L157.657 217.301L157.867 212.721L146.398 212.799L146.546 217.301L147.349 226.986Z",
    fill: "#FCA176"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.191 225.362L149.404 220.715C149.42 220.419 149.539 220.137 149.739 219.919C149.94 219.701 150.21 219.559 150.503 219.519L157.568 218.59L157.654 217.316H146.543L147.413 227.745L149.191 225.362Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.58 93.5221L146.543 217.301H157.654L162.222 116.385C162.249 116.064 162.397 115.765 162.634 115.549C162.872 115.333 163.182 115.215 163.503 115.22C163.819 115.221 164.124 115.342 164.356 115.557C164.588 115.773 164.73 116.068 164.756 116.385L174.913 161.311L170.614 217.301H182.126L190.484 163.966C190.754 162.247 190.807 160.502 190.642 158.77L184.052 89.1225L140.58 93.5221Z",
    fill: "#15247C"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.197 222.574L148.472 222.298C149.503 221.294 150.887 220.74 152.323 220.758C153.759 220.775 155.129 221.363 156.136 222.391L156.287 222.574C156.791 223.102 157.075 223.804 157.08 224.535V225.7C157.076 226.376 157.18 227.049 157.389 227.693L158.333 230.843C158.577 231.606 158.7 232.402 158.7 233.205V233.604C158.686 233.908 158.553 234.196 158.33 234.401C158.107 234.608 157.812 234.716 157.509 234.707H146.562C146.411 234.713 146.26 234.691 146.118 234.639C145.977 234.589 145.846 234.509 145.735 234.406C145.624 234.304 145.535 234.18 145.472 234.041C145.41 233.904 145.375 233.756 145.37 233.604V233.452C145.37 232.523 145.525 231.603 145.827 230.726L146.926 227.628C147.181 226.92 147.316 226.174 147.324 225.421L147.355 224.532C147.396 223.8 147.695 223.106 148.197 222.574Z",
    fill: "#494D70"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.358 233.452V233.604C145.372 233.908 145.505 234.196 145.728 234.401C145.951 234.608 146.246 234.716 146.549 234.707H157.509C157.66 234.713 157.811 234.692 157.952 234.639C158.094 234.589 158.224 234.509 158.335 234.407C158.446 234.304 158.536 234.18 158.598 234.041C158.661 233.905 158.696 233.756 158.701 233.604V233.204C158.706 233.049 158.695 232.898 158.67 232.746H145.358V233.452Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.367 224.749V232.495C169.367 232.792 169.424 233.09 169.538 233.362C169.651 233.638 169.817 233.889 170.027 234.1C170.237 234.311 170.486 234.478 170.761 234.592C171.035 234.707 171.33 234.763 171.626 234.763H197.879C198.131 234.763 198.371 234.661 198.548 234.484C198.726 234.304 198.826 234.063 198.827 233.812C198.821 232.91 198.535 232.033 198.01 231.302C197.484 230.572 196.745 230.024 195.895 229.734L189.972 227.773L182.463 221.92C182.085 221.624 181.618 221.468 181.138 221.48C180.66 221.491 180.2 221.669 179.836 221.982L176.5 224.839C176.259 225.045 175.971 225.187 175.661 225.252C175.352 225.316 175.031 225.301 174.728 225.207L170.515 223.891C170.382 223.853 170.243 223.847 170.106 223.873C169.971 223.898 169.842 223.954 169.731 224.037C169.621 224.12 169.53 224.227 169.467 224.351C169.404 224.474 169.37 224.61 169.367 224.749Z",
    fill: "#494D70"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.626 234.769H197.88C198.13 234.769 198.371 234.667 198.549 234.49C198.726 234.311 198.826 234.069 198.827 233.818C198.834 233.496 198.792 233.177 198.704 232.867H169.401C169.488 233.397 169.759 233.88 170.167 234.227C170.574 234.574 171.091 234.766 171.626 234.769Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.312 225.025C182.255 225.024 182.201 225.002 182.16 224.963C182.138 224.941 182.121 224.915 182.109 224.885C182.097 224.857 182.091 224.825 182.091 224.794C182.091 224.763 182.097 224.732 182.109 224.703C182.121 224.674 182.138 224.647 182.16 224.625L183.747 222.909C183.769 222.887 183.795 222.869 183.824 222.857C183.853 222.845 183.884 222.839 183.915 222.839C183.946 222.839 183.977 222.845 184.006 222.857C184.035 222.869 184.061 222.887 184.083 222.909C184.105 222.931 184.123 222.957 184.135 222.986C184.147 223.015 184.153 223.046 184.153 223.077C184.153 223.109 184.147 223.14 184.135 223.169C184.123 223.198 184.105 223.224 184.083 223.247L182.497 224.957C182.441 224.993 182.378 225.017 182.312 225.025Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.565 226.004C183.508 226.003 183.454 225.981 183.414 225.942C183.391 225.92 183.374 225.894 183.362 225.864C183.35 225.835 183.344 225.804 183.344 225.773C183.344 225.742 183.35 225.71 183.362 225.682C183.374 225.652 183.391 225.626 183.414 225.604L185 223.888C185.044 223.843 185.105 223.818 185.168 223.818C185.231 223.818 185.292 223.843 185.336 223.888C185.381 223.932 185.406 223.993 185.406 224.057C185.406 224.12 185.381 224.18 185.336 224.225L183.75 225.942C183.693 225.975 183.63 225.997 183.565 226.004Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.815 226.986C184.758 226.985 184.704 226.963 184.664 226.924C184.641 226.902 184.624 226.876 184.612 226.847C184.6 226.818 184.594 226.786 184.594 226.755C184.594 226.724 184.6 226.693 184.612 226.664C184.624 226.635 184.641 226.609 184.664 226.586L186.25 224.87C186.295 224.825 186.355 224.8 186.418 224.8C186.481 224.8 186.542 224.825 186.586 224.87C186.631 224.915 186.656 224.975 186.656 225.039C186.656 225.102 186.631 225.163 186.586 225.208L185 226.924C184.948 226.968 184.882 226.99 184.815 226.986Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.305 225.177C154.262 225.181 154.218 225.17 154.182 225.146C153.552 224.846 152.864 224.69 152.166 224.69C151.469 224.69 150.781 224.846 150.151 225.146C150.087 225.172 150.015 225.173 149.95 225.149C149.885 225.124 149.832 225.076 149.801 225.013C149.77 224.951 149.764 224.879 149.783 224.812C149.803 224.745 149.847 224.688 149.907 224.653C150.615 224.304 151.393 224.123 152.182 224.123C152.97 224.123 153.749 224.304 154.457 224.653C154.516 224.691 154.561 224.748 154.583 224.815C154.606 224.883 154.604 224.955 154.58 225.022C154.552 225.07 154.512 225.11 154.464 225.137C154.416 225.164 154.361 225.178 154.305 225.177Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.305 226.586C154.262 226.591 154.218 226.58 154.182 226.555C153.552 226.254 152.864 226.098 152.166 226.098C151.469 226.098 150.78 226.254 150.151 226.555C150.087 226.582 150.015 226.583 149.95 226.558C149.885 226.534 149.832 226.485 149.801 226.423C149.77 226.36 149.764 226.289 149.783 226.222C149.803 226.155 149.847 226.098 149.907 226.063C150.615 225.714 151.393 225.533 152.182 225.533C152.97 225.533 153.749 225.714 154.457 226.063C154.516 226.101 154.561 226.158 154.583 226.225C154.606 226.292 154.604 226.365 154.58 226.431C154.552 226.48 154.512 226.519 154.464 226.547C154.416 226.574 154.361 226.588 154.305 226.586Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.305 227.965C154.262 227.97 154.218 227.959 154.182 227.934C153.552 227.634 152.864 227.478 152.166 227.478C151.469 227.478 150.781 227.634 150.151 227.934C150.087 227.961 150.015 227.962 149.95 227.937C149.885 227.912 149.832 227.864 149.801 227.802C149.77 227.739 149.764 227.667 149.783 227.601C149.803 227.534 149.847 227.477 149.907 227.442C150.615 227.093 151.393 226.911 152.182 226.911C152.97 226.911 153.749 227.093 154.457 227.442C154.516 227.48 154.561 227.537 154.583 227.604C154.606 227.671 154.604 227.744 154.58 227.81C154.552 227.859 154.512 227.898 154.464 227.925C154.416 227.953 154.361 227.966 154.305 227.965Z",
    fill: "white"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.673 15.4843C171.673 15.4843 160.932 5.40227 158.636 14.7283L157.981 17.1295L154.401 31.1773C154.33 31.5398 168.29 34.9914 168.33 34.5297L168.571 32.0201L169.188 24.5562C169.488 23.8777 169.709 23.1666 169.846 22.4369C170.697 18.7592 171.673 15.4843 171.673 15.4843Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.441 16.3426C175.768 16.3426 177.654 14.4492 177.654 12.1133C177.654 9.77749 175.768 7.88409 173.441 7.88409C171.114 7.88409 169.228 9.77749 169.228 12.1133C169.228 14.4492 171.114 16.3426 173.441 16.3426Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.339 9.10485C174.339 9.10485 175.154 28.2433 165.565 27.6577C157.262 27.1651 158.809 14.3348 158.809 14.3348L160.784 6.19861L174.339 9.10485Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.837 6.73147C177.401 3.81345 174.887 0.869725 171.222 0.156798C167.557 -0.556439 164.129 1.23099 163.566 4.149C163.003 7.06702 165.517 10.0104 169.182 10.7237C172.846 11.4366 176.274 9.64917 176.837 6.73147Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.95 1.8764C159.654 1.43024 157.339 3.42556 156.778 6.3318C156.216 9.23804 157.5 12.5873 159.796 13.0335C162.092 13.4797 164.528 10.8647 165.089 7.94913C165.651 5.0336 164.247 2.31946 161.95 1.8764Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.867 17.7306C157.867 17.7306 158.636 17.9413 159.102 17.6934L157.389 19.4811L157.867 17.7306Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.111 10.589C173.697 10.7591 173.271 10.8966 172.836 11.001C172.785 11.0131 172.731 11.0047 172.686 10.9775C172.641 10.9505 172.609 10.9065 172.595 10.8554C172.587 10.83 172.584 10.803 172.587 10.7764C172.59 10.7498 172.599 10.724 172.613 10.7011C172.627 10.6782 172.645 10.6584 172.667 10.6435C172.689 10.6283 172.714 10.6181 172.741 10.6137C172.741 10.6137 173.954 10.1769 174.071 10.1273C174.419 9.94884 174.751 9.74156 175.065 9.50763C175.085 9.49028 175.108 9.47696 175.134 9.46859C175.159 9.45992 175.186 9.45682 175.213 9.45868C175.239 9.46085 175.265 9.46797 175.289 9.48006C175.313 9.49214 175.334 9.50887 175.352 9.52932C175.369 9.54977 175.383 9.57332 175.391 9.59872C175.399 9.62413 175.403 9.65109 175.4 9.67804C175.398 9.70469 175.391 9.73071 175.379 9.75457C175.367 9.77874 175.351 9.80012 175.33 9.81747C174.958 10.1261 174.549 10.3854 174.111 10.589Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.744 29.6561L169.022 26.7995C167.833 27.5679 166.037 27.9954 163.512 27.224C162.274 26.8336 161.122 26.2089 160.117 25.3835C160 25.272 159.92 25.2472 159.809 25.2999C159.792 25.3157 159.778 25.3346 159.769 25.3557C159.76 25.3767 159.755 25.3993 159.755 25.4223C159.755 25.4452 159.76 25.4678 159.769 25.4889C159.778 25.51 159.792 25.5289 159.809 25.5447C160.117 25.9288 161.373 26.8986 163.512 27.6422C166.179 30.2015 168.744 29.6561 168.744 29.6561Z",
    fill: "#ECBCA7"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.506 96.5895H153.58C153.548 96.5898 153.516 96.5839 153.486 96.5718C153.457 96.5594 153.43 96.5414 153.407 96.5188C153.384 96.4959 153.366 96.4686 153.354 96.4389C153.342 96.4088 153.336 96.3769 153.336 96.3447C153.341 96.2815 153.369 96.222 153.413 96.1771C153.458 96.1321 153.517 96.1049 153.58 96.0999H179.506C179.571 96.0999 179.633 96.1256 179.679 96.1715C179.724 96.2177 179.75 96.2799 179.75 96.3447C179.75 96.4097 179.724 96.4717 179.679 96.5179C179.633 96.5637 179.571 96.5895 179.506 96.5895Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.935 99.3655H140.984L135.855 63.4063L144.367 42.0463L150.33 31.45L154.278 31.6204C154.278 31.6204 153.713 35.8094 161.91 36.9434C168.895 37.9131 168.562 32.0077 168.562 32.0077L181.08 32.8598L184.935 99.3655Z",
    fill: "#336FFF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.403 34.277C168.825 32.0933 166.011 29.7088 162.118 28.9516C158.226 28.194 154.729 29.3503 154.307 31.5344C153.885 33.7181 156.699 36.1025 160.592 36.8601C164.484 37.6173 167.981 36.461 168.403 34.277Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.969 37.0425L128.256 68.596C127.932 70.385 128.227 72.2316 129.093 73.8291L144.864 102.919C144.864 102.919 143.447 107.065 146.793 110.396C146.793 110.396 150.947 106.585 152.747 102.721L140.583 71.5456L144.555 57.8943L133.969 37.0425Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.558 56.717L189.944 56.0973L187.272 38.9387C187.011 37.2842 186.196 35.7685 184.962 34.642C183.727 33.5151 182.147 32.8449 180.482 32.7421L168.528 32.0201L177.558 56.717Z",
    fill: "#336FFF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.272 42.1332L144.207 59.0594H129.855L133.966 37.0457C134.291 35.302 135.233 33.7348 136.618 32.6331C138.003 31.5316 139.738 30.9693 141.503 31.0504L154.278 31.6205L149.272 42.1332Z",
    fill: "#336FFF"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.725 47.3507L140.58 71.5487L150.299 96.45H154.66L146.815 70.1142L148.506 47.4963C148.517 47.3959 148.49 47.2949 148.43 47.2137C148.37 47.1326 148.282 47.0774 148.183 47.0588C148.084 47.0405 147.982 47.0604 147.897 47.1143C147.812 47.1685 147.751 47.2531 147.725 47.3507Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.432 115.895C160.146 116.615 159.064 117.65 158.286 118.905C157.509 120.16 157.062 121.592 156.988 123.068L152.231 217.301H157.654L162.259 116.49C162.27 116.213 162.364 115.947 162.529 115.725C162.695 115.504 162.923 115.338 163.185 115.251C162.571 115.373 161.98 115.591 161.432 115.895Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.66 96.4501L156.244 101.349C156.244 101.349 151.503 107.635 146.796 110.396C146.796 110.396 151.065 106.445 152.75 102.721L150.302 96.4501H154.66Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.463 56.4071L181.806 45.3213C181.794 45.2392 181.815 45.1558 181.865 45.0895C181.915 45.0232 181.989 44.9796 182.071 44.9681C182.153 44.9566 182.236 44.9783 182.302 45.0282C182.368 45.0781 182.411 45.1524 182.423 45.2345L184.938 56.3607L182.463 56.4071Z",
    fill: "black"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.966 13.0304C159.966 13.0304 158.991 11.1064 157.04 11.5401C154.827 12.0452 154.352 16.7608 157.747 17.7027C159.515 18.2016 159.361 17.0831 159.333 15.6082C159.468 14.7317 159.679 13.8691 159.966 13.0304Z",
    fill: "#FBD0BC"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.719 12.7206C156.878 12.6382 157.053 12.5889 157.231 12.5756C157.41 12.5623 157.589 12.5852 157.759 12.6431C157.918 12.719 158.059 12.8284 158.172 12.9638C158.286 13.0989 158.369 13.2569 158.417 13.427C158.563 13.8543 158.593 14.3134 158.503 14.7562L158.457 15.1528C158.446 15.2085 158.414 15.2581 158.367 15.29C158.32 15.3219 158.262 15.3337 158.207 15.3232C158.151 15.3126 158.102 15.2801 158.07 15.233C158.038 15.1859 158.026 15.128 158.037 15.0722L158.083 14.6756C158.142 14.3063 158.119 13.9286 158.015 13.5695C157.943 13.3421 157.793 13.1469 157.593 13.018C157.362 12.953 157.116 12.9715 156.898 13.0707C156.844 13.0902 156.785 13.089 156.732 13.0673C156.679 13.0456 156.636 13.0047 156.611 12.953C156.559 12.9189 156.611 12.8042 156.719 12.7206Z",
    fill: "black"
  }));
};

var css_248z$f = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.err-msg {\n  color: #f55c55;\n  font-size: 14px;\n  line-height: 20px;\n}\n.svg-wrap svg {\n  width: 100% !important;\n}\n.felo-join-org-dialog *::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\n.felo-join-org-dialog *::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px #fff;\n}\n.felo-join-org-dialog *::-webkit-scrollbar-thumb {\n  background-color: #d8d6d6;\n  border-radius: 4px;\n  outline: 1px solid #d8d6d6;\n}\n.felo-join-org-dialog-header {\n  padding-top: 24px;\n}\n.felo-join-org-dialog-header .felo-join-org-dialog-title {\n  max-width: calc(100% - 40px);\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n}\n.felo-join-org-dialog-body {\n  position: relative;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  padding: 20px 0;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content.first-pane {\n  margin: 80px 0;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .column-wrap {\n  display: flex;\n  flex-direction: column;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .form-item {\n  margin-bottom: 0;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .form-item input,\n.felo-join-org-dialog-body .felo-join-org-dialog-content .form-item button {\n  border-radius: 4px;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .create-org-svg-wrap {\n  margin-bottom: 25px;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .create-org-svg-wrap svg {\n  width: 200px;\n  height: 200px;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .join-org-svg-wrap {\n  margin-bottom: 15px;\n}\n.felo-join-org-dialog-body .felo-join-org-dialog-content .join-org-svg-wrap svg {\n  width: 200px;\n  height: 200px;\n}\n.felo-join-org-dialog-body .form-not-explain .ant-form-item-explain {\n  min-height: 0;\n}\n.felo-join-org-dialog-footer {\n  display: flex;\n  justify-content: space-between;\n}\n.felo-join-org-dialog-footer button + button {\n  margin-left: 12px;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn) {\n  min-width: 80px;\n  height: 32px;\n  padding-right: 7px;\n  padding-left: 7px;\n  color: #797879;\n  line-height: 20px;\n  background: transparent;\n  border: 1px solid #797879;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn):hover {\n  background-color: #f1f3f5;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn):active {\n  background-color: #ececec;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn).primary {\n  color: white;\n  background-color: #2994ff;\n  border-style: none;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn).primary:hover {\n  background-color: #47a3ff;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn).primary:active {\n  background-color: #3288df;\n}\n.felo-join-org-dialog-footer button:not(.ant-btn).primary[disabled] {\n  color: #797879;\n  background-color: #e4e4e4;\n  cursor: not-allowed;\n}\n.felo-join-org-dialog-options-wrap + .felo-join-org-dialog-options-wrap {\n  margin-top: 30px;\n}\n.felo-join-org-dialog-options-wrap {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 650px;\n  margin: 0 auto;\n  padding: 18px 20px;\n  border: 2px solid #fff;\n  border-radius: 8px;\n  box-shadow: 0 0 10px 0 rgba(206, 210, 222, 0.5);\n  cursor: pointer;\n  transition: all 0.2s linear;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.felo-join-org-dialog-options-wrap:hover {\n  background-color: #f2f8ff;\n  border-color: #9ec9f5;\n  box-shadow: 0 0 10px 0 #ced2de;\n}\n.felo-join-org-dialog-options-wrap:hover .options-icon {\n  color: #5ba1e7;\n}\n.felo-join-org-dialog-options-wrap .options-wrap + .options-wrap {\n  margin-top: 15px;\n}\n.felo-join-org-dialog-options-wrap .options-info-title {\n  color: #000;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n}\n.felo-join-org-dialog-options-wrap .options-info-desc {\n  margin-top: 10px;\n  color: #9d9d9d;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n.felo-join-org-dialog-options-wrap .options-icon {\n  margin-left: 30px;\n}\n";
styleInject(css_248z$f);

var SelectOptions = function SelectOptions(props) {
  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('join-org-dialog');
  return /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-options-wrap ").concat(props.className),
    onClick: props.onClick
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "options-info"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "options-info-title"
  }, props.title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "options-info-desc"
  }, props.desc)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "options-icon"
  }, /*#__PURE__*/React__default['default'].createElement(Icon.RightOutlined, {
    size: 24
  })));
};

var ENTER_ORG_TYPE = {
  CREATE: 1,
  JOINCODE: 2
};
var LANG = navigator.language.substr(0, 2) || '';
var TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || '';

var JoinOrgDialog = function JoinOrgDialog(props) {
  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('join-org-dialog');

  var _useLocaleReceiver = useLocaleReceiver('PageHeader'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errMsg = _useState4[0],
      setErrMsg = _useState4[1];

  var _useState5 = React.useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      createTeamMethodType = _useState6[0],
      setCreateTeamMethodType = _useState6[1];

  var carouselHeaderRef = React.useRef();
  var carouselContentRef = React.useRef();
  var SelectOrgOptionsArr = [{
    title: locale.titleJoinNewOrg,
    desc: locale.descJoinNewOrg,
    type: ENTER_ORG_TYPE.JOINCODE
  }, {
    title: locale.titleCreateNewOrg,
    desc: locale.descCreateNewOrg,
    type: ENTER_ORG_TYPE.CREATE
  }];

  var carouselAfterChange = function carouselAfterChange(current) {
    carouselHeaderRef.current.goTo(current);
    setErrMsg('');
  };

  var create = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(teamName) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return post$1(props.baseURL + '/v5/web/team.create', {
                team_name: teamName,
                lang: LANG,
                timezone: TIMEZONE
              }, props.token);

            case 3:
              res = _context.sent;
              return _context.abrupt("return", res);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function create(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var join = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(teamId) {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return post$1(props.baseURL + '/v5/web/team.join', {
                invite_code: teamId,
                lang: LANG,
                timezone: TIMEZONE
              }, props.token);

            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function join(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var isPromise = function isPromise(val) {
    return val !== undefined && val !== null && typeof val.then === 'function' && typeof val.catch === 'function';
  };

  var submit = function submit(values) {
    if (!props.currentInfo) return;
    var res;
    setLoading(true);

    switch (createTeamMethodType) {
      case ENTER_ORG_TYPE.CREATE:
        res = create(values.orgName.trim());
        break;

      case ENTER_ORG_TYPE.JOINCODE:
        res = join(values.orgCode.trim());
        break;
    }

    if (isPromise(res)) {
      res.then(function (rsp) {
        setLoading(false);

        if (rsp.response) {
          rsp = rsp.response.data;
        }

        if (!rsp.status.ok) {
          var _rsp$status = rsp.status,
              err_code = _rsp$status.err_code,
              err_metadata = _rsp$status.err_metadata;

          switch (err_code) {
            case 'missing_required_param':
              setErrMsg(locale.errMsgWrongOrgCode);
              break;

            case 'team_not_exist':
              setErrMsg(locale.errMsgTeamNotExist);
              break;

            default:
              var _errMsg = err_metadata.messages[0];
              setErrMsg(_errMsg);
              break;
          }

          return;
        }

        var info = rsp.data.certificate;
        props.submit(info);
        props.onClose();
      });
    } else {
      setErrMsg('Something is wrong');
      setLoading(false);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(Dialog__default['default'], {
    title: '',
    visible: props.visible,
    animation: "zoom",
    maskAnimation: "fade",
    onClose: props.onClose,
    destroyOnClose: true,
    wrapClassName: "".concat(prefixCls, " center"),
    width: '90vw',
    style: {
      maxWidth: 900
    },
    closeIcon: /*#__PURE__*/React__default['default'].createElement(Icon.PlusOutlined, {
      rotate: 45,
      style: {
        position: 'relative',
        top: 12
      }
    })
  }, /*#__PURE__*/React__default['default'].createElement("section", null, /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-header")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-title")
  }, /*#__PURE__*/React__default['default'].createElement(_Carousel__default['default'], {
    ref: carouselHeaderRef,
    effect: "fade",
    dots: false
  }, /*#__PURE__*/React__default['default'].createElement("div", null, locale.addOrg), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "text",
    size: "small",
    onClick: function onClick() {
      carouselContentRef.current.prev();
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon.ArrowLeftOutlined, {
    size: 16
  })))))), /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-body")
  }, /*#__PURE__*/React__default['default'].createElement(_Carousel__default['default'], {
    ref: carouselContentRef,
    afterChange: carouselAfterChange,
    dots: false
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-content first-pane")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "svg-wrap",
    style: {
      marginRight: 80
    }
  }, /*#__PURE__*/React__default['default'].createElement(SigninOrgBg, null)), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      marginRight: 20
    }
  }, SelectOrgOptionsArr.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement(SelectOptions, {
      key: index,
      className: "enter-org-option",
      title: item.title,
      desc: item.desc,
      onClick: function onClick() {
        setCreateTeamMethodType(item.type);
        carouselContentRef.current.next();
      }
    });
  })))), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-content center form-not-explain")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "center column-wrap"
  }, /*#__PURE__*/React__default['default'].createElement("div", null, createTeamMethodType == ENTER_ORG_TYPE.CREATE ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "create-org-svg-wrap"
  }, /*#__PURE__*/React__default['default'].createElement(createOrgBg, null)) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: "join-org-svg-wrap"
  }, /*#__PURE__*/React__default['default'].createElement(joinOrgBg, null))), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      width: 350
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Form__default['default'], {
    onFinish: submit,
    validateMessages: {
      required: ''
    },
    layout: "vertical",
    autoComplete: "off",
    requiredMark: false,
    onChange: function onChange() {
      setErrMsg('');
    }
  }, createTeamMethodType == ENTER_ORG_TYPE.CREATE && /*#__PURE__*/React__default['default'].createElement(_Form__default['default'].Item, {
    label: locale.createTeamNameNow,
    name: "orgName",
    rules: [{
      required: true
    }],
    className: 'form-item'
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
    placeholder: locale.labelName,
    disabled: loading,
    maxLength: 60
  })), createTeamMethodType == ENTER_ORG_TYPE.JOINCODE && /*#__PURE__*/React__default['default'].createElement(_Form__default['default'].Item, {
    label: locale.labelJoinOrgCode,
    name: "orgCode",
    rules: [{
      required: true
    }],
    className: 'form-item'
  }, /*#__PURE__*/React__default['default'].createElement(_Input__default['default'], {
    placeholder: locale.labelOrgCode,
    disabled: loading,
    maxLength: 8
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "err-msg"
  }, errMsg, " \xA0"), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React__default['default'].createElement(_Form__default['default'].Item, {
    className: 'form-item'
  }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    loading: loading,
    block: true,
    type: "primary",
    htmlType: "submit"
  }, createTeamMethodType == ENTER_ORG_TYPE.CREATE ? locale.create : locale.join))))))))))));
};

var css_248z$g = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.felo-switch-org-dialog *::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\n.felo-switch-org-dialog *::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px #fff;\n}\n.felo-switch-org-dialog *::-webkit-scrollbar-thumb {\n  background-color: #d8d6d6;\n  border-radius: 4px;\n  outline: 1px solid #d8d6d6;\n}\n.felo-switch-org-dialog button .icon + span {\n  margin-left: 10px;\n}\n.felo-switch-org-dialog-header {\n  padding-top: 24px;\n}\n.felo-switch-org-dialog-header .felo-switch-org-dialog-title {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n}\n.felo-switch-org-dialog-body {\n  position: relative;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap {\n  min-height: 150px;\n  max-height: 60vh;\n  margin: 10px 0 30px;\n  padding: 0 8px;\n  overflow-y: auto;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-account-info {\n  position: -webkit-sticky;\n  position: sticky;\n  top: -6px;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 4px;\n  background-color: #fff;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-account-info .account {\n  display: block;\n  margin: 0;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap {\n  margin: 8px 0 15px;\n  padding: 8px;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.08) 0 0 3px 1px;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul {\n  margin: 0;\n  padding: 0;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li + li {\n  border-top: 1px solid #e0e5eb;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  list-style: none;\n  cursor: pointer;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li:hover {\n  background-color: #eee;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li .team-info {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  min-width: 0;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li .team-info .avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  color: #ffffff;\n  font-size: 16px;\n  line-height: 18px;\n  background-color: #c9c9c9;\n  border-radius: 8px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-list-wrap .felo-switch-org-dialog-org-wrap ul li .team-info .name {\n  max-width: 90%;\n  margin-left: 10px;\n  overflow: hidden;\n  font-size: 16px;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #f1f6fa;\n  border-radius: 8px;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .text-wrap {\n  display: flex;\n  align-items: center;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .text-wrap svg + span {\n  margin-left: 10px;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px;\n  background-color: #fff;\n  border: 1px solid #d3d3d3;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .add-btn:hover {\n  background-color: #f7f7f7;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .add-btn:active {\n  background-color: #ebebeb;\n}\n.felo-switch-org-dialog-body .felo-switch-org-dialog-add-account .add-btn .icon + span {\n  margin-left: 10px;\n}\n.felo-switch-org-dialog-footer {\n  display: flex;\n  justify-content: space-between;\n}\n.felo-switch-org-dialog-footer button + button {\n  margin-left: 12px;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn) {\n  min-width: 80px;\n  height: 32px;\n  padding-right: 7px;\n  padding-left: 7px;\n  color: #797879;\n  line-height: 20px;\n  background: transparent;\n  border: 1px solid #797879;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn):hover {\n  background-color: #f1f3f5;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn):active {\n  background-color: #ececec;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn).primary {\n  color: white;\n  background-color: #2994ff;\n  border-style: none;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn).primary:hover {\n  background-color: #47a3ff;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn).primary:active {\n  background-color: #3288df;\n}\n.felo-switch-org-dialog-footer button:not(.ant-btn).primary[disabled] {\n  color: #797879;\n  background-color: #e4e4e4;\n  cursor: not-allowed;\n}\n";
styleInject(css_248z$g);

var AvatarColorsArr = ['#C6B858', '#A96C6C', '#6C78A9', '#A06CA9', '#DD8A62', '#67A6D2', '#72CADC', '#79C69A', '#6C9AA9', '#8CA96C'];

var SwitchOrgDialog = function SwitchOrgDialog(props) {
  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('switch-org-dialog');

  var _useLocaleReceiver = useLocaleReceiver('PageHeader'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var _useState = React.useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      currentInfo = _useState2[0],
      setCurrentInfo = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      currentToken = _useState4[0],
      setCurrentToken = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      accountList = _useState6[0],
      setAccountList = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      joinOrgDialogVisible = _useState8[0],
      setJoinOrgDialogVisible = _useState8[1];

  var translateToList = function translateToList(list) {
    list.forEach(function (item) {
      item.teams.forEach(function (team) {
        team.avatarColor = AvatarColorsArr[team.team_id % AvatarColorsArr.length];
      });
    });
    setAccountList(list);
  };

  var selectTeam = function selectTeam(team) {
    props.onTeamSelect(team.team_id);
  };

  var logout = function logout(item) {
    props.onLogout(item);
  };

  var toggleJoinOrgDialogVisible = function toggleJoinOrgDialogVisible() {
    setJoinOrgDialogVisible(!joinOrgDialogVisible);
  };

  var afterCreateTeam = function afterCreateTeam(info) {
    props.afterCreateTeam(info);
  };

  React.useEffect(function () {
    if (props.accountList.length) {
      translateToList(props.accountList);
    }
  }, [props.accountList]);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Dialog__default['default'], {
    title: '',
    visible: props.visible,
    animation: "zoom",
    maskAnimation: "fade",
    onClose: props.onClose,
    destroyOnClose: true,
    wrapClassName: "".concat(prefixCls, " center"),
    width: 668,
    closeIcon: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null)
  }, /*#__PURE__*/React__default['default'].createElement("section", null, /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-header")
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "".concat(prefixCls, "-title")
  }, locale.titleSelectOrg)), /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-body")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-list-wrap")
  }, accountList.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: index
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-account-info")
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "account"
    }, item.account), /*#__PURE__*/React__default['default'].createElement(_Dropdown__default['default'], {
      overlay: function overlay() {
        return /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'], {
          style: {
            border: '1px solid #EEE'
          }
        }, /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
          key: "addOrg",
          onClick: function onClick() {
            setCurrentInfo(item);
            setCurrentToken(item.teams ? item.teams[0].access_token : '');
            toggleJoinOrgDialogVisible();
          }
        }, locale.addOrg), /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
          key: "logout",
          onClick: function onClick() {
            logout(item);
          }
        }, locale.logout));
      },
      trigger: ['click']
    }, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      type: 'text',
      size: 'small',
      className: "more"
    }, /*#__PURE__*/React__default['default'].createElement(Icon.MoreOutlined, {
      rotate: 90
    })))), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-org-wrap")
    }, /*#__PURE__*/React__default['default'].createElement("ul", null, item.teams.map(function (team) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: team.team_id,
        onClick: function onClick() {
          selectTeam(team);
        }
      }, /*#__PURE__*/React__default['default'].createElement("span", {
        className: "team-info"
      }, /*#__PURE__*/React__default['default'].createElement("span", {
        className: "avatar",
        style: {
          backgroundColor: team.avatarColor ? team.avatarColor : '#616061'
        }
      }, team.team_name ? team.team_name[0].toLocaleUpperCase() : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon.TeamOutlined, null))), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "name"
      }, team.team_name)), /*#__PURE__*/React__default['default'].createElement("span", null, !!team.isSelected && /*#__PURE__*/React__default['default'].createElement("span", {
        style: {
          fontSize: 20
        }
      }, /*#__PURE__*/React__default['default'].createElement(Icon.CheckCircleTwoTone, {
        twoToneColor: "#00C293"
      }))));
    }))));
  }))), /*#__PURE__*/React__default['default'].createElement("section", {
    className: "".concat(prefixCls, "-footer")
  }, /*#__PURE__*/React__default['default'].createElement("span", null, props.anonymouslyFn && /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: "link",
    onClick: props.anonymouslyFn
  }, locale.loginAnonymous)), /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: props.onClose
  }, locale.cancel), /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "primary",
    onClick: props.onClose
  }, locale.confirm))))), /*#__PURE__*/React__default['default'].createElement(JoinOrgDialog, {
    visible: joinOrgDialogVisible,
    onClose: toggleJoinOrgDialogVisible,
    currentInfo: currentInfo,
    baseURL: props.baseURL,
    token: currentToken,
    submit: afterCreateTeam
  }));
};

var _Pro, _Dev;
var SelectedTeamInfoDefault = {
  id: '',
  account: '',
  access_token: '',
  avatar: '',
  avatarColor: '',
  expires_in: 0,
  isSelected: false,
  team_id: 0,
  team_name: '',
  token_type: '',
  userName: '',
  lang: '',
  timezone: ''
};
var AppKey = {
  IM: 'IM',
  Meet: 'Meet',
  Drive: 'Drive',
  Task: 'Task',
  Form: 'Form'
};
var AppUrl = {
  Pro: (_Pro = {}, _defineProperty(_Pro, AppKey.IM, 'https://im.felo.me/'), _defineProperty(_Pro, AppKey.Meet, 'https://meet.felo.me/'), _defineProperty(_Pro, AppKey.Drive, 'https://drive.felo.me/'), _defineProperty(_Pro, AppKey.Task, 'https://task.felo.me/'), _defineProperty(_Pro, AppKey.Form, 'https://form.felo.me/'), _Pro),
  Dev: (_Dev = {}, _defineProperty(_Dev, AppKey.IM, 'https://im-dev.felo.me/'), _defineProperty(_Dev, AppKey.Meet, 'https://meet-dev.felo.me/'), _defineProperty(_Dev, AppKey.Drive, 'https://drive-dev.felo.me/'), _defineProperty(_Dev, AppKey.Task, 'https://task-dev.felo.me/'), _defineProperty(_Dev, AppKey.Form, 'https://form-dev.felo.me/'), _Dev)
};
var ProOri = 'https://account.felo.me/';
var DevOri = 'https://api.sandbox.felo.me/';

var PageHeader = function PageHeader(props) {
  var _React$useContext = React__default['default'].useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('header');

  var _useLocaleReceiver = useLocaleReceiver('PageHeader'),
      _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
      locale = _useLocaleReceiver2[0];

  var isTestEnv = props.sdk.getApiOrigin().indexOf('api.sandbox.felo.me') !== -1;

  var _useState = React.useState(props.showMode === 'avatar'),
      _useState2 = _slicedToArray(_useState, 1),
      justShowAvatar = _useState2[0];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      infoVisible = _useState6[0],
      setInfoVisible = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      InvitationOrgDialogVisible = _useState8[0],
      setInvitationOrgDialogVisible = _useState8[1];

  var _useState9 = React.useState('JoinOrganization'),
      _useState10 = _slicedToArray(_useState9, 2),
      diglogType = _useState10[0],
      setDiglogType = _useState10[1];

  var _useState11 = React.useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      switchOrgDialogVisible = _useState12[0],
      setSwitchOrgDialogVisible = _useState12[1];

  var _useState13 = React.useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      accountList = _useState14[0],
      setAccountList = _useState14[1];

  var _useState15 = React.useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      loginLoading = _useState16[0],
      setLoginLoading = _useState16[1];

  var _useState17 = React.useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      loginBtnLoading = _useState18[0],
      setLoginBtnLoading = _useState18[1];

  var teamSelectQueuedRef = React.useRef([]);

  var _useState19 = React.useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      queuedState = _useState20[0],
      _setQueuedState = _useState20[1];

  var queuedStateRef = React.useRef(queuedState);

  var _useState21 = React.useState(''),
      _useState22 = _slicedToArray(_useState21, 2),
      planVersions = _useState22[0],
      setPlanVersions = _useState22[1];

  var _useState23 = React.useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      isCreator = _useState24[0],
      setIsCreator = _useState24[1];

  var setQueuedState = function setQueuedState(data) {
    _setQueuedState(data);

    queuedStateRef.current = data;
  };

  var _useState25 = React.useState(SelectedTeamInfoDefault),
      _useState26 = _slicedToArray(_useState25, 2),
      selectedTeamInfo = _useState26[0],
      _setSelectedTeamInfo = _useState26[1];

  var selectedTeamInfoRef = React.useRef(selectedTeamInfo);

  var setSelectedTeamInfo = function setSelectedTeamInfo(data) {
    _setSelectedTeamInfo(data);

    selectedTeamInfoRef.current = data;
  };

  var checkTokenExpireTimeoutRef = React.useRef();
  var checkTokenInfoTypeRef = React.useRef('none');

  var planInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, resInfo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return post$1(getUrl(AppKey.Meet) + '/api/v5/felo-minutes/public/teamPlan', {
                teamId: selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id
              }, 'Bearer ' + (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.access_token));

            case 3:
              res = _context.sent;

              if (res.success) {
                setPlanVersions(res.result.team_sub.plan_id);
              }

              _context.next = 7;
              return get$3(getUrl(AppKey.IM) + '/api/v5/web/team.get', {
                team_id: selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id
              }, 'Bearer ' + (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.access_token));

            case 7:
              resInfo = _context.sent;

              if (resInfo.data.creator) {
                if (resInfo.data.creator.id === (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.id)) {
                  setIsCreator(true);
                } else {
                  setIsCreator(false);
                }
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function planInfo() {
      return _ref.apply(this, arguments);
    };
  }();

  var login = function login() {
    if (props.loginWithNewWindow) {
      props.sdk.login({
        isPopup: true
      });
    } else {
      setLoginBtnLoading(true);
      props.sdk.login();
    }
  };

  var showInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return post$1(getUrl(AppKey.Meet) + '/api/v5/felo-minutes/public/teamPlan', {
                teamId: selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id
              }, 'Bearer ' + (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.access_token));

            case 3:
              res = _context2.sent;

              if (res.success) {
                setPlanVersions(res.result.team_sub.plan_id);
              }

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function showInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var resetSelectedTeamInfo = function resetSelectedTeamInfo() {
    setSelectedTeamInfo(undefined);
    setTimeout(function () {
      setSelectedTeamInfo(SelectedTeamInfoDefault);
    }, 0);
  };

  var onVisibleChange = function onVisibleChange(visible) {
    setInfoVisible(visible);
  };

  var closeInfoVisible = function closeInfoVisible() {
    setInfoVisible(false);
  };

  var toggleSwitchOrgDialogVisible = function toggleSwitchOrgDialogVisible() {
    setSwitchOrgDialogVisible(!switchOrgDialogVisible);
  };

  var setSelectedTeamInfoByList = function setSelectedTeamInfoByList(list, teamId) {
    var info = {};
    list.forEach(function (item) {
      item.teams.forEach(function (team) {
        if (team.team_id === teamId) {
          team.isSelected = true;
          info = _objectSpread2(_objectSpread2({}, team), {}, {
            account: item.account
          });
          return;
        }

        team.isSelected = false;
      });
    });
    setSelectedTeamInfo(info);
  };

  var selectTeam = function selectTeam(teamId) {
    var accountListCopy = accountList.concat([]);

    if (!teamId && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.account)) {
      var accountIndex = accountListCopy.findIndex(function (item) {
        return item.account === selectedTeamInfo.account;
      });
      if (accountIndex == -1) return;
      var teamIndex = accountListCopy[accountIndex].teams.findIndex(function (team) {
        return team.team_id === selectedTeamInfo.team_id;
      });

      if (teamIndex != -1) {
        accountListCopy[accountIndex].teams[teamIndex].isSelected = true;
        setAccountList(accountListCopy);
      }

      return;
    }

    setSelectedTeamInfoByList(accountListCopy, teamId || 0);
    setAccountList(accountListCopy);
  };

  var autoSelectTeam = function autoSelectTeam() {
    var account = selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.account; // 当有帐号登出登入时

    var hasAccount = accountList.findIndex(function (item) {
      return item.account === account;
    }) != -1;

    if (account && hasAccount) {
      selectTeam();
      return;
    }

    var hasTeam = false;
    accountList.map(function (item) {
      if (!item) return;
      item.teams.map(function (team) {
        if (team.team_id == props.teamId) {
          hasTeam = true;
        }
      });
    }); // 可匿名登录则让用户自行选择

    if (!hasTeam && props.anonymously && props.teamId) {
      toggleSwitchOrgDialogVisible();
    }

    var selectTeamId = !!props.teamId && hasTeam ? props.teamId : accountList[0].teams[0].team_id;
    selectTeam(selectTeamId);
  };

  var translateToAccountList = function translateToAccountList(list) {
    var newList = [];
    list.map(function (item) {
      var account = item.account_info.user_name;
      var index = newList.findIndex(function (list) {
        return list.account === account;
      });
      var _item$account_info = item.account_info,
          id = _item$account_info.id,
          avatar = _item$account_info.avatar,
          display_name = _item$account_info.display_name,
          profile = _item$account_info.profile;

      var teamInfo = _objectSpread2(_objectSpread2(_objectSpread2({}, item.team), item.login_info), {}, {
        id: id,
        avatar: avatar,
        userName: display_name,
        lang: profile.lang || '',
        timezone: profile.timezone || ''
      });

      if (index === -1) {
        var obj = {
          account: account,
          teams: [teamInfo]
        };
        newList.push(obj);
        return;
      }

      newList[index].teams.push(teamInfo);
    });
    return newList;
  };

  var teamListChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _selectedTeamInfoRef$;

      var teamList, data, hasTeam, list;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return props.sdk.getTeamList();

            case 2:
              teamList = _context3.sent;

              if (teamList.length) {
                _context3.next = 18;
                break;
              }

              setLoginLoading(true);
              setAccountList([]);
              setSwitchOrgDialogVisible(false);

              if (!props.anonymously) {
                _context3.next = 14;
                break;
              }

              _context3.next = 10;
              return props.sdk.loginAnonymous();

            case 10:
              data = _context3.sent;
              setTimeout(function () {
                setSelectedTeamInfo(data);
              }, 0);
              _context3.next = 15;
              break;

            case 14:
              resetSelectedTeamInfo();

            case 15:
              setLoginLoading(false);

              if (props.onLogout) {
                props.onLogout();
              }

              return _context3.abrupt("return");

            case 18:
              if (!(props.anonymously && props.teamId && !((_selectedTeamInfoRef$ = selectedTeamInfoRef.current) === null || _selectedTeamInfoRef$ === void 0 ? void 0 : _selectedTeamInfoRef$.id))) {
                _context3.next = 22;
                break;
              }

              hasTeam = teamList.findIndex(function (item) {
                return item.team.team_id === props.teamId;
              }) != -1;

              if (hasTeam) {
                _context3.next = 22;
                break;
              }

              return _context3.abrupt("return");

            case 22:
              list = translateToAccountList(teamList);
              setAccountList(list);
              setTimeout(function () {
                var _selectedTeamInfoRef$2;

                setSelectedTeamInfoByList(list, ((_selectedTeamInfoRef$2 = selectedTeamInfoRef.current) === null || _selectedTeamInfoRef$2 === void 0 ? void 0 : _selectedTeamInfoRef$2.team_id) || 0);
              }, 0);

              if (teamSelectQueuedRef.current.length) {
                setQueuedState(!queuedStateRef.current);
              }

            case 26:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function teamListChange() {
      return _ref3.apply(this, arguments);
    };
  }();

  var loginAnonymous = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var isLogin,
          data,
          _args4 = arguments;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isLogin = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;

              if (switchOrgDialogVisible) {
                toggleSwitchOrgDialogVisible();
              }

              if (isLogin) {
                _context4.next = 5;
                break;
              }

              logoutAll(function () {}); // 触发 teamListChange 来获取token

              return _context4.abrupt("return");

            case 5:
              _context4.next = 7;
              return props.sdk.loginAnonymous();

            case 7:
              data = _context4.sent;
              setLoginLoading(false);
              setAccountList([]);
              setTimeout(function () {
                setSelectedTeamInfo(data);
              }, 0);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function loginAnonymous() {
      return _ref4.apply(this, arguments);
    };
  }();

  var getLoginInfo = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var loginInfo, list;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              props.sdk.onTeamChange(function () {
                teamListChange();
              });
              _context5.next = 3;
              return props.sdk.login({
                anonymously: true
              });

            case 3:
              loginInfo = _context5.sent;

              if (!(loginInfo && !loginInfo.length)) {
                _context5.next = 9;
                break;
              }

              if (!props.anonymously) {
                _context5.next = 8;
                break;
              }

              loginAnonymous();
              return _context5.abrupt("return");

            case 8:
              // 没有组织时触发回调空对象
              resetSelectedTeamInfo();

            case 9:
              list = translateToAccountList(loginInfo);
              setAccountList(list);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function getLoginInfo() {
      return _ref5.apply(this, arguments);
    };
  }();

  var onTeamSelect = function onTeamSelect(teamId) {
    selectTeam(teamId);
    toggleSwitchOrgDialogVisible();
  };

  var afterCreateTeam = function afterCreateTeam(info) {
    teamSelectQueuedRef.current = [].concat(_toConsumableArray(teamSelectQueuedRef.current), [info.team.team_id]);
  };

  var onLogout = function onLogout(info) {
    props.sdk.logout({
      account: [info.account]
    });

    if (props.onAccountLogout) {
      props.onAccountLogout(info.account);
    }
  };

  var logoutAll = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(fn) {
      var accounts;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              accounts = [];
              accountList.map(function (item) {
                if (!item) return;
                accounts.push(item.account);
              });
              setLoginLoading(true);
              _context6.next = 5;
              return props.sdk.logout({
                account: accounts
              }).then(function () {
                if (fn) {
                  fn();
                  return;
                }

                setAccountList([]);
                /**
                 * logout后自动触发 teamListChange 来后续操作
                 */
                //   if (props.anonymously) {
                //     loginAnonymous();
                //     return;
                //   }
                //   setLoginLoading(false);
                //   resetSelectedTeamInfo();
              });

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function logoutAll(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var getCheckTeamInfoType = function getCheckTeamInfoType(teamInfo) {
    if (!teamInfo) return 'none';

    if (teamInfo.team_id) {
      return 'login';
    } else {
      return 'anonymous';
    }
  };

  var clearTokenExpireTimeout = function clearTokenExpireTimeout() {
    if (checkTokenExpireTimeoutRef.current) {
      window.clearTimeout(checkTokenExpireTimeoutRef.current);
    }
  };

  var checkTokenExpire = function checkTokenExpire(teamInfo) {
    if (!props.onTokenPrivilegeDidExpire) return; // 相同类型则不重新计算，例如：切换组织

    var infoType = getCheckTeamInfoType(teamInfo);

    if (infoType === checkTokenInfoTypeRef.current) {
      return;
    } else {
      checkTokenInfoTypeRef.current = infoType;
    }

    clearTokenExpireTimeout();
    if (!teamInfo) return;
    var newData;
    checkTokenExpireTimeoutRef.current = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var _selectedTeamInfoRef$3, teamList, list, currentTeamId, newTeamInfo, info, data;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (props.onTokenPrivilegeDidExpire) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              if (!(checkTokenInfoTypeRef.current === 'login')) {
                _context7.next = 15;
                break;
              }

              _context7.next = 5;
              return props.sdk.getTeamList();

            case 5:
              teamList = _context7.sent;
              list = translateToAccountList(teamList);
              setAccountList(list);
              currentTeamId = (_selectedTeamInfoRef$3 = selectedTeamInfoRef.current) === null || _selectedTeamInfoRef$3 === void 0 ? void 0 : _selectedTeamInfoRef$3.team_id;
              newTeamInfo = teamList.filter(function (item) {
                return item.team.team_id === currentTeamId;
              })[0];
              info = Object.assign(teamInfo, _objectSpread2(_objectSpread2(_objectSpread2({}, newTeamInfo.team), newTeamInfo.login_info), {}, {
                avatar: newTeamInfo.account_info.avatar,
                userName: newTeamInfo.account_info.display_name,
                id: newTeamInfo.account_info.id,
                account: newTeamInfo.account_info.user_name
              }));
              props.onTokenPrivilegeDidExpire(info);
              newData = info;
              _context7.next = 21;
              break;

            case 15:
              if (!(checkTokenInfoTypeRef.current === 'anonymous')) {
                _context7.next = 21;
                break;
              }

              _context7.next = 18;
              return props.sdk.loginAnonymous();

            case 18:
              data = _context7.sent;
              props.onTokenPrivilegeDidExpire(data);
              newData = data;

            case 21:
              checkTokenInfoTypeRef.current = 'none';
              checkTokenExpire(newData);

            case 23:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })), teamInfo.expires_in * 1000 - 2 * 60 * 1000); // 提前2分钟
  };

  var getAppUrl = function getAppUrl(key) {
    var env = isTestEnv ? 'Dev' : 'Pro';
    return AppUrl[env][key] + "?team_id=".concat(selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id);
  };

  var getAppMeetUrl = function getAppMeetUrl(key) {
    var env = isTestEnv ? 'Dev' : 'Pro';
    return AppUrl[env][key] + "home?team_id=".concat(selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id);
  };

  var getUrl = function getUrl(key) {
    var env = isTestEnv ? 'Dev' : 'Pro';
    return AppUrl[env][key];
  };

  var checkIsLogin = function checkIsLogin() {
    return !!accountList.length && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.id);
  };

  React.useEffect(function () {
    setIsMobile(props.deviceMode === 'mobile');
  }, [props.deviceMode]);
  React.useEffect(function () {
    // 跟随外部切换组织
    if (!(selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.account)) return;
    selectTeam(props.teamId);
  }, [props.teamId]);
  React.useEffect(function () {
    setLoginLoading(true);
    getLoginInfo().then(function () {
      setLoginLoading(false);
    });
    return function () {
      props.sdk.onTeamChange(function () {});
    };
  }, []);
  React.useEffect(function () {
    teamSelectQueuedRef.current.map(function (teamId) {
      selectTeam(teamId);
    });
    teamSelectQueuedRef.current = [];
  }, [queuedState]);
  React.useEffect(function () {
    // 自动选中组织
    if (accountList.length) {
      autoSelectTeam();
    }
  }, [accountList.length]);
  React.useEffect(function () {
    // 把当前选中组织回调给外部
    if (loginLoading || !selectedTeamInfo) return;
    console.log('page header onLoginInfo:', 'accountList:', accountList, 'selectedTeamInfo:', selectedTeamInfo, 'teamId:', props.teamId);
    var teamInfo = selectedTeamInfo.access_token ? selectedTeamInfo : undefined;
    props.onLoginInfo(teamInfo);
    checkTokenExpire(teamInfo);
  }, [selectedTeamInfo]);
  React.useEffect(function () {
    if (selectedTeamInfo && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id)) {
      planInfo();
    }
  }, [selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id]);

  var versionName = function versionName(version) {
    var name = '';

    switch (version) {
      case 'STARTER':
        name = locale.freeVersion;
        break;

      case 'STANDARD':
        name = locale.generalVersion;
        break;

      case 'PREMIUM':
        name = locale.advancedVersion;
        break;

      case 'ENTERPRISE':
        name = locale.enterpriseVersion;
        break;
    }

    return name;
  };

  var upgradeClick = function upgradeClick() {
    var path = "".concat(isTestEnv ? DevOri : ProOri, "billing?team_id=").concat(selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id);
    window.open(path);
  };

  var MenuHeader = function MenuHeader() {
    return /*#__PURE__*/React__default['default'].createElement("section", {
      className: "".concat(prefixCls, "-menu-current-info ").concat(isMobile ? 'mobile' : '')
    }, !isMobile && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "corp"
    }, selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_name), isMobile ? /*#__PURE__*/React__default['default'].createElement("div", {
      className: 'userinfo'
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-menu-current-info-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(_Avatar__default['default'], {
      className: "avatar",
      size: 40,
      src: selectedTeamInfo && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.avatar) ? selectedTeamInfo.avatar : ''
    }, selectedTeamInfo && selectedTeamInfo.userName && selectedTeamInfo.userName[0].toUpperCase())), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "userinfo-content-mobile"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "corp"
    }, selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "account"
    }, selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.userName))) : /*#__PURE__*/React__default['default'].createElement("div", {
      className: 'userinfo'
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "".concat(prefixCls, "-menu-current-info-avatar")
    }, /*#__PURE__*/React__default['default'].createElement(_Avatar__default['default'], {
      className: "avatar",
      size: 48,
      src: selectedTeamInfo && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.avatar) ? selectedTeamInfo.avatar : ''
    }, selectedTeamInfo && selectedTeamInfo.userName && selectedTeamInfo.userName[0].toUpperCase())), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "account"
    }, selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.userName)), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "versions"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: planVersions === 'STARTER' ? 'freeVer' : 'otherVer',
      onClick: upgradeClick
    }, versionName(planVersions)), planVersions === 'STARTER' && isCreator && /*#__PURE__*/React__default['default'].createElement("button", {
      className: 'upgradeButton'
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "upgradeContent",
      onClick: upgradeClick
    }, /*#__PURE__*/React__default['default'].createElement(SvgUpgrade, null), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "upgradediv"
    }, locale.upgrade)))));
  };

  var moreApp = function moreApp() {
    return /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "moreApp",
      className: "menu-item-disabled-hover"
    }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      align: "center",
      size: 6
    }, /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "menu-item-app-btn",
      type: "text",
      onClick: function onClick() {
        window.open(getAppUrl(AppKey.IM));
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "menu-item-app-wrap"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "menu-item-app-icon-wrap"
    }, /*#__PURE__*/React__default['default'].createElement(SvgAppIm, null)), /*#__PURE__*/React__default['default'].createElement("span", null, "IM")))), /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "menu-item-app-btn",
      type: "text",
      onClick: function onClick() {
        window.open(getAppMeetUrl(AppKey.Meet));
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "menu-item-app-wrap"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "menu-item-app-icon-wrap"
    }, /*#__PURE__*/React__default['default'].createElement(SvgAppMeet, null)), /*#__PURE__*/React__default['default'].createElement("span", null, "Meet")))), /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "menu-item-app-btn",
      type: "text",
      onClick: function onClick() {
        window.open(getAppUrl(AppKey.Drive));
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "menu-item-app-wrap"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "menu-item-app-icon-wrap"
    }, /*#__PURE__*/React__default['default'].createElement(SvgAppDrive, null)), /*#__PURE__*/React__default['default'].createElement("span", null, "Drive")))))), /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
      style: {
        marginTop: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      align: "center",
      size: 8
    }, /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "menu-item-app-btn",
      type: "text",
      onClick: function onClick() {
        window.open(getAppUrl(AppKey.Task));
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "menu-item-app-wrap"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "menu-item-app-icon-wrap"
    }, /*#__PURE__*/React__default['default'].createElement(SvgAppTask, null)), /*#__PURE__*/React__default['default'].createElement("span", null, "Task")))), /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
      className: "menu-item-app-btn",
      type: "text",
      onClick: function onClick() {
        window.open(getAppUrl(AppKey.Form));
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "menu-item-app-wrap"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "menu-item-app-icon-wrap"
    }, /*#__PURE__*/React__default['default'].createElement(SvgAppForm, null)), /*#__PURE__*/React__default['default'].createElement("span", null, "Form")))))))));
  };

  var menu = function menu() {
    return /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'], {
      className: "".concat(props.colorMode === 'dark' ? 'account-menu-content-dark' : 'account-menu-content-light').concat(isMobile ? ' mobile' : '')
    }, /*#__PURE__*/React__default['default'].createElement(MenuHeader, null), props.orgManagementVisible && /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "orgManagement",
      onClick: function onClick() {
        window.open("https://account.felo.me/userportal/#/sso?token=".concat('#'));
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(Icon.ApartmentOutlined, {
      style: {
        fontSize: 15,
        color: '#1C202A'
      }
    }), /*#__PURE__*/React__default['default'].createElement("span", null, locale.orgManagement))), props.personalInfoVisible && /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "personalCenter",
      onClick: function onClick() {
        window.open("".concat(isTestEnv ? DevOri : ProOri, "?team_id=").concat(selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.team_id));
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(SvgAccount, null), /*#__PURE__*/React__default['default'].createElement("span", null, locale.personalInfo))), /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "invitationOrganization",
      onClick: function onClick() {
        closeInfoVisible();
        setDiglogType('JoinOrganization');
        setInvitationOrgDialogVisible(!InvitationOrgDialogVisible);
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(SvgInvite, null), /*#__PURE__*/React__default['default'].createElement("span", null, locale.invitationOrganization))), /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "recommendFriend",
      onClick: function onClick() {
        closeInfoVisible();
        setDiglogType('RecommendFriend');
        setInvitationOrgDialogVisible(!InvitationOrgDialogVisible);
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(SvgRecommend$1, null), /*#__PURE__*/React__default['default'].createElement("span", null, locale.recommendFriend))), /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      hidden: isMobile,
      key: "switchOrg",
      onClick: function onClick() {
        closeInfoVisible();
        toggleSwitchOrgDialogVisible();
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(SvgSwitch, null), /*#__PURE__*/React__default['default'].createElement("span", null, locale.switchAccount))), /*#__PURE__*/React__default['default'].createElement(_Menu__default['default'].Item, {
      key: "logout",
      onClick: function onClick() {
        closeInfoVisible();
        logoutAll();
      }
    }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
      className: "menu-item-wrap",
      align: "center",
      size: 12,
      style: {
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default['default'].createElement(SvgExit, null), /*#__PURE__*/React__default['default'].createElement("span", null, locale.logout))));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    className: "\n          ".concat(props.colorMode === 'dark' ? "".concat(prefixCls, "-dark") : '', "\n          ").concat(props.className ? props.className : '', "\n          ").concat(isMobile ? "".concat(prefixCls, "-mobile") : '', "\n          ").concat(justShowAvatar ? " avatar" : '', "\n        "),
    style: _objectSpread2({
      width: '100%'
    }, props.style),
    justify: 'space-between'
  }, !justShowAvatar && /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    align: "center",
    className: "".concat(prefixCls, "-space-wrap ").concat(prefixCls, "-title")
  }, props.title ? props.title : /*#__PURE__*/React__default['default'].createElement("h2", null, "Felo"))), /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    align: "center",
    className: "".concat(prefixCls, "-space-wrap")
  }, props.appVisible && checkIsLogin() && !justShowAvatar && /*#__PURE__*/React__default['default'].createElement(_Dropdown__default['default'], {
    overlay: moreApp,
    overlayClassName: 'felo-dropdown-wrap felo-dropdown-apps',
    trigger: ['click'],
    align: {
      offset: [0, 10]
    },
    placement: "bottomRight"
  }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    className: "".concat(prefixCls, "-info-box ").concat(prefixCls, "-icon-wrap")
  }, /*#__PURE__*/React__default['default'].createElement(SvgMore, null))), /*#__PURE__*/React__default['default'].createElement(_Skeleton__default['default'], {
    avatar: {
      shape: 'circle',
      size: isMobile ? 30 : undefined
    },
    active: true,
    paragraph: false,
    loading: loginLoading,
    className: "skeleton"
  }, checkIsLogin() ? /*#__PURE__*/React__default['default'].createElement(_Dropdown__default['default'], {
    overlay: menu,
    overlayClassName: "felo-dropdown-wrap\n                  ".concat(props.colorMode === 'dark' ? ' mobile' : ''),
    trigger: ['click'],
    placement: "bottomRight",
    onVisibleChange: onVisibleChange
  }, /*#__PURE__*/React__default['default'].createElement(_Row__default['default'], {
    className: "".concat(prefixCls, "-info-box"),
    onClick: showInfo
  }, /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    align: "center",
    className: "".concat(prefixCls, "-space-wrap")
  }, /*#__PURE__*/React__default['default'].createElement(_Avatar__default['default'], {
    className: "avatar",
    size: 32,
    src: selectedTeamInfo && (selectedTeamInfo === null || selectedTeamInfo === void 0 ? void 0 : selectedTeamInfo.avatar) ? selectedTeamInfo.avatar : ''
  }, selectedTeamInfo && selectedTeamInfo.userName && selectedTeamInfo.userName[0].toUpperCase()))), !isMobile && !justShowAvatar && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], {
    flex: "auto",
    className: "".concat(prefixCls, "-current-info")
  }, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    direction: "vertical",
    size: 0,
    className: "".concat(prefixCls, "-current-info-box")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-current-account")
  }, selectedTeamInfo && selectedTeamInfo.userName), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-current-corp")
  }, selectedTeamInfo && selectedTeamInfo.team_name))), /*#__PURE__*/React__default['default'].createElement(_Col__default['default'], null, /*#__PURE__*/React__default['default'].createElement(_Space__default['default'], {
    align: "center",
    className: "".concat(prefixCls, "-space-wrap")
  }, /*#__PURE__*/React__default['default'].createElement(Icon.CaretDownOutlined, {
    rotate: infoVisible ? 180 : 0,
    className: "".concat(prefixCls, "-animation-svg")
  })))))) : /*#__PURE__*/React__default['default'].createElement(_Button__default['default'], {
    type: 'primary',
    onClick: login,
    loading: loginBtnLoading
  }, locale.login))))), /*#__PURE__*/React__default['default'].createElement(SwitchOrgDialog, {
    visible: switchOrgDialogVisible,
    onClose: toggleSwitchOrgDialogVisible,
    accountList: accountList,
    onTeamSelect: onTeamSelect,
    onLogout: onLogout,
    afterCreateTeam: afterCreateTeam,
    anonymouslyFn: undefined,
    isTestEnv: isTestEnv,
    baseURL: "".concat(isTestEnv ? DevOri : 'https://api.felo.me/', "im")
  }), /*#__PURE__*/React__default['default'].createElement(InvitationOrganizationDialog, {
    visible: InvitationOrgDialogVisible,
    onVisibleChange: setInvitationOrgDialogVisible,
    baseURL: "".concat(isTestEnv ? DevOri : 'https://api.felo.me/', "im"),
    meetUrl: getUrl(AppKey.Meet),
    loginUrl: isTestEnv ? DevOri : ProOri,
    teamInfo: selectedTeamInfo,
    diglogType: diglogType
  }));
};

PageHeader.defaultProps = {
  colorMode: 'light',
  deviceMode: 'pc',
  showMode: 'normal',
  teamId: 0,
  anonymously: false,
  personalInfoVisible: true,
  orgManagementVisible: false,
  loginWithNewWindow: false
};

exports.Avatar = AvatarComponent;
exports.CommonShare = CommonShare;
exports.ConfigProvider = FeloConfigProvider;
exports.ContactTree = ContactTree;
exports.CustomSearch = CustomSearch;
exports.Dropdown = Dropdown;
exports.InvitationShare = InvitationShare;
exports.Loading = Loading$1;
exports.LocaleProvider = LocaleProvider;
exports.PageHeader = PageHeader;
exports.Search = Search;
exports.SelectorContent = SelectorContent;
exports.SelectorDialog = SelectorDialog;
exports.Share = Share;
exports.fetchRCTreeData = fetchRCTreeData;
